<!-- src/layout/TiktokQuery.vue  npm run serve-->
<template>

  <div :class="['tiktok-query', 'full-page-layout', `theme-${currentTheme}`]">
    <!-- 登录模态框组件 -->
    <div v-if="showLoginModal && !isCheckingLoginStatus" class="login-modal-overlay">
      <div class="login-modal-wrapper">
        <div class="login-modal-container">
          <!-- 登录模态框组件 -->
          <LoginModal
              v-model="showLoginModal"
              @close="handleLoginModalClose"
              @login-success="handleLoginSuccess"
              @register-success="handleRegisterSuccess"
          />
        </div>
      </div>
    </div>

    <!-- 修改密码组件 -->
    <ChangePassword ref="changePasswordModal" />
    <!-- 主要内容区域 -->
    <div :class="{ 'content-disabled': !isUserLoggedIn && !isLoginModalClosed }" class="full-page-content">
      <!-- 移动端侧边栏遮罩层 -->
      <div v-if="isMobile && showSidebar" class="sidebar-overlay" @click="closeSidebar"></div>
      
      <!-- 左侧边栏 - 管理后台风格 -->
      <div :class="['sidebar', 'sidebar-dark', { 'sidebar-mobile': isMobile, 'sidebar-hidden': isMobile && !showSidebar }]"
           @click="closeSidebar"
      >
        <!-- Logo区域 -->
        <div class="sidebar-logo" @click="handleMenuClick('query')" style="cursor: pointer;">
          <span class="logo-text">{{ siteInfo.site_name || '抖数君后台管理系统' }}</span>
        </div>

        <!-- 菜单区域 -->
        <div class="sidebar-menu">
          <!-- 数据查询 -->
          <div :class="['menu-item', { 'active': activeMenu === 'query' }]" @click.stop="handleMenuClick('query')">
            <Icon type="ios-search" class="menu-icon" />
            <span class="menu-text">AI作品优化建议分析</span>
          </div>

          <!-- 账号权重查询 -->
          <div :class="['menu-item', { 'active': activeMenu === 'weight' }]" @click.stop="handleMenuClick('weight')">
            <Icon type="ios-stats" class="menu-icon" />
            <span class="menu-text">AI账号权重查询</span>
          </div>

          <!-- 作品数据监控 -->
          <div v-if="isUserLoggedIn" :class="['menu-item', { 'active': activeMenu === 'monitor' }]" @click.stop="handleMenuClick('monitor')">
            <Icon type="ios-analytics" class="menu-icon" />
            <span class="menu-text">作品数据监控</span>
          </div>

          <!-- 用户充值 -->
          <div v-if="isUserLoggedIn" :class="['menu-item', { 'active': activeMenu === 'recharge' }]" @click.stop="handleMenuClick('recharge')">
            <Icon type="ios-card" class="menu-icon" />
            <span class="menu-text">用户充值</span>
          </div>

          <!-- 系统基本设置 -->
          <div v-if="isUserLoggedIn" :class="['menu-item', { 'active': activeMenu === 'settings' }]" @click.stop="handleMenuClick('settings')">
            <Icon type="ios-settings" class="menu-icon" />
            <span class="menu-text">系统基本设置</span>
          </div>
        </div>
      </div>

      <!-- 主内容区域 -->
      <div :class="['main-content', { 'main-content-mobile': isMobile }]">
        <!-- 移动端站点标题（仅移动端显示，在最顶部） -->
        <div v-if="isMobile" class="mobile-header-title" @click="handleMenuClick('query')" style="cursor: pointer;">
          <h2>{{ siteInfo.site_name || '抖数君—作品分析建议优化平台' }}</h2>
        </div>
        
        <!-- 顶部导航栏 -->
        <div class="top-header">
          <!-- 左侧：菜单按钮（仅移动端显示）+ 面包屑或标题 -->
          <div class="header-left">
            <!-- 移动端菜单按钮 -->
            <div v-if="isMobile" class="mobile-menu-btn-inline" @click="toggleSidebar">
              <Icon type="ios-menu" size="24" />
            </div>
            <!-- 页面标题（仅在非数据查询页面显示） -->
            <h2 class="page-title" v-if="activeMenu !== 'query'">{{ getPageTitle() }}</h2>
          </div>

          <!-- 右侧：用户信息、皮肤切换、全屏按钮 -->
          <div class="header-right">
            <!-- 皮肤切换 -->
            <div class="theme-switcher">
              <Select v-model="currentTheme" @on-change="handleThemeChange" style="width: 120px;">
                <Option v-for="theme in themeOptions" :key="theme.name" :value="theme.name">
                  {{ theme.label }}
                </Option>
              </Select>
            </div>

            <!-- 全屏显示按钮 -->
            <Button type="primary" ghost @click="toggleFullscreen" class="fullscreen-btn">
              <Icon :type="isFullscreen ? 'ios-contract' : 'ios-expand'" />
              {{ isFullscreen ? '退出全屏' : '全屏显示' }}
            </Button>

            <!-- 用户显示 -->
            <div class="user-dropdown-wrapper" v-if="isUserLoggedIn" @click.stop>
              <div class="user-display" @click="toggleUserDropdown">
                <Avatar :src="require('@/assets/images/default-avatar.png')" size="small" />
                <span class="username">{{ username }}</span>
                <span class="user-role">超级管理员</span>
                <Icon type="ios-arrow-down" :class="{ 'rotate-icon': userDropdownVisible }" style="margin-left: 5px;" />
              </div>
              <div class="user-dropdown-menu" v-if="userDropdownVisible">
                <div class="dropdown-item" @click="handleOpenUserProfile">
                  <Icon type="ios-person" />
                  用户个人资料
                </div>
                <div class="dropdown-item" @click="handleClearCache">
                  <Icon type="ios-trash" />
                  清除缓存
                </div>
                <div class="dropdown-item" @click="handleOpenChangePassword">
                  <Icon type="ios-key" />
                  修改密码
                </div>
                <div class="dropdown-item divided" @click="handleLogoutClick">
                  <Icon type="ios-log-out" />
                  退出账号
                </div>
              </div>
            </div>

            <!-- API开发文档链接 -->
            <a v-if="!isMobile" @click="handleApiDocClick" class="api-doc-link-header">
              <Icon type="ios-document" />
              API开发文档
            </a>
          </div>
        </div>

        <div class="content-wrapper">

        <!-- 查询结果 logo 容器 -->
        <div v-if="showResultLogo" class="result-logo-container">
          <img :src="resultLogoSrc" alt="查询结果" class="result-logo"/>
        </div>


        <!--
                &lt;!&ndash; 添加 API 开发文档链接 - 放在右上角 &ndash;&gt;
                <div class="api-doc-link-container">
                  <a @click="handleApiDocClick" class="api-doc-link">
                    API开发文档
                  </a>
                </div>
        -->

        <!-- 数据查询页面 -->
        <div v-if="activeMenu === 'query'" class="query-page">
        <!-- 输入框区域 -->
        <div class="input-section">
          <input
              v-model="inputValue"
              class="input-field"
              placeholder="输入作品分享链接或ID(单条添加)"
              type="text"
          >
          <!-- 修改原来的批量添加按钮 -->
          <div class="add-buttons-container">
            <Button
                @click="addItem"
                type="primary"
                icon="md-add"
            >
              单条添加
            </Button>

            <Button type="primary" icon="md-add" @click="openBatchAddModal">批量添加</Button>
          </div>

        </div>


        <!-- 待查询项列表 -->
        <div class="pending-items">

          <!-- VIP会员显示到期时间 -->
          <h3 class="pend-daichaxun" v-if="vipStatus.is_vip">
            ↓ 待查询项 <span style="color: #dc3545">VIP到期：{{ vipStatus.end_date || vipStatus.expire_time }}</span>
            <span v-if="vipStatus.days_left" style="color: #ff964b; margin-left: 10px;">(剩余{{ vipStatus.days_left }}天)</span>
            <span v-if="vipStatus.daily_limit > 0" style="color: #28a745; margin-left: 10px;">今日查询：{{ vipStatus.used_today || 0 }}/{{ vipStatus.daily_limit }}次（剩{{ vipStatus.remaining_today || 0 }}次）</span>
            <button v-show="!vipStatus.is_vip" class="recharge-link-btn"  @click="showVipPackages">包月充值</button>
          </h3>

          <!-- 非VIP会员显示当前点数 -->
          <h3 class="pend-daichaxun" v-else>
            ↓ 待查询项 您当前点数：{{ queryBalance }}
            <button v-show="isSiteInfoLoaded && !vipStatus.is_vip  && siteInfo.allow_point_recharge" class="recharge-link-btn" @click="recharge">点数充值</button>
          </h3>


          <div class="pending-list">
            <div
                v-for="(item, index) in pendingItems"
                :key="index"
                class="pending-item"
            >
              <span class="pending-item-text">{{ item.displayText || item.id }}</span>
              <button class="remove-btn" @click="removeItem(index)">×</button>
            </div>
            <div v-if="pendingItems.length === 0" class="empty-pending">
              暂无待查询项（单次至多二十条）...
            </div>
          </div>
          <div class="pending-footer">
            <span class="pend-daichaxun">{{ pendingItems.length }}/20</span>
            <Button
                v-if="pendingItems.length > 0"
                ghost
                size="large"
                type="error"
                @click="clearAllPending"
            >
              清空所有
            </Button>


            <!-- 批量导入按钮 -->
            <Button
                @click="openBatchImportModal"
                type="primary"
                icon="md-add"
                style="margin-right: 10px;"
            >
              从主页链接批量导入
            </Button>


          </div>

        </div>

        <!--        &lt;!&ndash; 播放开关 &ndash;&gt;
                <div class="play-toggle">
                  <label class="switch">
                    <input v-model="isPlaying" type="checkbox">
                    <span class="slider round"></span>
                  </label>
                  <span class="toggle-label">播放按钮/如果不勾选播放，则不会扣除用户点数(查不出来也不会扣除点数)</span>

                </div>-->

        <!-- 操作按钮区域 -->
        <div class="action-buttons">

          <button class="select-btn" @click="selectAll">
            {{ (selectedItems.length > 0 && selectedItems.length === dataItems.length) ? '取消全选' : '一键全选' }}
          </button>

          <button
              :disabled="isBatchQuerying"
              class="query-btn"
              @click="batchQuery"
          >
            {{ isBatchQuerying ? '正在查询中...' : '一键查询待选项' }}
          </button>

          <button :disabled="isRefreshing" class="refresh-btn" @click="refresh">
            {{ isRefreshing ? '正在刷新中...' : '刷新勾选项目视频数据' }}
          </button>
          <button class="clear-btn" @click="clearAll">删除勾选项目</button>
          <button class="export-btn" @click="exportToExcel">一键导出EXCEL</button>
          <button class="export-btn" @click="goToMonitorData">作品数据监控</button>

          <button
              :disabled="isBatchAiAnalyzing || selectedItems.length === 0"
              class="ai-batch-btn"
              @click="batchAiAnalysis"
          >
            <span v-if="!isBatchAiAnalyzing">AI 优化建议分析</span>
            <span v-else class="ai-batch-btn-loading">
              <span class="ai-spinner"></span>
              AI分析中 {{ batchAiProgress.done }}/{{ batchAiProgress.total }}
            </span>
          </button>
        </div>

        <!-- 数据表格（PC端和移动端都显示） -->
        <div class="table-container" style="position: relative;">
          <!-- 查询历史标题区域 -->
          <div class="table-header-section">
            <div class="table-header-left">
              <Icon type="ios-list" size="20" style="margin-right: 8px; color: #1890ff;" />
              <h3 class="table-title">查询历史</h3>
              <span class="table-count">（共 {{ total }} 条记录）</span>
            </div>
            <div class="table-header-right">
              <Button size="small" @click="refreshAllData" :loading="isRefreshing" style="margin-right: 8px;">
                <Icon type="ios-refresh" /> 刷新全部
              </Button>
              <Button size="small" type="error" @click="clearAllFailed" v-if="hasFailedItems">
                <Icon type="ios-trash" /> 清空失败项
              </Button>
            </div>
          </div>
          
          <!-- 查询Loading遮罩层 -->
          <div v-if="showQueryLoading" class="query-loading-overlay">
            <div class="loading-spinner">
              <div class="spinner-circle"></div>
              <p class="loading-text">正在查询数据，请稍候...</p>
            </div>
          </div>
          
          <!-- AI 批量分析全屏 Loading 遮罩（居中、自定义好看转圈） -->
          <div v-if="showAiBatchLoading" class="ai-batch-loading-overlay">
            <div class="ai-batch-loading-card">
              <div class="ai-batch-loading-spinner">
                <div class="ai-batch-spinner-ring"></div>
                <div class="ai-batch-spinner-core"></div>
              </div>
              <p class="ai-batch-loading-title">AI 优化建议分析中</p>
              <p class="ai-batch-loading-text">{{ aiBatchLoadingText }}</p>
              <div class="ai-batch-loading-progress">
                <div class="ai-batch-progress-bar">
                  <div
                    class="ai-batch-progress-fill"
                    :style="{ width: (batchAiProgress.total ? (batchAiProgress.done / batchAiProgress.total * 100) : 0) + '%' }"
                  ></div>
                </div>
                <span class="ai-batch-progress-count">{{ batchAiProgress.done }}/{{ batchAiProgress.total }}</span>
              </div>
            </div>
          </div>
          
          <Table
              ref="selection"
              :columns="tableColumns"
              :data="dataItems"
              :scroll="isMobile ? { x: 'max-content', y: 'auto' } : { x: 'max-content' }"
              border
              stripe
              @on-selection-change="handleSelectionChange"
              @on-row-click="(row, index) => handleRowClick(row, index, $event)"
              :row-class-name="rowClassName"
          >


            <!-- 使用 scoped slot 自定义"作品ID"列 -->
            <template #aweme_id="{ row }">
              <span :title="`点击我跳转到该抖音作品页面：https://www.douyin.com/video/ ${row.aweme_id || '无ID'}`"
                    style="color: #1890ff; text-decoration: underline; cursor: pointer;"
                    @click="handleVideoIdClick(row.aweme_id)"
              >
              {{ row.aweme_id || '无ID' }}
             </span>
            </template>
            
            <!-- 操作列：查看详情、刷新、删除按钮 -->
            <template #action="{ row }">
              <div class="action-button-group">
                <!-- 查看详情按钮：点击弹窗显示作品详细信息 -->
                <Button 
                  size="small" 
                  type="info" 
                  @click.stop="viewVideoDetail(row)"
                  style="margin-right: 5px;"
                >
                  <Icon type="ios-eye" /> 查看
                </Button>
                
                <!-- 刷新按钮：重新获取该作品的最新数据 -->
                <Button 
                  size="small" 
                  type="primary" 
                  @click.stop="refreshSingleVideo(row)"
                  :loading="row.refreshing"
                  style="margin-right: 5px;"
                >
                  <Icon type="ios-refresh" /> 刷新
                </Button>
                
                <!-- 删除按钮：从列表中删除该作品记录 -->
                <Button 
                  size="small" 
                  type="error" 
                  @click.stop="deleteVideoItem(row)"
                >
                  <Icon type="ios-trash" /> 删除
                </Button>
              </div>
            </template>
          </Table>


          <!-- 分页功按钮开始（PC端和移动端都显示） -->
          <div class="pagination">
            <!-- PC端显示每页条数选择器 -->
            <div v-if="!isMobile" class="page-size-selector">
              <span class="page-size-label">每页显示：</span>
              <Select v-model="pageSize" @on-change="handlePageSizeChange" style="width: 100px;">
                <Option v-for="size in pageSizeOptions" :key="size" :value="size">
                  {{ size }}条/页
                </Option>
              </Select>
            </div>
            
            <!-- 上一页按钮 -->
            <button
                :disabled="totalPages <= 1 || currentPage === 1"
                class="page-btn"
                @click="prevPageDyvideodata"
            >
              上一页
            </button>

            <!-- 分页信息（PC端显示全部信息，移动端简化） -->
            <span v-if="!isMobile">第 {{ currentPage }} 页，共 {{ totalPages }} 页</span>
            <span v-else>{{ currentPage }}/{{ totalPages }}</span>

            <!-- 下一页按钮 -->
            <button
                :disabled="totalPages <= 1 || currentPage === totalPages"
                class="page-btn"
                @click="nextPageDyvideodata"
            >
              下一页
            </button>

            <!-- 总记录数（PC端显示） -->
            <div class="page-info" v-if="!isMobile">
              共 {{ total }} 条记录
            </div>
          </div>
          <!-- 分页功按钮结束 -->
        </div>

        <!-- 移动端卡片列表（仅移动端显示，在表格下面） -->
        <div v-if="isMobile && dataItems && dataItems.length > 0" class="card-list">

          <!-- 移动端搜索框 -->
          <div class="mobile-search-container">
            <input
                v-model="mobileSearchQuery"
                placeholder="搜索视频ID..."
                class="mobile-search-input"
                @keyup.enter="mobileSearchVideos"
            />
            <button
                @click="mobileSearchVideos"
                class="mobile-search-btn"
            >
              查找
            </button>
            <button
                v-if="isMobileSearching"
                @click="clearMobileSearch"
                class="mobile-search-clear-btn"
            >
              清除
            </button>
          </div>

          <!-- 搜索结果信息 -->
          <div v-if="isMobileSearching && mobileSearchResults.length > 0" class="search-results-info">
            找到 {{ mobileSearchResults.length }} 个匹配的结果
          </div>

          <!-- 无搜索结果提示 -->
          <div v-if="isMobileSearching && mobileSearchResults.length === 0" class="search-results-info no-results">
            未找到匹配的视频
          </div>

          <!-- 搜索结果模式：显示匹配的卡片 -->
          <template v-if="isMobileSearching">
            <div v-for="(item, index) in mobileSearchResults" :key="index" class="card-item">
              <div class="card-header">
                <span class="video-id">作品ID: {{ item.aweme_id || '无' }}</span>
              </div>

            <div class="card-body">
              <!-- 作品信息 -->
              <div class="card-section">
                <h3 class="section-title">作品信息</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">封面:</span>
                    <div class="info-value">
                      <div v-if="item.cover_info?.default_cover || item.aweme_cover" class="cover-wrapper">
                        <img
                            :src="item.cover_info?.default_cover || item.aweme_cover"
                            alt="封面"
                            class="card-cover"
                            @click="showLargeImage(item.cover_info?.default_cover || item.aweme_cover)"
                        >
                      </div>
                      <div v-else class="card-cover-placeholder">无封面</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <span class="info-label">描述:</span>
                    <span class="info-value">{{ item.desc || '无描述' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">分类:</span>
                    <span class="info-value">{{ item.video_category_desc || item.video_category || '无分类' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">形式:</span>
                    <span class="info-value">{{ item.orientation || '未知' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">时长:</span>
                    <span class="info-value">{{ item.duration_formatted || '未知' }}</span>
                  </div>
                </div>
              </div>

              <!-- 作者信息 -->
              <div class="card-section">
                <h3 class="section-title">作者信息</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">作者:</span>
                    <span class="info-value">{{ item.owner_nickname || item.author_nickname || '无昵称' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">作者ID:</span>
                    <span class="info-value">{{ item.owner_handle || item.author_unique_id || '无ID' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">粉丝:</span>
                    <span class="info-value">{{ (item.author_info?.follower_count || item.follower_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">总获赞:</span>
                    <span class="info-value">{{ (item.author_info?.total_favorited || item.total_favorited || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">认证类型:</span>
                    <span class="info-value">{{ item.author_info?.verification_type_desc || item.verification_type_desc || '未认证' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">认证描述:</span>
                    <span class="info-value">{{ item.author_info?.verification_desc || item.verification_desc || '无' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">企业认证:</span>
                    <span class="info-value">{{ item.author_info?.enterprise_verify_reason || item.enterprise_verify_reason || '无' }}</span>
                  </div>
                </div>
              </div>

              <!-- 作品状态 -->
              <div class="card-section">
                <h3 class="section-title">作品状态</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">状态:</span>
                    <span class="info-value">
              <span :class="['status-badge', item.status === 'error' ? 'status-error' : 'status-success']">
                {{ item.status === 'error' ? '失败' : '成功' }}
              </span>
            </span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">限流:</span>
                    <span class="info-value">
              <span :class="['status-badge', (item.is_limited === true || item.is_limited === 1) ? 'status-warning' : 'status-success']">
                {{ (item.is_limited === true || item.is_limited === 1) ? '是' : '否' }}
              </span>
            </span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">删除:</span>
                    <span class="info-value">
              <span :class="['status-badge', (item.is_deleted === true || item.deleted === true || item.is_deleted === 1) ? 'status-error' : 'status-success']">
                {{ (item.is_deleted === true || item.deleted === true || item.is_deleted === 1) ? '是' : '否' }}
              </span>
            </span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">可下载:</span>
                    <span class="info-value">
              <span :class="['status-badge', (item.download_allowed === true || item.download_allowed === 1) ? 'status-success' : 'status-error']">
                {{ (item.download_allowed === true || item.download_allowed === 1) ? '是' : '否' }}
              </span>
            </span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">带货:</span>
                    <span class="info-value">
              <span :class="['status-badge', (item.is_product_video === true || item.is_product_video === 1) ? 'status-success' : 'status-default']">
                {{ (item.is_product_video === true || item.is_product_video === 1) ? '是' : '否' }}
              </span>
            </span>
                  </div>
                </div>
              </div>


              <!-- 只有在是带货视频时才显示带货详细信息 -->
              <div v-if="item.is_product_video === true || item.is_product_video === 1" class="card-section">
                <h3 class="section-title">带货信息</h3>
                <div class="info-grid">
                  <!-- 显示产品类型 -->
                  <div class="info-item" v-if="item.product_details && item.product_details.product_type">
                    <span class="info-label">产品类型:</span>
                    <span class="info-value">{{ item.product_details.product_type }}</span>
                  </div>

                  <!-- 显示销售线索 -->
                  <div class="info-item" v-if="item.product_details && item.product_details.sales_clues">
                    <span class="info-label">销售线索:</span>
                    <span class="info-value">{{ item.product_details.sales_clues }}</span>
                  </div>

                  <!-- 如果有产品信息数组且不为空 -->
                  <div class="info-item" v-if="item.product_details && item.product_details.product_info && item.product_details.product_info.length > 0">
                    <span class="info-label">产品信息:</span>
                    <span class="info-value">{{ item.product_details.product_info.join(', ') }}</span>
                  </div>

                  <!-- 如果有价格信息数组且不为空 -->
                  <div class="info-item" v-if="item.product_details && item.product_details.price_info && item.product_details.price_info.length > 0">
                    <span class="info-label">价格信息:</span>
                    <span class="info-value">{{ item.product_details.price_info.join(', ') }}</span>
                  </div>

                  <!-- 如果有促销信息数组且不为空 -->
                  <div class="info-item" v-if="item.product_details && item.product_details.promotional_info && item.product_details.promotional_info.length > 0">
                    <span class="info-label">促销信息:</span>
                    <span class="info-value">{{ item.product_details.promotional_info.join(', ') }}</span>
                  </div>

                  <!-- 如果没有任何详细信息但确实是带货视频 -->
                  <div class="info-item" v-if="item.product_details &&
                         !item.product_details.product_type &&
                         !item.product_details.sales_clues &&
                         (!item.product_details.product_info || item.product_details.product_info.length === 0) &&
                         (!item.product_details.price_info || item.product_details.price_info.length === 0) &&
                         (!item.product_details.promotional_info || item.product_details.promotional_info.length === 0)">
                    <span class="info-label">详细信息:</span>
                    <span class="info-value">暂无详细带货信息</span>
                  </div>
                </div>
              </div>





              <!-- 数据统计 -->
              <div class="card-section">
                <h3 class="section-title">数据统计</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">播放:</span>
                    <span class="info-value">{{ (item.play_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">点赞:</span>
                    <span class="info-value">{{ (item.digg_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">评论:</span>
                    <span class="info-value">{{ (item.comment_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">收藏:</span>
                    <span class="info-value">{{ (item.collect_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">转发:</span>
                    <span class="info-value">{{ (item.share_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">下载:</span>
                    <span class="info-value">{{ (item.download_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">推荐:</span>
                    <span class="info-value">{{ (item.recommend_count || 0) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">赞赏:</span>
                    <span class="info-value">{{ (item.admire_count || 0) }}</span>
                  </div>
                </div>
              </div>

              <!-- 时间信息 -->
              <div class="card-section">
                <h3 class="section-title">时间信息</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">创建时间:</span>
                    <span class="info-value">{{ item.create_time || '无' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">更新时间:</span>
                    <span class="info-value">{{ item.last_query_time || '无' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">发布时间:</span>
                    <span class="info-value">{{ item.publish_time || '无' }}</span>
                  </div>
                </div>
              </div>

              <!-- 其他指标 -->
              <div class="card-section">
                <h3 class="section-title">其他指标</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">查询次数:</span>
                    <span class="info-value">{{ item.query_count || 0 }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">播放指数:</span>
                    <span class="info-value">{{ item.play_index || 0 }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">互动率:</span>
                    <span class="info-value">{{ item.engagement_rate_formatted || (item.engagement_rate ? (parseFloat(item.engagement_rate) * 100).toFixed(2) + '%' : '0%') }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">加权互动率:</span>
                    <span class="info-value">{{ item.weighted_engagement_rate_formatted || '0%' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">流量池:</span>
                    <span class="info-value">{{ item.traffic_pool_desc || item.traffic_pool || '未知' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">热搜词:</span>
                    <span class="info-value">{{ formatHotWordsForMobile(item.hot_words) }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">优化建议:</span>
                    <span class="info-value">{{ formatHotWordsForMobile(item.optimization_tips) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </template>

          <!-- 正常显示模式：显示当前页的卡片 -->
          <template v-else>
            <div v-for="(item, index) in dataItems" :key="index" class="card-item">
              <div class="card-header">
                <span class="video-id">作品ID: {{ item.aweme_id || '无' }}</span>
              </div>

              <div class="card-body">
                <!-- 作品信息 -->
                <div class="card-section">
                  <h3 class="section-title">作品信息</h3>
                  <div class="info-grid">
                    <div class="info-item">
                      <span class="info-label">封面:</span>
                      <div class="info-value">
                        <div v-if="item.cover_info?.default_cover || item.aweme_cover" class="cover-wrapper">
                          <img
                              :src="item.cover_info?.default_cover || item.aweme_cover"
                              alt="封面"
                              class="card-cover"
                              @click="showLargeImage(item.cover_info?.default_cover || item.aweme_cover)"
                          >
                        </div>
                        <div v-else class="card-cover-placeholder">无封面</div>
                      </div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">描述:</span>
                      <span class="info-value">{{ item.desc || '无描述' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">分类:</span>
                      <span class="info-value">{{ item.video_category_desc || item.video_category || '无分类' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">形式:</span>
                      <span class="info-value">{{ item.orientation || '未知' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">时长:</span>
                      <span class="info-value">{{ item.duration_formatted || '未知' }}</span>
                    </div>
                  </div>
                </div>

                <!-- 作者信息 -->
                <div class="card-section">
                  <h3 class="section-title">作者信息</h3>
                  <div class="info-grid">
                    <div class="info-item">
                      <span class="info-label">作者:</span>
                      <span class="info-value">{{ item.owner_nickname || item.author_nickname || '无昵称' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">作者ID:</span>
                      <span class="info-value">{{ item.owner_handle || item.author_unique_id || '无ID' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">粉丝:</span>
                      <span class="info-value">{{ (item.author_info?.follower_count || item.follower_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">总获赞:</span>
                      <span class="info-value">{{ (item.author_info?.total_favorited || item.total_favorited || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">认证类型:</span>
                      <span class="info-value">{{ item.author_info?.verification_type_desc || item.verification_type_desc || '未认证' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">认证描述:</span>
                      <span class="info-value">{{ item.author_info?.verification_desc || item.verification_desc || '无' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">企业认证:</span>
                      <span class="info-value">{{ item.author_info?.enterprise_verify_reason || item.enterprise_verify_reason || '无' }}</span>
                    </div>
                  </div>
                </div>

                <!-- 作品状态 -->
                <div class="card-section">
                  <h3 class="section-title">作品状态</h3>
                  <div class="info-grid">
                    <div class="info-item">
                      <span class="info-label">状态:</span>
                      <span class="info-value">
                <span :class="['status-badge', item.status === 'error' ? 'status-error' : 'status-success']">
                  {{ item.status === 'error' ? '失败' : '成功' }}
                </span>
              </span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">限流:</span>
                      <span class="info-value">
                <span :class="['status-badge', (item.is_limited === true || item.is_limited === 1) ? 'status-warning' : 'status-success']">
                  {{ (item.is_limited === true || item.is_limited === 1) ? '是' : '否' }}
                </span>
              </span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">删除:</span>
                      <span class="info-value">
                <span :class="['status-badge', (item.is_deleted === true || item.deleted === true || item.is_deleted === 1) ? 'status-error' : 'status-success']">
                  {{ (item.is_deleted === true || item.deleted === true || item.is_deleted === 1) ? '是' : '否' }}
                </span>
              </span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">可下载:</span>
                      <span class="info-value">
                <span :class="['status-badge', (item.download_allowed === true || item.download_allowed === 1) ? 'status-success' : 'status-error']">
                  {{ (item.download_allowed === true || item.download_allowed === 1) ? '是' : '否' }}
                </span>
              </span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">带货:</span>
                      <span class="info-value">
                <span :class="['status-badge', (item.is_product_video === true || item.is_product_video === 1) ? 'status-success' : 'status-default']">
                  {{ (item.is_product_video === true || item.is_product_video === 1) ? '是' : '否' }}
                </span>
              </span>
                    </div>
                  </div>
                </div>

                <!-- 统计信息 -->
                <div class="card-section">
                  <h3 class="section-title">统计信息</h3>
                  <div class="info-grid">
                    <div class="info-item">
                      <span class="info-label">播放:</span>
                      <span class="info-value">{{ (item.play_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">点赞:</span>
                      <span class="info-value">{{ (item.digg_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">评论:</span>
                      <span class="info-value">{{ (item.comment_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">收藏:</span>
                      <span class="info-value">{{ (item.collect_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">分享:</span>
                      <span class="info-value">{{ (item.share_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">下载:</span>
                      <span class="info-value">{{ (item.download_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">推荐:</span>
                      <span class="info-value">{{ (item.recommend_count || 0) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">赞赏:</span>
                      <span class="info-value">{{ (item.admire_count || 0) }}</span>
                    </div>
                  </div>
                </div>

                <!-- 时间信息 -->
                <div class="card-section">
                  <h3 class="section-title">时间信息</h3>
                  <div class="info-grid">
                    <div class="info-item">
                      <span class="info-label">创建时间:</span>
                      <span class="info-value">{{ item.create_time || '无' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">更新时间:</span>
                      <span class="info-value">{{ item.last_query_time || '无' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">发布时间:</span>
                      <span class="info-value">{{ item.publish_time || '无' }}</span>
                    </div>
                  </div>
                </div>

                <!-- 其他指标 -->
                <div class="card-section">
                  <h3 class="section-title">其他指标</h3>
                  <div class="info-grid">
                    <div class="info-item">
                      <span class="info-label">查询次数:</span>
                      <span class="info-value">{{ item.query_count || 0 }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">播放指数:</span>
                      <span class="info-value">{{ item.play_index || 0 }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">互动率:</span>
                      <span class="info-value">{{ item.engagement_rate_formatted || (item.engagement_rate ? (parseFloat(item.engagement_rate) * 100).toFixed(2) + '%' : '0%') }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">加权互动率:</span>
                      <span class="info-value">{{ item.weighted_engagement_rate_formatted || '0%' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">流量池:</span>
                      <span class="info-value">{{ item.traffic_pool_desc || item.traffic_pool || '未知' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">热搜词:</span>
                      <span class="info-value">{{ formatHotWordsForMobile(item.hot_words) }}</span>
                    </div>

                    <div class="info-item">
                      <span class="info-label">优化建议:</span>
                      <span class="info-value">{{ formatHotWordsForMobile(item.optimization_tips) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- 移动端分页按钮（仅移动端显示） -->
        <div v-if="isMobile && dataItems && dataItems.length > 0" class="pagination">
          <!-- 移动端每页条数选择器 -->
          <div class="page-size-selector-mobile">
            <Select v-model="mobilePageSize" @on-change="handleMobilePageSizeChange" size="small" style="width: 110px;">
              <Option v-for="size in mobilePageSizeOptions" :key="size" :value="size">
                {{ size }}条/页
              </Option>
            </Select>
          </div>
          
          <!-- 上一页按钮 -->
          <button
              :disabled="totalPages <= 1 || currentPage === 1"
              class="page-btn"
              @click="prevPageDyvideodata"
          >
            上一页
          </button>

          <!-- 移动端分页信息 -->
          <div class="page-info-mobile">
            <span>{{ currentPage }}/{{ totalPages }}</span>
            <span>共{{ total }}条</span>
          </div>

          <!-- 下一页按钮 -->
          <button
              :disabled="totalPages <= 1 || currentPage === totalPages"
              class="page-btn"
              @click="nextPageDyvideodata"
          >
            下一页
          </button>
        </div>

        <!-- 当没有数据时显示提示 -->
        <div v-else-if="isMobile" class="no-data">
          <p>暂无数据</p>
        </div>

        </div>

        <!-- 账号权重查询页面 -->
        <div v-if="activeMenu === 'weight'" class="weight-page">
          <WeightQuery />
        </div>

        <!-- 作品数据监控页面 -->
        <div v-if="activeMenu === 'monitor'" class="monitor-page">
          <MonitorData />
        </div>

        <!-- 用户充值页面 -->
        <div v-if="activeMenu === 'recharge'" class="recharge-page">
          <!-- 根据后台设置动态显示充值界面 -->
          <VipRecharge v-if="!allowPointRecharge" />
          <Recharge v-else />
        </div>

        <!-- 系统基本设置页面 -->
        <div v-if="activeMenu === 'settings'" class="settings-page">
          <div class="settings-header">
            <h2>系统基本设置</h2>
          </div>

          <div class="settings-container">
            <div class="settings-section">
              <h3>API请求IP白名单设置</h3>
              <div class="ip-whitelist-content">
                <p class="current-ip">当前IP: {{ currentIp }}</p>
                <div class="ip-input-group">
                  <Input
                      v-model="ipWhitelistInput"
                      type="textarea"
                      :rows="8"
                      placeholder="请输入IP白名单，每行一个IP&#10;支持格式：&#10;- 单个IP: 192.168.1.100&#10;- IP段: 192.168.1.0/24&#10;- 多个IP用换行分隔"
                  />
                </div>
                <div class="ip-actions">
                  <Button type="primary" @click="saveIpWhitelist" :loading="ipWhitelistLoading">
                    保存设置
                  </Button>
                  <Button @click="loadIpWhitelist">
                    重新加载
                  </Button>
                </div>
              </div>
            </div>

<!--            <div class="settings-section">-->
<!--              <h3>网站基本信息</h3>-->
<!--              <div class="site-info-display">-->
<!--                <p><strong>网站名称：</strong>{{ siteInfo.site_name }}</p>-->
<!--                <p><strong>网站描述：</strong>{{ siteInfo.site_description }}</p>-->
<!--                <p><strong>联系电话：</strong>{{ siteInfo.contact_phone }}</p>-->
<!--                <p><strong>联系邮箱：</strong>{{ siteInfo.contact_email }}</p>-->
<!--                <p><strong>允许点数充值：</strong>{{ siteInfo.allow_point_recharge ? '是' : '否' }}</p>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>

        <!-- 底部版权和提示信息 -->
        <footer class="page-footer">
          <div class="footer-content">
            <p class="copyright">© 2026 抖数君科技有限公司 | 保留所有权利</p>
            <p class="icp-record">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">浙ICP备2026035279号-4</a>
            </p>
            <p class="legal-notice">
              请勿使用本平台进行非法业务<span class="warning-text">【如刷单,引流推广,网络水军,黄赌毒】</span>。如有违规行为，请立即停止使用本平台。
            </p>
          </div>
        </footer>
      </div>

      <!-- 详细数据 Modal -->
          <Modal
              v-model="showDetailModal"
              :footer-hide="true"
              :title="computedModalTitle"
              width="800"
          >
            <!-- 替换原来的 detail-modal-content 部分 -->
            <div v-if="currentVideoDetails" class="detail-modal-content">
              <Tabs  ref="tabs" v-model="activeTab"  value="basic"  >
                <TabPane label="基本信息" name="basic">
                  <div class="detail-section">
                    <h3>作品信息</h3>
                    <p><strong>作品ID：</strong>{{ currentVideoDetails.aweme_id || '无ID' }}</p>
                    <p><strong>作品描述：</strong>{{ currentVideoDetails.desc || '无描述' }}</p>
                    <p><strong>作品分类：</strong>{{
                        currentVideoDetails.video_category_desc || currentVideoDetails.video_category || '无分类'
                      }}</p>
                    <p><strong>作品形式：</strong>{{ currentVideoDetails.orientation || '未知' }}</p>
                    <p><strong>作品类型：</strong>{{ currentVideoDetails.media_type_desc || '普通作品' }}</p>
                    <p><strong>作品时长：</strong>{{
                        currentVideoDetails.duration_formatted || (currentVideoDetails.duration + '秒') || '未知'
                      }}</p>
                    <p><strong>分辨率：</strong>{{
                        (currentVideoDetails.width || '未知') + 'x' + (currentVideoDetails.height || '未知')
                      }}</p>
                    <p><strong>视频大小：</strong>{{
                        currentVideoDetails.data_size_formatted || (currentVideoDetails.data_size + ' 字节') || '未知'
                      }}</p>
                  </div>

                  <div class="detail-section">
                    <h3>作者信息</h3>
                    <p><strong>达人昵称：</strong>{{
                        currentVideoDetails.owner_nickname || currentVideoDetails.author_nickname || '无昵称'
                      }}</p>
                    <p><strong>抖音号：</strong>{{
                        currentVideoDetails.owner_handle || currentVideoDetails.author_unique_id || '无ID'
                      }}</p>
                    <p><strong>用户签名：</strong>{{ currentVideoDetails?.signature || '无签名' }}</p>
                    <p><strong>粉丝数：</strong>{{ (currentVideoDetails?.author_info?.follower_count || currentVideoDetails?.follower_count || 0) }}</p>
                    <!--                    <p><strong>关注数：</strong>{{ (currentVideoDetails.following_count || 0) }}</p>-->
                    <!--                    <p><strong>作品数：</strong>{{ (currentVideoDetails.aweme_count || 0) }}</p>-->
                    <p><strong>总获赞：</strong>{{ (currentVideoDetails?.author_info?.total_favorited || currentVideoDetails?.total_favorited|| 0) }}</p>
                    <p><strong>认证信息：</strong>{{
                        currentVideoDetails.verification_type_desc || currentVideoDetails.verification_desc || '未认证'
                      }}</p>
                    <p><strong>企业认证：</strong>{{ currentVideoDetails.enterprise_verify_reason || '无' }}</p>
                  </div>
                </TabPane>

                <TabPane label="作品状态" name="status">
                  <div class="detail-section">
                    <p><strong>是否限流：</strong>
                      <Tag
                          :color="(currentVideoDetails.is_limited === 1 || currentVideoDetails.is_limited === true) ? 'red' : 'green'">
                        {{
                          (currentVideoDetails.is_limited === 1 || currentVideoDetails.is_limited === true) ? '是' : '否'
                        }}
                      </Tag>
                    </p>
                    <p v-if="(currentVideoDetails.is_limited === 1 || currentVideoDetails.is_limited === true)"><strong>限流原因：</strong>{{
                        currentVideoDetails.limit_reason || '无说明'
                      }}</p>
                    <p><strong>是否删除：</strong>
                      <Tag
                          :color="(currentVideoDetails.is_deleted === 1 || currentVideoDetails.deleted === true) ? 'red' : 'green'">
                        {{
                          (currentVideoDetails.is_deleted === 1 || currentVideoDetails.deleted === true) ? '是' : '否'
                        }}
                      </Tag>
                    </p>
                    <p v-if="(currentVideoDetails.is_deleted === 1 || currentVideoDetails.deleted === true)"><strong>删除原因：</strong>{{
                        currentVideoDetails.deleted_reason || '无说明'
                      }}</p>
                    <p><strong>流量池：</strong>{{
                        currentVideoDetails.traffic_pool_desc || currentVideoDetails.traffic_pool || '未知'
                      }}</p>
                    <p><strong>是否可下载：</strong>
                      <Tag
                          :color="(currentVideoDetails.download_allowed === 1 || currentVideoDetails.download_allowed === true) ? 'green' : 'red'">
                        {{
                          (currentVideoDetails.download_allowed === 1 || currentVideoDetails.download_allowed === true) ? '是' : '否'
                        }}
                      </Tag>
                    </p>
                    <p v-if="!(currentVideoDetails.download_allowed === 1 || currentVideoDetails.download_allowed === true)">
                      <strong>不可下载原因：</strong>{{ currentVideoDetails.download_disabled_reason || '无说明' }}</p>
                    <p><strong>是否带货视频：</strong>
                      <Tag
                          :color="(currentVideoDetails.is_product_video === 1 || currentVideoDetails.is_product_video === true) ? 'green' : 'red'">
                        {{
                          (currentVideoDetails.is_product_video === 1 || currentVideoDetails.is_product_video === true) ? '是' : '否'
                        }}
                      </Tag>
                    </p>
                  </div>
                </TabPane>

                <!-- 在详细数据 Modal 的 Tabs 中添加带货信息 Tab -->
                <TabPane label="带货信息" name="product">
                  <div class="detail-section" v-if="currentVideoDetails.is_product_video === true || currentVideoDetails.is_product_video === 1">
                    <h3>带货详情</h3>

                    <!-- 产品类型 -->
                    <p v-if="currentVideoDetails.product_details && currentVideoDetails.product_details.product_type">
                      <strong>产品类型：</strong>{{ currentVideoDetails.product_details.product_type }}
                    </p>

                    <!-- 销售线索 -->
                    <p v-if="currentVideoDetails.product_details && currentVideoDetails.product_details.sales_clues">
                      <strong>销售线索：</strong>{{ currentVideoDetails.product_details.sales_clues }}
                    </p>

                    <!-- 产品信息 -->
                    <div v-if="currentVideoDetails.product_details && currentVideoDetails.product_details.product_info">
                      <strong>产品信息：</strong>
                      <div v-if="typeof currentVideoDetails.product_details.product_info === 'object' &&
             currentVideoDetails.product_details.product_info !== null &&
             !Array.isArray(currentVideoDetails.product_details.product_info)">
                        <!-- 处理对象格式的 product_info -->
                        <p v-for="(value, key) in currentVideoDetails.product_details.product_info" :key="key">
                          {{ getKeyLabel(key) }}: {{ value }}
                        </p>
                      </div>
                      <div v-else-if="Array.isArray(currentVideoDetails.product_details.product_info) &&
                  currentVideoDetails.product_details.product_info.length > 0">
                        <!-- 处理数组格式的 product_info（保持向后兼容） -->
                        {{ currentVideoDetails.product_details.product_info.join(', ') }}
                      </div>
                    </div>



                    <!-- 价格信息 -->
                    <p v-if="currentVideoDetails.product_details && currentVideoDetails.product_details.price_info && currentVideoDetails.product_details.price_info.length > 0">
                      <strong>价格信息：</strong>{{ currentVideoDetails.product_details.price_info.join(', ') }}
                    </p>

                    <!-- 促销信息 -->
                    <p v-if="currentVideoDetails.product_details && currentVideoDetails.product_details.promotional_info && currentVideoDetails.product_details.promotional_info.length > 0">
                      <strong>促销信息：</strong>{{ currentVideoDetails.product_details.promotional_info.join(', ') }}
                    </p>

                    <!-- 如果没有详细信息 -->
                    <p v-if="currentVideoDetails.product_details &&
       !currentVideoDetails.product_details.product_type &&
       !currentVideoDetails.product_details.sales_clues &&
       (!currentVideoDetails.product_details.product_info || currentVideoDetails.product_details.product_info.length === 0) &&
       (!currentVideoDetails.product_details.price_info || currentVideoDetails.product_details.price_info.length === 0) &&
       (!currentVideoDetails.product_details.promotional_info || currentVideoDetails.product_details.promotional_info.length === 0)">
                      <strong>详细信息：</strong>暂无详细带货信息
                    </p>
                  </div>

                  <div class="detail-section" v-else>
                    <p>该视频不是带货视频</p>
                  </div>
                </TabPane>

                <TabPane label="数据表现" name="statistics">
                  <div class="detail-section">
                    <p><strong>播放指数：</strong>{{ currentVideoDetails.play_index || 0 }}</p>
                    <p><strong>播放量：</strong>{{ (currentVideoDetails.play_count || 0) }}</p>
                    <p><strong>点赞量：</strong>{{ (currentVideoDetails.digg_count || 0) }}</p>
                    <p><strong>评论量：</strong>{{ (currentVideoDetails.comment_count || 0) }}</p>
                    <p><strong>收藏量：</strong>{{ (currentVideoDetails.collect_count || 0) }}</p>
                    <p><strong>转发量：</strong>{{ (currentVideoDetails.share_count || 0) }}</p>
                    <p><strong>推荐量：</strong>{{ (currentVideoDetails.recommend_count || 0) }}</p>
                    <p><strong>赞赏量：</strong>{{ (currentVideoDetails.admire_count || 0) }}</p>
                    <p><strong>下载量：</strong>{{ (currentVideoDetails.download_count || 0) }}</p>
                    <p><strong>互动率：</strong>{{
                        currentVideoDetails.engagement_rate_formatted || (currentVideoDetails.engagement_rate ? (parseFloat(currentVideoDetails.engagement_rate) * 100).toFixed(2) + '%' : '0%')
                      }}</p>
                  </div>
                </TabPane>

                <TabPane label="AI 深度分析报告" name="suggestions">
                  <div class="detail-section">
                    <h4 class="ai-suggestion-subtitle">AI 深度分析报告</h4>
                    <p class="ai-suggestion-tip">💡 AI 模型智能生成，仅供参考。内容由 AI 大模型基于作品数据深度分析。</p>

                    <!-- 综合优化建议 -->
                    <div class="optimization-tips"
                         v-if="currentVideoDetails.optimization_tips"
                         v-html="formatOptimizationTips(currentVideoDetails.optimization_tips)"></div>

                    <!-- 内容质量评分 -->
                    <div v-if="currentVideoDetails.content_evaluation" class="ai-detail-section">
                      <h4 class="ai-suggestion-subtitle">📋 内容质量评分</h4>
                      <p class="ai-suggestion-content">{{ currentVideoDetails.content_evaluation }}</p>
                    </div>

                    <!-- 数据表现分析 -->
                    <div v-if="currentVideoDetails.data_analysis" class="ai-detail-section">
                      <h4 class="ai-suggestion-subtitle">📊 数据表现分析</h4>
                      <p class="ai-suggestion-content">{{ currentVideoDetails.data_analysis }}</p>
                    </div>

                    <!-- 优化方向 -->
                    <div v-if="currentVideoDetails.optimization_directions" class="ai-detail-section">
                      <h4 class="ai-suggestion-subtitle">🎯 优化方向</h4>
                      <p class="ai-suggestion-content">{{ currentVideoDetails.optimization_directions }}</p>
                    </div>

                    <!-- 推荐话题标签 -->
                    <div v-if="currentVideoDetails.hashtag_suggestions" class="ai-detail-section">
                      <h4 class="ai-suggestion-subtitle"># 推荐话题标签</h4>
                      <p class="ai-suggestion-content">{{ currentVideoDetails.hashtag_suggestions }}</p>
                    </div>

                    <!-- 发布时间建议 -->
                    <div v-if="currentVideoDetails.posting_time_advice" class="ai-detail-section">
                      <h4 class="ai-suggestion-subtitle">⏰ 发布时间建议</h4>
                      <p class="ai-suggestion-content">{{ currentVideoDetails.posting_time_advice }}</p>
                    </div>

                    <!-- 竞品对标分析 -->
                    <div v-if="currentVideoDetails.competition_analysis" class="ai-detail-section">
                      <h4 class="ai-suggestion-subtitle">⚔️ 竞品对标分析</h4>
                      <p class="ai-suggestion-content">{{ currentVideoDetails.competition_analysis }}</p>
                    </div>

                    <!-- AI 推荐新标题 -->
                    <div v-if="currentVideoDetails.ai_title" class="ai-titles-section">
                      <h4 class="ai-suggestion-subtitle">AI 推荐新标题（点击复制）</h4>
                      <div class="ai-titles-list">
                        <div v-for="(t, i) in (currentVideoDetails.ai_title || '').split('|').filter(Boolean)"
                             :key="i"
                             class="ai-title-item"
                             @click="copyAiTitle(t.trim())">
                          {{ t.trim() }}
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>

                <TabPane label="其他信息" name="other">
                  <div class="detail-section">
                    <p><strong>作品热搜词：</strong>{{ formatHotWords(currentVideoDetails.hot_words) }}</p>
                    <p><strong>发布时间：</strong>{{
                        currentVideoDetails.create_time_formatted || currentVideoDetails.publish_time || '无时间'
                      }}</p>
                    <p><strong>查询时间：</strong>{{
                        currentVideoDetails.last_query_time || new Date().toLocaleString()
                      }}</p>
                    <p><strong>查询次数：</strong>{{ currentVideoDetails.query_count || 0 }}</p>
                  </div>
                </TabPane>
              </Tabs>
            </div>

            <div v-else>
              <p>暂无视频详情</p>
            </div>
            <!-- 新增：跳转到抖音官网的按钮 -->
            <div class="modal-action-bar">
              <Button
                  type="warning"
                  size="large"
                  :loading="aiAnalyzing"
                  :disabled="aiAnalyzing"
                  @click="triggerAiAnalysis(currentVideoDetails)"
                  class="modal-action-btn modal-action-btn-primary"
              >
                <Icon type="md-flame" />
                <span v-if="!aiAnalyzing">AI 优化建议分析</span>
                <span v-else>AI 分析中...</span>
              </Button>

              <Button
                  type="primary"
                  size="large"
                  @click="handleVideoIdClick(currentVideoDetails.aweme_id)"
                  class="modal-action-btn"
              >
                跳转到官网
              </Button>

              <Button
                  type="success"
                  size="large"
                  @click="copyLink(currentVideoDetails.aweme_id)"
                  class="modal-action-btn"
              >
                复制作品链接
              </Button>
            </div>

          </Modal>
        </div>


        <!-- 大图模态框 -->
        <Modal
            v-model="isLargeImageModalVisible"
            :footer-hide="true"
            title="查看大图"
            width="100%"
            :style="{ height: '90vh', overflow: 'hidden' }"
            class="full-screen-modal"
        >
          <div style="display: flex; justify-content: center; align-items: center; height: 100%; padding: 20px;">
            <img
                :src="largeImageUrl"
                alt="大图" style="
          max-width: 100%;
          max-height: 90vh;
          height: auto;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
          transition: transform 0.3s ease;
        "
                @click="toggleFullScreen"
            />
          </div>
        </Modal>


        <!-- 作者详情 Modal -->
        <Modal
            v-model="showAuthorModal"
            :footer-hide="true"
            title="作者详情"
            width="500"
            class="author-modal"
        >
          <div class="author-modal-content">
            <!-- 左侧头像 -->
            <div class="author-avatar">
              <img
                  v-if="currentAuthorInfo?.author_info?.avatar_url || currentAuthorInfo?.avatar_url"
                  :src="currentAuthorInfo?.author_info?.avatar_url || currentAuthorInfo?.avatar_url"
                  alt="作者头像" style="width: 80px; height: 80px; border-radius: 50%; object-fit: cover;"
              />
              <div v-else class="avatar-placeholder">无头像</div>
            </div>

            <!-- 右侧信息 -->
            <div class="author-info">
              <h3>{{ (currentAuthorInfo?.author_info?.nickname || currentAuthorInfo?.author_nickname) || '未知' }}</h3>
              <p><strong>作者ID：</strong>{{ (currentAuthorInfo?.author_info?.unique_id || currentAuthorInfo?.author_unique_id) || '无' }}</p>
              <p><strong>粉丝数：</strong>{{ (currentAuthorInfo?.author_info?.follower_count || currentAuthorInfo?.follower_count) || 0 }}</p>
              <p><strong>获赞数：</strong>{{ (currentAuthorInfo?.author_info?.total_favorited || currentAuthorInfo?.total_favorited) || 0 }}</p>
              <!--              <p><strong>作品数：</strong>{{ (currentAuthorInfo?.author_info?.aweme_count || currentAuthorInfo?.aweme_count) || 0 }}</p>-->
              <p><strong>创建时间：</strong>{{ currentAuthorInfo?.create_time || '无' }}</p>
            </div>
          </div>

          <!-- 底部按钮 -->
          <div class="modal-footer">
            <Button type="primary" @click="openAuthorPage(currentAuthorInfo?.author_info?.sec_uid || currentAuthorInfo?.sec_uid)">
              跳转到抖音主页
            </Button>
            <Button type="success" @click="copyAuthorLink(currentAuthorInfo?.author_info?.sec_uid || currentAuthorInfo?.sec_uid)">
              复制主页链接
            </Button>
            <Button @click="closeAuthorModal">关闭</Button>
          </div>
        </Modal>

        <Modal 
          v-model="showQueryResultModal" 
          title="查询结果" 
          width="700"
          :mask-closable="false"
          class="query-result-modal"
          @on-ok="handleOk" 
          @on-cancel="handleCancel"
        >
          <div class="query-result-content">
            <!-- 统计信息 -->
            <div class="result-summary">
              <div class="summary-item success">
                <Icon type="ios-checkmark-circle" class="summary-icon" />
                <span class="summary-label">成功:</span>
                <span class="summary-value">{{ successCount }}</span>
              </div>
              <div class="summary-item failed">
                <Icon type="ios-close-circle" class="summary-icon" />
                <span class="summary-label">失败:</span>
                <span class="summary-value">{{ failedCount }}</span>
              </div>
              <div class="summary-item total">
                <Icon type="ios-list" class="summary-icon" />
                <span class="summary-label">总计:</span>
                <span class="summary-value">{{ queryResultList.length }}</span>
              </div>
            </div>

            <!-- 结果表格 -->
            <div class="result-table-wrapper">
              <table class="result-table-modern">
                <thead>
                  <tr>
                    <th class="col-index">序号</th>
                    <th class="col-video-id">视频ID</th>
                    <th class="col-ai-action">AI作品分析</th>
                    <th class="col-status">状态</th>
                    <th class="col-message">失败原因</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="(item, index) in queryResultList" 
                    :key="index"
                    :class="{ 'row-failed': item.status === '失败' }"
                  >
                    <td class="col-index">{{ index + 1 }}</td>
                    <td class="col-video-id">
                      <span class="video-id-text" :title="item.aweme_id">{{ item.aweme_id }}</span>
                    </td>
                    <td class="col-ai-action">
                      <Button
                        v-if="item.status === '成功'"
                        size="small"
                        type="warning"
                        :loading="aiAnalyzing && currentVideoDetails && currentVideoDetails.aweme_id === item.aweme_id"
                        :disabled="aiAnalyzing"
                        class="result-ai-analyze-btn"
                        @click="handleQueryResultAiAnalyze(item)"
                      >
                        <Icon type="md-flame" />
                        <span v-if="!(aiAnalyzing && currentVideoDetails && currentVideoDetails.aweme_id === item.aweme_id)">AI作品分析</span>
                        <span v-else>分析中...</span>
                      </Button>
                      <span v-else class="ai-action-disabled">—</span>
                    </td>
                    <td class="col-status">
                      <span 
                        class="status-badge" 
                        :class="item.status === '失败' ? 'status-failed' : 'status-success'"
                      >
                        <Icon 
                          :type="item.status === '失败' ? 'ios-close-circle' : 'ios-checkmark-circle'" 
                          class="status-icon" 
                        />
                        {{ item.status }}
                      </span>
                    </td>
                    <td class="col-message">
                      <span v-if="item.status === '失败'" class="error-message" :title="item.message">
                        {{ item.message }}
                      </span>
                      <span v-else class="success-mark">✓</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal>

      </div>


    </div>

    <!-- 添加修改密码组件 -->
    <ChangePassword ref="changePasswordModal" />

    <!-- 用户个人资料模态框 -->
    <Modal
        v-model="showUserProfileModal"
        title="用户个人资料"
        width="560"
        :mask-closable="true"
        :footer-hide="true"
        class-name="user-profile-modal"
    >
      <!-- 加载中状态 -->
      <div v-if="userProfileLoading" class="user-profile-loading">
        <Spin size="large"></Spin>
        <p style="margin-top: 12px; color: #909399;">正在加载个人资料...</p>
      </div>

      <!-- 资料内容 -->
      <div v-else class="user-profile-body">
        <!-- 顶部头像+身份标签区 -->
        <div class="user-profile-header">
          <!-- 头像，没有则使用默认头像 -->
          <Avatar :src="userProfile.avatar || require('@/assets/images/default-avatar.png')" size="64" />
          <!-- 用户名和身份标签 -->
          <div class="user-profile-header-info">
            <div class="user-profile-name">
              {{ userProfile.username || '未设置' }}
              <!-- VIP徽章 -->
              <span v-if="userProfile.super_vip_status === 'svip'" class="role-badge super-vip">超级VIP</span>
              <span v-else-if="userProfile.vip_status === 'vip'" class="role-badge vip">VIP</span>
              <span v-else-if="userProfile.is_admin" class="role-badge admin">管理员</span>
              <span v-else class="role-badge normal">普通用户</span>
            </div>
            <div class="user-profile-role">{{ userProfile.role_label }}</div>
          </div>
        </div>

        <!-- 资料详情列表 -->
        <div class="user-profile-list">
          <!-- 用户名 -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-person" /> 用户名</span>
            <span class="profile-value">{{ userProfile.username || '-' }}</span>
          </div>
          <!-- 用户ID -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-finger-print" /> 用户ID</span>
            <span class="profile-value">{{ userProfile.user_id || '-' }}</span>
          </div>
          <!-- 身份标签 -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-medal" /> 身份标签</span>
            <span class="profile-value">
              <!-- 超级VIP显示超级VIP资料 -->
              <template v-if="userProfile.super_vip_status === 'svip'">
                <span class="highlight-svip">超级VIP会员</span>
                <span class="profile-sub" v-if="userProfile.super_vip_expire_time">
                  （到期时间：{{ userProfile.super_vip_expire_time }}）
                </span>
              </template>
              <!-- 普通VIP显示VIP资料 -->
              <template v-else-if="userProfile.vip_status === 'vip'">
                <span class="highlight-vip">VIP会员</span>
                <span class="profile-sub" v-if="userProfile.vip_expire_time">
                  （到期时间：{{ userProfile.vip_expire_time }}）
                </span>
              </template>
              <!-- VIP已过期 -->
              <template v-else-if="userProfile.vip_status === 'expired' || userProfile.super_vip_status === 'expired'">
                <span class="highlight-expired">VIP已过期</span>
              </template>
              <!-- 非VIP显示点数 -->
              <template v-else>
                <span class="highlight-normal">普通用户</span>
                <span class="profile-sub">（当前点数：{{ userProfile.points || userProfile.balance || 0 }}）</span>
              </template>
            </span>
          </div>
          <!-- 注册邮箱 -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-mail" /> 注册邮箱</span>
            <span class="profile-value">{{ userProfile.email || '-' }}</span>
          </div>
          <!-- 当前点数/余额 -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="logo-yen" /> 剩余点数</span>
            <span class="profile-value highlight-points">{{ userProfile.points || userProfile.balance || 0 }} 点</span>
          </div>
          <!-- 今日查询次数（仅VIP/超级VIP用户展示等级限额；非VIP用户以实际今日调用次数显示） -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-pulse" /> 今日查询</span>
            <span class="profile-value">
              <!-- 超级VIP或有daily_limit，显示"已用/限额（剩X次）" -->
              <template v-if="userProfile.super_vip_status === 'svip' || userProfile.vip_status === 'vip' || userProfile.daily_limit > 0">
                <span class="highlight-today">
                  {{ userProfile.today_used }} / {{ userProfile.daily_limit }} 次
                </span>
                <span class="profile-sub">
                  （剩 {{ userProfile.today_remaining || 0 }} 次）
                </span>
              </template>
              <!-- 非VIP用户：无每日限额概念，仅展示今日已查询次数 -->
              <template v-else>
                <span class="highlight-normal">
                  今日已查询 {{ userProfile.today_used || 0 }} 次
                </span>
              </template>
            </span>
          </div>
          <!-- 是否超级VIP -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-medal" /> 是否超级VIP</span>
            <span class="profile-value">
              <span :class="userProfile.is_super_vip ? 'highlight-yes' : 'highlight-no'">
                {{ userProfile.is_super_vip ? '是' : '否' }}
              </span>
            </span>
          </div>
          <!-- 注册地IP -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-globe" /> 注册地IP</span>
            <span class="profile-value">{{ userProfile.register_ip || '-' }}</span>
          </div>
          <!-- 区域 -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-pin" /> 区域</span>
            <span class="profile-value">{{ userProfile.register_region || '未知地区' }}</span>
          </div>
          <!-- 是否管理员 -->
          <div class="profile-row" v-if="userProfile.is_admin">
            <span class="profile-label"><Icon type="ios-shield-checkmark" /> 管理员</span>
            <span class="profile-value highlight-yes">是</span>
          </div>
          <!-- 注册时间 -->
          <div class="profile-row">
            <span class="profile-label"><Icon type="ios-time" /> 注册时间</span>
            <span class="profile-value">{{ userProfile.created_at || '-' }}</span>
          </div>
          <!-- 最后登录时间 -->
          <div class="profile-row" v-if="userProfile.last_login_time">
            <span class="profile-label"><Icon type="ios-clock" /> 最后登录</span>
            <span class="profile-value">{{ userProfile.last_login_time }}</span>
          </div>
        </div>

        <!-- 底部操作按钮 -->
        <div class="user-profile-footer">
          <Button type="primary" size="small" @click="showUserProfileModal = false">关闭</Button>
        </div>
      </div>
    </Modal>

    <!-- IP白名单设置模态框 -->
    <Modal
        v-model="showIpWhitelistModal"
        title="API请求IP白名单设置"
        @on-ok="saveIpWhitelist"
        @on-cancel="cancelIpWhitelist"
        :loading="ipWhitelistLoading"
    >
      <div class="ip-whitelist-form">
        <p>请输入允许访问的IP地址，每行一个IP。</p>
        <textarea
            v-model="ipWhitelistInput"
            class="ip-whitelist-textarea"
            placeholder="例如：
                    10.0.0.1
                    203.123.45.67"
            rows="8"
        ></textarea>

        <div class="current-ip">
          <p>您当前的IP地址:
            <template v-if="currentIp">
              <strong>{{ currentIp }}</strong>
            </template>
            <template v-else>
              <strong class="loading-text">正在获取中...</strong>
              <span class="loading-dots"></span>
            </template>
          </p>
        </div>

      </div>
    </Modal>

    <!-- 在模板中的其他模态框后面添加 -->
    <!-- 批量导入模态框 -->
    <Modal
        v-model="showBatchImportModal"
        title="主页链接作品批量导入"
        :width="batchImportModalWidth"
        :footer-hide="true"
        :mask-closable="false"
    >
      <div class="batch-import-container">
        <!-- 链接输入区域 -->
        <div v-if="parsedAuthors.length === 0" class="link-input-section">
          <!-- 提示信息：说明如何输入链接 -->
          <p style="margin-bottom: 10px; color: #666;">
            请输入主页链接，多个链接请用换行分隔
          </p>
          <!-- 文本域：用户输入主页链接 -->
          <Input
              v-model="batchImportLinks"
              type="textarea"
              :rows="6"
              placeholder="请输入主页链接，每行一个&#10;例如：&#10;https://v.douxxxx.com/Csof5z6jvrQ/;&#10;https://v.douxxxx.com/fnfjnfjff/"          style="margin-bottom: 15px;"
          />
          <!-- 操作按钮区域 -->
          <div style="text-align: right;">
            <!-- 取消按钮 -->
            <Button @click="showBatchImportModal = false" style="margin-right: 10px;">取消</Button>
            <!-- 解析链接按钮 -->
            <Button
                type="primary"
                @click="parseHomeLinks"
                :loading="isParsingLinks"
                :disabled="!batchImportLinks.trim()"
            >
              {{ isParsingLinks ? '解析中...' : '解析链接' }}
            </Button>
          </div>
        </div>

        <!-- 作者选择和作品展示区域 -->
        <!-- 修改作者选择和作品展示区域 -->
        <div v-else>
          <!-- 作者选择Tabs -->
          <Tabs
              v-model="selectedAuthorIndex"
              type="card"
              @on-click="switchAuthor"          style="margin-bottom: 20px;"
          >
            <!-- 为每个作者创建一个TabPane -->
            <TabPane
                v-for="(author, index) in parsedAuthors"
                :key="author.id"
                :label="author.nickname"
                :name="index"
            >
              <!-- 作者信息展示区域 -->
              <div class="author-info">
                <!-- 作者头像和基本信息 -->
                <div style="display: flex; align-items: center; margin-bottom: 15px;">
                  <!-- 作者头像 -->
                  <Avatar :src="author.avatar" size="large" />
                  <!-- 作者昵称和作品数量 -->
                  <div style="margin-left: 15px;">
                    <div style="font-size: 16px; font-weight: bold;">{{ author.nickname }}</div>
                    <div style="color: #666;">作品数量: {{ author.workCount }}</div>
                  </div>
                </div>

                <!-- 全选按钮 -->
                <div style="margin-bottom: 15px;">
                  <Button @click="toggleAllWorks" size="small">
                    {{ authorWorks[parsedAuthors[selectedAuthorIndex]?.id] && authorWorks[parsedAuthors[selectedAuthorIndex].id].works.every(w => w.isSelected) ? '取消全选' : '全选作品' }}
                  </Button>
                </div>
              </div>

              <!-- 作品网格展示 -->
              <div class="works-grid">
                <!-- 遍历当前作者的所有作品 -->
                <div
                    v-for="work in (parsedAuthors[selectedAuthorIndex] && authorWorks[parsedAuthors[selectedAuthorIndex].id] ? authorWorks[parsedAuthors[selectedAuthorIndex].id].works : [])"
                    :key="work.aweme_id || work.id"
                    class="work-card"
                    :class="{ selected: work.isSelected }"
                    @click="toggleWorkSelection(work.aweme_id || work.id)"
                >
                  <!-- 作品封面和统计数据 -->
                  <div class="work-cover">
                    <!-- 作品封面图片 -->
                    <img :src="work.cover_url || work.cover" alt="作品封面" v-if="work.cover_url || work.cover" />
                    <div v-else class="no-cover">无封面</div>
                    <!-- 作品统计数据（点赞、评论、分享）
                         使用 formatStatNum 智能缩写：12345 → 1.2万，避免在窄列卡片中挤压 -->
                    <div class="work-stats">
                      <div class="stat-item" :title="`点赞数：${work.digg_count || work.likes || 0}`">
                        <Icon type="md-heart" /> {{ formatStatNum(work.digg_count || work.likes || 0) }}
                      </div>
                      <div class="stat-item" :title="`评论数：${work.comment_count || work.comments || 0}`">
                        <Icon type="md-text" /> {{ formatStatNum(work.comment_count || work.comments || 0) }}
                      </div>
                      <div class="stat-item" :title="`分享数：${work.share_count || work.shares || 0}`">
                        <Icon type="md-share" /> {{ formatStatNum(work.share_count || work.shares || 0) }}
                      </div>
                    </div>
                  </div>
                  <!-- 作品标题 -->
                  <div class="work-title">{{ work.desc || work.title || '无标题' }}</div>

                  <!-- 作品发布时间 -->
                  <div class="work-publish-time" v-if="work.create_time">
                    作品发布时间：{{ new Date(work.create_time * 1000).toLocaleDateString() }}
                  </div>
                </div>
              </div>


              <!-- 分页控制区域 -->
              <div style="margin-top: 20px;">
                <div class="pagination-buttons">
                  <Button @click="goToFirstPage" :disabled="!canGoBack || isPageLoading">
                    <Spin v-if="isPageLoading && pageAction === 'first'" size="small" style="margin-right: 5px;"></Spin>
                    回到第一页
                  </Button>
                  <Button @click="prevPage" :disabled="!canPrev || isPageLoading">
                    <Spin v-if="isPageLoading && pageAction === 'prev'" size="small" style="margin-right: 5px;"></Spin>
                    上一页
                  </Button>
                  <Button @click="nextPage" :disabled="!canNext || isPageLoading">
                    <Spin v-if="isPageLoading && pageAction === 'next'" size="small" style="margin-right: 5px;"></Spin>
                    下一页
                  </Button>
                </div>
                <!-- 原有按钮 -->
                <div style="text-align: right;">
                  <!-- 重新输入链接按钮 -->
                  <Button @click="parsedAuthors = []; authorWorks = []; resetAllPagination()" style="margin-right: 10px;">
                    重新输入链接
                  </Button>
                  <!-- 关闭按钮 -->
                  <Button @click="showBatchImportModal = false" style="margin-right: 10px;">
                    关闭
                  </Button>
                  <!-- 开始导入按钮 -->
                  <Button
                      type="primary"
                      @click="startImport"
                      :loading="isImporting"
                    :disabled="!authorWorks[parsedAuthors[selectedAuthorIndex]?.id] || authorWorks[parsedAuthors[selectedAuthorIndex].id].works.filter(w => w.isSelected).length === 0"
                >
                  {{ isImporting ? '导入中...' : '开始导入所有作品' }}
                </Button>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  </Modal>


  <!-- 在模板中的其他模态框后面添加 -->
  <!-- 批量添加模态框 -->
  <Modal
      v-model="showBatchAddModal"
      title="批量添加作品链接"
      width="800"
      :footer-hide="true"
      :mask-closable="false"
  >
    <div class="batch-add-container">
      <!-- 链接输入区域 -->
      <div class="link-input-section">
        <!-- 提示信息 -->
        <p style="margin-bottom: 10px; color: #666;">
          请输入作品链接或ID，多个请用换行分隔
        </p>
        <!-- 文本域：用户输入链接 -->
        <Input
            v-model="batchAddLinks"
            type="textarea"
            :rows="8"
            placeholder="支持以下格式：&#10;1. 某音分享链接：https://v.douyin.com/xxxxx&#10;2. 纯数字ID：70859287123456789&#10;每行一个链接或ID"          style="margin-bottom: 15px;"
        />
        <!-- 操作按钮区域 -->
        <div style="text-align: right;">
          <!-- 取消按钮 -->
          <Button @click="showBatchAddModal = false" style="margin-right: 10px;">取消</Button>
          <!-- 添加按钮 -->
          <Button
              type="primary"
              @click="processBatchAdd"
              :loading="isBatchAdding"
              :disabled="!batchAddLinks.trim()"
          >
            {{ isBatchAdding ? '添加中...' : '添加到待查询项' }}
          </Button>
        </div>
      </div>
    </div>
  </Modal>



  <div class="floating-qrcode-container" v-if="!isMobile" >
    <!-- 浮动二维码框 -->
    <div
        v-show="isVisible && !hasUnlockedAnyWork"
        class="qrcode-box"
        @mouseenter="showTooltip"
        @mouseleave="hideTooltip"
    >
      <div class="qrcode-header">
        <span class="qrcode-title">免费领取流量卡，请点击</span>
        <button class="close-btn" @click="closeQrCode" title="关闭广告">×</button>
      </div>
      <div class="qrcode-content">
        <a
            href="https://hy.yunhaoka.com/#/pages/micro_store/index?agent_id=c5e7b9b85971eda52210db56129c38e0"
            target="_blank"    style="display: block; text-decoration: none;"
        >
        <img :src="qrCodeUrl" alt="免费领取流量卡" class="qrcode-img" />
        </a>
      </div>
<!--      <div class="qrcode-footer">
        <p class="qrcode-desc">扫码添加，获取更多服务</p>
      </div>-->
    </div>

    <!-- 悬浮触发器（可选） -->
<!--    <div class="floating-trigger" @click="toggleQrCode">
      <i class="icon-wechat"></i>
    </div>-->
  </div>

</template>

<script>
import ChangePassword from './ChangePassword.vue';
import MonitorData from './monitorData.vue';
import VipRecharge from './VipRecharge.vue'; // VIP充值组件
import Recharge from './Recharge.vue'; // 充值组件（包含VIP和点数）
import WeightQuery from './WeightQuery.vue'; // 账号权重查询组件
import apiClient from '@/api/index';
// 导入HTTP客户端库，用于发送网络请求
// 导入自定义的登录模态框组件
import LoginModal from './LoginModal.vue';
// 从View UI Plus库中导入Button和Table组件
/*import {Button, Modal, Table, TabPane, Tabs} from 'view-ui-plus';*/
import { Modal, Button, Input, Tabs, TabPane, Avatar, Icon,Table,Spin } from 'view-ui-plus';
// 导入View UI Plus的样式文件
import 'view-ui-plus/dist/styles/viewuiplus.css';
// 导入xlsx库，用于Excel文件的导出功能
import * as XLSX from 'xlsx';
import { Signature } from '@/utils/signature';

// 导出默认Vue组件
export default {
  // 组件名称，用于调试和递归组件
  name: 'TiktokQuery',

  // 注册组件，使它们在模板中可用
  components: {
    Modal,// View UI Plus模态框组件
    LoginModal,  // 登录模态框组件
    Button,      // View UI Plus按钮组件
    Table,        // View UI Plus表格组件
    Tabs,// View UI Plus标签页组件
    TabPane,// View UI Plus标签页组件
    ChangePassword,// 修改密码组件
    MonitorData,// 作品数据监控组件
    VipRecharge, // VIP充值组件
    Recharge, // 充值组件（包含VIP和点数）
    Avatar,
    Input,
    Icon,
    Spin,  // 添加 Spin 组件
    WeightQuery // 账号权重查询组件
  },

  // 组件数据，返回一个函数，确保每个实例都有独立的数据
  data() {
    return {
      activeTab: 'basic', // 默认选中"基本信息"标签页
      isVisible: true,
      qrCodeUrl: require('@/assets/images/guanggao.jpg'), // 替换为您的广告图
      isPageLoading: false,        // 分页加载状态
      pageAction: '',              // 当前分页操作类型
      // 为每个作者维护独立的分页状态
      authorPagination: {}, // 存储每个作者的分页状态 {authorId: {hasNextPage, hasPrevPage, cursorHistory, currentCursor}}

      // 批量导入分页相关属性

      currentCursor: '',        // 当前游标
      hasNextPage: false,       // 是否还有下一页
      hasPrevPage: false,       // 是否有上一页
      pageHistory: [],          // 页面历史记录（用于返回上一页）
      currentPageIndex: 0,      // 当前页面索引

      // 批量添加模态框相关
      showBatchAddModal: false,        // 控制批量添加模态框显示
      batchAddLinks: '',               // 批量添加的链接内容
      isBatchAdding: false,            // 是否正在批量添加

      // 控制批量导入模态框显示
      showBatchImportModal: false,
      // 批量导入的主页链接
      batchImportLinks: '',
      // 解析出的作者列表
      parsedAuthors: [],
      // 当前选中的作者索引
      selectedAuthorIndex: 0,
      // 各作者的作品列表
      authorWorks: [],
      // 是否正在解析链接
      isParsingLinks: false,
      // 是否正在导入
      isImporting: false,

      showIpWhitelistModal: false,     // 控制IP白名单模态框显示
      ipWhitelistLoading: false,       // IP白名单保存加载状态
      ipWhitelistInput: '',            // IP白名单输入内容
      currentIp: '',                   // 当前用户IP地址


      isVipStatusLoaded: false, // 新增：标识VIP状态是否已加载完成
      vipStatus: {
        is_vip: false,// 是否是会员
        is_super_vip: false, // 是否是超级会员
        package_name: '', // 套餐名称
        end_date: '', // 到期时间
        expire_time: '',// 会员到期时间（兼容旧字段）
        start_date: '', // 开始时间
        days_left: 0, // 剩余天数
        daily_limit: 0, // 每日限额
        used_today: 0, // 今日已用
        remaining_today: 0 // 今日剩余
      },
      vipPackages: [],// 会员套餐数据
      vipPackagesList: [], // 新增：用于存储所有VIP套餐列表
      showVipModal: false,// 控制会员模态框的显示状态
      
      allowPointRecharge: false, // 是否允许点数充值（后台控制）

      // 查询加载状态
      showQueryLoading: false,

      isCheckingLoginStatus: true, // 添加检查状态 主要用来控制登录状态的显示和隐藏
      isBatchQuerying: false, // 是否正在进行批量查询
      showQueryResultModal: false, // 控制查询结果 Modal 的显示状态，默认为 false（隐藏）
      queryResultList: [],         // 存储查询结果的列表
      showAuthorModal: false,           // 控制作者模态框显示状态
      currentAuthorInfo: null,          // 当前选中的作者信息
      isLargeImageModalVisible: false, // 控制大图模态框的显示状态
      largeImageUrl: '',               // 当前显示的大图 URL
      showResultLogo: false, // 是否显示查询结果 logo
      resultLogoSrc: '', // 当前显示的 logo 图片路径
      showDetailModal: false,         // 控制 Modal 显示状态
      currentVideoDetails: {},        // 当前作品详细数据
      isLoginModalClosed: false,      // 登录模态框是否已关闭，用于控制内容的禁用状态
      isMobile: false,                // 是否为移动设备，用于响应式布局
      showSidebar: false,             // 是否显示侧边栏，用于移动端侧边栏的显示控制
      windowWidth: 0,                 // 窗口宽度，用于检测屏幕尺寸变化
      allDataItems: [],               // 所有数据项，包含从API获取的所有查询结果
      currentPage: 1,                 // 当前页码，用于分页功能
      pageSize: 9,                   // 每页显示条数（PC端），用于分页功能
      pageSizeOptions: [9, 20, 50, 100], // 每页条数选项
      mobilePageSize: 3,             // 移动端每页显示条数
      mobilePageSizeOptions: [3, 5, 10, 20], // 移动端每页条数选项
      total: 0,                       // 数据总条数，用于分页计算
      loading: false,                 // 是否正在加载，用于显示加载状态
      isAllSelected: false,           // 是否全选，用于全选按钮的状态控制
      selectedItems: [],              // 已选中的项目，用于批量操作
      username: '',                   // 用户名，显示当前登录用户
      queryBalance: 0,                // 查询余额，显示用户剩余查询次数
      inputValue: '',                 // 输入框值，用于添加查询项
      isPlaying: true,                // 是否播放，控制查询时是否增加播放量
      aiAnalyzing: false,             // AI作品优化分析中状态
      aiAnalyzed: false,              // 标记当前作品是否已进行过AI分析
      isBatchAiAnalyzing: false,      // 批量AI分析中状态
      batchAiProgress: { done: 0, total: 0 }, // 批量AI分析进度
      showAiBatchLoading: false,      // 批量AI分析全屏Loading显示状态
      aiBatchLoadingText: '',         // 批量AI分析Loading提示文字
      showLoginModal: true,           // 是否显示登录模态框，控制登录界面的显示
      isUserLoggedIn: false,          // 用户是否已登录，控制用户状态
      dataItems: [],                  // 当前页数据，用于表格显示
      resizeTimer: null,          // 用于防抖的定时器
      userAgent: '',              // 用户代理字符串
      purchaseOptions: [              // 充值选项，显示给用户的选择
        {times: 100, price: 9.9},      // 100次查询10元
        {times: 200, price: 17.9},      // 200次查询18元
        {times: 500, price: 39.9},      // 500次查询40元
        {times: 1000, price: 74.9}      // 1000次查询75元
      ],
      siteInfo: {
        site_name: '',
        site_description: '',
        contact_phone: '',
        contact_email: '',
        allow_point_recharge: true // 默认值设为 true 或 false 都可以
      },
      isSiteInfoLoaded: false, // 新添加：标识网站信息是否已加载完成
      // 移动端无限滚动相关属性
      mobileVisibleCount: 3,          // 移动端初始可见的数据项数量
      mobileLoadIncrement: 3,         // 移动端每次加载的数据项数量
      mobileCurrentLoadedCount: 3,    // 移动端当前已加载的数据项数量

      // 移动端搜索功能相关属性
      mobileSearchQuery: '',          // 移动端搜索关键词
      mobileSearchResults: [],        // 移动端搜索结果
      isMobileSearching: false,       // 移动端是否正在搜索
      mobileSearchTimer: null,        // 移动端搜索防抖定时器

      // 新增：皮肤切换相关
      currentTheme: 'starry',         // 当前主题：classic经典, starry星空, blue蓝色, purple紫色, green绿色, red红色, orange橙色
      themeOptions: [
        { name: 'default', label: '经典' },
        { name: 'starry', label: '星空' },
        { name: 'blue', label: '蓝色' },
        { name: 'purple', label: '紫色' },
        { name: 'green', label: '绿色' },
        { name: 'red', label: '红色' },
        { name: 'orange', label: '橙色' }
      ],

      // 新增：全屏显示相关
      isFullscreen: false,            // 是否全屏显示

      // 新增：菜单激活状态
      activeMenu: 'query',            // 当前激活的菜单：query数据查询, monitor作品数据监控, recharge用户充值, settings系统设置

      // 新增：用户下拉菜单显示控制
      userDropdownVisible: false,     // 控制用户下拉菜单的显示状态

      // 新增：用户个人资料模态框相关
      showUserProfileModal: false,    // 是否显示用户个人资料模态框
      userProfileLoading: false,      // 加载用户资料的loading状态
      userProfile: {                  // 用户个人资料对象
        user_id: 0,                   // 用户ID
        username: '',                 // 用户名
        email: '',                    // 注册邮箱
        phone: '',                    // 手机号
        avatar: '',                   // 头像URL
        balance: 0,                   // 余额/点数
        points: 0,                    // 点数
        register_ip: '',              // 注册IP
        register_region: '',          // 注册地区
        is_vip: false,                // 是否VIP
        vip_expire_time: '',          // VIP到期时间
        vip_package_name: '',         // VIP套餐名称
        vip_daily_limit: 0,           // VIP每日限额
        is_super_vip: false,          // 是否超级VIP
        super_vip_expire_time: '',    // 超级VIP到期时间
        super_vip_daily_limit: 0,     // 超级VIP每日限额
        is_admin: false,              // 是否管理员
        created_at: '',               // 注册时间
        last_login_time: '',          // 最后登录时间
        qq: '',                       // QQ
        wechat: '',                   // 微信
        vip_status: 'normal',         // VIP状态：normal/vip/expired
        super_vip_status: 'normal',   // 超级VIP状态
        role_label: '普通用户',       // 身份标签
        // 今日查询相关（后端新增）
        today_used: 0,                // 今日已用查询次数
        today_remaining: 0,           // 今日剩余查询次数
        daily_limit: 0,               // 每日查询总限额
      },

      tableColumns: [
        {
          type: 'selection', // 类型：选择列，用于多选功能
          width: this.isMobile ? 50 : 40, // 移动端列宽增加，确保可点击
          align: 'center', // 内容对齐方式：居中对齐
        },
        {
          title: '序号', // 列标题：显示当前行的序号
          width: this.isMobile ? '5px' : '60px', // PC端列宽增大
          align: 'center', // 内容对齐方式：居中对齐
          render: (h, params) => {
            const index = (this.currentPage - 1) * this.currentPageSize + params.index + 1;
            return h('span', index); // 返回虚拟DOM节点，显示序号
          }
        },
        {
          title: '作品信息', // 列标题：分组显示作品相关信息
          align: 'center', // 内容对齐方式：居中对齐
          children: [ // 子列配置
            {
              title: '作品ID', // 子列标题：显示作品的唯一标识符
              slot: 'aweme_id', // 指定列使用 scoped slot
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 120 : 200, // PC端列宽增大
            },
            {
              title: '流量池', // 子列标题：显示流量池信息
              key: 'traffic_pool_desc', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 120, // PC端列宽增大
              render: (h, params) => {
                const pool = params.row.traffic_pool_desc || params.row.traffic_pool || '未知';
                return h('span', pool);
              }
            },
            {
              title: '优化建议', // 子列标题：显示是否有优化建议
              key: 'optimization_tips', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 120, // PC端列宽增大
              render: (h, params) => {
                const hasTips = params.row.optimization_tips && params.row.optimization_tips.length > 0;
                return h('span', {
                  style: {
                    color: hasTips ? '#1890ff' : '#999'
                  }
                }, hasTips ? '有建议[点击下展开]' : '无建议');
              }
            },
            {
              title: 'AI推荐标题', // 子列标题：AI生成的推荐标题
              key: 'ai_title', // 数据键名
              align: 'center',
              width: this.isMobile ? 100 : 200,
              render: (h, params) => {
                const aiTitle = params.row.ai_title || '';
                if (!aiTitle) return h('span', { style: { color: '#999' } }, '暂无');
                const firstTitle = aiTitle.split('|')[0] || '';
                const shortTitle = firstTitle.length > 15 ? firstTitle.substring(0, 15) + '...' : firstTitle;
                return h('span', {
                  attrs: { title: aiTitle.replace(/\|/g, '\n') },
                  style: {
                    color: '#722ed1',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => this.copyAiTitle(firstTitle.trim())
                  }
                }, shortTitle);
              }
            },
            {
              title: '封面', // 子列标题：显示作品封面图片
              key: 'aweme_cover', // 数据键名：从数据对象中获取 aweme_cover 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 30 : 60, // PC端列宽增大
              render: (h, params) => { // 自定义渲染函数
                let coverUrl = params.row.cover_info?.default_cover || params.row.aweme_cover || ''; // 获取封面URL
                if (!coverUrl) {
                  return h('div', {
                    style: {
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      fontSize: '10px',
                      color: '#999'
                    }
                  }, '无封面');
                }
                return h('div', {
                  style: {
                    width: '40px',
                    height: '50px',
                    backgroundImage: `url("${coverUrl}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '4px',
                    cursor: 'pointer' // 添加鼠标指针样式，提示可点击
                  },
                  onClick: (event) => {
                    event.stopPropagation();
                    this.$Message.info('点击了图片');
                    this.showLargeImage(coverUrl);
                  }
                });
              }
            },
            {
              title: '描述', // 子列标题：显示作品描述
              key: 'desc', // 数据键名：从数据对象中获取 desc 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 120 : 200, // PC端列宽增大
              render: (h, params) => {
                const desc = params.row.desc || '无描述';
                // 截取前30个字符并添加省略号
                const shortDesc = desc.length > 30 ? desc.substring(0, 30) + '...' : desc;
                return h('span', {
                  attrs: {
                    title: desc // 鼠标悬停显示完整描述
                  }
                }, shortDesc);
              }
            },
            {
              title: '分类', // 子列标题：显示作品分类
              key: 'video_category_desc', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const category = params.row.video_category_desc || params.row.video_category || '无';
                return h('span', category);
              }
            },
            {
              title: '形式', // 子列标题：显示作品形式（横屏/竖屏）
              key: 'orientation', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 60 : 80, // PC端列宽增大
              render: (h, params) => {
                const orientation = params.row.orientation || '未知';
                return h('span', orientation);
              }
            },
            {
              title: '时长', // 子列标题：显示视频时长
              key: 'duration_formatted', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const duration = params.row.duration_formatted || '未知';
                return h('span', duration);
              }
            }
          ]
        },

        {
          title: '作者信息', // 列标题：分组显示作者相关信息
          align: 'center', // 内容对齐方式：居中对齐
          children: [ // 子列配置
            {
              title: '作者昵称', // 子列标题：显示作者昵称
              key: 'author_nickname', // 数据键名：从数据对象中获取 author_nickname 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 100 : 180, // PC端列宽增大
              render: (h, params) => {
                const nickname = params.row.owner_nickname || params.row.author_nickname || '无昵称';
                return h('span', {
                  style: {
                    color: '#1890ff',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  },
                  onclick: (event) => {
                    event.stopPropagation();
                    this.handleAuthorClick(params.row);
                  }
                }, nickname);
              }
            },
            {
              title: '作者ID', // 子列标题：显示作者唯一标识符
              key: 'author_unique_id', // 数据键名：从数据对象中获取 author_unique_id 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 100 : 140, // PC端列宽增大
              hidden: this.isMobile, // 在移动端隐藏该列
              render: (h, params) => {
                const author_unique_id = params.row.owner_handle || params.row.author_unique_id || '无';
                return h('span', {
                  style: {
                    color: '#1890ff',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  },
                  onclick: (event) => {
                    event.stopPropagation();
                    this.handleAuthorClick(params.row);
                  }
                }, author_unique_id);
              }
            },
            {
              title: '粉丝数', // 子列标题：显示作者粉丝数
              key: 'follower_count', // 数据键名：从数据对象中获取 follower_count 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.author_info?.follower_count || params.row.follower_count || 0;
                return h('span', (count)); // 显示格式化后的粉丝数
              }
            },
            {
              title: '总获赞数', // 子列标题：显示作者总获赞数
              key: 'total_favorited', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.author_info?.total_favorited || params.row.total_favorited || 0;
                return h('span', (count)); // 显示格式化后的总获赞数
              }
            },
            {
              title: '认证类型', // 子列标题：显示认证类型
              key: 'verification_type_desc', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 120, // PC端列宽增大
              render: (h, params) => {
                const verification = params.row.author_info?.verification_type_desc || params.row.verification_type_desc || '未认证';
                return h('span', verification);
              }
            },
            {
              title: '认证描述', // 子列标题：显示认证描述
              key: 'verification_desc', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 120, // PC端列宽增大
              render: (h, params) => {
                const verificationDesc = params.row.author_info?.verification_desc || params.row.verification_desc || '无';
                return h('span', verificationDesc);
              }
            }
          ]
        },
        {
          title: '作品状态', // 列标题：显示作品状态
          align: 'center', // 内容对齐方式：居中对齐
          children: [
            {
              title: '查询状态', // 子列标题：显示查询状态
              key: 'status', // 数据键名：从数据对象中获取 status 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 60 : 90, // PC端列宽增大
              render: (h, params) => { // 自定义渲染函数
                const isFailed = params.row.status === 'error'; // 判断是否为失败状态
                const isStarryTheme = this.currentTheme === 'starry'; // 判断是否是星空主题

                if (!isFailed) { // 如果不是失败状态
                  return h('div', {
                    style: {
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: isStarryTheme ? '#1e3a2f' : '#d4edda', // 星空主题使用深绿色背景
                      color: isStarryTheme ? '#ffffff' : '#155724', // 星空主题使用纯白色文字
                      fontSize: isStarryTheme ? '13px' : '12px', // 星空主题字号稍大
                      fontWeight: isStarryTheme ? '700' : 'bold', // 星空主题加粗
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 星空主题增加字间距
                      border: isStarryTheme ? '2px solid #34d399' : 'none', // 星空主题添加边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(52, 211, 153, 0.4)' : 'none', // 星空主题添加阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 星空主题添加文字阴影
                    }
                  }, [
                    h('span', {
                      style: {
                        marginRight: '4px',
                        fontWeight: 'bold',
                        fontSize: isStarryTheme ? '14px' : '12px'
                      }
                    }, '✓'),
                    h('span', '成功')
                  ]);
                } else { // 如果是失败状态
                  return h('div', {
                    style: {
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: isStarryTheme ? '#3a1e1e' : '#f8d7da', // 星空主题使用深红色背景
                      color: isStarryTheme ? '#ffffff' : '#721c24', // 星空主题使用纯白色文字
                      fontSize: isStarryTheme ? '13px' : '12px', // 星空主题字号稍大
                      fontWeight: isStarryTheme ? '700' : 'bold', // 星空主题加粗
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 星空主题增加字间距
                      border: isStarryTheme ? '2px solid #fb7185' : 'none', // 星空主题添加边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(251, 113, 133, 0.4)' : 'none', // 星空主题添加阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 星空主题添加文字阴影
                    }
                  }, [
                    h('span', {
                      style: {
                        marginRight: '4px',
                        fontWeight: 'bold',
                        fontSize: isStarryTheme ? '14px' : '12px'
                      }
                    }, '✗'),
                    h('span', '失败')
                  ]);
                }
              }
            },
            {
              title: '限流', // 子列标题：显示是否限流
              key: 'is_limited', // 数据键名：从数据对象中获取 is_limited 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 90, // 列宽：移动端80px，PC端90px
              render: (h, params) => { // 自定义渲染函数：h是createElement函数，params包含行数据
                const isLimited = params.row.is_limited === true || params.row.is_limited === 1; // 判断是否限流：值为true或1表示限流
                const isStarryTheme = this.currentTheme === 'starry'; // 判断是否是星空主题：用于应用不同的样式

                if (isLimited) { // 如果限流状态为"是"
                  // 限流：是 - 红色标签样式（与查询状态失败样式一致）
                  return h('div', { // 创建一个div元素作为标签容器
                    style: { // 定义内联样式对象
                      display: 'inline-flex', // 使用inline-flex布局：元素内联显示且支持flexbox
                      alignItems: 'center', // 垂直居中对齐子元素
                      justifyContent: 'center', // 水平居中对齐子元素
                      padding: '4px 8px', // 内边距：上下4px，左右8px
                      borderRadius: '4px', // 圆角：4px圆角
                      backgroundColor: isStarryTheme ? '#3a1e1e' : '#f8d7da', // 背景色：星空主题用深红色，普通主题用浅红色
                      color: isStarryTheme ? '#ffffff' : '#721c24', // 文字颜色：星空主题用白色，普通主题用深红色
                      fontSize: isStarryTheme ? '13px' : '12px', // 字体大小：星空主题13px，普通主题12px
                      fontWeight: isStarryTheme ? '700' : 'bold', // 字体粗细：星空主题700，普通主题bold
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 字间距：星空主题增加0.5px间距
                      border: isStarryTheme ? '2px solid #fb7185' : 'none', // 边框：星空主题2px红色边框，普通主题无边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(251, 113, 133, 0.4)' : 'none', // 阴影：星空主题红色阴影，普通主题无阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 文字阴影：星空主题黑色阴影增强可读性
                    }
                  }, [
                    h('span', { // 创建第一个span元素：显示图标
                      style: { // 图标样式
                        marginRight: '4px', // 右边距：与文字保持4px间距
                        fontWeight: 'bold', // 加粗显示图标
                        fontSize: isStarryTheme ? '14px' : '12px' // 图标大小：星空主题14px，普通主题12px
                      }
                    }, '✗'), // 显示叉号图标：表示否定/失败状态
                    h('span', '是') // 创建第二个span元素：显示文字"是"
                  ]);
                } else { // 如果限流状态为"否"
                  // 限流：否 - 绿色标签样式（与查询状态成功样式一致）
                  return h('div', { // 创建一个div元素作为标签容器
                    style: { // 定义内联样式对象
                      display: 'inline-flex', // 使用inline-flex布局
                      alignItems: 'center', // 垂直居中对齐子元素
                      justifyContent: 'center', // 水平居中对齐子元素
                      padding: '4px 8px', // 内边距：上下4px，左右8px
                      borderRadius: '4px', // 圆角：4px圆角
                      backgroundColor: isStarryTheme ? '#1e3a2f' : '#d4edda', // 背景色：星空主题用深绿色，普通主题用浅绿色
                      color: isStarryTheme ? '#ffffff' : '#155724', // 文字颜色：星空主题用白色，普通主题用深绿色
                      fontSize: isStarryTheme ? '13px' : '12px', // 字体大小：星空主题13px，普通主题12px
                      fontWeight: isStarryTheme ? '700' : 'bold', // 字体粗细：星空主题700，普通主题bold
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 字间距：星空主题增加0.5px间距
                      border: isStarryTheme ? '2px solid #34d399' : 'none', // 边框：星空主题2px绿色边框，普通主题无边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(52, 211, 153, 0.4)' : 'none', // 阴影：星空主题绿色阴影，普通主题无阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 文字阴影：星空主题黑色阴影增强可读性
                    }
                  }, [
                    h('span', { // 创建第一个span元素：显示图标
                      style: { // 图标样式
                        marginRight: '4px', // 右边距：与文字保持4px间距
                        fontWeight: 'bold', // 加粗显示图标
                        fontSize: isStarryTheme ? '14px' : '12px' // 图标大小：星空主题14px，普通主题12px
                      }
                    }, '✓'), // 显示对勾图标：表示肯定/成功状态
                    h('span', '否') // 创建第二个span元素：显示文字"否"
                  ]);
                }
              }
            },
            {
              title: '删除', // 子列标题：显示是否删除
              key: 'is_deleted', // 数据键名：从数据对象中获取 is_deleted 或 deleted 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 90, // 列宽：移动端80px，PC端90px
              render: (h, params) => { // 自定义渲染函数：h是createElement函数，params包含行数据
                // 判断是否删除：支持三种数据格式（布尔值true、数字1、或deleted字段为true）
                const isDeleted = params.row.is_deleted === true || params.row.deleted === true || params.row.is_deleted === 1;
                const isStarryTheme = this.currentTheme === 'starry'; // 判断是否是星空主题：用于应用不同的样式

                if (isDeleted) { // 如果删除状态为"是"
                  // 删除：是 - 红色标签样式（表示负面状态）
                  return h('div', { // 创建一个div元素作为标签容器
                    style: { // 定义内联样式对象
                      display: 'inline-flex', // 使用inline-flex布局：元素内联显示且支持flexbox
                      alignItems: 'center', // 垂直居中对齐子元素
                      justifyContent: 'center', // 水平居中对齐子元素
                      padding: '4px 8px', // 内边距：上下4px，左右8px
                      borderRadius: '4px', // 圆角：4px圆角
                      backgroundColor: isStarryTheme ? '#3a1e1e' : '#f8d7da', // 背景色：星空主题用深红色，普通主题用浅红色
                      color: isStarryTheme ? '#ffffff' : '#721c24', // 文字颜色：星空主题用白色，普通主题用深红色
                      fontSize: isStarryTheme ? '13px' : '12px', // 字体大小：星空主题13px，普通主题12px
                      fontWeight: isStarryTheme ? '700' : 'bold', // 字体粗细：星空主题700，普通主题bold
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 字间距：星空主题增加0.5px间距
                      border: isStarryTheme ? '2px solid #fb7185' : 'none', // 边框：星空主题2px红色边框，普通主题无边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(251, 113, 133, 0.4)' : 'none', // 阴影：星空主题红色阴影，普通主题无阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 文字阴影：星空主题黑色阴影增强可读性
                    }
                  }, [
                    h('span', { // 创建第一个span元素：显示图标
                      style: { // 图标样式
                        marginRight: '4px', // 右边距：与文字保持4px间距
                        fontWeight: 'bold', // 加粗显示图标
                        fontSize: isStarryTheme ? '14px' : '12px' // 图标大小：星空主题14px，普通主题12px
                      }
                    }, '✗'), // 显示叉号图标：表示否定/失败状态
                    h('span', '是') // 创建第二个span元素：显示文字"是"
                  ]);
                } else { // 如果删除状态为"否"
                  // 删除：否 - 绿色标签样式（表示正面状态）
                  return h('div', { // 创建一个div元素作为标签容器
                    style: { // 定义内联样式对象
                      display: 'inline-flex', // 使用inline-flex布局
                      alignItems: 'center', // 垂直居中对齐子元素
                      justifyContent: 'center', // 水平居中对齐子元素
                      padding: '4px 8px', // 内边距：上下4px，左右8px
                      borderRadius: '4px', // 圆角：4px圆角
                      backgroundColor: isStarryTheme ? '#1e3a2f' : '#d4edda', // 背景色：星空主题用深绿色，普通主题用浅绿色
                      color: isStarryTheme ? '#ffffff' : '#155724', // 文字颜色：星空主题用白色，普通主题用深绿色
                      fontSize: isStarryTheme ? '13px' : '12px', // 字体大小：星空主题13px，普通主题12px
                      fontWeight: isStarryTheme ? '700' : 'bold', // 字体粗细：星空主题700，普通主题bold
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 字间距：星空主题增加0.5px间距
                      border: isStarryTheme ? '2px solid #34d399' : 'none', // 边框：星空主题2px绿色边框，普通主题无边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(52, 211, 153, 0.4)' : 'none', // 阴影：星空主题绿色阴影，普通主题无阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 文字阴影：星空主题黑色阴影增强可读性
                    }
                  }, [
                    h('span', { // 创建第一个span元素：显示图标
                      style: { // 图标样式
                        marginRight: '4px', // 右边距：与文字保持4px间距
                        fontWeight: 'bold', // 加粗显示图标
                        fontSize: isStarryTheme ? '14px' : '12px' // 图标大小：星空主题14px，普通主题12px
                      }
                    }, '✓'), // 显示对勾图标：表示肯定/成功状态
                    h('span', '否') // 创建第二个span元素：显示文字"否"
                  ]);
                }
              }
            },
            {
              title: '可下载', // 子列标题：显示是否可下载
              key: 'download_allowed', // 数据键名：从数据对象中获取 download_allowed 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 90, // 列宽：移动端80px，PC端90px
              render: (h, params) => { // 自定义渲染函数：h是createElement函数，params包含行数据
                // 判断是否可下载：值为true或1表示可下载
                const isAllowed = params.row.download_allowed === true || params.row.download_allowed === 1;
                const isStarryTheme = this.currentTheme === 'starry'; // 判断是否是星空主题：用于应用不同的样式

                if (isAllowed) { // 如果可下载状态为"是"
                  // 可下载：是 - 绿色标签样式（表示正面状态）
                  return h('div', { // 创建一个div元素作为标签容器
                    style: { // 定义内联样式对象
                      display: 'inline-flex', // 使用inline-flex布局：元素内联显示且支持flexbox
                      alignItems: 'center', // 垂直居中对齐子元素
                      justifyContent: 'center', // 水平居中对齐子元素
                      padding: '4px 8px', // 内边距：上下4px，左右8px
                      borderRadius: '4px', // 圆角：4px圆角
                      backgroundColor: isStarryTheme ? '#1e3a2f' : '#d4edda', // 背景色：星空主题用深绿色，普通主题用浅绿色
                      color: isStarryTheme ? '#ffffff' : '#155724', // 文字颜色：星空主题用白色，普通主题用深绿色
                      fontSize: isStarryTheme ? '13px' : '12px', // 字体大小：星空主题13px，普通主题12px
                      fontWeight: isStarryTheme ? '700' : 'bold', // 字体粗细：星空主题700，普通主题bold
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 字间距：星空主题增加0.5px间距
                      border: isStarryTheme ? '2px solid #34d399' : 'none', // 边框：星空主题2px绿色边框，普通主题无边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(52, 211, 153, 0.4)' : 'none', // 阴影：星空主题绿色阴影，普通主题无阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 文字阴影：星空主题黑色阴影增强可读性
                    }
                  }, [
                    h('span', { // 创建第一个span元素：显示图标
                      style: { // 图标样式
                        marginRight: '4px', // 右边距：与文字保持4px间距
                        fontWeight: 'bold', // 加粗显示图标
                        fontSize: isStarryTheme ? '14px' : '12px' // 图标大小：星空主题14px，普通主题12px
                      }
                    }, '✓'), // 显示对勾图标：表示肯定/成功状态
                    h('span', '是') // 创建第二个span元素：显示文字"是"
                  ]);
                } else { // 如果可下载状态为"否"
                  // 可下载：否 - 红色标签样式（表示负面状态）
                  return h('div', { // 创建一个div元素作为标签容器
                    style: { // 定义内联样式对象
                      display: 'inline-flex', // 使用inline-flex布局
                      alignItems: 'center', // 垂直居中对齐子元素
                      justifyContent: 'center', // 水平居中对齐子元素
                      padding: '4px 8px', // 内边距：上下4px，左右8px
                      borderRadius: '4px', // 圆角：4px圆角
                      backgroundColor: isStarryTheme ? '#3a1e1e' : '#f8d7da', // 背景色：星空主题用深红色，普通主题用浅红色
                      color: isStarryTheme ? '#ffffff' : '#721c24', // 文字颜色：星空主题用白色，普通主题用深红色
                      fontSize: isStarryTheme ? '13px' : '12px', // 字体大小：星空主题13px，普通主题12px
                      fontWeight: isStarryTheme ? '700' : 'bold', // 字体粗细：星空主题700，普通主题bold
                      letterSpacing: isStarryTheme ? '0.5px' : 'normal', // 字间距：星空主题增加0.5px间距
                      border: isStarryTheme ? '2px solid #fb7185' : 'none', // 边框：星空主题2px红色边框，普通主题无边框
                      boxShadow: isStarryTheme ? '0 2px 8px rgba(251, 113, 133, 0.4)' : 'none', // 阴影：星空主题红色阴影，普通主题无阴影
                      textShadow: isStarryTheme ? '0 1px 3px rgba(0, 0, 0, 0.8)' : 'none' // 文字阴影：星空主题黑色阴影增强可读性
                    }
                  }, [
                    h('span', { // 创建第一个span元素：显示图标
                      style: { // 图标样式
                        marginRight: '4px', // 右边距：与文字保持4px间距
                        fontWeight: 'bold', // 加粗显示图标
                        fontSize: isStarryTheme ? '14px' : '12px' // 图标大小：星空主题14px，普通主题12px
                      }
                    }, '✗'), // 显示叉号图标：表示否定/失败状态
                    h('span', '否') // 创建第二个span元素：显示文字"否"
                  ]);
                }
              }
            },

          ]
        },
        {
          title: '数据统计', // 列标题：分组显示数据统计信息
          align: 'center', // 内容对齐方式：居中对齐
          children: [ // 子列配置
            {
              title: '播放(预估值)', // 子列标题：显示播放次数
              key: 'play_count', // 数据键名：从数据对象中获取 play_count 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.play_count || 0; // 获取播放次数，如果没有则为0
                return h('span', (count)); // 显示格式化后的播放次数
              }
            },
            {
              title: '点赞', // 子列标题：显示点赞次数
              key: 'digg_count', // 数据键名：从数据对象中获取 digg_count 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.digg_count || 0; // 获取点赞次数，如果没有则为0
                return h('span', (count)); // 显示格式化后的点赞次数
              }
            },
            {
              title: '评论', // 子列标题：显示评论次数
              key: 'comment_count', // 数据键名：从数据对象中获取 comment_count 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.comment_count || 0; // 获取评论次数，如果没有则为0
                return h('span', (count)); // 显示格式化后的评论次数
              }
            },
            {
              title: '收藏', // 子列标题：显示收藏次数
              key: 'collect_count', // 数据键名：从数据对象中获取 collect_count 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.collect_count || 0; // 获取收藏次数，如果没有则为0
                return h('span', (count)); // 显示格式化后的收藏次数
              }
            },
            {
              title: '转发', // 子列标题：显示转发次数
              key: 'share_count', // 数据键名：从数据对象中获取 share_count 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.share_count || 0; // 获取转发次数，如果没有则为0
                return h('span', (count)); // 显示格式化后的转发次数
              }
            },
            {
              title: '下载', // 子列标题：显示下载次数
              key: 'download_count', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.download_count || 0;
                return h('span', (count));
              }
            },
            {
              title: '推荐', // 子列标题：显示推荐次数
              key: 'recommend_count', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.recommend_count || 0;
                return h('span', (count));
              }
            },
            {
              title: '赞赏', // 子列标题：显示赞赏次数
              key: 'admire_count', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const count = params.row.admire_count || 0;
                return h('span', (count));
              }
            }
          ]
        },
        {
          title: '时间信息', // 列标题：分组显示时间相关数据
          align: 'center', // 内容对齐方式：居中对齐
          children: [ // 子列配置
            // {
            //   title: '查询时间', // 子列标题：显示作品创建时间
            //   key: 'create_time', // 数据键名：从数据对象中获取 create_time 字段
            //   align: 'center', // 内容对齐方式：居中对齐
            //   width: this.isMobile ? 120 : 180 // PC端列宽增大
            // },
            {
              title: '查询时间', // 子列标题：显示最后一次查询的时间
              key: 'last_query_time', // 数据键名：从数据对象中获取 last_query_time 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 120 : 180 // PC端列宽增大
            },
            {
              title: '发布时间', // 子列标题：显示视频发布时间
              key: 'create_time', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 120 : 180 // PC端列宽增大
            }
          ]
        },
        {
          title: '其他指标', // 列标题：分组显示其他信息
          align: 'center', // 内容对齐方式：居中对齐
          children: [ // 子列配置
            // {
            //   title: '刷新次数', // 子列标题：显示作品被刷新的次数
            //   key: 'query_count', // 数据键名：从数据对象中获取 query_count 字段
            //   align: 'center', // 内容对齐方式：居中对齐
            //   width: this.isMobile ? 80 : 100 // PC端列宽增大
            // },
            {
              title: '企业认证', // 子列标题：显示企业认证信息
              key: 'enterprise_verify_reason', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 100 : 150, // PC端列宽增大
              render: (h, params) => {
                const enterpriseVerify = params.row.author_info?.enterprise_verify_reason || params.row.enterprise_verify_reason || '无';
                return h('span', {
                  attrs: {
                    title: enterpriseVerify // 鼠标悬停显示完整信息
                  }
                }, enterpriseVerify);
              }
            },
            {
              title: '播放指数', // 子列标题：显示播放指数
              key: 'play_index', // 数据键名：从数据对象中获取 play_index 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const index = params.row.play_index || 0; // 获取播放指数，如果没有则为0
                return h('span', index); // 显示播放指数
              }
            },
            {
              title: '互动率', // 子列标题：显示互动率
              key: 'engagement_rate_formatted', // 数据键名：从数据对象中获取 engagement_rate_formatted 字段
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const rate = params.row.engagement_rate_formatted ||
                    (params.row.engagement_rate ? (parseFloat(params.row.engagement_rate) * 100).toFixed(2) + '%' : '0%');
                return h('span', rate); // 显示互动率
              }
            },
            {
              title: '加权互动率', // 子列标题：显示加权互动率
              key: 'weighted_engagement_rate_formatted', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 80 : 100, // PC端列宽增大
              render: (h, params) => {
                const rate = params.row.weighted_engagement_rate_formatted || '0%';
                return h('span', rate); // 显示加权互动率
              }
            },


            {
              title: '热搜词', // 子列标题：显示热搜词
              key: 'hot_words', // 数据键名
              align: 'center', // 内容对齐方式：居中对齐
              width: this.isMobile ? 100 : 300, // PC端列宽增大
              render: (h, params) => {
                let hotWords = params.row.hot_words || [];
                // 如果是字符串，尝试解析为数组
                if (typeof hotWords === 'string') {
                  try {
                    hotWords = JSON.parse(hotWords);
                  } catch (e) {
                    hotWords = [hotWords];
                  }
                }

                // 确保是数组
                if (!Array.isArray(hotWords)) {
                  hotWords = [];
                }

                // 只显示前3个热搜词，避免列过宽
                const displayWords = hotWords.slice(0, 10);
                const displayText = displayWords.join(', ') || '无';

                return h('span', {
                  attrs: {
                    title: hotWords.join(', ') // 鼠标悬停时显示完整列表
                  }
                }, displayText);
              }
            }
          ]
        },
        {
          title: '带货信息',
          align: 'center',
          children: [
            {
              title: '是否带货',
              key: 'is_product_video',
              align: 'center',
              width: this.isMobile ? 60 : 80,
              render: (h, params) => {
                const isProduct = params.row.is_product_video === true || params.row.is_product_video === 1;
                return h('span', {
                  style: {
                    color: isProduct ? '#52c41a' : '#999'
                  }
                }, isProduct ? '是' : '否');
              }
            },
            // 修改表格中产品详情列的 render 函数

// 修改表格中产品详情列的 render 函数
            {
              title: '产品详情',
              key: 'product_details',
              align: 'center',
              width: this.isMobile ? 120 : 200,
              render: (h, params) => {
                // 检查是否为带货视频
                const isProductVideo = params.row.is_product_video === true || params.row.is_product_video === 1;

                if (!isProductVideo) {
                  return h('span', {
                    attrs: {
                      title: '非带货视频' // 鼠标悬停显示完整信息
                    }
                  }, '非带货视频');
                }

                // 获取产品详情
                const productDetails = params.row.product_details;

                if (!productDetails) {
                  return h('span', {
                    attrs: {
                      title: '暂无详情' // 鼠标悬停显示完整信息
                    }
                  }, '暂无详情');
                }

                // 构建产品信息显示内容 - 根据新结构改进逻辑
                let displayParts = [];

                // 添加产品类型
                if (productDetails.product_type) {
                  displayParts.push(productDetails.product_type);
                }

                // 添加销售线索
                if (productDetails.sales_clues) {
                  // 检查是否为布尔值
                  if (typeof productDetails.sales_clues === 'boolean') {
                    displayParts.push(`${productDetails.sales_clues ? '有' : '无'}销售线索`);
                  } else {
                    // 原有的处理方式
                    displayParts.push(`${productDetails.sales_clues}条线索`);
                  }
                }


                // 处理产品信息对象
                if (productDetails.product_info && typeof productDetails.product_info === 'object') {
                  const productInfo = productDetails.product_info;

                  // 添加商品标题
                  if (productInfo.title) {
                    const title = productInfo.title.length > 15
                        ? productInfo.title.substring(0, 15) + '...'
                        : productInfo.title;
                    displayParts.push(title);
                  }

                  // 添加销量信息
                  if (productInfo.sales) {
                    const salesText = productInfo.sales >= 10000
                        ? `${(productInfo.sales / 10000).toFixed(1)}w`
                        : productInfo.sales;
                    displayParts.push(`已售${salesText}`);
                  }
                }

                // 添加促销信息
                if (productDetails.promotional_info && Array.isArray(productDetails.promotional_info) && productDetails.promotional_info.length > 0) {
                  displayParts.push(...productDetails.promotional_info);
                }

                // 如果没有提取到有效信息，显示默认文本
                if (displayParts.length === 0) {
                  displayParts.push('带货视频');
                }

                // 组合显示内容，最多显示3个部分
                let productInfo = displayParts.slice(0, 3).join(' | ');

                // 截取过长的文本
                const displayText = productInfo.length > 20 ? productInfo.substring(0, 20) + '...' : productInfo;

                return h('span', {
                  attrs: {
                    title: productInfo // 鼠标悬停显示完整信息
                  }
                }, displayText);
              }
            }
          ]
        },
        // 操作列：提供查看详情、刷新、删除等操作按钮
        {
          title: '操作', // 列标题：显示操作按钮
          slot: 'action', // 使用 slot 自定义列内容
          align: 'center', // 内容对齐方式：居中对齐
          width: this.isMobile ? 150 : 220, // PC端列宽：220px，移动端：150px
          fixed: this.isMobile ? undefined : 'right' // PC端固定列在右侧
        }
      ],
      pendingItems: [],               // 待查询项列表，存储用户添加但尚未查询的项目
      isRefreshing: false,            // 是否正在刷新全部数据
      isShowDetailModal: false,       // 是否显示详情弹窗
      detailModalData: null           // 详情弹窗数据
    };
  },

  // 计算属性，基于响应式依赖进行缓存
  computed: {
    // 计算模态框标题
    computedModalTitle() {
      return this.currentVideoDetails.aweme_id ? `作品ID: ${this.currentVideoDetails.aweme_id} 的详细信息` : '';
    },

    /**
     * 批量导入 Modal 的响应式宽度
     * 说明：
     *   - 移动端：撑满屏幕宽度（95vw），避免横向滚动
     *   - 小屏 PC（< 1280px）：固定 720px（容纳 3-4 列）
     *   - 中屏 PC（1280-1600px）：固定 800px（容纳 4 列）
     *   - 大屏 PC（>= 1600px）：固定 900px（容纳 4-5 列）
     * 解决：原固定 800px 在大屏下会被拉伸，导致作品网格列数过多，统计数据挤压
     */
    batchImportModalWidth() {
      if (this.isMobile) {
        return '95vw';
      }
      const w = this.windowWidth || (typeof window !== 'undefined' ? window.innerWidth : 1280);
      if (w < 1280) return 720;
      if (w < 1600) return 800;
      return 900;
    },

    // 查询结果统计 - 成功数量
    successCount() {
      return this.queryResultList.filter(item => item.status === '成功').length;
    },

    // 查询结果统计 - 失败数量
    failedCount() {
      return this.queryResultList.filter(item => item.status === '失败').length;
    },

    // 获取已解锁的作品ID集合（从localStorage读取）
    unlockedWorks() {
      try {
        const stored = localStorage.getItem('unlockedWorks');
        return stored ? new Set(JSON.parse(stored)) : new Set();
      } catch (e) {
        console.error('读取解锁数据失败:', e);
        return new Set();
      }
    },

    // 检查是否有任何已解锁的作品
    hasUnlockedAnyWork() {
      return this.unlockedWorks.size > 0;
    },

    // 是否可以返回
    canPrev() {
      const authorId = this.parsedAuthors[this.selectedAuthorIndex]?.id;
      const authorData = this.authorWorks[authorId];
      return authorData && authorData.cursorHistory.length > 1;
    },
    // 是否可以前进
    canNext() {
      const authorId = this.parsedAuthors[this.selectedAuthorIndex]?.id;
      const authorData = this.authorWorks[authorId];
      return authorData && authorData.hasNextPage;
    },
    // 是否可以返回
    canGoBack() {
      // 修改前：return this.selectedAuthorIndex > 0;
      // 修改后：检查当前作者是否有分页历史记录，或者当前不在第一页
      const authorId = this.parsedAuthors[this.selectedAuthorIndex]?.id;
      const authorData = this.authorWorks[authorId];

      // 如果有游标历史记录且长度大于1，说明可以回到第一页
      if (authorData && authorData.cursorHistory && authorData.cursorHistory.length > 1) {
        return true;
      }

      // 或者如果当前游标不为0，也可以回到第一页
      if (authorData && authorData.currentCursor !== 0) {
        return true;
      }

      // 原有逻辑保留
      return this.selectedAuthorIndex > 0;
    },

    // 当前主题名称
    currentThemeName() {
      const theme = this.themeOptions.find(t => t.name === this.currentTheme);
      return theme ? theme.label : '经典';
    },

    // 当前每页显示条数（根据设备类型动态调整）
    currentPageSize() {
      return this.isMobile ? this.mobilePageSize : this.pageSize;
    },

    // 当前总页数
    totalPages() {
      return Math.ceil(this.total / this.currentPageSize);
    },
    
    // 检查是否有失败的查询项
    hasFailedItems() {
      // 检查当前页数据中是否有状态为 error 的项
      return this.dataItems.some(item => item.status === 'error');
    }

  },

  // 【性能优化】生命周期钩子，在实例挂载完成后调用
  // 优化前：7 个 API 请求全部串行 await，总耗时 = sum(全部请求耗时)
  // 优化后：分 3 个阶段并行执行互不依赖的请求，总耗时 ≈ max(每组最慢的请求)
  async mounted() {

    console.log('组件开始挂载...');
    
    // ========== 第一阶段：站点状态检查（必须串行） ==========
    // 站点关闭时请求拦截器会直接跳转关闭页面，后续逻辑不执行
    await this.checkSiteStatus();
    
    // 如果站点关闭，checkSiteStatus会跳转，不会继续执行下面的代码
    
    // 监听token过期事件
    window.addEventListener('tokenExpired', this.handleTokenExpired);
    // 监听被挤下线事件（单设备登录控制）
    window.addEventListener('sessionKickedOut', this.handleSessionKickedOut);
    await this.$nextTick(() => {
      const node = this.$refs.someRef;
      if (node && node.parentNode) {
        console.log(node.parentNode);
      } else {
        console.warn('Node not found or not mounted in the DOM.');
      }
    });

    // 先检查是否为移动设备（必须在加载数据之前，同步操作无开销）
    this.checkIsMobile();
    this.windowWidth = window.innerWidth;

    // ========== 第二阶段：并行发起 4 个互不依赖的异步请求（核心优化） ==========
    // fetchSiteInfo / checkUserLoginStatus / fetchVipPackagesList / fetchCurrentIp 四个请求互不依赖
    // 原代码为串行 await，现在用 Promise.all 并行执行，总耗时 = max(最慢的一个)
    // fetchCurrentIp 用 .catch 包住，即使 IP 服务超时也不阻塞主流程
    await Promise.all([
      this.fetchSiteInfo(),                     // 获取站点基本信息
      this.checkUserLoginStatus(true),          // 检查用户登录状态
      this.fetchVipPackagesList(),              // 获取VIP套餐列表
      this.fetchCurrentIp().catch(() => {}),    // 获取当前IP（失败不阻塞）
    ]);
    // Promise.all 返回后，上述四个方法设置的响应式数据已全部就绪

    // 处理 fetchSiteInfo 的结果
    console.log('allow_point_recharge:', this.siteInfo.allow_point_recharge )
    this.allowPointRecharge = this.siteInfo.allow_point_recharge || false; // 设置是否允许点数充值

    // 处理 checkUserLoginStatus 的结果
    this.isCheckingLoginStatus = false; // 标记登录状态检查完成

    // 定时轮询检测单设备登录状态（每60秒检测是否被挤下线）
    this._sessionCheckTimer = setInterval(() => {
      if (this.isUserLoggedIn) {
        this.checkUserLoginStatus(false);
      }
    }, 60000);

    // 添加窗口大小改变事件监听器，用于响应式布局
    window.addEventListener('resize', this.handleResize);

    // 添加移动端滚动事件监听器
    // 移除移动端滚动加载
    // window.addEventListener('scroll', this.handleMobileScroll);

    // 设置页面标题 - 根据登录状态和当前菜单设置
    if (this.isUserLoggedIn) {
      // 已登录状态，根据当前菜单设置标题
      switch(this.activeMenu) {
        case 'query':
          document.title = '抖数君-AI作品优化建议分析';
          break;
        case 'settings':
          document.title = '抖数君-系统基本设置';
          break;
        case 'monitor':
          document.title = '抖数君-作品数据监控';
          break;
        case 'recharge':
          document.title = '抖数君-用户充值';
          break;
        default:
          document.title = '抖数君-AI作品优化建议分析';
      }
    } else {
      // 未登录状态，使用网站名称
      document.title = this.siteInfo.site_name || '抖数君—AI作品分析建议优化平台';
    }

    // 设置页面描述
    this.setMetaDescription(this.siteInfo.site_description || '默认网站描述');

    const metaTag = document.createElement('meta');
    metaTag.httpEquiv = 'X-UA-Compatible';
    metaTag.content = 'IE=edge,chrome=1';
    document.head.appendChild(metaTag);

    // ========== 第三阶段：登录依赖操作（并行执行） ==========
    // getUserVipStatus 和 loadIpWhitelist 互不依赖，改为 Promise.all 并行
    if (this.isUserLoggedIn) {
      await Promise.all([
        this.getUserVipStatus(),  // 获取VIP状态
        this.loadIpWhitelist(),    // 加载IP白名单数据
      ]);
    } else {
      // 如果未登录，也标记为已加载完成
      this.isVipStatusLoaded = true;
    }

    // 加载保存的主题，如果没有则默认使用星空模式
    const savedTheme = localStorage.getItem('currentTheme');
    if (savedTheme) {
      this.currentTheme = savedTheme;
      console.log('✅ 加载保存的主题:', savedTheme);
    } else {
      // 如果没有保存的主题，默认使用星空模式
      this.currentTheme = 'starry';
      localStorage.setItem('currentTheme', 'starry');
      console.log('✅ 设置默认主题为: starry');
    }

    // 加载保存的每页条数设置
    const savedPageSize = localStorage.getItem('pageSize');
    if (savedPageSize && this.pageSizeOptions.includes(Number(savedPageSize))) {
      this.pageSize = Number(savedPageSize);
      console.log('加载保存的PC端每页条数:', this.pageSize);
    }
    
    // 加载保存的移动端每页条数设置
    const savedMobilePageSize = localStorage.getItem('mobilePageSize');
    if (savedMobilePageSize && this.mobilePageSizeOptions.includes(Number(savedMobilePageSize))) {
      this.mobilePageSize = Number(savedMobilePageSize);
      console.log('加载保存的移动端每页条数:', this.mobilePageSize);
    }
    
    // 如果有数据，需要重新更新分页显示
    if (this.allDataItems.length > 0) {
      this.updatePaginatedData();
    }

    // 初始化 body 的主题类名，让 Modal 等挂载到 body 下的组件也能继承 CSS 变量
    document.body.className = `theme-${this.currentTheme}`;

    // 添加全屏状态变化监听
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);

    // 加载并验证解锁状态（纯本地 localStorage 操作，无需 await）
    this.loadAndValidateUnlockedWorks();

    // 添加点击外部关闭下拉菜单的监听器
    document.addEventListener('click', this.handleClickOutside);

  },

  // 生命周期钩子，在实例销毁之前调用
  beforeDestroy() {
    window.removeEventListener('tokenExpired', this.handleTokenExpired);
    window.removeEventListener('sessionKickedOut', this.handleSessionKickedOut);
    // 清除单设备登录状态检测定时器
    if (this._sessionCheckTimer) {
      clearInterval(this._sessionCheckTimer);
      this._sessionCheckTimer = null;
    }
    if (this.handleEscClose) {
      document.removeEventListener('keydown', this.handleEscClose);
    }
    // 清除防抖定时器
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }

    // 清除移动端搜索定时器
    if (this.mobileSearchTimer) {
      clearTimeout(this.mobileSearchTimer);
    }

    // 移除窗口大小改变事件监听器，防止内存泄漏
    window.removeEventListener('resize', this.handleResize);
    // 移除移动端滚动事件监听器
    // 移除移动端滚动事件
    // window.removeEventListener('scroll', this.handleMobileScroll);
    // 移除全屏状态变化监听
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    // 移除点击外部关闭下拉菜单的监听器
    document.removeEventListener('click', this.handleClickOutside);
    // 清理 body 的主题类名
    document.body.className = '';
  },

  // 组件方法，定义组件的各种功能
  methods: {
    /**
     * 切换主题
     */
    handleThemeChange(themeName) {
      console.log('切换主题为:', themeName);
      this.currentTheme = themeName;
      localStorage.setItem('currentTheme', themeName);
      // 将主题类名应用到 body 元素，确保全局样式生效
      document.body.className = `theme-${themeName}`;
      // 触发自定义事件通知其他组件
      window.dispatchEvent(new CustomEvent('theme-changed', { detail: { theme: themeName } }));
      
      const themeLabel = this.themeOptions.find(t => t.name === themeName)?.label || '经典';
      this.$Message.success(`已切换到${themeLabel}主题`);
    },

    /**
     * 检查站点状态
     */
    async checkSiteStatus() {
      console.log('🔍 检查站点状态...');
      try {
        const response = await apiClient.get('/site/status', {
          params: { platform: 'web' }
        });
        
        console.log('站点状态响应:', response);
        
        // 如果成功到达这里，说明站点正常运行（code=200）
        console.log('✅ 站点正常运行');
        return true;
        
      } catch (error) {
        // 如果是503错误，拦截器已经处理了跳转，不需要额外操作
        if (error.response && error.response.status === 503) {
          console.warn('⚠️ 站点已关闭（HTTP 503），拦截器已处理跳转');
          return false;
        }
        
        // 其他错误，允许继续运行
        console.error(' 检查站点状态失败:', error.message);
        console.warn('⚠️ 降级模式：继续运行应用');
        return true;
      }
    },
    
    /**
     * 处理菜单点击事件
     * @param {string} menu - 菜单名称
     */
    handleMenuClick(menu) {
      console.log('点击菜单:', menu);
      console.log('当前 activeMenu:', this.activeMenu);
      this.activeMenu = menu;
      console.log('设置后 activeMenu:', this.activeMenu);
      
      // 根据菜单项设置浏览器标题
      if (this.isUserLoggedIn) {
        switch(menu) {
          case 'query':
            document.title = '抖数君-AI作品优化建议分析';
            break;
          case 'weight':
            document.title = '抖数君-账号权重查询';
            break;
          case 'settings':
            document.title = '抖数君-系统基本设置';
            // 点击系统基本设置时，异步获取IP地址
            this.fetchCurrentIp();
            break;
          case 'monitor':
            document.title = '抖数君-作品数据监控';
            break;
          case 'recharge':
            document.title = '抖数君-用户充值';
            break;
        }
      }
      
      // 移动端点击菜单项后自动关闭侧边栏
      if (this.isMobile) {
        this.closeSidebar();
      }
    },

    handleOk() {
      console.log('点击了确定');
      this.showQueryResultModal = false;
      this.$nextTick(() => {
        this.switchToSuggestionsTab();
      });
    },
    handleCancel() {
      console.log('点击了取消');
      this.showQueryResultModal = false;
      this.$nextTick(() => {
        this.switchToSuggestionsTab();
      });
    },

    /**
     * 查询结果弹窗中点击"AI作品分析"按钮
     * @param {Object} resultItem - 查询结果行数据，包含 aweme_id
     */
    async handleQueryResultAiAnalyze(resultItem) {
      if (!resultItem || !resultItem.aweme_id) {
        this.$Message.warning('未找到作品ID，无法执行AI分析');
        return;
      }
      const awemeId = resultItem.aweme_id;
      // 先从 allDataItems 中找完整数据
      let video = this.allDataItems.find(it => it.aweme_id === awemeId);
      if (!video) {
        this.$Message.warning('未找到该作品的详细数据，请稍后再试');
        return;
      }
      // 关闭查询结果弹窗，打开详情弹窗并触发 AI 分析
      this.showQueryResultModal = false;
      this.currentVideoDetails = video;
      this.showDetailModal = true;
      await this.$nextTick();
      this.activeTab = 'suggestions';
      this.triggerAiAnalysis(video);
    },

    switchToSuggestionsTab() {
      console.log('准备切换到 suggestions tab');

      this.$nextTick(() => {
        console.log('DOM已更新');
        const tabs = this.$refs.tabs;
        console.log('Tabs组件引用:', tabs);

        if (tabs) {
          console.log('当前activeTab值:', this.activeTab);

          setTimeout(() => {
            this.activeTab = 'suggestions';
            console.log('currentVideoDetails in setTimeout:', this.currentVideoDetails);
          }, 100);

          console.log('已设置activeTab为 suggestions');

          this.showDetailModal = true;


        } else {
          console.warn('Tabs 组件未找到，请检查 ref 是否正确绑定');
        }
      });
    },
    // showTooltip() {
    //   this.isVisible = true;
    // },
    // hideTooltip() {
    //   this.isVisible = false;
    // },
    closeQrCode() {
      this.isVisible = false;
    },
    // toggleQrCode() {
    //   this.isVisible = !this.isVisible;
    // },
    /**
     * 跳转到监控数据页面
     */
    goToMonitorData() {

      // 检查路由是否存在
      const hasRoute = this.$router.hasRoute('MonitorData');

      if (hasRoute) {
        // 在新窗口中打开
        const routeData = this.$router.resolve({
          name: 'MonitorData',

        });
        window.open(routeData.href, '_blank');
      }
    },
    /**
     * 更新分页数据
     */
    updatePaginatedData() {
      // 计算起始索引
      const start = (this.currentPage - 1) * this.currentPageSize;
      // 计算结束索引
      const end = start + this.currentPageSize;
      // 从所有数据中截取当前页数据
      this.dataItems = this.allDataItems.slice(start, end);
    },
    /**
     * 上一页
     */
    async prevPageDyvideodata() {
      // 如果当前页大于1
      if (this.currentPage > 1) {
        // 当前页减1
        this.currentPage--;
        // 更新分页数据
        this.updatePaginatedData();
      }
    },
    /**
     * 下一页
     */
    async nextPageDyvideodata() {
      // 如果当前页小于总页数
      if (this.currentPage < this.totalPages) {
        // 当前页加1
        this.currentPage++;
        // 更新分页数据
        this.updatePaginatedData();
      }
    },
    /**
     * 处理每页条数改变
     */
    handlePageSizeChange() {
      // 保存设置到 localStorage
      localStorage.setItem('pageSize', this.pageSize);
      // 重置到第一页
      this.currentPage = 1;
      // 更新分页数据
      this.updatePaginatedData();
      this.$Message.success(`已设置为每页显示 ${this.pageSize} 条`);
    },
    /**
     * 处理移动端每页条数改变
     */
    handleMobilePageSizeChange() {
      // 保存设置到 localStorage
      localStorage.setItem('mobilePageSize', this.mobilePageSize);
      // 重置到第一页
      this.currentPage = 1;
      // 更新分页数据
      this.updatePaginatedData();
      this.$Message.success(`已设置为每页显示 ${this.mobilePageSize} 条`);
    },


    /**
     * 打开批量添加模态框
     */
    openBatchAddModal() {
      // 检查用户是否已登录
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }

      // 显示模态框 批量添加
      this.showBatchAddModal = true;
      // 清空链接输入框
      this.batchAddLinks = '';
    },



    /**
     * 处理批量添加
     */
    async processBatchAdd() {
      // 检查输入是否为空
      if (!this.batchAddLinks.trim()) {
        this.$Message.warning('请输入作品链接或ID');
        return;
      }

      // 设置添加状态为进行中
      this.isBatchAdding = true;
      try {
        // 按行分割输入内容并过滤空行
        const lines = this.batchAddLinks.split('\n').filter(line => line.trim().length > 0);

        if (lines.length === 0) {
          this.$Message.warning('未找到有效的链接或ID');
          return;
        }

        let addedCount = 0;

        // 处理每一行输入
        for (const line of lines) {
          // 检查待查询项是否已满20个
          if (this.pendingItems.length >= 20) {
            this.$Message.warning('待查询项已达到最大数量20个');
            break;
          }

          let videoId = null;
          let displayText = line.trim();

          // 首先从整行文本中提取抖音链接，支持包含中文的混合文本
          const urlInText = line.match(/https:\/\/v\.douyin\.com\/[A-Za-z0-9_-]+/);
          let processedLine = line;
          if (urlInText) {
            // 如果找到了链接，只处理链接部分
            processedLine = urlInText[0];
            displayText = urlInText[0];
          }

          // 提取链接 - 支持多种格式 (修正正则表达式，添加连字符支持)
          const urlPatterns = [
            /https:\/\/v\.douyin\.com\/[A-Za-z0-9_-]+/, // 短链接格式 (修正：添加连字符支持)
            /https?:\/\/www\.iesdouyin\.com\/share\/video\/(\d+)/, // 分享链接格式
            /https?:\/\/www\.douyin\.com\/video\/(\d+)/, // 长链接格式
            /[?&]modal_id=(\d+)/ // modal_id参数格式
          ];

          let urlMatch = null;
          for (const pattern of urlPatterns) {
            const match = processedLine.match(pattern);
            if (match) {
              urlMatch = match;
              break;
            }
          }

          if (urlMatch) {
            // 如果匹配到URL格式
            if (urlMatch[1]) {
              // 如果是带捕获组的正则表达式，直接使用捕获组
              videoId = urlMatch[1];
            } else {
              // 否则使用API解析短链接
              try {
                const response = await apiClient.post('query/parse-link', {
                  douyin_url: urlMatch[0]
                });

                if (response.data.code === 200 && response.data.data.video_id) {
                  videoId = response.data.data.video_id;
                } else {
                  this.$Message.warning(`链接解析失败: ${urlMatch[0]}`);
                  continue;
                }
              } catch (error) {
                this.$Message.error(`链接解析错误: ${urlMatch[0]}`);
                console.error('链接解析失败:', error);
                continue;
              }
            }
            displayText = videoId;
          } else {
            // 尝试匹配纯数字ID
            const idMatch = processedLine.match(/\b\d+\b/);
            if (idMatch) {
              videoId = idMatch[0];
              displayText = idMatch[0];
            }
          }

          // 如果找到了有效的ID
          if (videoId) {
            // 检查是否已存在
            if (!this.pendingItems.some(item => item.id === videoId)) {
              this.pendingItems.push({
                id: videoId,
                displayText: displayText,
                originalUrl: `https://www.douyin.com/video/${videoId}`
              });
              addedCount++;
            } else {
              this.$Message.warning(`作品ID已存在: ${videoId}`);
            }
          } else {
            this.$Message.warning(`无效的链接或ID格式: ${line}`);
          }
        }

        if (addedCount > 0) {
          this.$Message.success(`成功添加 ${addedCount} 个作品到待查询项`);
          // 关闭模态框
          this.showBatchAddModal = false;
        } else {
          this.$Message.warning('未添加任何有效的作品');
        }
      } catch (error) {
        this.$Message.error('批量添加失败，请稍后重试');
        console.error('批量添加失败:', error);
      } finally {
        // 重置添加状态
        this.isBatchAdding = false;
      }
    },
    /**
     * 打开批量导入模态框
     */
    openBatchImportModal() {
      // 检查登录状态
      if (!this.checkLoginStatus()) return;
      
      // 显示模态框
      this.showBatchImportModal = true;
      // 清空链接输入框
      this.batchImportLinks = '';
      // 清空解析结果
      this.parsedAuthors = [];
      this.selectedAuthorIndex = 0;
      this.authorWorks = [];
    },

    /**
     * 解析主页链接
     */
    async parseHomeLinks() {
      if (!this.batchImportLinks.trim()) {
        this.$Message.warning('请输入主页链接');
        return;
      }

      this.isParsingLinks = true;

      try {
        const lines = this.batchImportLinks.split('\n').filter(line => line.trim().length > 0);

        if (lines.length === 0) {
          this.$Message.warning('未找到有效的链接');
          return;
        }

        // 初始化作者列表
        this.parsedAuthors = [];
        this.authorWorks = {};
        const userEmail = localStorage.getItem('userEmail') || '';

        // 处理每个链接
        for (const line of lines) {
          let link = line.trim();

          // 支持的4种格式处理
          let processedLink = link;

          // 类型1: 长按复制此条消息，打开抖音搜索，查看TA的更多作品。 https://v.douyin.com/JrukYjPGeV0/
          const messagePattern = /https:\/\/v\.douyin\.com\/[A-Za-z0-9_-]+/;
          const messageMatch = link.match(messagePattern);
          if (messageMatch) {
            processedLink = messageMatch[0];
          }

          // 验证链接格式是否有效
          const validUrlPattern = /^https:\/\/v\.douyin\.com\/[A-Za-z0-9_-]+|^https:\/\/www\.douyin\.com\/user\/[A-Za-z0-9_-]+/;

          if (validUrlPattern.test(processedLink) || /^[A-Za-z0-9_-]{30,}$/.test(processedLink)) {
            try {
              // 统一使用 user_urls 参数传递链接
              const response = await apiClient.post('v2/query/getvideosinfo', {
                user_urls: [processedLink],
                user_email: userEmail,
                max_cursor: 0
              });

              if (response.data.code === 200 && response.data.data && response.data.data[0]) {
                const userData = response.data.data[0];
                await this.processAuthorData(userData, link.trim());
              } else {
                this.$Message.warning(`无法解析链接: ${processedLink}`);
                continue;
              }
            } catch (error) {
              console.error('解析链接失败:', error);
              this.$Message.warning(`链接解析失败: ${processedLink}`);
              continue;
            }
          } else {
            this.$Message.warning(`无法识别的链接格式: ${link}`);
          }
        }

        if (this.parsedAuthors.length > 0) {
          this.$Message.success(`成功解析 ${this.parsedAuthors.length} 个作者`);
        } else {
          this.$Message.warning('未解析到任何有效的作者');
        }
      } catch (error) {
        console.error('解析链接失败:', error);
        this.$Message.error('解析链接失败，请稍后重试');
      } finally {
        this.isParsingLinks = false;
      }
    },

    /**
     * 处理作者数据的通用方法
     */
    async processAuthorData(userData, originalLink) {
      const authorId = userData.sec_user_id;
      const nickname = userData.user_info?.nickname || '未知用户';
      const avatar = userData.user_info?.avatar_url || '';
      const workCount = userData.user_info?.aweme_count || 0;

      // 检查作者是否已存在
      const existingAuthorIndex = this.parsedAuthors.findIndex(author => author.id === authorId);

      if (existingAuthorIndex === -1) {
        // 添加作者信息
        this.parsedAuthors.push({
          id: authorId,
          nickname,
          avatar,
          workCount,
          secUserId: authorId,
          homepageUrl: originalLink
        });
      }

      // 初始化该作者的作品数据
      if (!this.authorWorks[authorId]) {
        this.authorWorks[authorId] = {
          works: [],
          hasNextPage: false,
          currentCursor: '',
          cursorHistory: [''],
          pageIndex: 0
        };
      }

      // 处理作品数据
      if (userData.videos && Array.isArray(userData.videos.list)) {
        const newWorks = userData.videos.list.map(work => ({
          ...work,
          id: work.aweme_id || work.id,
          isSelected: false,
          cover_url: work.cover_url || work.cover,
          digg_count: work.digg_count || work.likes || 0,
          comment_count: work.comment_count || work.comments || 0,
          share_count: work.share_count || work.shares || 0,
          desc: work.desc || work.title || '',
          create_time: work.create_time || work.publishTime
        }));

        // 合并作品数据，避免重复
        const existingWorkIds = new Set(this.authorWorks[authorId].works.map(w => w.id));
        const uniqueNewWorks = newWorks.filter(work => !existingWorkIds.has(work.id));

        this.authorWorks[authorId].works.push(...uniqueNewWorks);
        this.authorWorks[authorId].hasNextPage = userData.videos.has_more;
        this.authorWorks[authorId].currentCursor = userData.videos.max_cursor || '';
      }
    },
    /**
     * 加载指定作者的作品
     * @param {string} authorId - 作者ID
     * @param {string} cursor - 游标值（可选）
     */
    async loadAuthorWorks(authorId, cursor = null) {
      const authorData = this.authorWorks[authorId];
      if (!authorData) return;

      try {
        const userEmail = localStorage.getItem('userEmail') || '';

        // 使用传入的游标值，如果未提供则使用当前游标或默认值0
        const requestCursor = cursor !== null ? cursor : (authorData.currentCursor || 0);

        const response = await apiClient.post('v2/query/getvideosinfo', {
          user_urls: [`https://www.douyin.com/user/${authorId}`],
          user_email: userEmail,
          max_cursor: requestCursor  // 使用正确的游标值
        });

        if (response.data.code === 200 && response.data.data && response.data.data[0]) {
          const newVideos = response.data.data[0].videos.list || [];
          const hasMore = response.data.data[0].videos.has_more;
          const newCursor = response.data.data[0].videos.max_cursor;

          // 更新作品数据
          authorData.works = newVideos;

          // 更新分页状态
          authorData.hasNextPage = hasMore;
          authorData.currentCursor = newCursor;

          // 只有在向前翻页时才添加游标到历史记录中
          if (cursor === null || cursor === 0 || requestCursor < newCursor) {
            // 避免重复添加相同的游标
            if (authorData.cursorHistory[authorData.cursorHistory.length - 1] !== newCursor) {
              authorData.cursorHistory.push(newCursor);
            }
          }

          authorData.pageIndex = authorData.cursorHistory.length - 1;
        }
      } catch (error) {
        console.error('加载作品失败:', error);
        this.$Message.error('加载失败，请稍后重试');
      }
    },
    /**
     * 切换作者Tab
     */
    switchAuthor(index) {
      this.selectedAuthorIndex = parseInt(index);// 转换为数字
    },

    /**
     * 切换作品选择状态
     */
    toggleWorkSelection(workId) {
      const authorWork = this.authorWorks[this.selectedAuthorIndex];
      if (authorWork) {
        const work = authorWork.works.find(w => w.id === workId);
        if (work) {
          work.isSelected = !work.isSelected;
        }
      }
    },

    /**
     * 切换全选状态
     */
    toggleAllWorks() {
      // 获取当前选中的作者
      const currentAuthor = this.parsedAuthors[this.selectedAuthorIndex];
      if (!currentAuthor) return;

      const authorId = currentAuthor.id;
      const authorData = this.authorWorks[authorId];

      if (!authorData || !authorData.works) return;

      // 检查是否所有作品都被选中
      const allSelected = authorData.works.every(work => work.isSelected);

      // 如果全部选中，则取消全选；否则全选
      authorData.works.forEach(work => {
        work.isSelected = !allSelected;
      });
    },


    /**
     * 检查是否有下一页（用于按钮禁用状态）
     */
    hasNextPageFunc(authorIndex) {
      const authorWork = this.authorWorks[authorIndex];
      if (!authorWork) return false;

      const pagination = this.authorPagination[authorWork.authorId];
      return pagination && pagination.hasNextPage;
    },

    /**
     * 检查是否有上一页（用于按钮禁用状态）
     */
    hasPrevPageFunc(authorIndex) {
      const authorWork = this.authorWorks[authorIndex];
      if (!authorWork) return false;

      const pagination = this.authorPagination[authorWork.authorId];
      return pagination && pagination.hasPrevPage;
    },



    /**
     * 回到第一页的方法
     */
    async goToFirstPage() {
      // 检查是否可以回到第一页且当前未在加载状态，如果不满足条件则直接返回
      if (!this.canGoBack || this.isPageLoading) return;

      // 设置分页加载状态为true，表示正在加载
      this.isPageLoading = true;
      // 记录当前分页操作类型为"first"（第一页）
      this.pageAction = 'first';

      try {
        // 获取当前选中的作者信息
        const currentAuthor = this.parsedAuthors[this.selectedAuthorIndex];
        // 如果没有选中的作者，直接返回
        if (!currentAuthor) return;

        // 获取当前作者的ID
        const authorId = currentAuthor.id;
        // 获取当前作者的作品数据对象
        const authorData = this.authorWorks[authorId];

        // 如果存在作者数据
        if (authorData) {
          // 清空当前作者的作品数据数组
          authorData.works = [];
          // 重置游标历史记录，只保留表示第一页的初始游标值0
          authorData.cursorHistory = [0]; // 或者根据API要求设置合适的初始值
          // 设置当前游标为0，表示第一页
          authorData.currentCursor = 0;

          // 加载第一页数据，传递作者ID和游标值0
          await this.loadAuthorWorks(authorId, 0);
        }
      } catch (error) {
        // 捕获并记录错误信息
        console.error('回到第一页失败:', error);
        // 显示错误提示消息
        this.$Message.error('加载第一页数据失败');
      } finally {
        // 无论成功还是失败，最后都重置加载状态
        this.isPageLoading = false;
        // 重置分页操作类型为空字符串
        this.pageAction = '';
      }
    },





    /**
     * 重置所有分页状态
     */
    resetAllPagination() {
      if (this.authorWorks && this.authorPagination) {
        this.authorWorks.forEach(authorWork => {
          const pagination = this.authorPagination[authorWork.authorId];
          if (pagination) {
            pagination.cursorHistory = [];
            pagination.currentCursor = 0;
            pagination.hasNextPage = true;
            pagination.hasPrevPage = false;
          }
        });
      }
    },
    /**
     * 开始导入作品到待查询项
     */
    async startImport() {
      // 检查是否有选中的作者
      if (this.selectedAuthorIndex < 0 || this.selectedAuthorIndex >= this.parsedAuthors.length) {
        this.$Message.warning('请选择有效的作者');
        return;
      }

      const currentAuthor = this.parsedAuthors[this.selectedAuthorIndex];
      const authorId = currentAuthor.id;
      const authorData = this.authorWorks[authorId];

      // 检查作者数据是否存在
      if (!authorData) {
        this.$Message.warning('作者数据不存在');
        return;
      }

      // 获取选中的作品
      const selectedWorks = authorData.works.filter(work => work.isSelected);

      // 检查是否有选中的作品
      if (selectedWorks.length === 0) {
        this.$Message.warning('请至少选择一个作品');
        return;
      }

      // 检查待查询项是否已满
      if (this.pendingItems.length >= 20) {
        this.$Message.warning('待查询项已达到最大数量20个');
        return;
      }

      this.isImporting = true;

      try {
        let addedCount = 0;
        const maxAddCount = 20 - this.pendingItems.length; // 最多还能添加的数量

        // 添加选中的作品到待查询项
        for (let i = 0; i < selectedWorks.length && addedCount < maxAddCount; i++) {
          const work = selectedWorks[i];
          const videoId = work.aweme_id || work.id;

          // 检查是否已存在
          if (!this.pendingItems.some(item => item.id === videoId)) {
            this.pendingItems.push({
              id: videoId,
              displayText:  videoId,
              originalUrl: `https://www.douyin.com/video/${videoId}`
            });
            addedCount++;
          }
        }

        if (addedCount > 0) {
          this.$Message.success(`成功导入 ${addedCount} 个作品到待查询项`);
          // 导入成功后关闭模态框
          this.showBatchImportModal = false;
        } else {
          this.$Message.warning('没有新的作品被导入');
        }
      } catch (error) {
        console.error('导入作品失败:', error);
        this.$Message.error('导入作品失败，请稍后重试');
      } finally {
        this.isImporting = false;
      }
    },



    /**
     * 打开IP白名单设置模态框
     */
    async openIpWhitelistModal() {
      this.showIpWhitelistModal = true;
      this.ipWhitelistLoading = false;

      try {
        // 获取当前IP白名单设置
        const response = await apiClient.get('query/get_ip_whitelist');
        if (response.data.code === 200) {
          //this.ipWhitelistInput = response.data.data.ip_whitelist || '';
          // 如果返回的是逗号分隔的字符串，转换为换行格式
          if (response.data.data.ip_whitelist) {
            if (typeof response.data.data.ip_whitelist === 'string') {
              // 如果是字符串，按逗号分割并转换为换行格式
              this.ipWhitelistInput = response.data.data.ip_whitelist.split(',').map(ip => ip.trim()).join('\n');
            } else if (Array.isArray(response.data.data.ip_whitelist)) {
              // 如果是数组，直接转换为换行格式
              this.ipWhitelistInput = response.data.data.ip_whitelist.join('\n');
            } else {
              // 其他情况，转换为字符串处理
              this.ipWhitelistInput = String(response.data.data.ip_whitelist);
            }
          } else {
            this.ipWhitelistInput = '';
          }
        }
        // 获取当前IP地址
        try {
          const response = await fetch('https://ipinfo.io/json');
          if (response.ok) {
            const data = await response.json();
            this.currentIp = data.ip;
          } else {
            console.error('获取IP失败:', response.status);
          }
        } catch (error) {
          console.error('获取IP地址失败:', error);
        }

      } catch (error) {
        console.error('获取IP白名单失败:', error);
        this.$Message.error('获取IP白名单设置失败');
      }
    },



    /**
     * 取消IP白名单设置
     */
    cancelIpWhitelist() {
      this.showIpWhitelistModal = false;
      this.ipWhitelistInput = '';
    },

    /**
     * 获取所有VIP套餐列表
     */
    async fetchVipPackagesList() {
      try {
        const response = await apiClient.get('vip/packages');
        if (response.data.code === 200) {
          this.vipPackagesList = response.data.data;
        } else {
          this.$Message.error(response.data.msg || '获取VIP套餐列表失败');
        }
      } catch (error) {
        this.$Message.error('获取VIP套餐列表失败，请稍后重试');
        console.error('获取VIP套餐列表失败:', error);
      }
    },
    /**
     * 获取用户VIP状态
     */
    async getUserVipStatus() {
      try {
        const response = await apiClient.get('vip/status');
        console.log('VIP状态API返回:', response.data);
        if (response.data.code === 200) {
          // 确保完整更新VIP状态
          this.vipStatus = {
            ...this.vipStatus,
            ...response.data.data
          };
          console.log('更新后的VIP状态:', this.vipStatus);
          console.log('is_vip值:', this.vipStatus.is_vip, '类型:', typeof this.vipStatus.is_vip);
          console.log('end_date值:', this.vipStatus.end_date);
        }
      } catch (error) {
        console.error('获取VIP状态失败:', error);
      }finally {
        // 无论成功还是失败，都标记为已加载完成
        this.isVipStatusLoaded = true;
      }
    },

    /**
     * 显示VIP套餐
     */
    async showVipPackages() {
      // 检查登录状态
      if (!this.checkLoginStatus()) return;
      
      try {
        const response = await apiClient.get('vip/packages');
        if (response.data.code === 200) {
          this.vipPackages = response.data.data;
          this.showVipModal = true;

          // 这里可以使用Modal组件显示套餐选择界面
          this.$Modal.info({
            title: 'VIP套餐',
            render: (h) => {
              return h('div', {
                style: {
                  maxHeight: '400px',
                  overflowY: 'auto'
                }
              }, [
                h('div', {
                  style: {
                    marginBottom: '15px',
                    padding: '10px',
                    backgroundColor: '#f0f8ff',
                    borderRadius: '5px'
                  }
                }, [
                  h('p', `当前状态: ${this.vipStatus.is_vip ? 'VIP会员' : '普通用户'}`),
                  this.vipStatus.is_vip ? h('p', `到期时间: ${this.vipStatus.expire_time}`) : ''
                ]),
                ...this.vipPackages.map((pkg) => {
                  return h('div', {
                    style: {
                      marginBottom: '10px',
                      padding: '10px',
                      border: '1px solid #eee',
                      borderRadius: '5px'
                    }
                  }, [
                    h('h4', `${pkg.name} - ¥${pkg.price}`),
                    h('p', pkg.description),
                    h('Button', {
                      props: {
                        type: 'primary',
                        long: true
                      },
                      on: {
                        click: () => this.purchaseVip(pkg.id)
                      }
                    }, '立即购买')
                  ]);
                })
              ]);
            },
            width: 500
          });
        } else {
          this.$Message.error(response.data.msg || '获取VIP套餐失败');
        }
      } catch (error) {
        this.$Message.error('获取VIP套餐失败，请稍后重试');
        console.error('获取VIP套餐失败:', error);
      }
    },
    /**
     * 购买VIP套餐
     */
    async purchaseVip(packageId) {
      try {
        // 检查路由是否存在
        const hasRoute = this.$router.hasRoute('VipRecharge');

        if (hasRoute) {
          // 在新窗口中打开VIP充值页面，并传递套餐ID作为查询参数
          const routeData = this.$router.resolve({
            name: 'VipRecharge',
            query: { package_id: packageId }
          });
          window.open(routeData.href, '_blank');
        } else {
          // 如果路由不存在，使用原有的创建订单逻辑作为备选方案
          const response = await apiClient.post('vip/create-order', {
            package_id: packageId,
            user_email: localStorage.getItem('userEmail') || '',
            type: this.paymentMethod || 'alipay',
            device_type: this.deviceType || 'pc'
          });

          if (response.data.status === 'success') {
            // 获取支付链接并跳转
            const payUrl = response.data.data.pay_url;
            window.open(payUrl, '_blank');

            // 显示提示信息
            this.$Message.success('正在跳转到支付页面...');
          } else {
            this.$Message.error(response.data.msg || '创建订单失败');
          }
        }

        // 关闭当前的Modal
        this.$Modal.remove();
      } catch (error) {
        this.$Message.error('跳转到充值页面失败，请稍后重试');
        console.error('跳转到充值页面失败:', error);
      }
      /*    try {
            const response = await apiClient.post('vip/create-order', {
              package_id: packageId,// 套餐ID
              user_email: localStorage.getItem('userEmail') ,// 从本地存储获取用户邮箱
              type: this.paymentMethod,// 支付方式
              device_type: this.deviceType
            });

            if (response.data.status === 'success') {
              // 获取支付链接并跳转
              const payUrl = response.data.data.pay_url;
              window.open(payUrl, '_blank');

              // 显示提示信息
              this.$Message.success('正在跳转到支付页面...');

              // 关闭Modal
              this.$Modal.remove();

              // 可以添加轮询检查支付状态的逻辑
              // this.checkPaymentStatus(response.data.data.order_id);
            } else {
              this.$Message.error(response.data.msg || '创建订单失败');
            }
          } catch (error) {
            this.$Message.error('创建订单失败，请稍后重试');
            console.error('创建VIP订单失败:', error);
          }*/
    },
    /**
     * 检查支付状态（可选功能）
     */
    async checkPaymentStatus(orderId) {
      // 可以实现轮询检查支付状态的逻辑
      // 这里只是一个示例，实际使用时需要根据业务需求调整
      const check = async () => {
        try {
          const response = await apiClient.post('vip/check-payment', {
            order_id: orderId
          });

          if (response.data.status === 'success' && response.data.data.paid) {
            this.$Message.success('支付成功，VIP已开通！');
            await this.getUserVipStatus(); // 更新VIP状态
            return;
          }

          // 如果未支付成功，继续轮询
          if (!response.data.data.paid) {
            setTimeout(check, 3000); // 3秒后再次检查
          }
        } catch (error) {
          console.error('检查支付状态失败:', error);
        }
      };

      setTimeout(check, 3000);
    },


    // 在 methods 中添加
    getKeyLabel(key) {
      const labelMap = {
        'product_id': '商品ID',
        'promotion_id': '推广ID',
        'title': '商品标题',
        'sales': '销量'
      };
      return labelMap[key] || key;
    },
    /**
     * 移动端搜索视频ID（带防抖）
     */
    mobileSearchVideos() {
      // 清除之前的定时器
      if (this.mobileSearchTimer) {
        clearTimeout(this.mobileSearchTimer);
      }

      // 设置新的定时器
      this.mobileSearchTimer = setTimeout(() => {
        if (!this.mobileSearchQuery.trim()) {
          // 如果搜索关键词为空，重置搜索状态
          this.isMobileSearching = false;
          this.mobileSearchResults = [];
          return;
        }

        // 在当前显示的数据中搜索匹配的视频ID
        const query = this.mobileSearchQuery.trim().toLowerCase();
        this.mobileSearchResults = this.dataItems.filter(item =>
            item.aweme_id && item.aweme_id.toLowerCase().includes(query)
        );

        this.isMobileSearching = true;
        console.log('搜索结果:', this.mobileSearchResults); // 调试用
      }, 300); // 300ms防抖延迟
    },

    /**
     * 清除移动端搜索
     */
    clearMobileSearch() {
      this.mobileSearchQuery = '';
      this.isMobileSearching = false;
      this.mobileSearchResults = [];

      // 清除搜索定时器
      if (this.mobileSearchTimer) {
        clearTimeout(this.mobileSearchTimer);
        this.mobileSearchTimer = null;
      }
    },

    /**
     * 获取移动端当前应该显示的数据（搜索结果或正常数据）
     */
    getMobileDisplayData() {
      if (this.isMobileSearching) {
        return this.mobileSearchResults;
      }
      return this.getMobileVisibleData();
    },
    /**
     * 处理移动端滚动加载更多数据
     */
    handleMobileScroll() {
      // 只在移动端且有更多数据时执行
      if (!this.isMobile || this.mobileCurrentLoadedCount >= this.dataItems.length) {
        return;
      }

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight || document.documentElement.clientHeight;

      // 当滚动到接近底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.loadMoreMobileData();
      }
    },

    /**
     * 加载更多移动端数据
     */
    loadMoreMobileData() {
      // 增加已加载的数据项数量
      this.mobileCurrentLoadedCount = Math.min(
          this.mobileCurrentLoadedCount + this.mobileLoadIncrement,
          this.dataItems.length
      );
    },

    /**
     * 获取移动端可见的数据项
     */
    getMobileVisibleData() {
      if (!this.isMobile) {
        return this.dataItems;
      }
      return this.dataItems.slice(0, this.mobileCurrentLoadedCount);
    },
    /**
     * 智能格式化统计数字（避免长数字在窄列卡片中被挤压）
     * 规则：
     *   - < 10000：原样返回（132、664、1024 这种显示完整更好）
     *   - >= 10000 且 < 100000000：转「万」单位（如 12345 → 1.2万）
     *   - >= 100000000：转「亿」单位
     * @param {number|string} num - 原始数字
     * @returns {string} 格式化后的字符串
     */
    formatStatNum(num) {
      // 防御性处理：非数字、空值、负数
      const n = Number(num);
      if (!isFinite(n) || n < 0) return '0';
      if (n < 10000) return String(Math.floor(n));
      if (n < 100000000) {
        // 1.2万 / 12.3万 / 123.4万（保留 1 位小数，但去尾随 0）
        const wan = n / 10000;
        return (wan % 1 === 0 ? wan.toFixed(0) : wan.toFixed(1)) + '万';
      }
      const yi = n / 100000000;
      return (yi % 1 === 0 ? yi.toFixed(0) : yi.toFixed(1)) + '亿';
    },

    /**
     * 专门用于移动端格式化热搜词显示（处理Unicode编码问题）
     * @param {Array|string} hotWords - 热搜词数组或字符串
     * @returns {string} 格式化后的热搜词字符串
     */
    formatHotWordsForMobile(hotWords) {
      // 如果为空或未定义，返回'无'
      if (!hotWords || (Array.isArray(hotWords) && hotWords.length === 0)) {
        return '无';
      }

      let wordsArray = [];

      // 如果是字符串
      if (typeof hotWords === 'string') {
        // 尝试解析为数组
        try {
          const parsed = JSON.parse(hotWords);
          if (Array.isArray(parsed)) {
            wordsArray = parsed;
          } else {
            wordsArray = [hotWords];
          }
        } catch (e) {
          // 如果解析失败，直接使用原字符串
          wordsArray = [hotWords];
        }
      } else if (Array.isArray(hotWords)) {
        // 如果已经是数组
        wordsArray = hotWords;
      } else {
        // 其他情况
        return '无';
      }

      // 解码 Unicode 字符并只显示前5个
      const decodedWords = wordsArray.slice(0, 5).map(word => {
        if (typeof word !== 'string') {
          return String(word);
        }

        try {
          // 先尝试解码 URI 编码（处理 %E4%B8%AD%E6%96%87 格式）
          let decodedWord = decodeURIComponent(word);

          // 然后解码 Unicode 转义序列（处理 \u4e2d\u6587 格式）
          decodedWord = decodedWord.replace(/\\u([0-9a-fA-F]{4})/g, (match, grp) => {
            return String.fromCharCode(parseInt(grp, 16));
          });

          // 解码其他可能的转义字符
          decodedWord = decodedWord.replace(/\\n/g, '\n')
              .replace(/\\r/g, '\r')
              .replace(/\\t/g, '\t')
              .replace(/\\"/g, '"')
              .replace(/\\'/g, "'");

          return decodedWord;
        } catch (e) {
          // 如果解码失败，返回原始字符串
          return word;
        }
      });

      return decodedWords.join(', ') || '无';
    },
    /**
     * 格式化热搜词显示
     * @param {Array|string} hotWords - 热搜词数组或字符串
     * @returns {string} 格式化后的热搜词字符串
     */
    formatHotWords(hotWords) {
      // 如果为空或未定义，返回'无'
      if (!hotWords || (Array.isArray(hotWords) && hotWords.length === 0)) {
        return '无';
      }

      // 如果是字符串
      if (typeof hotWords === 'string') {
        // 尝试解析为数组
        try {
          const parsed = JSON.parse(hotWords);
          if (Array.isArray(parsed)) {
            hotWords = parsed;
          } else {
            hotWords = [hotWords];
          }
        } catch (e) {
          // 如果解析失败，直接使用原字符串
          hotWords = [hotWords];
        }
      }

      // 确保是数组
      if (!Array.isArray(hotWords)) {
        return '无';
      }

      // 解码 Unicode 字符并只显示前3个
      const decodedWords = hotWords.slice(0, 10).map(word => {
        if (typeof word !== 'string') {
          return String(word);
        }

        try {
          // 先尝试解码 URI 编码（处理 %E4%B8%AD%E6%96%87 格式）
          let decodedWord = decodeURIComponent(word);

          // 然后解码 Unicode 转义序列（处理 \u4e2d\u6587 格式）
          decodedWord = decodedWord.replace(/\\u([0-9a-fA-F]{4})/g, (match, grp) => {
            return String.fromCharCode(parseInt(grp, 16));
          });

          return decodedWord;
        } catch (e) {
          return word;
        }
      });

      return decodedWords.join(', ') || '无';
    },

    // 在methods中添加新方法
    formatOptimizationTips(tips) {
      if (!tips) return '暂无优化建议';

      // 将换行符转换为HTML换行标签
      return tips.replace(/\n/g, '<br>');
    },
    // 复制 AI 推荐标题
    copyAiTitle(title) {
      if (!title) return;
      // 检查 navigator.clipboard 是否可用（非HTTPS或非localhost环境可能不可用）
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(title).then(() => {
          this.$Message.success('已复制：' + title);
        }).catch(() => {
          this.fallbackCopyText(title);
        });
      } else {
        this.fallbackCopyText(title);
      }
    },
    // 复制降级方案：使用 textarea + execCommand
    fallbackCopyText(text) {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        // 避免滚动到底部
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (ok) {
          this.$Message.success('已复制：' + text);
        } else {
          this.$Message.error('复制失败，请手动复制');
        }
      } catch (e) {
        console.error('[复制] 降级方案失败:', e);
        this.$Message.error('复制失败，请手动复制');
      }
    },
    /**
     * 触发 AI 作品优化分析（异步轮询版）
     *
     * 与小程序端共用同一套异步机制：
     *   1. 发起异步分析请求 → 立即获得 task_id（1 秒内返回）
     *   2. 每 5 秒轮询一次结果
     *   3. 获取到结果后展示到详情面板并同步更新列表
     *
     * 此模式解决了 PHP 端 100 秒执行超时导致 AI 分析无法返回结果的问题
     *
     * @param {Object} video - 当前弹窗显示的视频详情对象
     */
    async triggerAiAnalysis(video) {
      // 校验作品 ID 是否存在
      if (!video || !video.aweme_id) {
        this.$Message.warning('未找到作品ID，无法执行AI分析');
        return;
      }
      // 防止重复点击
      if (this.aiAnalyzing) {
        return;
      }
      // 获取登录邮箱
      const userEmail = localStorage.getItem('userEmail') || '';
      if (!userEmail) {
        this.$Message.warning('请先登录后再使用AI分析功能');
        return;
      }

      const awemeId = video.aweme_id;
      this.aiAnalyzing = true;
      this.batchAiProgress = { done: 0, total: 1 };
      // 显示全屏居中 Loading 提示用户等待
      this.aiBatchLoadingText = 'AI 正在分析作品，请稍候（约 30-90 秒）...';
      this.showAiBatchLoading = true;

      try {
        // ========== 第一步：发起异步 AI 分析请求（1 秒内完成，不会超时） ==========
        const asyncResp = await apiClient.post('v2/query/ai/analyze', {
          aweme_id: awemeId,
          user_email: userEmail
        });
        // 解析响应（兼容 apiClient 不同返回格式）
        let asyncData = asyncResp;
        if (asyncResp && asyncResp.data) {
          asyncData = asyncResp.data;
        }
        console.log('[AI异步分析] 创建任务响应:', asyncData);

        // 异步任务创建失败：显示错误并退出
        if (!asyncData || asyncData.code !== 200 || !asyncData.data || !asyncData.data.task_id) {
          const msg = (asyncData && asyncData.msg) || 'AI分析任务创建失败';
          this.$Message.error('AI 分析失败：' + msg);
          return;
        }

        // 拿到 task_id，开始轮询阶段
        const taskId = asyncData.data.task_id;
        console.log('[AI异步分析] 任务已创建:', taskId);

        // ========== 第二步：轮询获取结果（最多轮询 5 分钟 = 60 次 × 5 秒） ==========
        const maxPolls = 60;
        const pollInterval = 5000; // 5 秒间隔
        let pollCount = 0;
        let notFoundCount = 0; // 连续 404 计数，防止误判瞬时竞态

        const pollResult = () => {
          return new Promise((resolve, reject) => {
            const doPoll = async () => {
              pollCount++;
              // 超过最大轮询次数，认为超时
              if (pollCount > maxPolls) {
                reject(new Error('AI分析超时，请稍后重试'));
                return;
              }

              try {
                const resp = await apiClient.get('v2/query/ai/analyze_result', {
                  params: { task_id: taskId }
                });
                // 解析响应
                let respData = resp;
                if (resp && resp.data) {
                  respData = resp.data;
                }
                console.log('[AI异步分析] 轮询 #' + pollCount + ', 响应:', respData);

                // 404 表示任务不存在或已过期
                if (!respData || respData.code === 404) {
                  notFoundCount++;
                  console.warn('[AI异步分析] 轮询 #' + pollCount + ', 404 not_found (连续' + notFoundCount + '次)');
                  // 连续 3 次 404 才认为任务真的丢失（容忍瞬时竞态）
                  if (notFoundCount >= 3) {
                    reject(new Error('AI分析任务已过期，请重新发起'));
                    return;
                  }
                  // 短暂等待后重试（可能后台正在原子写入）
                  setTimeout(doPoll, 2000);
                  return;
                }
                // 恢复正常，重置 404 计数
                notFoundCount = 0;

                const status = respData.data && respData.data.status;
                console.log('[AI异步分析] 轮询 #' + pollCount + ', 状态:', status);

                // 已完成：把结果返回给外层
                if (status === 'completed') {
                  resolve(respData.data);
                  return;
                }
                // 失败：抛出错误，外层弹窗提示
                if (status === 'failed') {
                  reject(new Error(respData.msg || 'AI分析失败'));
                  return;
                }
                // status === 'processing'，继续等待
                setTimeout(doPoll, pollInterval);
              } catch (err) {
                // 网络错误时继续重试
                console.warn('[AI异步分析] 轮询网络错误:', err);
                setTimeout(doPoll, pollInterval);
              }
            };
            doPoll();
          });
        };

        // 等待轮询结果
        const result = await pollResult();
        // 隐藏 Loading
        try { this.showAiBatchLoading = false; } catch (_) { /* 忽略 */ }

        // ========== 第三步：结果已返回，处理 8 个 AI 分析字段 ==========
        const newTips = String(result.optimization_tips || '');
        const newTitle = String(result.ai_title || '');
        const newEval = String(result.content_evaluation || '');
        const newDataAnalysis = String(result.data_analysis || '');
        const newDirections = String(result.optimization_directions || '');
        const newHashtags = String(result.hashtag_suggestions || '');
        const newPostingTime = String(result.posting_time_advice || '');
        const newCompetition = String(result.competition_analysis || '');

        console.log('[AI异步分析] 解析后 tips长度=' + newTips.length + ', title=' + newTitle);

        // 更新当前详情面板
        try {
          if (this.currentVideoDetails && this.currentVideoDetails.aweme_id === awemeId) {
            this.currentVideoDetails.optimization_tips = newTips;
            this.currentVideoDetails.ai_title = newTitle;
            this.currentVideoDetails.content_evaluation = newEval;
            this.currentVideoDetails.data_analysis = newDataAnalysis;
            this.currentVideoDetails.optimization_directions = newDirections;
            this.currentVideoDetails.hashtag_suggestions = newHashtags;
            this.currentVideoDetails.posting_time_advice = newPostingTime;
            this.currentVideoDetails.competition_analysis = newCompetition;
          }
          // 同步更新数据列表
          const idx = this.allDataItems.findIndex(it => it.aweme_id === awemeId);
          if (idx >= 0) {
            this.allDataItems[idx].optimization_tips = newTips;
            this.allDataItems[idx].ai_title = newTitle;
            this.allDataItems[idx].content_evaluation = newEval;
            this.allDataItems[idx].data_analysis = newDataAnalysis;
            this.allDataItems[idx].optimization_directions = newDirections;
            this.allDataItems[idx].hashtag_suggestions = newHashtags;
            this.allDataItems[idx].posting_time_advice = newPostingTime;
            this.allDataItems[idx].competition_analysis = newCompetition;
          }
          // 自动切换到 "AI 优化建议分析" 标签页
          this.$nextTick(() => {
            this.activeTab = 'suggestions';
            this.aiAnalyzed = true;
            const itemIdx = this.allDataItems.findIndex(it => it.aweme_id === awemeId);
            if (itemIdx >= 0) {
              this.allDataItems[itemIdx].aiAnalyzed = true;
            }
          });
        } catch (setErr) {
          console.error('[AI异步分析] 更新失败:', setErr);
        }

        if (newTips || newTitle) {
          this.$Message.success('AI 优化建议分析完成');
        } else {
          this.$Message.warning('AI 返回内容为空');
        }
      } catch (err) {
        // 清理 Loading 状态
        try { this.showAiBatchLoading = false; } catch (_) { /* 忽略 */ }
        console.error('[AI异步分析] 失败:', err);
        // 提取错误消息
        let msg = '网络或服务器异常，请稍后重试';
        try {
          if (err && err.response && err.response.data && err.response.data.msg) {
            msg = err.response.data.msg;
          } else if (err && err.message) {
            msg = err.message;
          }
        } catch (_) { /* 忽略 */ }
        this.$Message.error('AI 分析失败：' + msg);
      } finally {
        this.aiAnalyzing = false;
        // 确保 Loading 状态一定被清理
        this.showAiBatchLoading = false;
        this.aiBatchLoadingText = '';
      }
    },
    /**
     * 批量 AI 作品优化分析（异步并发轮询版）
     *
     * 核心优化：所有作品的分析请求同时发出（并行），无需逐个等待。
     * 流程：
     *   1. 并行发出所有作品的异步分析请求 → 收集所有 task_id
     *   2. 统一轮询所有任务，直到全部完成或失败
     *   3. 批量更新结果到列表和详情面板
     *
     * 此模式解决了旧版逐一分析超时的问题，批量分析效率大幅提升
     */
    async batchAiAnalysis() {
      if (this.isBatchAiAnalyzing) return;
      const items = (this.selectedItems || []).filter(it => it && it.aweme_id);
      if (items.length === 0) {
        this.$Message.warning('请先勾选要分析的作品');
        return;
      }
      const userEmail = localStorage.getItem('userEmail') || '';
      if (!userEmail) {
        this.$Message.warning('请先登录后再使用AI分析功能');
        return;
      }

      this.isBatchAiAnalyzing = true;
      this.batchAiProgress = { done: 0, total: items.length };
      this.aiBatchLoadingText = `正在准备分析 ${items.length} 个作品，请稍候...`;
      this.showAiBatchLoading = true;

      let successCount = 0;
      let failCount = 0;
      let firstSuccessItem = null;

      // ========== 第一步：并行发出所有作品的异步分析请求 ==========
      // 收集每个作品的任务信息：{ awemeId, taskId, item }
      const taskList = [];
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        const awemeId = it.aweme_id;
        this.batchAiProgress.done = i;
        this.aiBatchLoadingText = `正在发起第 ${i + 1}/${items.length} 个作品的分析请求...`;
        try {
          const response = await apiClient.post('v2/query/ai/analyze', {
            aweme_id: awemeId,
            user_email: userEmail
          });
          const respData = (response && response.data) ? response.data : null;
          if (respData && respData.code === 200 && respData.data && respData.data.task_id) {
            taskList.push({ awemeId, taskId: respData.data.task_id, item: it });
            console.log('[批量AI异步] 任务创建: aweme_id=' + awemeId + ', task_id=' + respData.data.task_id);
          } else {
            const msg = (respData && respData.msg) || '任务创建失败';
            console.warn('[批量AI异步] 创建失败:', awemeId, msg);
            failCount++;
          }
        } catch (err) {
          console.error('[批量AI异步] 创建异常:', awemeId, err);
          failCount++;
        }
      }

      // 如果所有作品都创建失败，直接退出
      if (taskList.length === 0) {
        this.showAiBatchLoading = false;
        this.aiBatchLoadingText = '';
        this.isBatchAiAnalyzing = false;
        this.$Message.error(`批量分析失败：0/${items.length} 条成功创建任务`);
        return;
      }

      // ========== 第二步：统一轮询所有任务 ==========
      const pollInterval = 5000;          // 5 秒间隔
      const maxPolls = 60;               // 最多轮询 60 次（5 分钟）
      const activeTasks = new Map();     // taskId → { awemeId, item, notFoundCount }
      const completedResults = new Map(); // taskId → result data

      // 初始化活跃任务集合
      for (const t of taskList) {
        activeTasks.set(t.taskId, { ...t, notFoundCount: 0 });
      }

      let round = 0;
      while (activeTasks.size > 0 && round < maxPolls) {
        round++;
        const doneCount = taskList.length - activeTasks.size;
        this.batchAiProgress = { done: doneCount, total: items.length };
        this.aiBatchLoadingText = `正在分析：已完成 ${doneCount}/${items.length} 个作品...（轮询第 ${round} 轮）`;
        // 等待 5 秒再轮询
        await new Promise(r => setTimeout(r, pollInterval));

        // 并行查询所有活跃任务的当前状态
        const pollPromises = [];
        for (const [taskId, taskInfo] of activeTasks) {
          pollPromises.push((async () => {
            try {
              const resp = await apiClient.get('v2/query/ai/analyze_result', {
                params: { task_id: taskId }
              });
              const respData = (resp && resp.data) ? resp.data : null;
              return { taskId, taskInfo, respData };
            } catch (err) {
              console.warn('[批量AI异步] 轮询网络错误:', taskId, err);
              return { taskId, taskInfo, respData: null, networkError: true };
            }
          })());
        }
        const pollResults = await Promise.all(pollPromises);

        // 处理每轮轮询结果
        for (const pr of pollResults) {
          const { taskId, taskInfo, respData, networkError } = pr;

          // 网络错误或 404：累计计数
          if (networkError || !respData || respData.code === 404) {
            taskInfo.notFoundCount++;
            if (taskInfo.notFoundCount >= 3) {
              // 连续 3 次失败，标记失败并移出活跃列表
              activeTasks.delete(taskId);
              failCount++;
              console.warn('[批量AI异步] 任务丢失: aweme_id=' + taskInfo.awemeId + ', task_id=' + taskId);
            }
            continue;
          }

          // 重置 404 计数
          taskInfo.notFoundCount = 0;
          const status = respData.data && respData.data.status;
          console.log('[批量AI异步] 轮询 #' + round + ', task_id=' + taskId + ', status=' + status);

          if (status === 'completed') {
            // 分析成功：移出活跃列表，记录结果
            activeTasks.delete(taskId);
            completedResults.set(taskId, respData.data);
            successCount++;
            console.log('[批量AI异步] 完成: aweme_id=' + taskInfo.awemeId + ', task_id=' + taskId);
          } else if (status === 'failed') {
            // 分析失败
            activeTasks.delete(taskId);
            failCount++;
            console.warn('[批量AI异步] 失败: aweme_id=' + taskInfo.awemeId + ', task_id=' + taskId + ', msg=' + (respData.msg || ''));
          }
          // status === 'processing' 继续等待下一轮
        }
      }

      // 超时未完成的任务标记为失败
      for (const [taskId, taskInfo] of activeTasks) {
        console.warn('[批量AI异步] 超时: aweme_id=' + taskInfo.awemeId + ', task_id=' + taskId);
        failCount++;
      }

      // ========== 第三步：批量更新结果到列表和详情面板 ==========
      for (const [taskId, data] of completedResults) {
        const taskInfo = taskList.find(t => t.taskId === taskId);
        if (!taskInfo) continue;
        const awemeId = taskInfo.awemeId;

        const newTips = String(data.optimization_tips || '');
        const newTitle = String(data.ai_title || '');
        const newEval = String(data.content_evaluation || '');
        const newDataAnalysis = String(data.data_analysis || '');
        const newDirections = String(data.optimization_directions || '');
        const newHashtags = String(data.hashtag_suggestions || '');
        const newPostingTime = String(data.posting_time_advice || '');
        const newCompetition = String(data.competition_analysis || '');

        // 更新数据列表
        const idx = this.allDataItems.findIndex(row => row.aweme_id === awemeId);
        if (idx >= 0) {
          this.allDataItems[idx].optimization_tips = newTips;
          this.allDataItems[idx].ai_title = newTitle;
          this.allDataItems[idx].content_evaluation = newEval;
          this.allDataItems[idx].data_analysis = newDataAnalysis;
          this.allDataItems[idx].optimization_directions = newDirections;
          this.allDataItems[idx].hashtag_suggestions = newHashtags;
          this.allDataItems[idx].posting_time_advice = newPostingTime;
          this.allDataItems[idx].competition_analysis = newCompetition;
        }
        // 更新当前详情面板
        if (this.currentVideoDetails && this.currentVideoDetails.aweme_id === awemeId) {
          this.currentVideoDetails.optimization_tips = newTips;
          this.currentVideoDetails.ai_title = newTitle;
          this.currentVideoDetails.content_evaluation = newEval;
          this.currentVideoDetails.data_analysis = newDataAnalysis;
          this.currentVideoDetails.optimization_directions = newDirections;
          this.currentVideoDetails.hashtag_suggestions = newHashtags;
          this.currentVideoDetails.posting_time_advice = newPostingTime;
          this.currentVideoDetails.competition_analysis = newCompetition;
        }
        // 记录第一个成功分析的作品
        if (!firstSuccessItem) {
          const updatedItem = this.allDataItems.find(row => row.aweme_id === awemeId);
          firstSuccessItem = updatedItem || taskInfo.item;
        }
      }

      // 隐藏 Loading
      this.showAiBatchLoading = false;
      this.aiBatchLoadingText = '';
      this.isBatchAiAnalyzing = false;
      this.batchAiProgress = { done: items.length, total: items.length };

      // 显示结果汇总
      if (failCount === 0) {
        this.$Message.success(`批量分析完成：成功 ${successCount} 条`);
      } else if (successCount === 0) {
        this.$Message.error(`批量分析失败：0/${items.length} 条成功`);
      } else {
        this.$Message.warning(`批量分析完成：成功 ${successCount} 条，失败 ${failCount} 条`);
      }

      // 分析完成后自动弹出详情模态框，展示第一个成功分析的作品，并切换到"优化建议"标签页
      if (firstSuccessItem) {
        this.currentVideoDetails = firstSuccessItem;
        this.showDetailModal = true;
        await this.$nextTick(() => {
          this.activeTab = 'suggestions';
        });
      }
    },
    // 处理token过期事件
    handleTokenExpired() {
      // 清除用户状态
      this.clearUserState();

      // 显示登录模态框
      this.showLoginModal = true;

      // 显示提示信息
      this.$Message.warning('登录已过期，请重新登录');
    },

    // 处理被挤下线事件（单设备登录控制）
    handleSessionKickedOut(event) {
      const message = (event && event.detail && event.detail.message) || '您的账号已在其他设备登录，当前登录已失效';
      // 清除用户状态
      this.clearUserState();
      // 显示登录模态框
      this.showLoginModal = true;
      // 显示提示信息
      this.$Message.warning(message);
    },

    // 在 methods 中添加
    async fetchSiteInfo() {
      try {
        const response = await apiClient.get('admin/getsite');
        if (response.data.code === 200) {
          this.siteInfo = response.data.data;
          this.isSiteInfoLoaded = true; // 设置为已加载
          // 设置页面标题
          document.title = this.siteInfo.site_name || '抖数君科技有限公司';

          // 设置页面描述
          this.setMetaDescription(this.siteInfo.site_description || '默认网站描述');

          // 设置页面关键词
          this.setMetaKeywords('某音,播放量,查询,监测,是否限流');
        }
      } catch (error) {
        console.error('获取网站信息失败:', error);
        this.isSiteInfoLoaded = true; // 即使出错也要设置为已加载，避免一直显示加载状态
      }
    },

    /**
     * 切换全屏
     */
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        // 进入全屏
        document.documentElement.requestFullscreen().then(() => {
          this.isFullscreen = true;
        }).catch(err => {
          this.$Message.error(`全屏显示失败: ${err.message}`);
        });
      } else {
        // 退出全屏
        document.exitFullscreen().then(() => {
          this.isFullscreen = false;
        });
      }
    },

    /**
     * 监听全屏状态变化
     */
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
    },

    /**
     * 获取当前页面标题
     */
    getPageTitle() {
      const titles = {
        query: '',  // 数据查询页面不显示标题
        monitor: '',  // 作品数据监控页面不显示标题
        recharge: '',  // 用户充值页面不显示标题
        settings: ''  // 系统基本设置页面不显示标题
      };
      return titles[this.activeMenu] || '';
    },

    /**
     * 购买VIP套餐
     * @param {Object} pkg - 套餐对象
     */
    purchaseVipPackage(pkg) {
      this.$Modal.confirm({
        title: '确认购买',
        content: `确定购买 ${pkg.name}（¥${pkg.price}）？`,
        onOk: () => {
          this.$Message.success('购买成功！');
          // TODO: 调用购买API
        }
      });
    },

    /**
     * 查看充值记录
     */
    viewRechargeHistory() {
      this.$Message.info('充值记录功能开发中...');
      // TODO: 跳转到充值记录页面
    },

    /**
     * 保存IP白名单
     */
    async saveIpWhitelist() {
      if (!this.ipWhitelistInput.trim()) {
        this.$Message.warning('请输入IP白名单');
        return;
      }

      this.ipWhitelistLoading = true;
      try {
        // 解析输入的IP列表（每行一个IP）
        const ipList = this.ipWhitelistInput
          .split('\n')
          .map(ip => ip.trim())
          .filter(ip => ip.length > 0);

        if (ipList.length === 0) {
          this.$Message.warning('请输入有效的IP地址');
          this.ipWhitelistLoading = false;
          return;
        }

        // 调用API保存IP白名单
        const response = await apiClient.post('query/set_ip_whitelist', {
          enable_whitelist: 1,
          ip_list: ipList
        });

        if (response.data.code === 200) {
          this.$Message.success(response.data.msg || 'IP白名单设置成功');
        } else {
          this.$Message.error(response.data.msg || 'IP白名单设置失败');
        }
      } catch (error) {
        console.error('保存IP白名单失败:', error);
        this.$Message.error('保存失败，请稍后重试');
      } finally {
        this.ipWhitelistLoading = false;
      }
    },

    /**
     * 加载IP白名单
     */
    async loadIpWhitelist() {
      try {
        // 调用API获取IP白名单
        const response = await apiClient.get('query/get_ip_whitelist');

        if (response.data.code === 200) {
          const data = response.data.data;
          // 将IP数组转换为每行一个的字符串格式
          this.ipWhitelistInput = data.ip_whitelist ? data.ip_whitelist.join('\n') : '';
          this.$Message.success('IP白名单已重新加载');
        } else {
          this.$Message.error(response.data.msg || '获取IP白名单失败');
        }
      } catch (error) {
        console.error('获取IP白名单失败:', error);
        this.$Message.error('获取失败，请稍后重试');
      }
    },

    /**
     * 【优化】获取当前用户IP地址
     * 添加了 AbortController 5秒超时，避免国外服务 ipinfo.io 响应慢阻塞页面加载
     */
    async fetchCurrentIp() {
      // 创建超时控制器，5秒后自动中断请求，防止国外服务 ipinfo.io 响应慢拖慢页面
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch('https://ipinfo.io/json', {
          signal: controller.signal // 绑定中断信号，超时自动 abort
        });
        clearTimeout(timeoutId); // 请求成功返回，清除超时定时器
        if (response.ok) {
          const data = await response.json();
          this.currentIp = data.ip;
        } else {
          console.error('获取IP失败:', response.status);
          this.currentIp = '获取失败';
        }
      } catch (error) {
        // 区分超时中断和网络错误，超时时静默降级
        if (error.name === 'AbortError') {
          console.warn('⏱️ 获取IP地址超时(5秒)，使用默认值');
        } else {
          console.error('获取IP地址失败:', error);
        }
        this.currentIp = '获取失败';
      }
    },

    /**
     * 处理用户下拉菜单显示状态变化
     * @param {boolean} visible - 菜单是否可见
     */
    handleUserDropdownVisible(visible) {
      this.userDropdownVisible = visible;
    },

    /**
     * 打开修改密码模态框
     */
    openChangePassword() {
      this.userDropdownVisible = false;
      if (this.$refs.changePasswordModal) {
        this.$refs.changePasswordModal.open();
      }
    },

    /**
     * 处理清除缓存点击
     */
    handleClearCache() {
      this.closeUserDropdown();
      this.clearCache();
    },

    /**
     * 处理打开修改密码点击
     */
    handleOpenChangePassword() {
      this.closeUserDropdown();
      this.openChangePassword();
    },

    /**
     * 处理退出账号点击
     */
    handleLogoutClick() {
      this.closeUserDropdown();
      this.handleLogout();
    },

    /**
     * 处理打开用户个人资料点击
     * 1. 关闭下拉菜单
     * 2. 显示模态框
     * 3. 调用接口拉取详细资料
     */
    handleOpenUserProfile() {
      // 关闭下拉菜单
      this.closeUserDropdown();
      // 显示模态框
      this.showUserProfileModal = true;
      // 异步拉取最新资料
      this.fetchUserProfile();
    },

    /**
     * 从后端拉取当前登录用户的详细个人资料
     * 调用 /user/profile 接口，结果回填到 userProfile
     */
    async fetchUserProfile() {
      // 开启loading
      this.userProfileLoading = true;
      try {
        // 调后端接口
        const response = await apiClient.get('/user/profile');
        // 后端返回约定：{ code: 200, msg: '获取成功', data: { ... } }
        if (response.data && response.data.code === 200 && response.data.data) {
          // 合并后端返回的资料到本地 state
          // Object.assign 避免影响未返回的字段，保持默认占位
          this.userProfile = Object.assign({}, this.userProfile, response.data.data);
        } else if (response.data && response.data.code === 401) {
          // 未登录或Token失效
          this.$Message.warning('登录已失效，请重新登录');
          this.showUserProfileModal = false;
        } else {
          // 其他错误
          this.$Message.error((response.data && response.data.msg) || '获取用户资料失败');
        }
      } catch (error) {
        // 网络/异常情况
        console.error('获取用户资料异常:', error);
        this.$Message.error('网络异常，获取用户资料失败');
      } finally {
        // 关闭loading
        this.userProfileLoading = false;
      }
    },


    /**
     * 切换用户下拉菜单显示状态
     */
    toggleUserDropdown() {
      this.userDropdownVisible = !this.userDropdownVisible;
    },

    /**
     * 关闭用户下拉菜单
     */
    closeUserDropdown() {
      this.userDropdownVisible = false;
    },

    /**
     * 点击外部关闭下拉菜单
     * @param {Event} event - 点击事件
     */
    handleClickOutside(event) {
      if (!event.target.closest('.user-dropdown-wrapper')) {
        this.userDropdownVisible = false;
      }
    },

    // 添加设置 meta description 的方法
    setMetaDescription(content) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = content;
    },

// 添加设置 meta keywords 的方法
    setMetaKeywords(content) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = content;
    },
    // 在方法中生成链接
    handleApiDocClick() {
      const routeUrl = this.$router.resolve({name: 'Doc'});

      window.open(routeUrl.href, '_blank');
    },
    // 复制作者主页链接
    copyAuthorLink(awemeId) {
      const link = `https://www.douyin.com/user/${awemeId}`;
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(link)
            .then(() => this.$Message.success('链接已复制'))
            .catch(() => this.$Message.error('复制失败'));
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = link;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.$Message.success('链接已复制');
        } catch (err) {
          this.$Message.error('复制失败');
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },

    // 跳转到抖音主页
    openAuthorPage(awemeId) {
      window.open(`https://www.douyin.com/user/${awemeId}`, '_blank');
    },

    // 关闭模态框
    closeAuthorModal() {
      this.showAuthorModal = false;
      this.currentAuthorInfo = null;
    },
    // 点击作者昵称或作者ID时触发
    handleAuthorClick(row) {
      console.log(row)
      this.currentAuthorInfo = row;
      this.showAuthorModal = true;
    },
    // 处理封面点击事件
    handleCoverClick(coverUrl, event) {
      if (!event || !event.target) {
        console.error('Event or event.target is undefined');
        return;
      }

      event.stopPropagation(); // 阻止事件冒泡
      if (coverUrl) {
        this.$Message.info('点击了图片');
        this.showLargeImage(coverUrl); // 调用显示大图的方法
      }
    },
    // 显示大图模态框
    showLargeImage(url) {
      // this.largeImageUrl = url; // 设置当前大图的 URL
      // this.isLargeImageModalVisible = true; // 显示大图模态框

      // 清除之前可能存在的事件监听器（防止重复绑定）
      document.removeEventListener('keydown', this.handleEscClose);

      // 创建一个临时的 div 容器用于显示大图
      const imgContainer = document.createElement('div');
      imgContainer.style.cssText = `    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    overflow: hidden;
    cursor: zoom-in;
  `;

      const img = document.createElement('img');
      img.src = url;
      img.style.cssText = `    max-width: 90%;
    max-height: 90vh;
    min-width: 300px;
    min-height: 300px;
    border-radius: 8px;
    box-shadow: 0 0 20px rgba(0,0,0,0.5);
    transition: transform 0.3s ease;
    cursor: pointer;
    object-fit: contain;
  `;

      // 双击放大/缩小
      img.ondblclick = () => {
        if (img.style.transform === 'scale(1.5)') {
          img.style.transform = 'scale(1)';
        } else {
          img.style.transform = 'scale(1.5)';
        }
      };

      // 点击图片关闭
      img.onclick = () => {
        // ✅ 关键修改：先检查是否存在于 body 中
        if (document.body.contains(imgContainer)) {
          document.body.removeChild(imgContainer);
        }
      };

      // 将图片添加到容器
      imgContainer.appendChild(img);
      document.body.appendChild(imgContainer);

      // 绑定 ESC 键事件（使用方法引用避免重复绑定）
      this.handleEscClose = (e) => {
        if (e.key === 'Escape') {
          if (document.body.contains(imgContainer)) {
            document.body.removeChild(imgContainer);
          }
        }
      };
      document.addEventListener('keydown', this.handleEscClose);
    },
    /**
     * 复制作品链接
     * @param {string} awemeId - 作品ID
     */
    copyLink(awemeId) {
      if (!awemeId) {
        this.$Message.warning('无效的作品ID');
        return;
      }

      const link = `https://www.douyin.com/video/${awemeId}`;

      // 检查 navigator.clipboard 是否可用
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(link)
            .then(() => {
              this.$Message.success('链接已复制到剪贴板');
            })
            .catch((error) => {
              console.error('复制失败:', error);
              this.$Message.error('复制链接失败，请稍后重试');
            });
      } else {
        // 回退到 document.execCommand 方法
        const textarea = document.createElement('textarea');
        textarea.value = link;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.$Message.success('链接已复制到剪贴板');
        } catch (err) {
          console.error('复制失败:', err);
          this.$Message.error('复制链接失败，请稍后重试');
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    /**
     * 显示成功 logo
     */
    showSuccessLogo() {
      this.resultLogoSrc = '/images/success_logo.png';
      this.showResultLogo = true;
      this.hideResultLogoAfterDelay();
    },

    /**
     * 显示失败 logo
     */
    showFailureLogo() {
      this.resultLogoSrc = '/images/failure.png';

      this.showResultLogo = true;
      this.hideResultLogoAfterDelay();
    },
    /**
     * 延迟隐藏查询结果 logo
     */
    hideResultLogoAfterDelay() {
      setTimeout(() => {
        this.showResultLogo = false;
      }, 2000); // 2秒后隐藏
    },
    // 打开充值列表页面的方法
    openRechargeList() {
      // 如果用户未登录，显示登录模态框
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }
      //this.$router.push({ name: 'RechargeList' }); // 跳转到充值列表页面
      // 使用 window.open 在新窗口中打开充值记录页面
      const routeUrl = this.$router.resolve({name: 'RechargeList'});
      window.open(routeUrl.href, '_blank');
    },

    /**
     * 处理表格行点击事件
     * @param {Object} row - 被点击的行数据
     * @param index
     * @param event
     */
    handleRowClick(row, index, event) {

      console.log('表格行点击:', row);
      this.currentAuthorInfo = row;// 设置当前作者信息

      // 从allDataItems中查找包含完整信息的数据项
      const fullDataItem = this.allDataItems.find(item => item.aweme_id === row.aweme_id);

      // 如果找到了完整数据项且包含signature，则使用它
      if (fullDataItem && fullDataItem.hasOwnProperty('signature')) {
        this.currentVideoDetails = fullDataItem;
      } else {
        // 否则使用表格行数据并确保signature字段存在
        this.currentVideoDetails = {
          ...row,
          signature: row.signature || ''
        };
      }

      this.showDetailModal = true; // 显示 Modal
    },
    /**
     * 处理窗口大小改变事件（防抖）
     */
    handleResize() {
      // 清除之前的定时器
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      // 设置新的定时器
      this.resizeTimer = setTimeout(() => {
        const oldIsMobile = this.isMobile;
        this.checkIsMobile();
        
        // 如果移动端状态发生变化，需要重新更新分页数据
        if (oldIsMobile !== this.isMobile && this.allDataItems.length > 0) {
          this.currentPage = 1; // 重置到第一页
          this.updatePaginatedData();
        }
      }, 100); // 100ms 防抖延迟
    },

    /**
     * 保存作品解锁状态到 localStorage
     * @param {string} workId - 作品ID
     */
    saveUnlockedWork(workId) {
      try {
        const stored = localStorage.getItem('unlockedWorks');
        const unlockedSet = stored ? new Set(JSON.parse(stored)) : new Set();
        unlockedSet.add(workId);
        localStorage.setItem('unlockedWorks', JSON.stringify([...unlockedSet]));
        console.log('已保存解锁状态:', workId);
      } catch (e) {
        console.error('保存解锁状态失败:', e);
      }
    },

    /**
     * 检查作品是否已解锁
     * @param {string} workId - 作品ID
     * @returns {boolean} - 是否已解锁
     */
    isWorkUnlocked(workId) {
      return this.unlockedWorks.has(workId);
    },

    /**
     * 清除指定作品的解锁状态（如果需要）
     * @param {string} workId - 作品ID
     */
    clearUnlockedWork(workId) {
      try {
        const stored = localStorage.getItem('unlockedWorks');
        if (stored) {
          const unlockedSet = new Set(JSON.parse(stored));
          unlockedSet.delete(workId);
          localStorage.setItem('unlockedWorks', JSON.stringify([...unlockedSet]));
          console.log('已清除解锁状态:', workId);
        }
      } catch (e) {
        console.error('清除解锁状态失败:', e);
      }
    },

    /**
     * 清除所有解锁状态（如果需要）
     */
    clearAllUnlockedWorks() {
      try {
        localStorage.removeItem('unlockedWorks');
        console.log('已清除所有解锁状态');
      } catch (e) {
        console.error('清除所有解锁状态失败:', e);
      }
    },

    /**
     * 加载并验证解锁状态
     * 在组件初始化时调用，确保解锁数据的有效性
     */
    loadAndValidateUnlockedWorks() {
      try {
        const stored = localStorage.getItem('unlockedWorks');
        if (stored) {
          const unlockedArray = JSON.parse(stored);
          console.log('加载已解锁作品数量:', unlockedArray.length);
          console.log('已解锁作品ID列表:', unlockedArray);
        } else {
          console.log('没有找到已解锁作品数据');
        }
      } catch (e) {
        console.error('加载解锁状态失败:', e);
        // 如果解析失败，清除错误数据
        localStorage.removeItem('unlockedWorks');
      }
    },

    handleGlobalClick(event) {
      if (this.isMobile && this.showSidebar) {
        this.hideSidebar(); // 如果是手机端且侧边栏显示，则隐藏侧边栏
      }
    },

    /**
     * 检查用户登录状态
     */
    async checkUserLoginStatus(isshowhistory = false) {
      try {
        //console.log('检查用户登录状态开始');

        // 从 localStorage 获取用户信息
        const loggedIn = localStorage.getItem('userLoggedIn') === 'true';
        const username = localStorage.getItem('username') || '';
        const queryBalance = parseInt(localStorage.getItem('userBalance')) || 0;
        const token = localStorage.getItem('token');
        const userEmail = localStorage.getItem('userEmail') || ''; // 容错处理

        // 如果没有 token，直接设置为未登录状态
        if (!token) {
          //console.log('未找到token，清除用户状态');
          this.clearUserState();
          return;
        }

        // 发送请求到后端检查登录状态
        // console.log('发送用户状态检查请求...');
        const response = await apiClient.get('/user/status');
        // console.log('用户状态检查响应:', response);

        // 如果后端返回登录成功状态
        if (response.data.code === 200 && response.data.data.is_logged_in) {
          const userInfo = response.data.data.user_info;
          this.updateUserState({
            username: userInfo.username || '',
            balance: userInfo.balance || 0,
            token,
            email: userInfo.email || '' // 后端返回的 email
          });
          this.showLoginModal = false;
          // console.log('用户已登录，更新状态完成');

          // 获取用户数据
          if (isshowhistory) {
            // console.log('获取用户数据...');
            await this.fetchUserData();
          }
        } else {
          if (response.data.code === 401) {
            this.clearUserState();
          }
          // console.log('用户未登录或登录已过期，清除用户状态');
          // 后端返回未登录状态，清除用户信息
          this.clearUserState();
        }
      } catch (error) {
        // console.error('检查登录状态失败:', error);
        // 处理被挤下线（单设备登录控制）
        if (error.response && error.response.status === 403 && error.response.data && error.response.data.data && error.response.data.data.kicked_out) {
          // 拦截器已触发 sessionKickedOut 事件，无需额外处理
          return;
        }
        // 特别处理401错误
        if (error.response && error.response.status === 401) {
          console.log('Token已过期，触发token过期处理');
          this.handleTokenExpired();
        } else {
          this.clearUserState();
        }
      }
    },

    /**
     * 更新用户状态
     * @param {Object} userInfo - 用户信息对象
     */


    // 修改 clearUserState 方法
    clearUserState() {
      this.isUserLoggedIn = false;
      this.showLoginModal = true;

      // 清除 localStorage 中的用户信息
      localStorage.removeItem('userLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('userBalance');
      localStorage.removeItem('token');
      localStorage.removeItem('userEmail');

      // 清空页面上的数据
      this.queryBalance = 0;
      this.username = '';
      this.pendingItems = []; // 清空待查询项
      this.allDataItems = []; // 清空所有数据项
      this.dataItems = [];    // 清空当前页数据
      this.total = 0;         // 清空数据总条数
      this.currentPage = 1;   // 重置当前页码

      // 退出登录后更新浏览器标题为未登录状态
      document.title = this.siteInfo.site_name || '抖数君—作品分析建议优化平台';
    },
    // 添加打开抖音视频的方法
    openDouyinVideo(awemeId) {
      console.log('awemeId:', awemeId)
      if (awemeId) {
        window.open(`https://www.douyin.com/video/${awemeId}`, '_blank');
      }
    },
    // 专门为表格视频ID点击设计的方法
    handleVideoIdClick(awemeId) {
      console.log('表格视频ID点击:', awemeId);
      this.openDouyinVideo(awemeId);
    },
    /**
     * 格式化数字显示
     * @param {number} num - 需要格式化的数字
     * @returns {string} 格式化后的字符串
     */
    formatNumber(num) {
      // 如果数字大于等于100万
      if (num >= 1000000) {
        // 返回以M为单位的格式化字符串
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        // 如果数字大于等于1000，返回以K为单位的格式化字符串
        return (num / 1000).toFixed(1) + 'K';
      }
      // 否则返回数字的字符串形式
      return num.toString();
    },

    /**
     * 处理移动端侧边栏切换
     */
    toggleSidebar() {
      //alert(this.showSidebar);
      // 切换侧边栏显示状态
      this.showSidebar = !this.showSidebar;
    },
    hideSidebar() {
      this.showSidebar = false; // 隐藏侧边栏
    },
    /**
     * 关闭侧边栏（点击遮罩层时调用）
     */
    closeSidebar() {
      this.showSidebar = false;
    },
    /**
     * 检查是否为移动设备
     */
    checkIsMobile() {
      // 设置窗口宽度
      this.windowWidth = window.innerWidth;

      // 获取用户代理字符串
      this.userAgent = navigator.userAgent.toLowerCase();

      // 综合判断是否为移动设备
      const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(this.userAgent);
      const isMobileWidth = window.innerWidth <= 768;


      // 判断窗口宽度是否小于等于768像素，如果是则为移动设备
      // 设置是否为移动设备
      this.isMobile = isMobileUA || isMobileWidth;
    },

    /**
     * 处理登录模态框关闭事件
     */
    handleLoginModalClose() {
      // 输出日志
      console.log('Login modal closed');
      // 设置登录模态框已关闭状态
      this.isLoginModalClosed = true;
    },
    /**
     * 处理退出账号
     */
    async handleLogout() {
      this.$Modal.confirm({
        title: '确认退出',
        content: '您确定要退出账号吗？',
        onOk: async () => {
          try {
            // 从 localStorage 获取 token
            const token = localStorage.getItem('token');

            // 如果没有 token，直接清除用户状态
            if (!token) {
              this.clearUserState();
              return;
            }

            // 调用退出 API
            const response = await apiClient.post('/user/logout', {});
            // 如果退出成功
            if (response.data.code === 200) {
              // 清除用户状态
              this.clearUserState();
              // 显示成功消息
              this.$Message.success('已退出账号');
            } else {
              // 显示错误消息
              this.$Message.error(response.data.msg || '退出失败');
            }
          } catch (error) {
            // 处理不同类型的错误
            if (error.response) {
              this.$Message.error(`服务器错误: ${error.response.status}`);
            } else if (error.request) {
              this.$Message.error('网络请求无响应，请检查网络连接');
            } else {
              this.$Message.error('退出失败，请稍后重试');
            }
          }
        }
      });
    },

    /**
     * 清除缓存
     */
    clearCache() {
      this.$Modal.confirm({
        title: '清除缓存',
        content: '清除缓存后需要重新登录，确定要清除吗？',
        onOk: () => {
          // 清除 localStorage 中的数据（保留主题设置）
          const currentTheme = localStorage.getItem('currentTheme');
          localStorage.clear();
          
          // 恢复主题设置
          if (currentTheme) {
            localStorage.setItem('currentTheme', currentTheme);
          }
          
          this.$Message.success('缓存已清除，即将跳转...');
          
          // 延迟刷新页面
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      });
    },
    /**
     * 处理表格选择变化
     * @param {Array} selection - 选中的项目数组
     */
    handleSelectionChange(selection) {
      // 设置选中项
      this.selectedItems = selection;
      // 更新全选状态：当选中项数量大于0且等于当前页数据数量时为全选
      this.isAllSelected = selection.length === this.dataItems.length && this.dataItems.length > 0;
      // 输出选中项日志
      console.log('Selected items:', selection);
    },

    updateUserState(userInfo) {
      this.isUserLoggedIn = true;
      this.username = userInfo.username || '';
      this.queryBalance = userInfo.balance || 0;

      // 更新 localStorage 中的用户信息
      localStorage.setItem('userLoggedIn', 'true');
      localStorage.setItem('username', userInfo.username || '');
      localStorage.setItem('userBalance', userInfo.balance || 0);
      localStorage.setItem('userEmail', userInfo.email || '');
      if (userInfo.token) {
        localStorage.setItem('token', userInfo.token);
      }
    },

    /**
     * 处理登录成功
     * @param {Object} loginData - 登录返回的数据
     */
    handleLoginSuccess(loginData) {
      // 设置用户已登录状态
      this.isUserLoggedIn = true;
      // 隐藏登录模态框
      this.showLoginModal = false;
      // 设置查询余额
      this.queryBalance = loginData.balance || 0;
      // 设置用户名
      this.username = loginData.username || '';

      // 如果有token
      if (loginData.token) {
        // 将token保存到localStorage
        localStorage.setItem('token', loginData.token);
      }

      // 保存用户登录状态到localStorage
      localStorage.setItem('userLoggedIn', 'true');
      // 保存用户邮箱到localStorage
      localStorage.setItem('userEmail', loginData.email);
      // 保存用户余额到localStorage
      localStorage.setItem('userBalance', loginData.balance || 0);
      // 保存用户名到localStorage
      localStorage.setItem('username', loginData.username || '');

      // 登录成功后更新浏览器标题
      switch(this.activeMenu) {
        case 'query':
          document.title = '抖数君-AI作品优化建议分析';
          break;
        case 'settings':
          document.title = '抖数君-系统基本设置';
          break;
        case 'monitor':
          document.title = '抖数君-作品数据监控';
          break;
        case 'recharge':
          document.title = '抖数君-用户充值';
          break;
        default:
          document.title = '抖数君-AI作品优化建议分析';
      }

      // 登录成功后获取用户数据（内部会同步获取VIP状态）
      this.fetchUserData();
    },

    /**
     * 处理注册成功
     * @param {Object} registerData - 注册返回的数据
     */
    handleRegisterSuccess(registerData) {
      // 设置用户已登录状态
      this.isUserLoggedIn = true;
      // 隐藏登录模态框
      this.showLoginModal = false;
      // 设置用户名
      this.username = registerData.username || '';
      // 设置查询余额
      this.queryBalance = registerData.balance || 0;
      // 显示注册成功消息
      this.$Message.success('注册并登录成功');

      // 如果有token
      if (registerData.token) {
        // 将token保存到localStorage
        localStorage.setItem('token', registerData.token);
      }

      // 保存用户登录状态到localStorage
      localStorage.setItem('userLoggedIn', 'true');
      // 保存用户邮箱到localStorage
      localStorage.setItem('userEmail', registerData.email);
      // 保存用户余额到localStorage
      localStorage.setItem('userBalance', registerData.balance || 0);
      // 保存用户名到localStorage
      localStorage.setItem('username', registerData.username || '');

      // 注册成功后更新浏览器标题
      switch(this.activeMenu) {
        case 'query':
          document.title = '抖数君-AI作品优化建议分析';
          break;
        case 'settings':
          document.title = '抖数君-系统基本设置';
          break;
        case 'monitor':
          document.title = '抖数君-作品数据监控';
          break;
        case 'recharge':
          document.title = '抖数君-用户充值';
          break;
        default:
          document.title = '抖数君-AI作品优化建议分析';
      }

      // 获取用户数据
      this.fetchUserData();
    },

    // /**
    //  * 检查用户是否已登录
    //  */
    // checkUserLoginStatus() {
    //   // 从localStorage获取登录状态
    //   const loggedIn = localStorage.getItem('userLoggedIn') === 'true';
    //   // 设置用户登录状态
    //   this.isUserLoggedIn = loggedIn;
    //   // 设置是否显示登录模态框
    //   this.showLoginModal = !loggedIn;
    //
    //   // 如果已登录
    //   if (loggedIn) {
    //     // 从localStorage获取查询余额
    //     this.queryBalance = parseInt(localStorage.getItem('userBalance')) || 0;
    //     // 从localStorage获取用户名
    //     this.username = localStorage.getItem('username') || '';
    //     // 获取用户数据
    //     this.fetchUserData();
    //   }
    // },

    /**
     * 检查用户登录状态
     * @returns {boolean} 是否已登录
     */
    checkLoginStatus() {
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        this.$Message.warning('请先登录后再操作');
        return false;
      }
      return true;
    },

    /**
     * 获取用户VIP状态
     */
    async fetchVipStatus() {
      // 如果用户未登录，则跳过VIP状态获取
      if (!this.isUserLoggedIn) {
        console.log('用户未登录，跳过VIP状态获取');
        return;
      }

      try {
        const response = await apiClient.get('/vip/status');
        console.log('VIP状态API返回:', response.data);
        if (response.data.code === 200) {
          this.vipStatus = {
            ...this.vipStatus,
            ...response.data.data
          };
          this.isVipStatusLoaded = true;
          console.log('更新后的VIP状态:', this.vipStatus);
        }
      } catch (error) {
        console.error('获取VIP状态失败:', error);
      }
    },

    /**
     * 获取用户数据
     */
    async fetchUserData() {
      // 如果用户未登录，则跳过数据获取
      if (!this.isUserLoggedIn) {
        console.log('用户未登录，跳过数据获取');
        return;
      }

      // 设置加载状态
      this.loading = true;
      try {
        // 显示加载提示
        this.$Message.loading({
          content: '正在加载数据...',
          duration: 0,
          closable: true
        });

        // 从localStorage获取用户邮箱
        const userEmail = localStorage.getItem('userEmail') || '';
        // 从localStorage获取token
        const token = localStorage.getItem('token') || '';

        const [historyResponse, balanceResponse] = await Promise.all([
          apiClient.post('v2/query/history', {user_email: userEmail}),
          apiClient.post('/user/balance', {user_email: userEmail})
        ]);

        // 同步获取VIP状态（不阻塞历史/余额加载）
        this.fetchVipStatus();

        // 诊断日志：检查后端是否真的返回 ai_title
        if (historyResponse.data && historyResponse.data.data && historyResponse.data.data.videos) {
          const firstVideo = historyResponse.data.data.videos[0];
          console.log('[AI诊断-V2] 视频总数:', historyResponse.data.data.videos.length);
          console.log('[AI诊断-V2] 第一条视频字段:', Object.keys(firstVideo).filter(k => k.includes('ai') || k.includes('title') || k.includes('optim')));
          console.log('[AI诊断-V2] 第一条 ai_title=', JSON.stringify(firstVideo.ai_title || ''));
          console.log('[AI诊断-V2] 第一条 optimization_tips 长度=', (firstVideo.optimization_tips || '').length);
          // 统计有多少条有 ai_title
          const withTitle = historyResponse.data.data.videos.filter(v => v.ai_title).length;
          console.log('[AI诊断-V2] 有 ai_title 的视频数:', withTitle, '/', historyResponse.data.data.videos.length);
        }

        // 处理查询历史数据
        if (historyResponse.data.code === 200) {
          // 如果返回数据格式正确
          if (historyResponse.data.data && historyResponse.data.data.videos) {
            // 设置总条数
            this.total = historyResponse.data.data.videos.length || 0;
            // 重置当前页码
            this.currentPage = 1;
            // 设置所有数据项
            this.allDataItems = [...historyResponse.data.data.videos];
            // 更新分页数据
            this.updatePaginatedData();
            // 显示成功消息
            this.$Message.success('查询历史加载成功');
          } else {
            // 数据格式不正确时清空数据
            this.allDataItems = [];
            this.dataItems = [];
            // 显示警告消息
            this.$Message.warning('查询历史数据格式不正确');
          }
        } else {
          if (historyResponse.data.code === 401) {
            this.clearUserState();
          }
          // 显示错误消息
          this.$Message.error(historyResponse.data.msg || '获取查询历史失败');
        }

        // 处理余额数据
        if (balanceResponse.data.code === 200) {
          // 如果返回数据格式正确
          if (balanceResponse.data.data && balanceResponse.data.data.balance !== undefined) {
            // 设置查询余额
            this.queryBalance = parseInt(balanceResponse.data.data.balance) || 0;
            // 保存余额到localStorage
            localStorage.setItem('userBalance', this.queryBalance);
            // 显示成功消息
            this.$Message.success('余额信息更新成功');
          } else {
            // 显示警告消息
            this.$Message.warning('余额数据格式不正确');
          }
        } else {
          if (historyResponse.data.code === 401) {
            this.clearUserState();
          }
          // 显示错误消息
          this.$Message.error(balanceResponse.data.msg || '获取余额失败');
        }

      } catch (error) {
        // 处理不同类型的错误
        if (error.response) {
          // 服务器返回错误状态码
          this.$Message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          // 网络请求无响应
          this.$Message.error('网络请求无响应，请检查网络连接');
        } else {
          // 其他错误
          this.$Message.error('数据加载失败，请稍后重试');
        }
      } finally {
        // 销毁所有消息提示
        this.$Message.destroy();
        // 重置加载状态
        this.loading = false;
      }
    },



    /**
     * 上一页
     */
    async prevPage() {
      if (!this.canPrev) return;

      this.isPageLoading = true;
      this.pageAction = 'prev';

      try {
        const currentAuthor = this.parsedAuthors[this.selectedAuthorIndex];
        if (!currentAuthor) return;

        const authorId = currentAuthor.id;
        const authorData = this.authorWorks[authorId];

        if (authorData && authorData.cursorHistory.length > 1) {
          // 移除当前游标
          authorData.cursorHistory.pop();
          // 获取上一个游标（注意这里需要获取倒数第二个元素）
          const prevCursor = authorData.cursorHistory[authorData.cursorHistory.length - 1];

          // 清空当前作品数据
          authorData.works = [];

          // 加载上一页数据，传递上一页的游标值
          await this.loadAuthorWorks(authorId, prevCursor);
        }
      } catch (error) {
        console.error('上一页加载失败:', error);
        this.$Message.error('加载上一页数据失败');
      } finally {
        this.isPageLoading = false;
        this.pageAction = '';
      }
    },
    /**
     * 下一页
     */
    // 修改 nextPage 方法
    async nextPage() {
      if (!this.canNext) return;

      this.isPageLoading = true;
      this.pageAction = 'next';

      try {
        const currentAuthor = this.parsedAuthors[this.selectedAuthorIndex];
        if (!currentAuthor) return;

        const authorId = currentAuthor.id;
        const authorData = this.authorWorks[authorId];

        if (authorData && authorData.hasNextPage) {
          // 保存当前游标到历史记录
          authorData.cursorHistory.push(authorData.currentCursor);

          // 清空当前作品数据
          authorData.works = [];

          // 加载下一页数据
          await this.loadAuthorWorks(authorId, authorData.currentCursor);
        }
      } catch (error) {
        console.error('下一页加载失败:', error);
        this.$Message.error('加载下一页数据失败');
      } finally {
        this.isPageLoading = false;
        this.pageAction = '';
      }
    },

    /**
     * 刷新全部查询历史数据
     * 调用 /api/v2/query/refresh API 刷新所有视频的最新数据
     */
    async refreshAllData() {
      // 检查用户登录状态
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }

      // 检查是否有数据可刷新
      if (!this.allDataItems || this.allDataItems.length === 0) {
        this.$Message.warning('没有数据可刷新');
        return;
      }

      // 设置刷新状态
      this.isRefreshing = true;

      try {
        // 显示加载提示
        this.$Modal.info({
          title: '刷新状态',
          content: '正在刷新全部数据，请不要关闭此页面，请稍候...',
          okText: '关闭',
          closable: true
        });

        // 从 localStorage 获取用户邮箱
        const userEmail = localStorage.getItem('userEmail') || '';

        // 提取所有视频 ID
        const videoIds = this.allDataItems.map(item => item.aweme_id);

        // 准备请求数据
        const requestData = {
          works_ids: videoIds,
          user_email: userEmail,
          include_play: this.isPlaying
        };

        const timestamp = Math.floor(Date.now() / 1000);
        const signature = Signature.generateSignature(requestData, timestamp);

        // 调用刷新 API（POST请求）
        const response = await apiClient.post('v2/query/refresh', requestData, {
          headers: {
            'X-Signature': signature,
            'X-Timestamp': timestamp
          }
        });

        // 检查API响应
        if (response.data.code === 200) {
          const resultData = response.data.data;

          // 更新数据
          if (resultData.results && Array.isArray(resultData.results)) {
            // 创建结果映射
            const resultMap = {};
            resultData.results.forEach(video => {
              if (video.aweme_id) {
                resultMap[video.aweme_id] = video;
              }
            });

            // 更新现有数据
            this.allDataItems = this.allDataItems.map(item => {
              if (resultMap[item.aweme_id]) {
                const updatedItem = {
                  id: Date.now() + Math.random(),
                  aweme_id: resultMap[item.aweme_id].aweme_id,
                  sec_uid: resultMap[item.aweme_id].sec_uid || '',
                  author_nickname: resultMap[item.aweme_id].owner_nickname || resultMap[item.aweme_id].author_info?.nickname || '',
                  author_unique_id: resultMap[item.aweme_id].owner_handle || resultMap[item.aweme_id].author_info?.unique_id || '',
                  aweme_cover: resultMap[item.aweme_id].cover_info?.default_cover || resultMap[item.aweme_id].aweme_cover || '',
                  media_type: resultMap[item.aweme_id].media_type || '',
                  collect_count: resultMap[item.aweme_id].collect_count || 0,
                  comment_count: resultMap[item.aweme_id].comment_count || 0,
                  download_count: resultMap[item.aweme_id].download_count || 0,
                  recommend_count: resultMap[item.aweme_id].recommend_count || 0,
                  digg_count: resultMap[item.aweme_id].digg_count || 0,
                  play_count: resultMap[item.aweme_id].play_count || 0,
                  share_count: resultMap[item.aweme_id].share_count || 0,
                  desc: resultMap[item.aweme_id].desc || '',
                  create_time: resultMap[item.aweme_id].create_time_formatted || resultMap[item.aweme_id].create_time || new Date().toLocaleString(),
                  publish_time: resultMap[item.aweme_id].publish_time || resultMap[item.aweme_id].create_time_formatted || new Date().toLocaleString(),
                  updated_at: new Date().toLocaleString(),
                  last_query_time: new Date().toLocaleString(),
                  query_count: (item.query_count || 0) + 1,
                  status: resultMap[item.aweme_id].status || 'success',
                  signature: resultMap[item.aweme_id].signature || '',
                  duration: resultMap[item.aweme_id].duration || 0,
                  duration_formatted: resultMap[item.aweme_id].duration_formatted || '',
                  media_type_desc: resultMap[item.aweme_id].media_type_desc || '',
                  orientation: resultMap[item.aweme_id].orientation || '',
                  width: resultMap[item.aweme_id].width || 0,
                  height: resultMap[item.aweme_id].height || 0,
                  cover_info: resultMap[item.aweme_id].cover_info || {},
                  download_allowed: resultMap[item.aweme_id].download_allowed,
                  download_disabled_reason: resultMap[item.aweme_id].download_disabled_reason || '',
                  download_url: resultMap[item.aweme_id].download_url || '',
                  data_size: resultMap[item.aweme_id].data_size || 0,
                  data_size_formatted: resultMap[item.aweme_id].data_size_formatted || '',
                  video_category: resultMap[item.aweme_id].video_category || '',
                  video_category_desc: resultMap[item.aweme_id].video_category_desc || '',
                  deleted: resultMap[item.aweme_id].deleted,
                  deleted_reason: resultMap[item.aweme_id].deleted_reason || '',
                  author_info: resultMap[item.aweme_id].author_info || {},
                  is_product_video: resultMap[item.aweme_id].is_product_video,
                  product_details: resultMap[item.aweme_id].product_details || {},
                  hot_words: resultMap[item.aweme_id].hot_words || [],
                  related_topics: resultMap[item.aweme_id].related_topics || [],
                  play_index: resultMap[item.aweme_id].play_index || 0,
                  traffic_pool: resultMap[item.aweme_id].traffic_pool || '',
                  traffic_pool_desc: resultMap[item.aweme_id].traffic_pool_desc || '',
                  is_limited: resultMap[item.aweme_id].is_limited,
                  limit_reason: resultMap[item.aweme_id].limit_reason || '',
                  admire_count: resultMap[item.aweme_id].admire_count || 0,
                  engagement_rate: resultMap[item.aweme_id].engagement_rate || 0,
                  engagement_rate_formatted: resultMap[item.aweme_id].engagement_rate_formatted || '',
                  optimization_tips: resultMap[item.aweme_id].optimization_tips || '',
                  weighted_engagement_rate: resultMap[item.aweme_id].weighted_engagement_rate || 0,
                  engagement_index: resultMap[item.aweme_id].engagement_index || 0,
                  weighted_engagement_rate_formatted: resultMap[item.aweme_id].weighted_engagement_rate_formatted || ''
                };
                delete resultMap[item.aweme_id];
                return updatedItem;
              }
              return item;
            });

            // 更新总条数
            this.total = this.allDataItems.length;

            // 重置到第一页
            this.currentPage = 1;

            // 更新分页数据
            this.updatePaginatedData();
          }

          // 更新用户余额
          if (resultData.new_balance !== undefined) {
            this.queryBalance = resultData.new_balance;
            localStorage.setItem('userBalance', this.queryBalance.toString());
          }

          // 显示成功消息
          this.$Message.success(
            `刷新完成！成功: ${resultData.success_count || 0}, 失败: ${resultData.error_count || 0}`
          );
        } else {
          this.$Message.error(response.data.msg || '刷新失败');
        }
      } catch (error) {
        console.error('刷新全部数据失败:', error);
        if (error.response) {
          this.$Message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          this.$Message.error('网络请求无响应，请检查网络连接');
        } else {
          this.$Message.error('刷新失败，请稍后重试');
        }
      } finally {
        // 清除加载提示
        this.$Modal.remove();
        // 重置刷新状态
        this.isRefreshing = false;
      }
    },

    /**
     * 清空所有待查询项
     */
    clearAllPending() {
      // 检查登录状态
      if (!this.checkLoginStatus()) return;
      
      // 如果有待查询项
      if (this.pendingItems.length > 0) {
        // 显示确认对话框
        this.$Modal.confirm({
          title: '确认清空',
          content: '确定要清空所有待查询项吗？',
          onOk: () => {
            // 清空待查询项
            this.pendingItems = [];
            // 显示成功消息
            this.$Message.success('已清空所有待查询项');
          }
        });
      }
    },

    /**
     * 提取文本中的抖音链接
     * @param {string} text - 输入文本
     * @returns {string} 提取到的链接或原文本
     */
    extractDouyinUrl(text) {
      if (!text) return '';

      // 多种抖音链接格式的正则表达式
      const urlPatterns = [
        // 完整的抖音链接
        /https?:\/\/v\.douyin\.com\/[a-zA-Z0-9_\-\/?=&#.]+/i,
        /https?:\/\/www\.douyin\.com\/[a-zA-Z0-9_\-\/?=&#.]+/i,
        // 短链接格式
        /https?:\/\/v\.douyin\.com\/[a-zA-Z0-9]+/i,
        // 包含视频ID的链接
        /https?:\/\/[a-zA-Z0-9\-\.]*douyin\.com\/video\/[0-9]+/i,
        // 包含modal_id参数的链接
        /https?:\/\/[a-zA-Z0-9\-\.]*douyin\.com\/[a-zA-Z0-9_\-\/?=&#]*modal_id=([0-9]+)/i,
        // 其他可能的抖音域名
        /https?:\/\/[a-zA-Z0-9\-\.]*iesdouyin\.com\/[a-zA-Z0-9_\-\/?=&#.]+/i
      ];

      // 尝试匹配各种链接格式
      for (const pattern of urlPatterns) {
        const match = text.match(pattern);
        if (match) {
          return match[0];
        }
      }

      // 如果没有找到链接，返回原文本
      return text.trim();
    },

    /**
     * 添加单条查询项
     */
    async addItem() {
      // 输出当前登录状态日志
      //console.log('当前登录状态:', this.isUserLoggedIn);
      // 如果用户未登录
      if (!this.isUserLoggedIn) {
        // 显示登录模态框
        this.showLoginModal = true;
        // 返回，不继续执行
        return;
      }

      // 如果输入值为空
      if (!this.inputValue.trim()) {
        // 显示警告消息
        this.$Message.warning('请输入作品分享链接或ID');
        // 返回，不继续执行
        return;
      }

      // 如果待查询项数量已达20个
      if (this.pendingItems.length >= 20) {
        // 显示警告消息
        this.$Message.warning('最多只能添加20个查询项');
        // 返回，不继续执行
        return;
      }

      try {
        // 提取抖音链接
        const extractedUrl = this.extractDouyinUrl(this.inputValue);

        // 检查是否为有效的URL或ID
        if (!extractedUrl) {
          this.$Message.warning('未找到有效的抖音视频链接');
          return;
        }

        let videoId = null;
        let displayText = '';

        // 处理不同格式的链接
        if (extractedUrl.startsWith('http')) {
          // 处理新链接格式: https://www.iesdouyin.com/share/video/7523965230288817449
          const shareLinkMatch = extractedUrl.match(/https?:\/\/www\.iesdouyin\.com\/share\/video\/(\d+)/);

          if (shareLinkMatch && shareLinkMatch[1]) {
            videoId = shareLinkMatch[1];
            displayText = videoId;
          } else {
            // 处理长链接格式: https://www.douyin.com/video/7234567890123456789
            const longLinkMatch = extractedUrl.match(/https?:\/\/www\.douyin\.com\/video\/(\d+)/);
            if (longLinkMatch && longLinkMatch[1]) {
              videoId = longLinkMatch[1];
              displayText = videoId;
            } else {
              // 处理modal_id参数格式: https://www.douyin.com/jingxuan?modal_id=7536526157475319092
              const modalIdMatch = extractedUrl.match(/[?&]modal_id=(\d+)/);
              if (modalIdMatch && modalIdMatch[1]) {
                videoId = modalIdMatch[1];
                displayText = videoId;
              } else {
                // 处理短链接格式: https://v.douyin.com/xxxxxx/
                const shortLinkMatch = extractedUrl.match(/https?:\/\/v\.douyin\.com\/([a-zA-Z0-9\-_]+)/);
                if (shortLinkMatch && shortLinkMatch[1]) {
                  // 显示加载提示
                  this.$Message.loading({
                    content: '正在解析链接...',
                    duration: 0
                  });

                  try {
                    // 调用后端API解析短链接
                    const response = await apiClient.post('/query/parse-link', { douyin_url: extractedUrl });

                    // 如果解析成功
                    if (response.data.code === 200 && response.data.data && response.data.data.video_id) {
                      // 设置视频ID
                      videoId = response.data.data.video_id;
                      // 设置显示文本
                      displayText = videoId;
                      this.$Message.destroy(); // 关闭加载提示
                    } else {
                      this.$Message.destroy(); // 关闭加载提示
                      // 显示错误消息
                      this.$Message.error('链接解析失败，请检查链接是否正确');
                      // 返回，不继续执行
                      return;
                    }
                  } catch (error) {
                    this.$Message.destroy(); // 关闭加载提示
                    // 处理不同类型的错误
                    if (error.response) {
                      // 服务器返回错误状态码
                      this.$Message.error(`服务器错误: ${error.response.status}`);
                    } else if (error.request) {
                      // 网络请求无响应
                      this.$Message.error('网络请求无响应，请检查网络连接');
                    } else {
                      // 其他错误
                      this.$Message.error('请求配置错误');
                    }
                    // 返回，不继续执行
                    return;
                  }
                } else {
                  // 未匹配到任何已知链接格式
                  this.$Message.warning('未识别到有效的抖音链接格式');
                  return;
                }
              }
            }
          }
        } else {
          // 处理纯数字ID输入
          const isPureNumber = /^\d+$/.test(extractedUrl);
          if (!isPureNumber) {
            this.$Message.warning('请输入有效的数字ID');
            return;
          }

          // 不再检查数字ID长度是否大于等于15位，允许任何长度的数字ID
          videoId = extractedUrl.replace(/[^\d]/g, '');
          displayText = videoId;
        }

        // 检查是否获取到有效的视频ID
        if (!videoId) {
          this.$Message.warning('未识别到有效的抖音链接或ID格式');
          return;
        }


        // 检查数字ID长度是否大于等于15位
        if (videoId.length < 15) {
          this.$Message.warning('请输入大于等于15位的纯数字视频ID');
          return;
        }

        // 检查是否已存在
        if (this.pendingItems.some(item => item.id === videoId)) {
          // 显示警告消息
          this.$Message.warning('该查询项已存在');
          // 返回，不继续执行
          return;
        }

        // 添加到待查询项
        this.pendingItems.push({
          id: videoId,
          displayText: displayText,
          originalUrl: extractedUrl
        });

        // 清空输入框
        this.inputValue = '';
        // 显示成功消息
        this.$Message.success('添加成功');
      } catch (error) {
        // 显示错误消息
        this.$Message.error('添加项失败，请稍后重试');
      }
    },
    /**
     * 移除查询项
     * @param {number} index - 要移除项的索引
     */
    removeItem(index) {
      // 从待查询项数组中移除指定索引的项
      this.pendingItems.splice(index, 1);
    },

    /**
     * 批量查询
     */
    async batchQuery() {
      // 检查用户登录状态
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true; // 如果用户未登录，显示登录模态框
        return;
      }

      // 如果没有待查询项
      if (this.pendingItems.length === 0) {
        this.$Message.warning('请先添加查询项'); // 提示用户需要添加查询项
        return;
      }

      // 设置查询状态为 true
      this.isBatchQuerying = true;

      try {
        // 显示加载遮罩层
        this.showQueryLoading = true;
        
        // 获取用户邮箱和 token
        const userEmail = localStorage.getItem('userEmail') || ''; // 从 localStorage 获取用户邮箱
        const token = localStorage.getItem('token') || '';         // 从 localStorage 获取用户 token
        const isPlaying = this.isPlaying;                         // 获取是否播放状态

        // 提取所有待查询的视频 ID
        const videoIds = this.pendingItems.map(item => item.id); // 从 pendingItems 中提取视频 ID 列表
        const requestData = {
          works_ids: videoIds, // 查询的视频 ID 列表
          user_email: userEmail, // 用户邮箱
          include_play: isPlaying // 是否包含播放量
        };

        // 生成签名
        const timestamp = Math.floor(Date.now() / 1000);
        const signature = Signature.generateSignature(requestData, timestamp);
        // 发送查询请求
        //const response = await axios.post('api/query/douyin', requestData, config);
        const response = await apiClient.post('v2/query/douyin', requestData, {
          headers: {
            'X-Signature': signature,
            'X-Timestamp': timestamp
          }
        });
        // 如果查询成功
        if (response.data.code === 200) {
          const resultData = response.data.data;

          this.currentVideoDetails = response.data.data;  // 赋值视频详情数据

          // 更新用户余额
          if (resultData.new_balance !== undefined) {
            this.queryBalance = resultData.new_balance;          // 更新查询余额
            localStorage.setItem('userBalance', this.queryBalance); // 将新余额保存到 localStorage
          }

          // 处理查询结果
          if (resultData.results && Array.isArray(resultData.results)) {
            const resultMap = {};
            resultData.results.forEach(video => {
              // 诊断日志：看看 AI 标题有没有正常返回
              console.log('[AI诊断] aweme_id=' + video.aweme_id,
                'ai_title=' + JSON.stringify(video.ai_title || ''),
                'optimization_tips长度=' + (video.optimization_tips || '').length
              );
              resultMap[video.aweme_id] = video;                 // 构建以 aweme_id 为键的结果映射
            });

            const existingItems = [];// 用于存储已存在的数据项
            const newItems = [];// 用于存储新数据项

            // 更新现有数据
            this.allDataItems.forEach(item => {
              if (resultMap[item.aweme_id]) {
                const updatedItem = {
                  ...item,
                  ...resultMap[item.aweme_id],
                  // 特别处理作者信息
                  author_nickname: resultMap[item.aweme_id].owner_nickname || resultMap[item.aweme_id].author_info?.nickname || item.author_nickname || '',
                  author_unique_id: resultMap[item.aweme_id].owner_handle || resultMap[item.aweme_id].author_info?.unique_id || item.author_unique_id || '',
                  follower_count: resultMap[item.aweme_id].author_info?.follower_count || resultMap[item.aweme_id].follower_count || 0,
                  following_count: resultMap[item.aweme_id].author_info?.following_count || resultMap[item.aweme_id].following_count || 0,
                  aweme_count: resultMap[item.aweme_id].author_info?.aweme_count || resultMap[item.aweme_id].aweme_count || 0,
                  total_favorited: resultMap[item.aweme_id].author_info?.total_favorited || resultMap[item.aweme_id].total_favorited || 0,
                  verification_type_desc: resultMap[item.aweme_id].author_info?.verification_type_desc || resultMap[item.aweme_id].verification_type_desc || '',
                  enterprise_verify_reason: resultMap[item.aweme_id].author_info?.enterprise_verify_reason || resultMap[item.aweme_id].enterprise_verify_reason || '',
                  // 特别处理时间信息
                  create_time: resultMap[item.aweme_id].create_time || item.create_time || new Date().toLocaleString(),
                  publish_time: resultMap[item.aweme_id].publish_time || item.publish_time || new Date().toLocaleString(),
                  updated_at: new Date().toLocaleString(),       // 更新时间
                  last_query_time:  resultMap[item.aweme_id].last_query_time,  // 最后查询时间
                  query_count: (item.query_count || 0) + 1,     // 查询次数加 1
                  status: resultMap[item.aweme_id].status || 'success' // 查询状态
                };
                existingItems.push(updatedItem);                // 将更新后的项添加到现有数据中
                delete resultMap[item.aweme_id];                // 从结果映射中删除已处理的项
              } else {
                existingItems.push(item);                       // 如果未匹配到，则保留原数据
              }
            });

            // 添加新数据
            Object.values(resultMap).forEach(video => {
              const newItem = {
                id: Date.now() + Math.random(),                 // 生成唯一 ID
                aweme_id: video.aweme_id,                       // 视频 ID
                sec_uid: video.sec_uid || '',                   // 安全用户ID
                author_nickname: video.owner_nickname || video.author_info?.nickname || '',   // 作者昵称
                author_unique_id: video.owner_handle || video.author_info?.unique_id || '',   // 作者唯一 ID
                aweme_cover: video.cover_info?.default_cover || video.aweme_cover || '',      // 封面图片
                media_type: video.media_type || '',             // 媒体类型
                collect_count: video.collect_count || 0,        // 收藏数
                comment_count: video.comment_count || 0,        // 评论数
                download_count: video.download_count || 0,      // 下载数
                recommend_count: video.recommend_count || 0,    // 推荐数
                digg_count: video.digg_count || 0,              // 点赞数
                play_count: video.play_count || 0,              // 播放数
                share_count: video.share_count || 0,            // 转发数
                desc: video.desc || '',                         // 描述
                create_time: video.create_time || new Date().toLocaleString(),     // 创建时间
                publish_time: video.publish_time || new Date().toLocaleString(),    // 发布时间
                updated_at: new Date().toLocaleString(),        // 更新时间
                last_query_time: video.last_query_time,   // 最后查询时间
                query_count: 1,                                 // 查询次数
                status: video.status || 'success',              // 查询状态
                // 新增字段
                signature: video.author_info?.signature || video.signature || '',// 用户签名
                follower_count: video.author_info?.follower_count || video.follower_count || 0, // 粉丝数
                following_count: video.author_info?.following_count || video.following_count || 0, // 关注数
                aweme_count: video.author_info?.aweme_count || video.aweme_count || 0, // 作品数
                total_favorited: video.author_info?.total_favorited || video.total_favorited || 0, // 总获赞
                verification_type_desc: video.author_info?.verification_type_desc || video.verification_type_desc || '', // 认证信息
                enterprise_verify_reason: video.author_info?.enterprise_verify_reason || video.enterprise_verify_reason || '', // 企业认证
                video_category_desc: video.video_category_desc || '', // 视频分类
                orientation: video.orientation || '',           // 作品形式
                duration_formatted: video.duration_formatted || '', // 时长
                width: video.width || 0,                        // 宽度
                height: video.height || 0,                      // 高度
                data_size_formatted: video.data_size_formatted || '', // 视频大小
                play_index: video.play_index || 0,              // 播放指数
                traffic_pool_desc: video.traffic_pool_desc || video.traffic_pool || '', // 流量池
                is_limited: video.is_limited,                   // 是否限流
                limit_reason: video.limit_reason || '',         // 限流原因
                is_deleted: video.deleted,                      // 是否删除
                deleted_reason: video.deleted_reason || '',     // 删除原因
                download_allowed: video.download_allowed,       // 是否可下载
                download_disabled_reason: video.download_disabled_reason || '', // 不可下载原因
                admire_count: video.admire_count || 0,          // 赞赏数
                engagement_rate_formatted: video.engagement_rate_formatted || '', // 互动率
                hot_words: video.hot_words || [],               // 热词
                optimization_tips: video.optimization_tips || '' // 优化建议
              };
              newItems.push(newItem);                          // 将新数据添加到新数据列表中
            });

            // 合并数据
            this.allDataItems = [...newItems, ...existingItems]; // 合并新数据和现有数据
            this.total = this.allDataItems.length;              // 更新总条数
            this.updatePaginatedData();                         // 更新分页数据
          }

          // 构建查询结果列表
          this.queryResultList = resultData.results.map(video => ({
            aweme_id: video.aweme_id,                           // 视频 ID
            status: video.status === 'success' ? '成功' : '失败', // 查询状态
            message: video.message || '未知错误'
          }));

          // 显示查询结果 Modal（不再自动关闭，由用户手动关闭）
          this.showQueryResultModal = true;

          // 显示查询结果信息
          this.$Message.success(
              `查询完成！成功: ${resultData.success_count || 0}, 失败: ${resultData.error_count || 0}`
          );

          // 清空待查询项
          this.pendingItems = [];

          // 更新当前视频详情 只更新第一个
          this.currentVideoDetails =this.allDataItems[0]
          // 确保模态框显示并切换到优化建议标签
          this.showDetailModal = true;  // 显示模态框
          await this.$nextTick(() => {
            this.activeTab = 'suggestions';  // 切换到优化建议标签
          });



        } else {
          this.$Message.error({
            content: response.data.msg || '查询失败',
            duration: 5 // 显示 3 秒钟，单位是秒
          });
        }
      } catch (error) {
        if (error.response) {
          this.$Message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          this.$Message.error('网络请求无响应，请检查网络连接');
        } else {
          this.$Message.error('查询失败，请稍后重试');
        }
      } finally {
        // 隐藏加载遮罩层
        this.showQueryLoading = false;
        this.$Modal.remove(); // 手动关闭模态框
        // 设置查询状态为 false

        this.isBatchQuerying = false;
        this.$Message.destroy(); // 销毁所有消息提示
      }
    },


    /**
     * 删除失败的项
     * @param {Array} failedIds - 查询失败的视频 ID 列表
     */
    async deleteFailedItems(failedIds) {
      try {
        const userEmail = localStorage.getItem('userEmail') || '';
        const token = localStorage.getItem('token') || '';

        // const config = {
        //   headers: {
        //     'Authorization': `Bearer ${token}`,
        //     'Content-Type': 'application/json'
        //   }
        // };

        // 调用删除 API
        // const response = await axios.post('api/query/delete', {
        //   works_ids: failedIds,
        //   user_email: userEmail
        // }, config);
        const response = await apiClient.post('query/delete', {
          works_ids: failedIds,
          user_email: userEmail
        });

        if (response.data.code === 200) {
          this.$Message.success('已自动删除查询失败的项');
        } else {
          this.$Message.error('删除失败项时出错');
        }
      } catch (error) {
        if (error.response) {
          this.$Message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          this.$Message.error('网络请求无响应，请检查网络连接');
        } else {
          this.$Message.error('删除失败项时出错');
        }
      }
    },
    /**
     * 全选/取消全选
     */
    selectAll() {
      // 如果用户未登录
      if (!this.isUserLoggedIn) {
        // 显示登录模态框
        this.showLoginModal = true;
        // 返回，不继续执行
        return;
      }
      // 判断当前是否已全选
      const isCurrentlySelectedAll = this.selectedItems.length > 0 && this.selectedItems.length === this.dataItems.length;

      // 如果当前已全选
      if (isCurrentlySelectedAll) {
        // 取消全选
        this.clearSelection();
      } else {
        // 执行全选
        this.doSelectAll();
      }
    },

    /**
     * 执行全选操作
     */
    doSelectAll() {
      // 在移动端只全选当前显示的 3 条数据
      const itemsToSelect = this.isMobile ? this.dataItems.slice(0, 3) : this.dataItems;
          
      // 设置选中项为当前页所有数据
      this.selectedItems = [...itemsToSelect];
    
      // 在下一个 DOM 更新周期执行
      this.$nextTick(() => {
        // 优先使用 View UI Plus 的 API
        if (this.$refs.selection) {
          // 清空当前选择
          this.$refs.selection.selectAll(false);
          
          // 逐个选中需要的项目
          itemsToSelect.forEach(item => {
            this.$refs.selection.toggleSelect(this.dataItems.indexOf(item));
          });
        } else {
          // 备用方案：通过 DOM 操作
          const checkboxes = document.querySelectorAll('.ivu-table-body .ivu-checkbox-input');
          // 遍历复选框
          checkboxes.forEach((checkbox, index) => {
            // 只选中前 itemsToSelect.length 个复选框
            if (index < itemsToSelect.length && !checkbox.checked) {
              // 触发点击事件
              checkbox.click();
            }
          });
        }
      });
    
      // 设置全选状态
      this.isAllSelected = true;
      // 显示信息消息
      this.$Message.info('已全选当前页');
    },

    /**
     * 清除所有选择
     */
    clearSelection() {
      // 清空选中项
      this.selectedItems = [];

      // 在下一个DOM更新周期执行
      this.$nextTick(() => {
        // 优先使用 View UI Plus 的 API
        if (this.$refs.selection) {
          // 取消所有选择
          this.$refs.selection.selectAll(false);
        } else {
          // 备用方案：通过 DOM 操作
          const checkboxes = document.querySelectorAll('.ivu-table-body .ivu-checkbox-input');
          // 遍历复选框
          checkboxes.forEach(checkbox => {
            // 如果复选框已选中
            if (checkbox.checked) {
              // 点击复选框
              checkbox.click();
            }
          });
        }
      });

      // 重置全选状态
      this.isAllSelected = false;
      // 显示信息消息
      this.$Message.info('已取消选择');
    },

    /**
     * 刷新选中数据
     */
    async refresh() {
      // 检查用户登录状态
      await this.checkUserLoginStatus();

      // 如果用户未登录，显示登录模态框
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }

      // 如果没有选中的数据
      if (this.selectedItems.length === 0) {
        // 显示警告消息
        this.$Message.warning('请先选择要刷新的数据');
        // 返回，不继续执行
        return;
      }

      // 设置刷新状态
      this.isRefreshing = true;

      try {
        // 隐藏可能残留的加载遮罩层
        this.showQueryLoading = false;
        
        // 显示加载提示
        this.$Modal.info({
          title: '刷新状态',
          content: '正在刷新数据，请不要关闭此页面，请稍候...',
          okText: '关闭',
          closable: true
        });

        // 获取用户邮箱和 token
        const userEmail = localStorage.getItem('userEmail') || '';
        const token = localStorage.getItem('token') || '';

        // 提取所有选中项的视频 ID
        const videoIds = this.selectedItems.map(item => item.aweme_id);

        // 准备请求数据
        const requestData = {
          works_ids: videoIds,
          user_email: userEmail,
          include_play: this.isPlaying
        };

        // 设置请求配置
        /*  const config = {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          };*/

        const timestamp = Math.floor(Date.now() / 1000);
        const signature = Signature.generateSignature(requestData, timestamp);
        // 发送刷新请求
        const response = await apiClient.post('v2/query/refresh', requestData, {
          headers: {
            'X-Signature': signature,
            'X-Timestamp': timestamp
          }
        });

        // 如果请求成功
        if (response.data.code === 200) {
          // 获取结果数据
          const resultData = response.data.data;



          // 显示成功消息
          this.$Message.success(
              `刷新完成！成功: ${resultData.success_count || 0}, 失败: ${resultData.error_count || 0}`
          );

          // 更新数据
          if (resultData.results && Array.isArray(resultData.results)) {
            // 创建结果映射
            const resultMap = {};
            resultData.results.forEach(video => {
              if (video.aweme_id) {
                resultMap[video.aweme_id] = video;
              }
            });

            // 更新现有数据
            this.allDataItems = this.allDataItems.map(item => {
              // 如果在结果映射中找到匹配的作品ID
              if (resultMap[item.aweme_id]) {
                // 创建更新后的项，保持与查询时相同的数据结构
                const updatedItem = {
                  id: Date.now() + Math.random(),                 // 生成唯一 ID
                  aweme_id: resultMap[item.aweme_id].aweme_id,                       // 视频 ID
                  sec_uid: resultMap[item.aweme_id].sec_uid || '',                   // 安全用户ID
                  author_nickname: resultMap[item.aweme_id].owner_nickname || resultMap[item.aweme_id].author_info?.nickname || '',   // 作者昵称
                  author_unique_id: resultMap[item.aweme_id].owner_handle || resultMap[item.aweme_id].author_info?.unique_id || '',   // 作者唯一 ID
                  aweme_cover: resultMap[item.aweme_id].cover_info?.default_cover || resultMap[item.aweme_id].aweme_cover || '',      // 封面图片
                  media_type: resultMap[item.aweme_id].media_type || '',             // 媒体类型
                  collect_count: resultMap[item.aweme_id].collect_count || 0,        // 收藏数
                  comment_count: resultMap[item.aweme_id].comment_count || 0,        // 评论数
                  download_count: resultMap[item.aweme_id].download_count || 0,      // 下载数
                  recommend_count: resultMap[item.aweme_id].recommend_count || 0,    // 推荐数
                  digg_count: resultMap[item.aweme_id].digg_count || 0,              // 点赞数
                  play_count: resultMap[item.aweme_id].play_count || 0,              // 播放数
                  share_count: resultMap[item.aweme_id].share_count || 0,            // 转发数
                  desc: resultMap[item.aweme_id].desc || '',                         // 描述
                  create_time: resultMap[item.aweme_id].create_time_formatted || resultMap[item.aweme_id].create_time || new Date().toLocaleString(),     // 创建时间
                  publish_time: resultMap[item.aweme_id].publish_time || resultMap[item.aweme_id].create_time_formatted || new Date().toLocaleString(),    // 发布时间
                  updated_at: new Date().toLocaleString(),        // 更新时间
                  last_query_time: new Date().toLocaleString(),   // 最后查询时间
                  query_count: (item.query_count || 0) + 1,     // 查询次数加 1
                  status: resultMap[item.aweme_id].status || 'success',              // 查询状态

                  // 新增字段
                  signature: resultMap[item.aweme_id].signature || '',              // 作者签名
                  duration: resultMap[item.aweme_id].duration || 0,                // 视频时长
                  duration_formatted: resultMap[item.aweme_id].duration_formatted || '', // 格式化视频时长
                  media_type_desc: resultMap[item.aweme_id].media_type_desc || '', // 媒体类型描述
                  orientation: resultMap[item.aweme_id].orientation || '',         // 视频方向
                  width: resultMap[item.aweme_id].width || 0,                      // 视频宽度
                  height: resultMap[item.aweme_id].height || 0,                    // 视频高度
                  cover_info: resultMap[item.aweme_id].cover_info || {},           // 封面信息
                  download_allowed: resultMap[item.aweme_id].download_allowed,     // 是否可下载
                  download_disabled_reason: resultMap[item.aweme_id].download_disabled_reason || '', // 不可下载原因
                  download_url: resultMap[item.aweme_id].download_url || '',       // 下载链接
                  data_size: resultMap[item.aweme_id].data_size || 0,              // 数据大小
                  data_size_formatted: resultMap[item.aweme_id].data_size_formatted || '', // 格式化数据大小
                  video_category: resultMap[item.aweme_id].video_category || '',   // 视频分类
                  video_category_desc: resultMap[item.aweme_id].video_category_desc || '', // 视频分类描述
                  deleted: resultMap[item.aweme_id].deleted,                      // 是否删除
                  deleted_reason: resultMap[item.aweme_id].deleted_reason || '',   // 删除原因
                  author_info: resultMap[item.aweme_id].author_info || {},         // 作者信息
                  is_product_video: resultMap[item.aweme_id].is_product_video,     // 是否带货视频
                  product_details: resultMap[item.aweme_id].product_details || {}, // 带货详情
                  hot_words: resultMap[item.aweme_id].hot_words || [],             // 热词
                  related_topics: resultMap[item.aweme_id].related_topics || [],   // 相关话题
                  play_index: resultMap[item.aweme_id].play_index || 0,            // 播放指数
                  traffic_pool: resultMap[item.aweme_id].traffic_pool || '',       // 流量池
                  traffic_pool_desc: resultMap[item.aweme_id].traffic_pool_desc || '', // 流量池描述
                  is_limited: resultMap[item.aweme_id].is_limited,                 // 是否限流
                  limit_reason: resultMap[item.aweme_id].limit_reason || '',       // 限流原因
                  admire_count: resultMap[item.aweme_id].admire_count || 0,        // 赞赏数
                  engagement_rate: resultMap[item.aweme_id].engagement_rate || 0,  // 互动率
                  engagement_rate_formatted: resultMap[item.aweme_id].engagement_rate_formatted || '', // 格式化互动率
                  optimization_tips: resultMap[item.aweme_id].optimization_tips || '', // 优化建议
                  weighted_engagement_rate: resultMap[item.aweme_id].weighted_engagement_rate || 0, // 加权互动率
                  engagement_index: resultMap[item.aweme_id].engagement_index || 0, // 互动指数
                  weighted_engagement_rate_formatted: resultMap[item.aweme_id].weighted_engagement_rate_formatted || '' // 格式化加权互动率
                };

                // 从结果映射中删除已处理的项
                delete resultMap[item.aweme_id];

                return updatedItem;
              }
              return item;
            });

            // 更新分页数据
            this.updatePaginatedData();
          }

          // 更新用户余额
          if (resultData.new_balance !== undefined) {
            this.queryBalance = resultData.new_balance;
            localStorage.setItem('userBalance', this.queryBalance.toString());
          }

          // 构建刷新结果列表
          this.queryResultList = resultData.results.map(video => ({
            aweme_id: video.aweme_id || '未知ID',
            status: video.status === 'success' ? '成功' : '失败',
            message: video.message || '未知错误'
          }));

          // 显示刷新结果 Modal（不再自动关闭，由用户手动关闭）
          this.showQueryResultModal = true;

          this.currentVideoDetails =this.allDataItems[0]
          // 确保模态框显示并切换到优化建议标签
          this.showDetailModal = true;  // 显示模态框
          await this.$nextTick(() => {
            this.activeTab = 'suggestions';  // 切换到优化建议标签
          });


        } else {
          this.$Message.error({
            content: response.data.msg || '刷新失败',
            duration: 5
          });
        }
      } catch (error) {
        if (error.response) {
          this.$Message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          this.$Message.error('网络请求无响应，请检查网络连接');
        } else {
          this.$Message.error('刷新失败，请稍后重试');
        }
      } finally {
        // 隐藏加载遮罩层
        this.showQueryLoading = false;
        this.$Modal.remove(); // 手动关闭模态框
        this.isRefreshing = false; // 重置刷新状态
      }
    },
    /**
     * 删除选中数据
     */
    async clearAll() {
      // 检查用户登录状态
      await this.checkUserLoginStatus();
      // 如果用户未登录
      if (!this.isUserLoggedIn) {
        // 显示登录模态框
        this.showLoginModal = true;
        // 返回，不继续执行
        return;
      }
      // 如果没有选中的数据
      if (this.selectedItems.length === 0) {
        // 显示警告消息
        this.$Message.warning('请先选择要删除的数据');
        // 返回，不继续执行
        return;
      }

      // 显示确认对话框
      this.$Modal.confirm({
        title: '确认删除',
        content: `<p>确定要删除选中的 ${this.selectedItems.length} 条查询记录吗？此操作不可恢复！</p>`,
        okText: '确定删除',
        cancelText: '取消',
        onOk: async () => {
          try {
            // 显示加载提示
            this.$Message.loading({
              content: '正在删除数据...',
              duration: 0,
              closable: true
            });

            // 从localStorage获取用户邮箱
            const userEmail = localStorage.getItem('userEmail') || '';
            // 从localStorage获取token
            const token = localStorage.getItem('token') || '';

            // 设置请求配置
            // const config = {
            //   headers: {
            //     'Authorization': `Bearer ${token}`,
            //     'Content-Type': 'application/json'
            //   }
            // };

            // 提取选中作品的ID
            const worksIds = this.selectedItems.map(item => item.aweme_id);
            // 发送删除请求
            // const response = await axios.post('api/query/delete', {
            //   works_ids: worksIds,
            //   user_email: userEmail
            // }, config);
            const response = await apiClient.post('query/delete', {
              works_ids: worksIds,
              user_email: userEmail
            });

            // 如果删除成功
            if (response.data.code === 200) {
              // 创建删除ID集合
              const deletedIds = new Set(worksIds);
              // 从本地数据中移除已删除的项目
              this.allDataItems = this.allDataItems.filter(item => !deletedIds.has(item.aweme_id));

              // 更新总数
              this.total = this.allDataItems.length;

              // 确保当前页不超过最大页数
              const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
              // 如果当前页超过最大页数
              if (this.currentPage > maxPage) {
                // 设置当前页为最大页数
                this.currentPage = maxPage;
              }

              // 更新当前页显示的数据
              this.updatePaginatedData();

              // 清空选中项
              this.selectedItems = [];
              // 重置全选状态
              this.isAllSelected = false;

              // 显示成功消息
              this.$Message.success('数据删除成功');
            } else {
              // 显示错误消息
              this.$Message.error(response.data.msg || '删除失败');
            }
          } catch (error) {
            // 处理不同类型的错误
            if (error.response) {
              // 服务器返回错误状态码
              this.$Message.error(`服务器错误: ${error.response.status}`);
            } else if (error.request) {
              // 网络请求无响应
              this.$Message.error('网络请求无响应，请检查网络连接');
            } else {
              // 其他错误
              this.$Message.error('删除失败，请稍后重试');
            }
          } finally {
            // 销毁所有消息提示
            this.$Message.destroy();
          }
        },
        onCancel: () => {
          // 输出取消删除日志
          console.log('用户取消删除');
        }
      });
    },

    /**
     * 导出数据到Excel
     */
    exportToExcel() {
      // 检查用户登录状态
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }

      // 检查是否有数据可导出
      if (!this.allDataItems || this.allDataItems.length === 0) {
        this.$Message.warning('没有数据可导出');
        return;
      }

      try {
        // 准备导出的数据
        const exportData = this.allDataItems.map((item, index) => {
          return {
            '序号': index + 1,
            '作品ID': "https://www.douyin.com/video/"+item.aweme_id || '',
            '作者昵称': item.owner_nickname || item.author_nickname || '',
            '作者ID': item.owner_handle || item.author_unique_id || '',
            '作品描述': item.desc || '',
            '作品状态': item.status === 'error' ? '失败' : '成功',
            '作品分类': item.video_category_desc || item.video_category || '',
            '作品形式': item.orientation || '',
            '作品时长': item.duration_formatted || '',
            '分辨率': (item.width || '未知') + 'x' + (item.height || '未知'),
            '视频大小': item.data_size_formatted || '',
            '粉丝数': item.author_info?.follower_count || item.follower_count || 0,
            '关注数': item.author_info?.following_count || item.following_count || 0,
            '作品数': item.author_info?.aweme_count || item.aweme_count || 0,
            '总获赞数': item.author_info?.total_favorited || item.total_favorited || 0,
            '认证类型': item.author_info?.verification_type_desc || item.verification_type_desc || '',
            '认证描述': item.author_info?.verification_desc || item.verification_desc || '',
            '企业认证': item.author_info?.enterprise_verify_reason || item.enterprise_verify_reason || '',
            '播放数': item.play_count || 0,
            '点赞数': item.digg_count || 0,
            '评论数': item.comment_count || 0,
            '收藏数': item.collect_count || 0,
            '转发数': item.share_count || 0,
            '下载数': item.download_count || 0,
            '推荐数': item.recommend_count || 0,
            '赞赏数': item.admire_count || 0,
            '播放指数': item.play_index || 0,
            '互动率': item.engagement_rate_formatted ||
                (item.engagement_rate ? (parseFloat(item.engagement_rate) * 100).toFixed(2) + '%' : '0%'),
            '加权互动率': item.weighted_engagement_rate_formatted || '0%',
            '流量池': item.traffic_pool_desc || item.traffic_pool || '未知',
            '限流': (item.is_limited === true || item.is_limited === 1) ? '是' : '否',
            '删除': (item.is_deleted === true || item.deleted === true || item.is_deleted === 1) ? '是' : '否',
            '可下载': (item.download_allowed === true || item.download_allowed === 1) ? '是' : '否',
            '带货': (item.is_product_video === true || item.is_product_video === 1) ? '是' : '否',
            '查询次数': item.query_count || 0,
            '创建时间': item.create_time || '',
            '更新时间': item.last_query_time || '',
            '发布时间': item.publish_time || '',
            '热搜词': this.formatHotWordsForExport(item.hot_words),
            '优化建议': Array.isArray(item.optimization_tips) ?
                item.optimization_tips.join('; ') :
                (item.optimization_tips || ''),
            'AI推荐标题': item.ai_title || '',
            '内容质量评分': item.content_evaluation || '',
            '数据表现分析': item.data_analysis || '',
            '优化方向': item.optimization_directions || '',
            '推荐话题标签': item.hashtag_suggestions || '',
            '发布时间建议': item.posting_time_advice || '',
            '竞品对标分析': item.competition_analysis || '',
          };
        });

        // 创建工作簿
        const wb = XLSX.utils.book_new();

        // 创建工作表
        const ws = XLSX.utils.json_to_sheet(exportData);

        // 设置列宽
        const colWidths = [
          { wch: 6 },  // 序号
          { wch: 20 }, // 作品ID
          { wch: 15 }, // 作者昵称
          { wch: 15 }, // 作者ID
          { wch: 30 }, // 作品描述
          { wch: 8 },  // 作品状态
          { wch: 12 }, // 作品分类
          { wch: 8 },  // 作品形式
          { wch: 10 }, // 作品时长
          { wch: 12 }, // 分辨率
          { wch: 12 }, // 视频大小
          { wch: 12 }, // 粉丝数
          { wch: 12 }, // 关注数
          { wch: 12 }, // 作品数
          { wch: 12 }, // 总获赞数
          { wch: 12 }, // 认证类型
          { wch: 15 }, // 认证描述
          { wch: 20 }, // 企业认证
          { wch: 12 }, // 播放数
          { wch: 12 }, // 点赞数
          { wch: 12 }, // 评论数
          { wch: 12 }, // 收藏数
          { wch: 12 }, // 转发数
          { wch: 12 }, // 下载数
          { wch: 12 }, // 推荐数
          { wch: 12 }, // 赞赏数
          { wch: 10 }, // 播放指数
          { wch: 10 }, // 互动率
          { wch: 12 }, // 加权互动率
          { wch: 10 }, // 流量池
          { wch: 6 },  // 限流
          { wch: 6 },  // 删除
          { wch: 8 },  // 可下载
          { wch: 6 },  // 带货
          { wch: 10 }, // 刷新次数
          { wch: 20 }, // 创建时间
          { wch: 20 }, // 更新时间
          { wch: 20 }, // 发布时间
          { wch: 30 }, // 热搜词
          { wch: 50 }  // 优化建议
        ];

        // 应用列宽设置
        ws['!cols'] = colWidths;

        // 将工作表添加到工作簿
        XLSX.utils.book_append_sheet(wb, ws, '抖音视频数据');

        // 生成文件名
        const fileName = `抖音视频数据分析_${new Date().toLocaleDateString()}.xlsx`;

        // 导出文件
        XLSX.writeFile(wb, fileName);

        // 显示成功消息
        this.$Message.success('数据导出成功');
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$Message.error('数据导出失败，请稍后重试');
      }
    },

    /**
     * 格式化导出用的热搜词
     * @param {Array|string} hotWords - 热搜词数组或字符串
     * @returns {string} 格式化后的热搜词字符串
     */
    formatHotWordsForExport(hotWords) {
      // 如果为空或未定义，返回空字符串
      if (!hotWords || (Array.isArray(hotWords) && hotWords.length === 0)) {
        return '';
      }

      let wordsArray = [];

      // 如果是字符串
      if (typeof hotWords === 'string') {
        // 尝试解析为数组
        try {
          const parsed = JSON.parse(hotWords);
          if (Array.isArray(parsed)) {
            wordsArray = parsed;
          } else {
            wordsArray = [hotWords];
          }
        } catch (e) {
          // 如果解析失败，直接使用原字符串
          wordsArray = [hotWords];
        }
      } else if (Array.isArray(hotWords)) {
        // 如果已经是数组
        wordsArray = hotWords;
      } else {
        // 其他情况
        return String(hotWords);
      }

      // 解码并格式化热搜词
      const decodedWords = wordsArray.map(word => {
        if (typeof word !== 'string') {
          return String(word);
        }

        try {
          // 先尝试解码 URI 编码（处理 %E4%B8%AD%E6%96%87 格式）
          let decodedWord = decodeURIComponent(word);

          // 然后解码 Unicode 转义序列（处理 \u4e2d\u6587 格式）
          decodedWord = decodedWord.replace(/\\u([0-9a-fA-F]{4})/g, (match, grp) => {
            return String.fromCharCode(parseInt(grp, 16));
          });

          // 解码其他可能的转义字符
          decodedWord = decodedWord.replace(/\\n/g, '\n')
              .replace(/\\r/g, '\r')
              .replace(/\\t/g, '\t')
              .replace(/\\"/g, '"')
              .replace(/\\'/g, "'");

          return decodedWord;
        } catch (e) {
          // 如果解码失败，返回原始字符串
          return word;
        }
      });

      return decodedWords.join(', ');
    },
    /**
     * 充值操作
     */
    async recharge() {
      // 检查用户登录状态
      //await this.checkUserLoginStatus();

      // 如果用户未登录，显示登录模态框
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }

      // 如果已登录，跳转到充值页面
      //this.$router.push({name: 'Recharge'});
      // 如果已登录，在新窗口中打开充值页面
      try {
        const routeUrl = this.$router.resolve({name: 'Recharge'}); // 获取路由的完整路径
        window.open(routeUrl.href, '_blank'); // 在新窗口中打开页面
      } catch (error) {
        console.error('Failed to open recharge page:', error);
        this.$Message.error('无法打开充值页面，请稍后重试');
      }
    },

    /**
     * 推广功能
     */
    promote() {
      // 输出推广日志
      console.log('Promote');
    },

    /**
     * 表格行类名：根据行数据返回自定义类名
     * 用于实现鼠标悬停时行变色效果
     * @param {Object} row - 当前行数据对象
     * @param {Number} index - 当前行索引
     * @returns {String} CSS类名字符串
     */
    rowClassName(row, index) {
      // 返回空字符串表示使用默认样式
      // 表格的hover效果通过CSS样式实现
      return '';
    },

    /**
     * 查看作品详情：点击"查看"按钮时调用
     * 弹出模态框显示作品的详细信息
     * @param {Object} row - 当前行的数据对象，包含作品的所有信息
     */
    viewVideoDetail(row) {
      console.log('查看作品详情:', row.aweme_id);  // 打印作品ID到控制台，用于调试
      
      // 将当前行数据赋值给详情弹窗数据
      this.detailModalData = row;
      
      // 将行数据赋值给 currentVideoDetails，用于模态框显示
      this.currentVideoDetails = row;
      
      // 显示详情模态框
      this.showDetailModal = true;
      
      // 使用nextTick确保DOM更新后再切换标签页
      this.$nextTick(() => {
        // 切换到优化建议标签页
        this.activeTab = 'suggestions';
      });
      
      // 显示成功提示
      this.$Message.info('已打开作品详情');
    },

    /**
     * 刷新单个作品：点击"刷新"按钮时调用
     * 重新请求该作品的最新数据并更新到列表中
     * @param {Object} row - 当前行的数据对象，包含作品ID等信息
     */
    async refreshSingleVideo(row) {
      console.log('刷新单个作品:', row.aweme_id);  // 打印作品ID到控制台，用于调试
      
      // 检查用户登录状态，未登录则提示登录
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;  // 显示登录模态框
        return;
      }
      
      // 设置当前作品的刷新状态为true，用于显示加载动画
      row.refreshing = true;
      
      try {
        // 显示加载提示消息
        this.$Message.loading({
          content: `正在刷新作品 ${row.aweme_id} 的数据...`,
          duration: 0,  // 持续显示，不自动关闭
          closable: true
        });
        
        // 从localStorage获取用户邮箱，用于API请求
        const userEmail = localStorage.getItem('userEmail') || '';
        
        // 构建请求数据对象
        const requestData = {
          works_ids: [row.aweme_id],  // 作品ID数组，只包含当前作品
          user_email: userEmail,      // 用户邮箱
          include_play: this.isPlaying  // 是否包含播放量
        };
        
        // 生成签名和时间戳，用于API验证
        const timestamp = Math.floor(Date.now() / 1000);
        const signature = Signature.generateSignature(requestData, timestamp);
        
        // 发送POST请求到API，获取作品最新数据
        const response = await apiClient.post('v2/query/refresh', requestData, {
          headers: {
            'X-Signature': signature,  // 签名头
            'X-Timestamp': timestamp   // 时间戳头
          }
        });
        
        // 检查API响应状态码
        if (response.data.code === 200) {
          const resultData = response.data.data;
          
          // 如果返回了results数组，更新当前作品数据
          if (resultData.results && Array.isArray(resultData.results) && resultData.results.length > 0) {
            const updatedVideo = resultData.results[0];  // 获取第一个作品数据
            
            // 在allDataItems中找到对应的作品并更新数据
            const itemIndex = this.allDataItems.findIndex(item => item.aweme_id === row.aweme_id);
            if (itemIndex !== -1) {
              // 合并新旧数据，保留原有的一些字段
              const updatedItem = {
                ...this.allDataItems[itemIndex],  // 保留原有数据
                ...updatedVideo,                  // 覆盖新数据
                status: updatedVideo.status || 'success',  // 更新状态
                query_count: (this.allDataItems[itemIndex].query_count || 0) + 1,  // 查询次数加1
                last_query_time: updatedVideo.last_query_time || new Date().toLocaleString(),  // 更新最后查询时间
                updated_at: new Date().toLocaleString()  // 更新时间
              };
              
              // 更新allDataItems中的数据
              this.allDataItems[itemIndex] = updatedItem;
              
              // 更新分页数据
              this.updatePaginatedData();
              
              // 显示成功提示
              this.$Message.success(`作品 ${row.aweme_id} 刷新成功`);
            }
          }
          
          // 更新用户余额（如果API返回了新余额）
          if (resultData.new_balance !== undefined) {
            this.queryBalance = resultData.new_balance;
            localStorage.setItem('userBalance', this.queryBalance.toString());
          }
        } else {
          // API返回错误状态码，显示错误消息
          this.$Message.error(response.data.msg || '刷新失败');
        }
      } catch (error) {
        // 捕获网络错误或异常
        console.error('刷新作品失败:', error);
        if (error.response) {
          this.$Message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          this.$Message.error('网络请求无响应，请检查网络连接');
        } else {
          this.$Message.error('刷新失败，请稍后重试');
        }
      } finally {
        // 无论成功失败，都清除加载提示
        this.$Message.destroy();
        // 重置当前作品的刷新状态
        row.refreshing = false;
      }
    },

    /**
     * 删除单个作品：点击"删除"按钮时调用
     * 弹出确认对话框，确认后从列表和数据库中删除该作品
     * @param {Object} row - 当前行的数据对象，包含作品ID等信息
     */
    deleteVideoItem(row) {
      console.log('删除作品:', row.aweme_id);  // 打印作品ID到控制台，用于调试
      
      // 检查用户登录状态，未登录则提示登录
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;  // 显示登录模态框
        return;
      }
      
      // 弹出确认对话框，防止误删
      this.$Modal.confirm({
        title: '确认删除',  // 对话框标题
        content: `<p>确定要删除作品 <strong>${row.aweme_id}</strong> 的查询记录吗？此操作不可恢复！</p>`,  // 对话框内容，使用HTML格式
        okText: '确定删除',  // 确认按钮文字
        cancelText: '取消',  // 取消按钮文字
        
        // 确认删除时的回调函数
        onOk: async () => {
          try {
            // 显示加载提示消息
            this.$Message.loading({
              content: '正在删除数据...',
              duration: 0,  // 持续显示，不自动关闭
              closable: true
            });
            
            // 从localStorage获取用户邮箱，用于API请求
            const userEmail = localStorage.getItem('userEmail') || '';
            
            // 构建删除请求数据
            const requestData = {
              works_ids: [row.aweme_id],  // 要删除的作品ID数组
              user_email: userEmail       // 用户邮箱
            };
            
            // 发送POST请求到删除API
            const response = await apiClient.post('query/delete', requestData);
            
            // 检查API响应状态码
            if (response.data.code === 200) {
              // 从allDataItems中移除已删除的作品
              this.allDataItems = this.allDataItems.filter(item => item.aweme_id !== row.aweme_id);
              
              // 更新总数
              this.total = this.allDataItems.length;
              
              // 确保当前页不超过最大页数
              const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
              if (this.currentPage > maxPage) {
                this.currentPage = maxPage;  // 如果当前页超出范围，调整到最大页
              }
              
              // 更新分页数据
              this.updatePaginatedData();
              
              // 清除选中项（如果删除的是选中项）
              this.selectedItems = this.selectedItems.filter(item => item.aweme_id !== row.aweme_id);
              this.isAllSelected = false;  // 重置全选状态
              
              // 显示成功提示
              this.$Message.success('作品删除成功');
            } else {
              // API返回错误状态码，显示错误消息
              this.$Message.error(response.data.msg || '删除失败');
            }
          } catch (error) {
            // 捕获网络错误或异常
            console.error('删除作品失败:', error);
            if (error.response) {
              this.$Message.error(`服务器错误: ${error.response.status}`);
            } else if (error.request) {
              this.$Message.error('网络请求无响应，请检查网络连接');
            } else {
              this.$Message.error('删除失败，请稍后重试');
            }
          } finally {
            // 清除加载提示消息
            this.$Message.destroy();
          }
        },
        
        // 取消删除时的回调函数
        onCancel: () => {
          console.log('用户取消删除操作');  // 打印取消日志
        }
      });
    },

    /**
     * 清空失败项：点击"清空失败项"按钮时调用
     * 删除所有状态为error的查询记录
     */
    async clearAllFailed() {
      console.log('清空失败项');  // 打印日志
      
      // 检查用户登录状态
      if (!this.isUserLoggedIn) {
        this.showLoginModal = true;
        return;
      }
      
      // 获取所有失败的作品ID
      const failedItems = this.allDataItems.filter(item => item.status === 'error');
      
      // 如果没有失败项，提示用户
      if (failedItems.length === 0) {
        this.$Message.info('没有失败的查询记录');
        return;
      }
      
      // 弹出确认对话框
      this.$Modal.confirm({
        title: '确认清空',
        content: `<p>确定要清空所有 <strong>${failedItems.length}</strong> 条失败的查询记录吗？此操作不可恢复！</p>`,
        okText: '确定清空',
        cancelText: '取消',
        
        onOk: async () => {
          try {
            // 显示加载提示
            this.$Message.loading({
              content: '正在清空失败记录...',
              duration: 0,
              closable: true
            });
            
            // 从localStorage获取用户邮箱
            const userEmail = localStorage.getItem('userEmail') || '';
            
            // 提取所有失败作品的ID
            const failedIds = failedItems.map(item => item.aweme_id);
            
            // 发送删除请求
            const response = await apiClient.post('query/delete', {
              works_ids: failedIds,
              user_email: userEmail
            });
            
            // 检查API响应
            if (response.data.code === 200) {
              // 从allDataItems中移除所有失败的作品
              this.allDataItems = this.allDataItems.filter(item => item.status !== 'error');
              
              // 更新总数
              this.total = this.allDataItems.length;
              
              // 确保当前页不超过最大页数
              const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
              if (this.currentPage > maxPage) {
                this.currentPage = maxPage;
              }
              
              // 更新分页数据
              this.updatePaginatedData();
              
              // 清空选中项
              this.selectedItems = [];
              this.isAllSelected = false;
              
              // 显示成功提示
              this.$Message.success(`成功清空 ${failedItems.length} 条失败记录`);
            } else {
              this.$Message.error(response.data.msg || '清空失败');
            }
          } catch (error) {
            console.error('清空失败记录失败:', error);
            this.$Message.error('清空失败，请稍后重试');
          } finally {
            this.$Message.destroy();
          }
        },
        
        onCancel: () => {
          console.log('用户取消清空操作');
        }
      });
    }
  }
};
</script>

<style scoped>

/* 账号权重查询页面样式 */
.weight-page {
  padding: 20px;
  min-height: calc(100vh - 120px);
  background: #f5f5f5;
  border: none;
}

/* 星空主题下的权重查询页面 */
.theme-starry .weight-page {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%) !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  box-shadow: none !important;
}

/* 移动端重置所有margin和padding - 仅移动端 */
@media (max-width: 768px) {
  html,
  body,
  #app,
  .tiktok-query,
  .full-page-layout,
  .full-page-content,
  .main-content-mobile,
  .top-header {
    margin: 0 !important;
    padding: 0 !important;
    top: 0 !important;
    left: 0 !important;
  }

  /* 强制覆盖view-ui-plus的全局样式 */
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  html {
    margin: 0 !important;
    padding: 0 !important;
  }

  #app {
    margin: 0 !important;
    padding: 0 !important;
  }
}

.floating-qrcode-container {
  position: fixed;
 /* bottom: 400px;*/
  top: 500px;
  right: 20px;
  z-index: 9999;
}

.qrcode-box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  width: 280px;
  padding: 4px;
  transition: opacity 0.3s ease;
  border: 1px solid #e1e1e1;
  transform: translateZ(0); /* 避免硬件加速问题 */
}

.qrcode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.qrcode-title {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;

  font-size: 12px;
  color: #333;
  font-weight: bold;
}

.close-btn {
  background: rgba(0, 0, 0, 0.6);
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: rgba(255, 0, 0, 0.8);
  transform: scale(1.1);
}

.qrcode-content {
  text-align: center;
}

.qrcode-img {
  width: 260px;
  height: 278px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.qrcode-footer {
  margin-top: 8px;
  text-align: center;
  font-size: 10px;
  color: #666;
}

.floating-trigger {
  width: 40px;
  height: 40px;
  background: #007AFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0,122,255,0.3);
  position: absolute;
  bottom: 60px;
  right: 20px;
}

/* 作品发布时间样式 */
.work-publish-time {
  font-size: 12px;
  color: #999;
  padding: 0 8px 8px;
  text-align: center;
}
/* 批量导入容器样式 */
.batch-import-container {
  min-height: 400px;
}

/* 链接输入区域样式 */
.link-input-section {
  padding: 20px;
}

/* 作品网格布局样式
 * 关键点：
 * 1. 最小列宽从 150px 提升到 180px，避免窄列导致统计数据被挤
 * 2. 最大列宽 220px，确保即使 modal 容器很宽也不会出现 6+ 列拥挤
 * 3. grid-auto-flow: row dense 让稀疏行更紧凑
 * 4. 滚动区域提升到 500px，单页可看更多作品
 */
.works-grid {
  display: grid;
  /* 调整：minmax 最小值从 150 → 180，最大值 1fr → 220（避免超宽容器列数过多） */
  grid-template-columns: repeat(auto-fill, minmax(180px, 220px));
  /* 列间距从 15 → 12，避免间距过大让卡片看起来更小 */
  gap: 12px;
  /* 提升滚动区域高度，方便浏览大量作品 */
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
  /* 居中对齐：当总数填不满最后一行时，多余空间分配到右侧而非中间 */
  justify-content: start;
}

/* 作品卡片样式
 * 调整：宽度由 grid 决定时 min-width 保证不小于 180px */
.work-card {
  height: auto; /* 允许卡片根据内容自适应高度 */
  min-height: 260px; /* 提升最小高度：封面 150 + 统计 30 + 标题 50 + 时间 30 ≈ 260 */
  width: 100%; /* 铺满 grid 单元格 */
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

/* 作品卡片悬停效果 */
.work-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* 选中的作品卡片样式 */
.work-card.selected {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 作品封面容器样式 */
.work-cover {
  position: relative;
  height: 150px;
  overflow: hidden;
}

/* 作品封面图片样式 */
.work-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 作品统计数据样式（覆盖在封面上）
 * 调整：3 个 stat-item 等宽分布，字号缩小到 11px（之前 12px 在窄列下挤） */
.work-stats {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.65);
  color: white;
  padding: 4px 6px;
  display: flex;
  justify-content: space-between; /* 三个等分占满，避免中间留白 */
  align-items: center;
  font-size: 11px;
  line-height: 1.2;
  /* 数字过长时换行隐藏 */
  overflow: hidden;
}

/* 统计项样式
 * 调整：flex: 1 等分宽度，文字居中 */
.stat-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1; /* 三等分父容器宽度 */
  min-width: 0; /* 允许 flex 子项收缩到内容最小尺寸 */
  padding: 0 2px;
  /* 数字过长时省略 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 统计项图标样式
 * 调整：图标不参与数字省略（min-width: 0 让父 flex 能收缩，图标靠 min-width 撑住） */
.stat-item i {
  margin-right: 3px;
  font-size: 12px;
  flex-shrink: 0; /* 图标不缩小，数字部分才能省略 */
}

/* 作品标题样式
 * 调整：单行省略 → 2 行省略（显示更多内容，长标题也能看清） */
.work-title {
  padding: 8px;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
  /* 2 行省略 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 标题与上方封面的弹性空间 */
  flex: 1;
  /* 标题颜色 */
  color: #333;
}

/* 作者信息区域样式 */
.author-info {
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.current-ip {
  margin-top: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.loading-text {
  color: #1890ff;
  font-style: italic;
}

.loading-dots::after {
  content: '...';
  animation: dots 1.5s steps(5, end) infinite;
}

@keyframes dots {
  0%, 20% { content: '.'; }
  40% { content: '..'; }
  60%, 100% { content: '...'; }
}
/* 顶部按钮容器样式 */
.top-buttons-container {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* IP白名单按钮样式 - 美化版 */
.ip-whitelist-btn {
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  letter-spacing: 0.5px;
}

.ip-whitelist-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.ip-whitelist-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
}

/* IP白名单文本域样式 */
.ip-whitelist-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
}

.ip-whitelist-textarea:focus {
  border-color: #2d8cf0;
  outline: none;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
}

/* 当前IP显示样式 */
.current-ip {
  margin-top: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 14px;
}

/* 修改密码按钮样式 - 美化版 */
.change-password-btn {
  margin-top: 10px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(245, 87, 108, 0.4);
  letter-spacing: 0.5px;
}

.change-password-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(245, 87, 108, 0.5);
}

.change-password-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(245, 87, 108, 0.4);
}
/* VIP套餐列表样式 */
.vip-packages-section {
  margin-top: 10px;
  padding: 5px;
  background-color: #fffaf0;
  border-radius: 8px;
  border: 1px solid #ffd700;
}




.vip-packages-section h3 {
  margin-top: 0;
  color: #8b4513;
}

.vip-package-item {
  margin-bottom: 15px;
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 5px;
  background-color: #fff;
}

.vip-package-item:last-child {
  margin-bottom: 0;
}

.package-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.package-header h4 {
  margin: 0;
  color: #333;
}

/* 套餐价格样式 */
.package-price {
  font-size: 18px;
  font-weight: bold;
  color: #ff4d4f;
}

/* 套餐详情样式 */
.package-details p {
  margin: 2px 0;
  font-size: 13px;
  color: #666;
}

/* 购买按钮样式 - 美化版 */
.package-buy-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
  border: none;
  border-radius: 12px;
  color: #8b4513;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  margin-top: 15px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(252, 182, 159, 0.4);
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

/* 鼠标悬停样式 */
.package-buy-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(252, 182, 159, 0.5);
  background: linear-gradient(135deg, #fcb69f 0%, #ffecd2 100%);
}

.package-buy-btn:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(252, 182, 159, 0.4);
}

/* 禁用按钮样式 */
.package-buy-btn:disabled {
  background: linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%);
  color: #999;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  opacity: 0.6;
}

.pend-huiyuanfuwu {
  text-align: left;
  font-size: 15px;
  font-weight: bold;
  margin: 3px 0;
  color: #8b4513;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
}

/* 添加VIP相关样式 */
.vip-section {
  margin: 2px 0;                    /* 设置上下边距 */
  padding: 5px;                     /* 设置内边距 */
  border: 2px solid #ffd700;         /* 设置边框宽度、样式和颜色 */
  border-radius: 8px;                /* 设置圆角 */
  background-color: #fffaf0;         /* 设置背景色 */
}

.vip-info {
  margin-top: 10px;                  /* 设置顶部边距 */
}

/* VIP充值按钮样式 - 美化版 */
.vip-recharge-btn {
  width: 100%;
  background: linear-gradient(135deg, #ffd700 0%, #ffcc00 100%);
  border: none;
  border-radius: 12px;
  color: #8b4513;
  padding: 14px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  letter-spacing: 1px;
}

.vip-recharge-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(255, 215, 0, 0.5);
  background: linear-gradient(135deg, #ffcc00 0%, #ffd700 100%);
}

.vip-recharge-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
}



/* 移动端搜索框容器样式 */
.mobile-search-container {                  /* 定义移动端搜索框容器的样式 */
  display: flex;                           /* 使用弹性布局，使子元素可以水平排列 */
  margin-bottom: 16px;                     /* 设置底部外边距为16像素，与下方元素保持距离 */
  gap: 8px;                                /* 设置子元素之间的间隔为8像素 */
  padding: 0 16px;                         /* 设置左右内边距为16像素，上下内边距为0 */
}

/* 移动端搜索输入框样式 */
.mobile-search-input {                      /* 定义移动端搜索输入框的样式 */
  flex: 1;                                 /* 弹性增长，占据容器中剩余的所有空间 */
  padding: 10px 12px;                      /* 设置内边距，上下10像素，左右12像素 */
  border: 1px solid #d9d9d9;               /* 设置1像素的实线边框，颜色为#d9d9d9（浅灰色） */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
  font-size: 14px;                         /* 设置字体大小为14像素 */
  outline: none;                           /* 移除默认的焦点轮廓 */
}

/* 搜索输入框获得焦点时的样式 */
.mobile-search-input:focus {                /* 定义移动端搜索输入框获得焦点时的样式 */
  border-color: #1890ff;                   /* 设置边框颜色为#1890ff（蓝色） */
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2); /* 添加蓝色阴影效果，增强焦点视觉效果 */
}

/* 移动端搜索清除按钮样式 */
.mobile-search-clear-btn {                  /* 定义移动端搜索清除按钮的样式 */
  padding: 10px 16px;                      /* 设置内边距，上下10像素，左右16像素 */
  background-color: #f5f5f5;               /* 设置背景颜色为#f5f5f5（浅灰色） */
  border: 1px solid #d9d9d9;               /* 设置1像素的实线边框，颜色为#d9d9d9（浅灰色） */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
  cursor: pointer;                         /* 设置鼠标指针为手型，表示该元素可点击 */
  font-size: 14px;                         /* 设置字体大小为14像素 */
}

/* 清除按钮悬停样式 */
.mobile-search-clear-btn:hover {            /* 定义移动端搜索清除按钮悬停时的样式 */
  background-color: #e6e6e6;               /* 设置背景颜色为#e6e6e6（更浅的灰色） */
}

/* 移动端搜索查找按钮样式 */
.mobile-search-btn {                        /* 定义移动端搜索查找按钮的样式 */
  padding: 10px 20px;                      /* 设置内边距，上下10像素，左右20像素 */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); /* 渐变背景色 */
  border: none;                            /* 移除边框 */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
  color: #fff;                             /* 设置文字颜色为白色 */
  cursor: pointer;                         /* 设置鼠标指针为手型，表示该元素可点击 */
  font-size: 14px;                         /* 设置字体大小为14像素 */
  font-weight: 600;                        /* 设置字体粗细为600（半粗体） */
  transition: all 0.3s ease;               /* 添加过渡效果 */
  white-space: nowrap;                     /* 防止文字换行 */
}

/* 查找按钮悬停样式 */
.mobile-search-btn:hover {                  /* 定义移动端搜索查找按钮悬停时的样式 */
  transform: translateY(-2px);             /* 向上移动2像素 */
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4); /* 添加阴影效果 */
}

/* 查找按钮点击样式 */
.mobile-search-btn:active {                 /* 定义移动端搜索查找按钮点击时的样式 */
  transform: translateY(0);                /* 回到原始位置 */
}

/* 搜索结果信息样式 */
.search-results-info {                      /* 定义搜索结果信息区域的样式 */
  margin-bottom: 16px;                     /* 设置底部外边距为16像素 */
  padding: 8px 12px;                       /* 设置内边距，上下8像素，左右12像素 */
  background-color: #f0f5ff;               /* 设置背景颜色为#f0f5ff（浅蓝色） */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
  color: #1890ff;                          /* 设置文字颜色为#1890ff（蓝色） */
  font-size: 14px;                         /* 设置字体大小为14像素 */
  margin: 0 16px 16px 16px;                /* 设置外边距，上0，右16px，下16px，左16px */
}

/* 右上角 API 文档链接容器 */
.api-doc-link-container {                   /* 定义API文档链接容器的样式 */
  position: absolute;                      /* 使用绝对定位 */
  top: 10px;                               /* 距离顶部10像素 */
  right: 20px;                             /* 距离右侧20像素 */
  z-index: 1000;                           /* 设置层级为1000，确保在其他元素之上 */
  margin-right: 15px;                      /* 设置右边距为15像素 */
}

/* 带货信息样式 */
.product-item {                             /* 定义带货信息项的样式 */
  border: 1px solid #e8eaec;               /* 设置1像素的实线边框，颜色为#e8eaec（浅灰色） */
  border-radius: 8px;                      /* 设置边框圆角为8像素 */
  padding: 12px;                           /* 设置内边距为12像素 */
  margin-bottom: 12px;                     /* 设置底部外边距为12像素 */
  background-color: #fafafa;               /* 设置背景颜色为#fafafa（非常浅的灰色） */
}

/* 最后一个带货项目样式 */
.product-item:last-child {                  /* 定义最后一个带货信息项的样式 */
  margin-bottom: 0;                        /* 设置底部外边距为0，避免多余的空间 */
}

/* 带货信息容器样式 */
.product-info {                             /* 定义带货信息容器的样式 */
  width: 100%;                             /* 设置宽度为100% */
}

/* 带货链接样式 */
.product-link {                             /* 定义带货链接的样式 */
  color: #1890ff;                          /* 设置文字颜色为#1890ff（蓝色） */
  text-decoration: underline;              /* 添加下划线 */
}

/* 带货链接悬停样式 */
.product-link:hover {                       /* 定义带货链接悬停时的样式 */
  color: #40a9ff;                          /* 设置文字颜色为#40a9ff（浅蓝色） */
}

/* 带货状态标签样式 */
.status-product {                           /* 定义带货状态标签的样式 */
  background-color: #fff7e6;               /* 设置背景颜色为#fff7e6（浅橙色） */
  color: #fa8c16;                          /* 设置文字颜色为#fa8c16（橙色） */
  border: 1px solid #ffd591;               /* 设置1像素的实线边框，颜色为#ffd591（浅橙色） */
}

/* 移动端卡片列表样式 */
.card-list {                                /* 定义卡片列表容器的样式 */
  display: flex;                           /* 使用弹性布局 */
  flex-direction: column;                  /* 设置弹性方向为垂直排列 */
  gap: 16px;                               /* 设置子元素之间的间隔为16像素 */
  padding: 16px;                           /* 设置内边距为16像素 */
}

/* 卡片项目样式 */
.card-item {                                /* 定义卡片项的样式 */
  border: 1px solid var(--card-border, #e8eaec);  /* 使用CSS变量设置边框颜色 */
  border-radius: 12px;                     /* 设置边框圆角为12像素 */
  background-color: var(--card-bg, #fff);  /* 使用CSS变量设置背景颜色 */
  color: var(--card-text, #333);           /* 使用CSS变量设置文字颜色 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 添加阴影效果，增强立体感 */
  overflow: hidden;                        /* 隐藏溢出的内容 */
}

/* 卡片头部样式 */
.card-header {                              /* 定义卡片头部的样式 */
  background-color: var(--card-bg, #f0f5ff);  /* 使用CSS变量设置背景颜色 */
  padding: 12px 16px;                      /* 设置内边距，上下12像素，左右16像素 */
  border-bottom: 1px solid var(--card-border, #e8eaec);  /* 使用CSS变量设置边框颜色 */
}

/* 视频ID样式 */
.video-id {                                 /* 定义视频ID文本的样式 */
  font-weight: 600;                        /* 设置字体粗细为600（半粗体） */
  color: var(--primary-color, #1890ff);    /* 使用CSS变量设置文字颜色 */
  font-size: 16px;                         /* 设置字体大小为16像素 */
}

/* 卡片主体样式 */
.card-body {                                /* 定义卡片主体部分的样式 */
  padding: 16px;                           /* 设置内边距为16像素 */
}

/* 卡片区域样式 */
.card-section {                             /* 定义卡片区域的样式 */
  margin-bottom: 20px;                     /* 设置底部外边距为20像素 */
}

/* 最后一个卡片区域样式 */
.card-section:last-child {                  /* 定义最后一个卡片区域的样式 */
  margin-bottom: 0;                        /* 设置底部外边距为0 */
}

/* 区域标题样式 */
.section-title {                            /* 定义区域标题的样式 */
  font-size: 16px;                         /* 设置字体大小为16像素 */
  font-weight: 600;                        /* 设置字体粗细为600（半粗体） */
  color: var(--primary-color, #333);       /* 使用CSS变量设置文字颜色 */
  margin: 0 0 12px 0;                      /* 设置外边距，上0，右0，下12px，左0 */
  padding-bottom: 8px;                     /* 设置底部内边距为8像素 */
  border-bottom: 1px solid var(--card-border, #f0f0f0);  /* 使用CSS变量设置边框颜色 */
}

/* 信息网格样式 */
.info-grid {                                /* 定义信息网格容器的样式 */
  display: grid;                           /* 使用网格布局 */
  grid-template-columns: 1fr;              /* 设置网格列模板为1个等宽列 */
  gap: 12px;                               /* 设置网格间距为12像素 */
}

/* 信息项目样式 */
.info-item {                                /* 定义信息项的样式 */
  display: flex;                           /* 使用弹性布局 */
  flex-wrap: wrap;                         /* 允许弹性项目换行 */
  align-items: center;                     /* 设置垂直居中对齐 */
}

/* 信息标签样式 */
.info-label {                               /* 定义信息标签的样式 */
  font-weight: 500;                        /* 设置字体粗细为500（中等粗细） */
  color: var(--card-text, #666);           /* 使用CSS变量设置文字颜色 */
  min-width: 70px;                         /* 设置最小宽度为70像素 */
  margin-right: 8px;                       /* 设置右边距为8像素 */
  flex-shrink: 0;                          /* 设置不收缩，保持固定宽度 */
}

/* 信息项目最后一个span样式 */
.info-item span:last-child {                /* 定义信息项中最后一个span元素的样式 */
  flex: 1;                                 /* 弹性增长，占据剩余空间 */
  color: #333;                             /* 设置文字颜色为#333（深灰色） */
}

/* 信息值样式 */
.info-value {                               /* 定义信息值的样式 */
  flex: 1;                                 /* 弹性增长，占据剩余空间 */
  color: var(--card-text, #333);           /* 使用CSS变量设置文字颜色 */
  text-align: center;                      /* 设置文本居中对齐 */
  display: flex;                           /* 使用弹性布局 */
  justify-content: center;                 /* 设置水平居中对齐 */
  align-items: center;                     /* 设置垂直居中对齐 */
}

/* 封面包装样式 */
.cover-wrapper {                            /* 定义封面包装容器的样式 */
  display: flex;                           /* 使用弹性布局 */
  justify-content: center;                 /* 设置水平居中对齐 */
  width: 100%;                             /* 设置宽度为100% */
}

/* 封面容器样式 */
.cover-container {                          /* 定义封面容器的样式 */
  text-align: center;                      /* 设置文本居中对齐 */
  margin-bottom: 16px;                     /* 设置底部外边距为16像素 */
}

/* 卡片封面样式 */
.card-cover {                               /* 定义卡片封面图片的样式 */
  width: 100%;                             /* 设置宽度为100% */
  max-width: 200px;                        /* 设置最大宽度为200像素 */
  height: auto;                            /* 设置高度自适应 */
  border-radius: 8px;                      /* 设置边框圆角为8像素 */
  cursor: pointer;                         /* 设置鼠标指针为手型，表示可点击 */
  transition: transform 0.2s;              /* 设置变换过渡效果，持续时间为0.2秒 */
}

/* 卡片封面悬停样式 */
.card-cover:hover {                         /* 定义卡片封面图片悬停时的样式 */
  transform: scale(1.05);                  /* 设置缩放效果，放大到1.05倍 */
}

/* 卡片封面占位符样式 */
.card-cover-placeholder {                   /* 定义卡片封面占位符的样式 */
  width: 100%;                             /* 设置宽度为100% */
  max-width: 200px;                        /* 设置最大宽度为200像素 */
  height: 120px;                           /* 设置高度为120像素 */
  display: flex;                           /* 使用弹性布局 */
  align-items: center;                     /* 设置垂直居中对齐 */
  justify-content: center;                 /* 设置水平居中对齐 */
  background-color: #f5f5f5;               /* 设置背景颜色为#f5f5f5（浅灰色） */
  color: #999;                             /* 设置文字颜色为#999（灰色） */
  border-radius: 8px;                      /* 设置边框圆角为8像素 */
  font-size: 14px;                         /* 设置字体大小为14像素 */
  margin: 0 auto;                          /* 设置水平居中，上下外边距为0 */
}

/* 状态标签样式 */
.status-badge {                             /* 定义状态徽章的样式 */
  display: inline-flex;                    /* 使用行内弹性布局 */
  justify-content: center;                 /* 设置水平居中对齐 */
  align-items: center;                     /* 设置垂直居中对齐 */
  padding: 4px 12px;                       /* 设置内边距，上下4像素，左右12像素 */
  border-radius: 16px;                     /* 设置边框圆角为16像素 */
  font-size: 12px;                         /* 设置字体大小为12像素 */
  font-weight: 500;                        /* 设置字体粗细为500（中等粗细） */
  min-width: 60px;                         /* 设置最小宽度为60像素 */
}

/* 成功状态样式 */
.status-success {                           /* 定义成功状态的样式 */
  background-color: #f6ffed;               /* 设置背景颜色为#f6ffed（浅绿色） */
  color: #52c41a;                          /* 设置文字颜色为#52c41a（绿色） */
  border: 1px solid #b7eb8f;               /* 设置1像素的实线边框，颜色为#b7eb8f（浅绿色） */
}

/* 错误状态样式 */
.status-error {                             /* 定义错误状态的样式 */
  background-color: #fff2f0;               /* 设置背景颜色为#fff2f0（浅红色） */
  color: #ff4d4f;                          /* 设置文字颜色为#ff4d4f（红色） */
  border: 1px solid #ffccc7;               /* 设置1像素的实线边框，颜色为#ffccc7（浅红色） */
}

/* 警告状态样式 */
.status-warning {                           /* 定义警告状态的样式 */
  background-color: #fffbe6;               /* 设置背景颜色为#fffbe6（浅橙色） */
  color: #faad14;                          /* 设置文字颜色为#faad14（橙色） */
  border: 1px solid #ffe58f;               /* 设置1像素的实线边框，颜色为#ffe58f（浅橙色） */
}

/* 信息状态样式 */
.status-info {                              /* 定义信息状态的样式 */
  background-color: #e6f7ff;               /* 设置背景颜色为#e6f7ff（浅蓝色） */
  color: #1890ff;                          /* 设置文字颜色为#1890ff（蓝色） */
  border: 1px solid #91d5ff;               /* 设置1像素的实线边框，颜色为#91d5ff（浅蓝色） */
}

/* 默认状态样式 */
.status-default {                           /* 定义默认状态的样式 */
  background-color: #f5f5f5;               /* 设置背景颜色为#f5f5f5（浅灰色） */
  color: #999;                             /* 设置文字颜色为#999（灰色） */
  border: 1px solid #d9d9d9;               /* 设置1像素的实线边框，颜色为#d9d9d9（浅灰色） */
}

/* 星空主题下卡片列表文字强制使用白色 */
.theme-starry .card-item,
.theme-starry .info-label,
.theme-starry .info-value,
.theme-starry .section-title,
.theme-starry .card-header,
.theme-starry .video-id {
  color: #ffffff !important;
}

/* 无数据样式 */
.no-data {                                  /* 定义无数据提示的样式 */
  text-align: center;                      /* 设置文本居中对齐 */
  padding: 40px 20px;                      /* 设置内边距，上下40像素，左右20像素 */
  color: #999;                             /* 设置文字颜色为#999（灰色） */
  font-size: 16px;                         /* 设置字体大小为16像素 */
}

/* 响应式调整 */
@media (min-width: 480px) {                 /* 当屏幕最小宽度为480像素时应用以下样式 */
  .info-grid {                              /* 定义信息网格容器的样式 */
    grid-template-columns: 1fr 1fr;        /* 设置网格列模板为2个等宽列 */
  }

  .section-title {                          /* 定义区域标题的样式 */
    font-size: 17px;                       /* 设置字体大小为17像素 */
  }

  .info-item {                              /* 定义信息项的样式 */
    font-size: 15px;                       /* 设置字体大小为15像素 */
  }
}

/* 详情区域样式 */
.detail-section {                           /* 定义详情区域的样式 */
  margin-bottom: 20px;                     /* 设置底部外边距为20像素 */
  padding: 15px;                           /* 设置内边距为15像素 */
  border: 1px solid #e8eaec;               /* 设置1像素的实线边框，颜色为#e8eaec（浅灰色） */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
  background-color: #f8f9fa;               /* 设置背景颜色为#f8f9fa（浅灰色） */
}

/* 详情区域标题样式 */
.detail-section h3 {                        /* 定义详情区域中h3标题的样式 */
  margin-top: 0;                           /* 设置顶部外边距为0 */
  margin-bottom: 15px;                     /* 设置底部外边距为15像素 */
  color: #1890ff;                          /* 设置文字颜色为#1890ff（蓝色） */
  border-bottom: 1px solid #e8eaec;        /* 设置底部边框为1像素实线，颜色为#e8eaec（浅灰色） */
  padding-bottom: 8px;                     /* 设置底部内边距为8像素 */
}

/* 优化建议样式 */
.optimization-tips {                        /* 定义优化建议的样式 */
  white-space: pre-line;                   /* 保留换行符 */
  line-height: 1.6;                        /* 设置行高为1.6 */
  background-color: #fff;                  /* 设置背景颜色为白色 */
  padding: 10px;                           /* 设置内边距为10像素 */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
  max-height: 600px;                       /* 设置最大高度为600像素 */
  overflow-y: auto;                        /* 设置垂直滚动条 */
}

/* AI 推荐标题区域 */
.ai-titles-section {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px dashed #e8e8e8;
}
.ai-titles-section h3 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}
.ai-titles-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ai-title-item {
  padding: 10px 14px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  font-size: 13px;
  line-height: 1.5;
}
.ai-title-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

/* AI 优化建议 - 子标题样式（紧凑、靠拢正文） */
.ai-suggestion-subtitle {
  font-size: 15px;
  font-weight: 600;
  color: #19be6b;
  margin: 0 0 10px 0;
  padding-left: 8px;
  border-left: 3px solid #19be6b;
  line-height: 1.4;
}

/* AI 优化建议 - 提示文本样式（小字、灰色、与标题区分开） */
.ai-suggestion-tip {
  font-size: 13px;
  color: #a0aec0;
  margin: -6px 0 12px 0;
  padding-left: 11px;
  line-height: 1.5;
}

/* AI 详细分析区块 */
.ai-detail-section {
  margin-top: 20px;
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

/* 星空主题深色背景 */
.theme-starry .ai-detail-section {
  background: rgba(255, 255, 255, 0.06);
}

/* 经典主题浅色背景 */
.theme-default .ai-detail-section {
  background: #f8f9fa;
}

/* 蓝色主题 */
.theme-blue .ai-detail-section {
  background: #E3F2FD;
}

/* 紫色主题 */
.theme-purple .ai-detail-section {
  background: #F3E5F5;
}

/* 绿色主题 */
.theme-green .ai-detail-section {
  background: #E8F5E9;
}

/* 红色主题 */
.theme-red .ai-detail-section {
  background: #FFEBEE;
}

/* 橙色主题 */
.theme-orange .ai-detail-section {
  background: #FFF3E0;
}

.ai-suggestion-content {
  font-size: 14px;
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 8px 0 0 0;
}

/* 星空主题白色文字 */
.theme-starry .ai-suggestion-content {
  color: #c8d6e5;
}

/* 经典主题深色文字 */
.theme-default .ai-suggestion-content {
  color: #333;
}

/* 蓝色主题 */
.theme-blue .ai-suggestion-content {
  color: #1565C0;
}

/* 紫色主题 */
.theme-purple .ai-suggestion-content {
  color: #6A1B9A;
}

/* 绿色主题 */
.theme-green .ai-suggestion-content {
  color: #2E7D32;
}

/* 红色主题 */
.theme-red .ai-suggestion-content {
  color: #C62828;
}

/* 橙色主题 */
.theme-orange .ai-suggestion-content {
  color: #E65100;
}

/* 模态框底部操作按钮区 - 紧凑、大号 */
.modal-action-bar {
  text-align: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.modal-action-btn {
  min-width: 150px;
  height: 42px;
  font-size: 15px;
  font-weight: 600;
  margin: 0 !important;
  border-radius: 6px;
  letter-spacing: 0.5px;
}
.modal-action-btn-primary {
  background: linear-gradient(90deg, #722ed1, #eb2f96) !important;
  border-color: #722ed1 !important;
  color: #fff !important;
  box-shadow: 0 2px 6px rgba(114, 46, 209, 0.35);
}
.modal-action-btn-primary:hover {
  box-shadow: 0 4px 12px rgba(114, 46, 209, 0.5);
  transform: translateY(-1px);
}

/* pc端分页按钮样式 - 美化版 */
.pagination .page-btn {
  flex-shrink: 0;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  height: auto;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* 分页容器间距调整 */
.pagination {
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* 每页条数选择器样式 */
.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 15px;
}

.page-size-label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}

/* 分页区域的 Select 组件样式优化 */
.pagination .ivu-select {
  font-size: 14px;
}

.pagination .ivu-select-selection {
  height: 32px;
  line-height: 32px;
}

/* 分页按钮悬停效果 */
.pagination .page-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.pagination .page-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* 分页按钮禁用状态样式 */
.pagination .page-btn:disabled {
  background: linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%);
  color: #999;
  cursor: not-allowed;
  opacity: 0.5;
  box-shadow: none;
  transform: none;
}

/* 查询结果 logo 容器 */
.result-logo-container {                    /* 定义查询结果logo容器的样式 */
  position: fixed;                         /* 使用固定定位 */
  top: 0;                                  /* 距离顶部0像素 */
  left: 0;                                 /* 距离左侧0像素 */
  width: 100%;                             /* 设置宽度为100% */
  height: 100%;                            /* 设置高度为100% */
  background-color: rgba(0, 0, 0, 0.8);    /* 设置背景颜色为半透明黑色 */
  display: flex;                           /* 使用弹性布局 */
  justify-content: center;                 /* 设置水平居中对齐 */
  align-items: center;                     /* 设置垂直居中对齐 */
  z-index: 9999;                           /* 设置层级为9999，确保在最上层 */
}

/* 查询结果 logo 样式 */
.result-logo {                              /* 定义查询结果logo的样式 */
  width: 300px;                            /* 设置宽度为300像素 */
  height: auto;                            /* 设置高度自适应 */
  animation: fadeInOut 2s ease-in-out;     /* 应用淡入淡出动画效果 */
}

/* 动画效果 */
@keyframes fadeInOut {                      /* 定义淡入淡出关键帧动画 */
  0% {                                       /* 动画开始状态 */
    opacity: 0;                             /* 设置透明度为0 */
  }
  50% {                                      /* 动画中间状态 */
    opacity: 1;                             /* 设置透明度为1 */
  }
  100% {                                     /* 动画结束状态 */
    opacity: 0;                             /* 设置透明度为0 */
  }
}

/* 卡片列表样式 */
.card-list {                                /* 定义卡片列表的样式 */
  display: flex;                           /* 使用弹性布局 */
  flex-direction: column;                  /* 设置弹性方向为垂直排列 */
  gap: 10px;                               /* 设置子元素之间的间隔为10像素 */
}

/* 卡片项目样式 */
.card-item {                                /* 定义卡片项的样式 */
  border: 1px solid var(--card-border, #e8eaec);  /* 使用CSS变量设置边框颜色 */
  border-radius: 8px;                      /* 设置边框圆角为8像素 */
  padding: 10px;                           /* 设置内边距为10像素 */
  background-color: var(--card-bg, #fff);  /* 使用CSS变量设置背景颜色 */
  color: var(--card-text, #333);           /* 使用CSS变量设置文字颜色 */
}

/* 卡片头部样式 */
.card-header {                              /* 定义卡片头部的样式 */
  font-weight: bold;                       /* 设置字体粗细为粗体 */
  margin-bottom: 8px;                      /* 设置底部外边距为8像素 */
}

/* 卡片封面样式 */
.card-cover {                               /* 定义卡片封面的样式 */
  width: 100%;                             /* 设置宽度为100% */
  height: 120px;                           /* 设置高度为120像素 */
  object-fit: cover;                       /* 设置对象适应模式为覆盖 */
  border-radius: 4px;                      /* 设置边框圆角为4像素 */
}

/* 修复内容禁用状态 */
.content-disabled {                         /* 定义内容禁用状态的样式 */
  pointer-events: none;                    /* 禁用鼠标事件 */
  opacity: 0.6;                            /* 设置透明度为0.6 */
  filter: blur(1px);                       /* 添加1像素的模糊效果 */
  transition: all 0.3s ease;               /* 设置所有属性的过渡效果，持续时间为0.3秒 */
  width: 100%;                             /* 设置宽度为100% */
}

/* 待查询项列表容器样式 - 深色玻璃态，契合主题皮肤 */
.pending-list {                             /* 定义待查询项列表容器的样式 */
  min-height: 50px;                        /* 设置最小高度为50像素 */
  border: 1px solid rgba(255, 255, 255, 0.12);                  /* 浅色半透明边框 */
  border-radius: 10px;                      /* 设置边框圆角为10像素 */
  padding: 12px;                           /* 设置内边距为12像素 */
  margin-bottom: 10px;                     /* 设置底部外边距为10像素 */
  max-height: 200px;                       /* 设置最大高度为200像素 */
  overflow-x: auto;                        /* 设置水平滚动条 */
  overflow-y: auto;                        /* 设置垂直滚动条 */
  display: flex;                           /* 使用弹性布局 */
  flex-wrap: wrap;                         /* 允许弹性项目换行 */
  gap: 10px;                                /* 设置子元素之间的间隔为10像素 */
  background: rgba(15, 15, 26, 0.55);     /* 深色半透明背景，贴合主题 */
  backdrop-filter: blur(6px);              /* 毛玻璃效果 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25); /* 柔和投影 */
}

/* 待查询项样式 - 深色卡片风格，避免白色背景突兀 */
.pending-item {                             /* 定义待查询项的样式 */
  display: flex;                           /* 使用弹性布局，使内部元素水平排列 */
  justify-content: space-between;          /* 两端对齐，左右元素分别靠边 */
  align-items: center;                     /* 垂直居中，使元素在垂直方向居中 */
  padding: 8px 12px;                       /* 内边距，使内容不贴边 */
  border: 1px solid rgba(255, 255, 255, 0.10);                  /* 浅色半透明边框 */
  border-radius: 8px;                      /* 更大的圆角，使边框更美观 */
  flex: 0 1 auto;                          /* 弹性属性：不自动扩展，仅按内容宽度收缩 */
  min-width: 160px;                        /* 最小宽度，避免短ID 太窄 */
  max-width: 280px;                        /* 最大宽度，限制长ID 撑得太长 */
  width: auto;                             /* 宽度按内容自适应 */
  background: rgba(30, 30, 50, 0.75);               /* 深色半透明背景，贴合主题 */
  color: #e2e8f0;                          /* 浅灰文字，深色背景上更清晰 */
  font-size: 14px;                         /* 字体大小，确保可读性 */
  transition: all 0.25s ease;              /* 悬停/聚焦时平滑过渡 */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); /* 轻微投影 */
  box-sizing: border-box;                  /* 边框内减，避免 padding 撑出最大宽度 */
}

.pending-item:hover {
  border-color: rgba(102, 126, 234, 0.55);
  background: rgba(40, 40, 70, 0.85);
  box-shadow: 0 0 12px rgba(102, 126, 234, 0.18);
  transform: translateY(-1px);
}

/* 待查询项文本样式 */
.pending-item-text {                        /* 定义待查询项文本的样式 */
  flex: 1;                                 /* 弹性属性，占据剩余空间 */
  white-space: nowrap;                     /* 不换行，保持文本在一行 */
  overflow: hidden;                        /* 隐藏溢出，防止文本超出容器 */
  text-overflow: ellipsis;                 /* 省略号，当文本过长时显示省略号 */
  margin-right: 8px;                       /* 右边距，与删除按钮保持距离 */
  color: #e2e8f0;                          /* 浅灰文字 */
  font-weight: 500;                        /* 中等字重，提升可读性 */
}

/* 删除按钮样式 - 美化版 */
.remove-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(255, 107, 107, 0.3);
}

.remove-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(255, 107, 107, 0.4);
}

.remove-btn:active {
  transform: scale(0.95);
}

/* 空待查询项提示样式 */
.empty-pending {                            /* 定义空待查询项提示的样式 */
  color: #999;                             /* 颜色，使用灰色表示提示信息 */
  text-align: center;                      /* 文本居中 */
  padding: 15px;                           /* 内边距，使文本不贴边 */
  width: 100%;                             /* 宽度，占据整个容器 */
}

/* 抖音查询主容器样式 */
.tiktok-query {                             /* 定义抖音查询主容器的样式 */
  display: flex;                           /* 弹性布局，使子元素水平排列 */
  font-family: 'Arial', sans-serif;        /* 字体，确保在各种设备上都能正常显示 */
  min-height: 100vh;                       /* 最小高度，确保占据整个视口高度 */
  width: 100%;                             /* 宽度，占据整个容器 */
  overflow-x: hidden;                      /* 隐藏水平滚动，防止意外滚动 */
  flex-direction: column;                  /* 垂直排列，在移动端时使用 */
}

/* 全页面布局样式 */
.full-page-layout {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.full-page-content {
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 100vh;
}

/* 侧边栏样式 */
.sidebar {                                  /* 定义侧边栏的样式 */
  width: 200px;                            /* 宽度，固定侧边栏宽度 */
  padding: 10px;                           /* 内边距，使内容不贴边 */
  border-right: 1px solid #ddd;            /* 右边框，区分侧边栏和主内容 */
  background-color: #f9f9f9;               /* 背景色，使侧边栏更突出 */
  min-height: 100vh;                       /* 最小高度，确保侧边栏占据整个视口高度 */
  position: fixed;                         /* 固定定位，使侧边栏不随滚动移动 */
  top: 0;                                  /* 顶部，从顶部开始 */
  left: 0;                                 /* 左侧，从左侧开始 */
  overflow-y: auto;                        /* 垂直滚动，当内容过高时可滚动 */
  z-index: 1000;                           /* 层级，确保侧边栏在其他元素之上 */
  display: flex;                           /* 弹性布局 */
  flex-direction: column;                  /* 垂直排列 */
}

/* 深色侧边栏样式 - 管理后台风格 */
.sidebar-dark {
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%) !important;
  border-right: 1px solid #2d3748 !important;
  color: #e2e8f0;
}

.sidebar-dark .sidebar-logo {
  padding: 20px 10px;
  text-align: center;
  border-bottom: 1px solid #2d3748;
  margin-bottom: 10px;
}

.sidebar-dark .logo-text {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 8px 12px;
  border-radius: 6px;
  display: block;
}

.sidebar-dark .sidebar-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar-dark .menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin: 0 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #cbd5e0;
  width: calc(100% - 16px);
  box-sizing: border-box;
}

.sidebar-dark .menu-item:hover {
  background: rgba(102, 126, 234, 0.2);
  color: #fff;
  transform: translateX(4px);
}

.sidebar-dark .menu-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.sidebar-dark .menu-icon {
  margin-right: 10px;
  font-size: 18px;
}

.sidebar-dark .menu-text {
  font-size: 14px;
  font-weight: 500;
}

/* 联系信息和导航图片容器 */
.contact-and-nav {                          /* 定义联系信息和导航图片容器的样式 */
  margin-top: 20px;                        /* 上边距，与其他元素保持距离 */
}

/* 联系信息样式 */
.contact-info {                             /* 定义联系信息的样式 */
  text-align: center;                      /* 文本居中 */
  margin-bottom: 0;                        /* 移除底部边距 */
}

/* 导航图片容器样式 */
.navigation-image {                         /* 定义导航图片容器的样式 */
  text-align: center;                      /* 文本居中 */
  padding: 0;                              /* 移除内边距 */
  margin-top: 1px;                        /* 上边距，与其他元素保持距离 */
}

/* 导航图片样式 */
.navigation-image img {                     /* 定义导航图片的样式 */
  max-width: 100%;                         /* 最大宽度，确保图片不会超出容器 */
  height: auto;                            /* 高度自适应，保持图片比例 */
  border-radius: 5px;                      /* 圆角，使图片更美观 */
  object-fit: contain;                     /* 对象适应，保持图片完整显示 */
}

/* 移动端侧边栏样式 */
.sidebar-mobile {                           /* 定义移动端侧边栏的样式 */
  width: 250px;                            /* 宽度，移动端侧边栏更宽 */
  transform: translateX(-100%);            /* 变换，初始状态下隐藏在左侧 */
  transition: transform 0.3s ease;         /* 过渡，显示/隐藏时有动画效果 */
  z-index: 1001;                           /* 层级，确保在其他元素之上 */
  height: 100vh;                           /* 高度，占据整个视口高度 */
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1); /* 阴影，使侧边栏更立体 */
  padding-top: 100px !important;            /* 顶部内边距，让内容不被导航栏遮挡 */
}

/* 移动端侧边栏显示状态样式 */
.sidebar-mobile:not(.sidebar-hidden) {      /* 定义移动端侧边栏显示状态的样式 */
  transform: translateX(0);                /* 变换，显示侧边栏 */
}

/* 移动端侧边栏隐藏样式 */
.sidebar-mobile {                           /* 定义移动端侧边栏隐藏状态的样式 */
  display: none;                           /* 隐藏，初始状态下不显示 */
}

/* 移动端侧边栏显示状态样式 */
.sidebar-mobile:not(.sidebar-hidden) {      /* 定义移动端侧边栏显示状态的样式 */
  display: block;                          /* 显示，当不隐藏时显示 */
}

/* 移动端菜单按钮样式 */
.mobile-menu-btn {                          /* 定义移动端菜单按钮的样式 */
  display: none;                           /* 隐藏，初始状态下不显示 */
  position: fixed;                         /* 固定定位，使按钮不随滚动移动 */
  top: 10px;                               /* 顶部，距离顶部10px */
  left: 10px;                              /* 左侧，距离左侧10px */
  z-index: 1002;                           /* 层级，确保在其他元素之上 */
  font-size: 24px;                         /* 字体大小，使按钮更明显 */
  background: linear-gradient(135deg, var(--primary-color, #667eea) 0%, var(--primary-color-dark, #764ba2) 100%); /* 背景色，使用CSS变量 */
  color: white;                            /* 颜色，白色文字 */
  width: 40px;                             /* 宽度，确保按钮大小合适 */
  height: 40px;                            /* 高度，确保按钮大小合适 */
  border-radius: 8px;                      /* 圆角，使按钮更美观 */
  align-items: center;                     /* 垂直居中 */
  justify-content: center;                 /* 水平居中 */
  cursor: pointer;                         /* 鼠标指针，提示可点击 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3); /* 阴影，使按钮更立体 */
  transition: all 0.3s ease;               /* 过渡动画 */
}

.mobile-menu-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

/* 用户信息区域样式 */
.user-info-section {                        /* 定义用户信息区域的样式 */
  display: flex;                           /* 弹性布局 */
  flex-direction: column;                  /* 垂直排列 */
  align-items: center;                     /* 水平居中 */
  gap: 10px;                               /* 间距，元素之间的间隙 */
  padding: 2px 0;                         /* 上下内边距 */
  border-bottom: 1px solid #eee;           /* 底部边框 */
  margin-bottom: 2px;                     /* 下边距，与其他元素保持距离 */
}

/* Logo区域样式 */
.logo {                                     /* 定义Logo区域的样式 */
  display: flex;                           /* 弹性布局 */
  flex-direction: column;                  /* 垂直排列 */
  align-items: center;                     /* 水平居中 */
  gap: 10px;                               /* 间距，元素之间的间隙 */
}

/* Logo图片样式 */
.logo img {                                 /* 定义Logo图片的样式 */
  width: 80px;                             /* 宽度，设置图片大小 */
  height: 80px;                            /* 高度，设置图片大小 */
  border-radius: 50%;                      /* 圆形，使图片呈圆形 */
  margin-bottom: 5px;                     /* 下边距，与文字保持距离 */
}

/* Logo文字样式 */
.logo span {                                /* 定义Logo文字的样式 */
  font-size: large;                        /* 字体大小，使文字更明显 */
  font-weight: bold;                       /* 粗体，使文字更突出 */
}

/* 查询次数信息样式 */
.query-times {                              /* 定义查询次数信息的样式 */
  margin: 0 0;                          /* 上下边距，与其他元素保持距离 */
  padding: 15px;                           /* 内边距，使内容不贴边 */
  background: #f8f9fa;                     /* 背景色，使区域更突出 */
  border-radius: 8px;                      /* 圆角，使边框更美观 */
  text-align: center;                      /* 文本居中 */
}

/* 余额数字样式 */
.balance-number {                           /* 定义余额数字的样式 */
  font-size: 24px;                         /* 字体大小，使数字更明显 */
  color: #007bff;                          /* 颜色，使用主题色 */
  font-weight: 600;                        /* 粗体，使数字更突出 */
  margin-top: 6px;                         /* 上边距，与文字保持距离 */
}

/* 充值选项项样式 */
.option-item {                              /* 定义充值选项项的样式 */
  display: flex;                           /* 弹性布局，使内部元素水平排列 */
  justify-content: space-between;          /* 两端对齐，左右元素分别靠边 */
  margin-bottom: 10px;                     /* 下边距，与其他元素保持距离 */
}

/* 充值和推广按钮样式 - 美化版 */
.recharge-btn, .promote-btn {
  width: 100%;
  margin-bottom: 12px;
  padding: 16px;
  border: none;
  border-radius: 12px;
  color: white;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  letter-spacing: 1px;
}

/* 充值按钮样式 - 粉橙渐变 */
.recharge-btn {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  box-shadow: 0 4px 15px rgba(250, 112, 154, 0.4);
}

.recharge-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(250, 112, 154, 0.5);
}

.recharge-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(250, 112, 154, 0.4);
}

/* 推广按钮样式 - 蓝绿渐变 */
.promote-btn {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  color: #333;
  box-shadow: 0 4px 15px rgba(168, 237, 234, 0.4);
}

.promote-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(168, 237, 234, 0.5);
}

.promote-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(168, 237, 234, 0.4);
}

/* 主内容区域样式 */
.main-content {                             /* 定义主内容区域的样式 */
  flex: 1;                                 /* 弹性属性，占据剩余空间 */
  padding: 20px;                           /* 内边距，使内容不贴边 */
  margin-left: 200px;                      /* 左边距，为侧边栏留出空间 */
  min-height: 100vh;                       /* 最小高度，确保占据整个视口高度 */
  width: calc(100% - 200px);               /* 宽度，减去侧边栏宽度 */
  box-sizing: border-box;                  /* 盒模型，使宽度计算包含内边距 */
  position: relative;                      /* 相对定位，为绝对定位子元素提供参考 */
}

/* 全页面布局下的主内容区域样式 */
.full-page-layout .main-content {
  margin-left: 200px;                      /* 保持侧边栏空间 */
  width: calc(100% - 200px);               /* 宽度，减去侧边栏宽度 */
  position: relative;                      /* 相对定位，为绝对定位子元素提供参考 */
}

/* 全页面内容区域样式 */
.full-page-content {
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 100vh;
  position: relative;                      /* 相对定位 */
  padding-top: 0 !important;               /* 移动端顶部无内边距 */
  margin-top: 0 !important;                /* 移动端顶部无边距 */
}

/* 内容包装器样式 */
.content-wrapper {
  width: 100%;
  max-width: 100%;
  position: relative;                      /* 相对定位 */
}

/* ==================== 顶部导航栏样式 ==================== */
.top-header {
  display: flex;
  justify-content: flex-end; /* 改为右对齐 */
  align-items: center;
  padding: 15px 20px;
  background: var(--header-bg, #fff);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin-bottom: 30px;  /* 增加底部边距，与输入框隔开 */
  transition: all 0.3s ease;
}

.header-left {
  flex: 0;
  margin-right: auto; /* 将左侧推到最左边 */
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 内联移动端菜单按钮 */
.mobile-menu-btn-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, var(--primary-color, #667eea) 0%, var(--primary-color-dark, #764ba2) 100%);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.mobile-menu-btn-inline:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--header-title-color, #2d3748);
  transition: color 0.3s ease;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0; /* 防止右侧内容被压缩 */
  margin-left: auto; /* 确保靠右 */
}

/* 皮肤切换按钮样式 */
.theme-switcher .ivu-btn {
  border-radius: 8px;
  font-weight: 500;
}

/* 全屏按钮样式 */
.fullscreen-btn {
  border-radius: 8px;
  font-weight: 500;
}

/* API开发文档链接样式 */
.api-doc-link-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(135deg, var(--primary-color, #667eea) 0%, var(--primary-color-dark, #764ba2) 100%);
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
}

.api-doc-link-header:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.api-doc-link-header .ivu-icon {
  font-size: 16px;
}

/* 用户显示样式 */
.user-display {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, var(--primary-color, #667eea) 0%, var(--primary-color-dark, #764ba2) 100%);
  border-radius: 8px;
  color: #fff;
  cursor: pointer; /* 新增：鼠标悬停显示手型，提示可交互 */
  transition: all 0.3s ease;
}

.user-display .ivu-avatar {
  border: 2px solid #fff;
}

.user-display .username {
  font-weight: 600;
  font-size: 14px;
}

.user-display .user-role {
  font-size: 12px;
  opacity: 0.9;
}

/* ==================== 主题切换样式 ==================== */
/* 经典主题 */
.theme-classic {
  --primary-color: #667eea;
  --primary-color-dark: #764ba2;
  --sidebar-bg: #f9f9f9;
  --header-bg: #fff;
  --header-title-color: #2d3748;
  --footer-bg: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --footer-text-color: #ffffff;
  --main-content-bg: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  --card-bg: #ffffff;
  --card-border: #e8eaec;
  --card-text: #333;
  --input-bg: #ffffff;
  --input-border: #e8e8e8;
  --input-text: #333;
  --table-bg: #ffffff;
  --table-header-bg: #f8f8f9;
  --table-border: #e8eaec;
  --table-text: #515a6e;
  --table-stripe-bg: #f8f8f9;
  --table-hover-bg: #e6f7ff;
  --modal-bg: #ffffff;
  --modal-header-bg: #f8f8f9;
  --modal-text: #515a6e;
  --modal-border: #e8eaec;
}

/* 星空主题 */
.theme-starry {
  --primary-color: #1a1a2e;
  --primary-color-dark: #16213e;
  --sidebar-bg: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  --header-bg: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  --header-title-color: #e2e8f0;
  --footer-bg: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  --footer-text-color: #e2e8f0;
  --main-content-bg: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%);
  --card-bg: #1a1a2e;
  --card-border: #2a2a3e;
  --card-text: #e2e8f0;
  --input-bg: #0f0f1a;
  --input-border: #2a2a3e;
  --input-text: #e2e8f0;
  --table-bg: #1a1a2e;
  --table-header-bg: #16213e;
  --table-border: #2a2a3e;
  --table-text: #e2e8f0;
  --table-stripe-bg: #0f0f1a;
  --table-hover-bg: #16213e;
  --modal-bg: #1a1a2e;
  --modal-header-bg: #16213e;
  --modal-text: #e2e8f0;
  --modal-border: #2a2a3e;
}

/* 星空主题 - 查询历史标题区域特殊样式 */
.theme-starry .table-header-section {
  border-left-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}

.theme-starry .table-header-section:hover {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 蓝色主题 */
.theme-blue {
  --primary-color: #2196F3;
  --primary-color-dark: #1976D2;
  --sidebar-bg: linear-gradient(180deg, #1976D2 0%, #1565C0 100%);
  --header-bg: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
  --header-title-color: #ffffff;
  --footer-bg: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
  --footer-text-color: #ffffff;
  --main-content-bg: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  --card-bg: #ffffff;
  --card-border: #e8eaec;
  --card-text: #1565C0;
  --input-bg: #ffffff;
  --input-border: #90CAF9;
  --input-text: #1565C0;
  --table-bg: #ffffff;
  --table-header-bg: #E3F2FD;
  --table-border: #90CAF9;
  --table-text: #1565C0;
  --table-stripe-bg: #E3F2FD;
  --table-hover-bg: #BBDEFB;
  --modal-bg: #ffffff;
  --modal-header-bg: #E3F2FD;
  --modal-text: #1565C0;
  --modal-border: #90CAF9;
}

/* 蓝色主题 - 查询历史标题区域特殊样式 */
.theme-blue .table-header-section {
  border-left-color: #2196F3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
}

.theme-blue .table-header-section:hover {
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

/* 紫色主题 */
.theme-purple {
  --primary-color: #9C27B0;
  --primary-color-dark: #7B1FA2;
  --sidebar-bg: linear-gradient(180deg, #7B1FA2 0%, #6A1B9A 100%);
  --header-bg: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
  --header-title-color: #ffffff;
  --footer-bg: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
  --footer-text-color: #ffffff;
  --main-content-bg: linear-gradient(135deg, #F3E5F5 0%, #E1BEE7 100%);
  --card-bg: #ffffff;
  --card-border: #e8eaec;
  --card-text: #6A1B9A;
  --input-bg: #ffffff;
  --input-border: #CE93D8;
  --input-text: #6A1B9A;
  --table-bg: #ffffff;
  --table-header-bg: #F3E5F5;
  --table-border: #CE93D8;
  --table-text: #6A1B9A;
  --table-stripe-bg: #F3E5F5;
  --table-hover-bg: #E1BEE7;
  --modal-bg: #ffffff;
  --modal-header-bg: #F3E5F5;
  --modal-text: #6A1B9A;
  --modal-border: #CE93D8;
}

/* 紫色主题 - 查询历史标题区域特殊样式 */
.theme-purple .table-header-section {
  border-left-color: #9C27B0;
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.2);
}

.theme-purple .table-header-section:hover {
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.4);
}

/* 绿色主题 */
.theme-green {
  --primary-color: #4CAF50;
  --primary-color-dark: #388E3C;
  --sidebar-bg: linear-gradient(180deg, #388E3C 0%, #2E7D32 100%);
  --header-bg: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
  --header-title-color: #ffffff;
  --footer-bg: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
  --footer-text-color: #ffffff;
  --main-content-bg: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
  --card-bg: #ffffff;
  --card-border: #e8eaec;
  --card-text: #2E7D32;
  --input-bg: #ffffff;
  --input-border: #81C784;
  --input-text: #2E7D32;
  --table-bg: #ffffff;
  --table-header-bg: #E8F5E9;
  --table-border: #81C784;
  --table-text: #2E7D32;
  --table-stripe-bg: #E8F5E9;
  --table-hover-bg: #C8E6C9;
  --modal-bg: #ffffff;
  --modal-header-bg: #E8F5E9;
  --modal-text: #2E7D32;
  --modal-border: #81C784;
}

/* 绿色主题 - 查询历史标题区域特殊样式 */
.theme-green .table-header-section {
  border-left-color: #4CAF50;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.2);
}

.theme-green .table-header-section:hover {
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

/* 红色主题 */
.theme-red {
  --primary-color: #F44336;
  --primary-color-dark: #D32F2F;
  --sidebar-bg: linear-gradient(180deg, #D32F2F 0%, #C62828 100%);
  --header-bg: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
  --header-title-color: #ffffff;
  --footer-bg: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
  --footer-text-color: #ffffff;
  --main-content-bg: linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%);
  --card-bg: #ffffff;
  --card-border: #e8eaec;
  --card-text: #C62828;
  --input-bg: #ffffff;
  --input-border: #EF9A9A;
  --input-text: #C62828;
  --table-bg: #ffffff;
  --table-header-bg: #FFEBEE;
  --table-border: #EF9A9A;
  --table-text: #C62828;
  --table-stripe-bg: #FFEBEE;
  --table-hover-bg: #FFCDD2;
  --modal-bg: #ffffff;
  --modal-header-bg: #FFEBEE;
  --modal-text: #C62828;
  --modal-border: #EF9A9A;
}

/* 红色主题 - 查询历史标题区域特殊样式 */
.theme-red .table-header-section {
  border-left-color: #F44336;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.2);
}

.theme-red .table-header-section:hover {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.4);
}

/* 橙色主题 */
.theme-orange {
  --primary-color: #FF9800;
  --primary-color-dark: #F57C00;
  --sidebar-bg: linear-gradient(180deg, #F57C00 0%, #E65100 100%);
  --header-bg: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  --header-title-color: #ffffff;
  --footer-bg: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  --footer-text-color: #ffffff;
  --main-content-bg: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  --card-bg: #ffffff;
  --card-border: #e8eaec;
  --card-text: #E65100;
  --input-bg: #ffffff;
  --input-border: #FFB74D;
  --input-text: #E65100;
  --table-bg: #ffffff;
  --table-header-bg: #FFF3E0;
  --table-border: #FFB74D;
  --table-text: #E65100;
  --table-stripe-bg: #FFF3E0;
  --table-hover-bg: #FFE0B2;
  --modal-bg: #ffffff;
  --modal-header-bg: #FFF3E0;
  --modal-text: #E65100;
  --modal-border: #FFB74D;
}

/* 橙色主题 - 查询历史标题区域特殊样式 */
.theme-orange .table-header-section {
  border-left-color: #FF9800;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.2);
}

.theme-orange .table-header-section:hover {
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

/* 主题色应用到菜单 */
.theme-starry .sidebar-dark .menu-item.active,
.theme-blue .sidebar-dark .menu-item.active,
.theme-purple .sidebar-dark .menu-item.active,
.theme-green .sidebar-dark .menu-item.active,
.theme-red .sidebar-dark .menu-item.active,
.theme-orange .sidebar-dark .menu-item.active {
  background: var(--primary-color) !important;
}

.theme-blue .sidebar-dark {
  background: linear-gradient(180deg, #1976D2 0%, #1565C0 100%) !important;
}

.theme-purple .sidebar-dark {
  background: linear-gradient(180deg, #7B1FA2 0%, #6A1B9A 100%) !important;
}

.theme-green .sidebar-dark {
  background: linear-gradient(180deg, #388E3C 0%, #2E7D32 100%) !important;
}

.theme-red .sidebar-dark {
  background: linear-gradient(180deg, #D32F2F 0%, #C62828 100%) !important;
}

.theme-orange .sidebar-dark {
  background: linear-gradient(180deg, #F57C00 0%, #E65100 100%) !important;
}

/* 移动端主内容区域样式 */
.main-content-mobile {                      /* 定义移动端主内容区域的样式 */
  margin-left: 0 !important;               /* 左边距，移动端无侧边栏 */
  margin-top: 0 !important;                /* 顶部边距，确保贴顶 */
  padding: 0 !important;                   /* 内边距，移动端无内边距，让导航栏贴顶 */
  width: 100%;                             /* 宽度，占据整个容器 */
}

@media (min-width: 769px) {                 /* 当屏幕最小宽度为769像素时应用以下样式 */
  .ivu-table-cell {                         /* 定义ivu-table-cell的样式 */
    font-size: 14px;                       /* 增大字体 */
    padding: 8px 12px;                     /* 增加内边距 */
  }
}

/* 在小屏幕上适配 */
@media (max-width: 768px) {                 /* 当屏幕最大宽度为768像素时应用以下样式 */

  /* 重置body和html的margin */
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    overflow-x: hidden !important;
  }

  /* 重置#app的样式 */
  #app {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 重置全页面布局 */
  .full-page-layout {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 重置全页面内容 */
  .full-page-content {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 顶部导航栏移动端优化 */
  .top-header {
    padding: 5px 12px;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
    flex-wrap: nowrap;
    margin-top: 0px !important;
    margin-bottom: 8px !important;
    border-radius: 0 0 12px 12px;
    box-shadow: none !important;
    position: fixed !important;
    top: 32px !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000 !important;
  }

  /* 内容区域添加内边距 */
  .content-wrapper {
    padding: 0 !important;
    display: block !important;
    width: 100% !important;
  }

  .header-left {
    gap: 8px;
  }

  /* 移动端站点标题（顶部独立一行） */
  .mobile-header-title {
    width: 100%;
    text-align: center;
    padding: 12px 10px 0px 10px !important;
    padding-top: 12px !important;
    padding-bottom: 0px !important;
    margin: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    background: var(--header-bg, #fff);
    border-radius: 0 0 8px 8px;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1001 !important;
    display: block;
    line-height: 1.1;
    box-sizing: border-box;
  }

  .mobile-header-title h2 {
    font-size: 20px;
    margin: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    line-height: 1;
    color: var(--text-color, #fff);
    font-weight: 600;
    height: auto;
  }

  .header-right {
    gap: 8px;
    flex-shrink: 1;
  }

  /* 移动端隐藏全屏按钮 */
  .fullscreen-btn {
    display: none;
  }

  /* 移动端缩小主题切换器 */
  .theme-switcher {
    width: 90px !important;
  }

  .theme-switcher .ivu-select {
    width: 90px !important;
  }

  /* 移动端用户信息简化 */
  .user-display .user-role {
    display: none;
  }

  .user-display .username {
    font-size: 12px;
  }

  .top-buttons-container {
    top: 10px;
    right: 10px;
    gap: 5px;
  }

  .ip-whitelist-btn {
    padding: 4px 8px;
    font-size: 12px;
  }


  /* 移动端隐藏 API 文档链接 */
  .api-doc-link-container {                 /* 定义API文档链接容器的样式 */
    display: none;                         /* 在移动端隐藏 */
  }

  /* 移动端菜单按钮显示 */
  .mobile-menu-btn {                        /* 定义移动端菜单按钮的样式 */
    display: flex;                         /* 显示，使用弹性布局 */
  }

  /* 侧边栏隐藏 */
  .sidebar {                                /* 定义侧边栏的样式 */
    display: none;                         /* 隐藏，移动端不显示侧边栏 */
  }

  /* 移动端侧边栏遮罩层 */
  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: block;
  }

  /* 主内容区域适配移动端 */
  .main-content {                           /* 定义主内容区域的样式 */
    margin-left: 0;                        /* 左边距，无侧边栏 */
    padding: 0 !important;                 /* 移动端无内边距，让内容贴顶 */
    padding-top: 65px !important;          /* 为固定标题和导航栏留出空间 */
    margin-top: 0 !important;              /* 确保顶部无边距 */
    width: 100%;                           /* 宽度，占据整个容器 */
    display: block !important;             /* 确保正常显示 */
    top: 0 !important;                     /* 确保定位在顶部 */
  }

  /* 输入框区域适配移动端 */
  .input-section {
    flex-direction: column;
    gap: 15px;
    margin-top: 25px !important; /* 增加顶部边距，让输入框往下移动 */
  }

  /* 输入框适配移动端 */
  .input-field {
    margin-right: 0;
    width: 100%;
    padding: 14px 18px;
    font-size: 16px;
    border-radius: 12px;
  }

  /* 添加按钮容器适配移动端 */
  .add-buttons-container {
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: 100%;
    justify-content: center;
  }

  /* 添加按钮适配移动端 */
  .add-buttons-container .ivu-btn {
    flex: 1;
    max-width: 160px;
    padding: 14px 20px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    height: auto;
  }

  /* 操作按钮区域适配移动端 */
  .action-buttons {                         /* 定义操作按钮区域的样式 */
    display: grid;                         /* 网格布局，使按钮排列更整齐 */
    grid-template-columns: repeat(2, 1fr); /* 两列，平均分配空间 */
    gap: 10px;                             /* 间距，按钮之间的间隙 */
  }

  /* 操作按钮适配移动端 */
  .action-buttons button {                  /* 定义操作按钮的样式 */
    flex: 1 1 40%;                         /* 弹性属性，允许增长和收缩 */
    margin-right: 0;                       /* 右边距，无右边距 */
    min-width: 120px;                      /* 最小宽度，确保按钮大小合适 */
    padding: 12px;                         /* 内边距，更大的点击区域 */
    font-size: 14px;                       /* 字体大小，适应小屏幕 */
  }

  /* 待查询项列表适配移动端 */
  .pending-list {                           /* 定义待查询项列表的样式 */
    flex-wrap: wrap;                       /* 换行，允许换行 */
    max-height: none;                      /* 最大高度，无最大高度限制 */
  }

  /* 待查询项适配移动端 */
  .pending-item {                           /* 定义待查询项的样式 */
    margin-bottom: 5px;                    /* 下边距，更小的间距 */
    min-width: calc(50% - 10px);           /* 最小宽度，适应小屏幕 */
  }

  /* 待查询项底部适配移动端 */
  .pending-footer {                         /* 定义待查询项底部的样式 */
    flex-direction: column;                /* 垂直排列，使元素垂直排列 */
    gap: 10px;                             /* 间距，元素之间的间隙 */
    align-items: flex-start;               /* 左对齐，元素左对齐 */
  }

  /* 播放开关适配移动端 */
  .play-toggle {                            /* 定义播放开关的样式 */
    flex-direction: column;                /* 垂直排列，使元素垂直排列 */
    align-items: flex-start;               /* 左对齐，元素左对齐 */
    gap: 10px;                             /* 间距，元素之间的间隙 */
  }

  /* 移动端分页容器样式 */
  .pagination {
    display: flex !important;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
    overflow-x: auto;
    white-space: nowrap;
    flex-wrap: nowrap; /* 保持在一行显示，不换行 */
    padding: 0 12px 15px 12px !important; /* 添加底部内边距 */
    width: 100% !important;
    box-sizing: border-box !important;
  }
  
  /* 移动端每页条数选择器样式 */
  .page-size-selector-mobile {
    flex-shrink: 0;
  }

  /* 移动端分页按钮样式 */
  .pagination .page-btn {
    flex-shrink: 0;
    padding: 8px 12px; /* 减小内边距 */
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    min-width: 60px; /* 减小最小宽度 */
    height: auto;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  }

  /* 移动端分页信息样式 */
  .pagination .page-info-mobile,
  .pagination span {
    display: flex;
    gap: 6px; /* 减小间距 */
    font-size: 12px; /* 减小字体 */
    font-weight: 600;
    white-space: nowrap;
    margin: 0;
    align-items: center;
    flex-shrink: 0; /* 不收缩 */
  }
  
  /* 表格容器适配移动端 */
  .table-container {
    display: block !important;             /* 移动端显示表格容器 */
    overflow-x: auto;
    overflow-y: visible !important;
    margin-bottom: 20px;
    border-radius: 5px;
    -webkit-overflow-scrolling: touch;
    font-size: 12px;
    white-space: nowrap;
    width: 100% !important;
    box-sizing: border-box !important;
    position: relative !important;
    z-index: 1 !important;
    pointer-events: auto !important;
  }



  /* 表格适配移动端 */
  :deep(.ivu-table) {                       /* 定义ivu-table的样式 */
    font-size: 12px;                       /* 字体大小，更小的字体 */
    min-width: 600px;                      /* 最小宽度，确保表格最小宽度 */
  }

  /* 表格头部适配移动端 */
  :deep(.ivu-table th) {                    /* 定义ivu-table表头的样式 */
    padding: 8px 5px;                      /* 内边距，更小的内边距 */
  }

  /* 表格单元格适配移动端 */
  :deep(.ivu-table td) {                    /* 定义ivu-table单元格的样式 */
    padding: 1px 1px;                      /* 内边距，更小的内边距 */
  }

  /* 隐藏部分表格列适配移动端 */
  :deep(.ivu-table-th:nth-child(n+6)),      /* 定义 ivu-table-th 的样式 */
  :deep(.ivu-table-td:nth-child(n+6)) {     /* 定义 ivu-table-td 的样式 */
    display: none !important;                /* 隐藏，隐藏第 6 列及以后的列 */
  }
  
  /* 确保移动端表格复选框可以点击 */
  :deep(.ivu-table-body) {
    position: relative !important;
    z-index: 1 !important;
    pointer-events: auto !important;
  }
  
  /* 确保移动端表格行可点击 */
  :deep(.ivu-table-row) {
    position: relative !important;
    z-index: 1 !important;
    pointer-events: auto !important;
    cursor: pointer !important;
  }
  
  /* 禁用移动端表格行的选中效果，避免冲突 */
  :deep(.ivu-table-row:hover) {
    background-color: transparent !important;
  }
  
  /* 确保移动端表格单元格可点击 */
  :deep(.ivu-table-cell) {
    position: relative !important;
    z-index: 1 !important;
    pointer-events: auto !important;
  }
  
  /* 确保移动端选择列单元格不被其他样式覆盖 */
  :deep(.ivu-table-selection .ivu-table-cell) {
    pointer-events: auto !important;
    cursor: pointer !important;
  }
  
  /* 移动端其他页面内容下移，避免被固定导航栏遮挡 */
  .monitor-page,
  .recharge-page,
  .settings-page {
    padding-top: 65px !important;
  }
  
  /* 确保移动端复选框可点击 */
  :deep(.ivu-checkbox-input) {
    position: relative !important;
    z-index: 10 !important;
    cursor: pointer !important;
    pointer-events: auto !important;
    width: 20px !important;
    height: 20px !important;
  }
  
  /* 确保移动端复选框包装器可点击 */
  :deep(.ivu-checkbox-wrapper) {
    position: relative !important;
    z-index: 10 !important;
    cursor: pointer !important;
    pointer-events: auto !important;
    padding: 5px !important;
  }
  
  /* 确保移动端选择列有足够宽度 */
  :deep(.ivu-table-selection) {
    min-width: 50px !important;
  }

  /* 表格头部适配移动端 */
  :deep(.ivu-table-header) {                /* 定义ivu-table-header的样式 */
    font-size: 12px;                       /* 字体大小，更小的字体 */
  }

  /* 表格单元格适配移动端 */
  :deep(.ivu-table-cell) {                  /* 定义ivu-table-cell的样式 */
    font-size: 12px;                       /* 调整表格内文字大小 */
  }

  /* 移动端卡片列表样式 */
  .card-list {
    display: flex !important;
    flex-direction: column;
    gap: 15px;
    padding: 15px 0 0 0 !important; /* 移除左右内边距，让卡片占满宽度 */
    visibility: visible !important;
    opacity: 1 !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* 移动端卡片项样式 */
  .card-item {
    border: 1px solid var(--card-border, #e8eaec);
    border-radius: 12px;
    padding: 15px 12px; /* 添加左右内边距 */
    background-color: var(--card-bg, #fff);
    color: var(--card-text, #333);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: block !important;
    visibility: visible !important;
    width: 100% !important;
    box-sizing: border-box !important;
    margin: 0 !important;
  }

  /* 移动端卡片头部样式 */
  .card-header {
    font-weight: bold;
    margin-bottom: 12px;
    font-size: 14px;
    color: var(--primary-color, #1890ff);
  }

  /* 移动端卡片区块样式 */
  .card-section {
    margin-bottom: 15px;
  }

  /* 移动端卡片区块标题样式 */
  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--primary-color, #667eea);
    margin-bottom: 8px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--card-border, #eee);
  }

  /* 移动端信息网格样式 */
  .info-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
  }

  /* 移动端信息项样式 */
  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  /* 移动端信息标签样式 */
  .info-label {
    color: var(--card-text, #666);
    font-weight: 500;
  }

  /* 移动端信息值样式 */
  .info-value {
    color: var(--card-text, #333);
    text-align: right;
    word-break: break-all;
  }

  /* 移动端封面图片样式 */
  .card-cover {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
  }

  /* 移动端状态徽章样式 */
  .status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
  }

  .status-success {
    background-color: #d4edda;
    color: #155724;
  }

  .status-error {
    background-color: #f8d7da;
    color: #721c24;
  }

  .status-warning {
    background-color: #fff3cd;
    color: #856404;
  }

  .status-info {
    background-color: #cce5ff;
    color: #004085;
  }

  .status-default {
    background-color: #e2e3e5;
    color: #383d41;
  }

  /* 星空主题下卡片列表文字强制使用白色 */
  .theme-starry .card-item,
  .theme-starry .info-label,
  .theme-starry .info-value,
  .theme-starry .section-title,
  .theme-starry .card-header,
  .theme-starry .video-id {
    color: #ffffff !important;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  /* 待查询项适配超小屏幕 */
  .pending-item {
    min-width: 100%;
  }

  /* 操作按钮区域适配超小屏幕 */
  .action-buttons {
    grid-template-columns: 1fr;
  }

  /* 分页组件适配超小屏幕 */
  .pagination {
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  /* 分页按钮适配超小屏幕 */
  .page-btn {
    min-width: 90px;
    padding: 10px 16px;
    font-size: 13px;
  }

  /* 移动端搜索框适配超小屏幕 */
  .mobile-search-container {
    flex-direction: column;
    gap: 8px;
  }

  .mobile-search-input {
    width: 100%;
  }

  .mobile-search-btn {
    width: 100%;
    padding: 12px;
  }
}

/* 输入框区域样式 - 紧凑版 */
.input-section {
  margin-bottom: 10px; /* 紧凑：从25px减少到10px */
  display: flex;
  align-items: center;
  gap: 10px; /* 紧凑：从15px减少到10px */
  padding: 12px; /* 紧凑：从20px减少到12px */
  background: var(--card-bg, linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%));
  border-radius: 12px; /* 紧凑：从16px减少到12px */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

/* 输入框样式 - 紧凑版（深色主题皮肤，强制覆盖浏览器默认/自动填充白色背景） */
.input-field {
  flex: 1;
  padding: 10px 14px; /* 紧凑：从14px 18px减少到10px 14px */
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px; /* 紧凑：从12px减少到8px */
  font-size: 14px; /* 紧凑：从15px减少到14px */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(15, 15, 26, 0.7) !important;
  color: #e2e8f0 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  -webkit-text-fill-color: #e2e8f0 !important;
}

/* 覆盖浏览器自动填充时出现的黄色/白色背景，确保始终使用主题深色 */
.input-field:-webkit-autofill,
.input-field:-webkit-autofill:hover,
.input-field:-webkit-autofill:focus,
.input-field:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px rgba(15, 15, 26, 0.95) inset !important;
  -webkit-text-fill-color: #e2e8f0 !important;
  transition: background-color 5000s ease-in-out 0s;
}

.input-field::placeholder {
  color: #8892b0;
  font-size: 13px; /* 紧凑：从14px减少到13px */
}

.input-field:hover {
  border-color: rgba(102, 126, 234, 0.6);
  box-shadow: 0 0 15px rgba(102, 126, 234, 0.2);
  background: rgba(20, 20, 40, 0.85) !important;
}

.input-field:focus {
  border-color: rgba(102, 126, 234, 0.9);
  background: rgba(20, 20, 40, 0.9) !important;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15);
  outline: none;
}

/* 星空主题下输入框与深色皮肤保持一致，避免白色背景突兀 */
.theme-starry .input-field,
.theme-classic .input-field,
.theme-blue .input-field,
.theme-purple .input-field,
.theme-green .input-field,
.theme-red .input-field,
.theme-orange .input-field {
  background: rgba(15, 15, 26, 0.85) !important;
  border-color: rgba(255, 255, 255, 0.15);
  color: #e2e8f0 !important;
  -webkit-text-fill-color: #e2e8f0 !important;
}

.theme-starry .input-field:hover,
.theme-classic .input-field:hover,
.theme-blue .input-field:hover,
.theme-purple .input-field:hover,
.theme-green .input-field:hover,
.theme-red .input-field:hover,
.theme-orange .input-field:hover {
  background: rgba(20, 20, 40, 0.9) !important;
  border-color: rgba(102, 126, 234, 0.6);
}

.theme-starry .input-field:focus,
.theme-classic .input-field:focus,
.theme-blue .input-field:focus,
.theme-purple .input-field:focus,
.theme-green .input-field:focus,
.theme-red .input-field:focus,
.theme-orange .input-field:focus {
  background: rgba(15, 15, 26, 0.95) !important;
  border-color: rgba(102, 126, 234, 0.9);
}

/* 添加按钮容器样式 */
.add-buttons-container {
  display: flex;
  gap: 8px; /* 紧凑：从10px减少到8px */
  align-items: center;
}

/* 添加按钮样式 - 美化版 */
.add-btn {
  padding: 14px 32px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  white-space: nowrap;
  letter-spacing: 0.5px;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.add-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* 待查询项区域样式 - 紧凑版 */
.pending-items {
  margin-bottom: 10px; /* 紧凑：从25px减少到10px */
  padding: 12px; /* 紧凑：从20px减少到12px */
  background: var(--card-bg, #ffffff);
  border-radius: 12px; /* 紧凑：从16px减少到12px */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

/* 播放开关样式 */
.play-toggle {                              /* 定义播放开关的样式 */
  margin-bottom: 20px;                     /* 下边距，与其他元素保持距离 */
  display: flex;                           /* 弹性布局，使内部元素水平排列 */
  align-items: center;                     /* 垂直居中，使元素在垂直方向居中 */
  padding: 15px;                           /* 内边距，使内容不贴边 */
  background: #f8f9fa;                     /* 背景色，使区域更突出 */
  border-radius: 8px;                      /* 圆角，使边框更美观 */
}

/* 开关样式 */
.switch {                                   /* 定义开关的样式 */
  position: relative;                      /* 相对定位，为绝对定位子元素提供参考 */
  display: inline-block;                   /* 行内块，使元素可以设置宽高 */
  width: 60px;                             /* 宽度，开关宽度 */
  height: 34px;                            /* 高度，开关高度 */
}

/* 开关输入框样式 */
.switch input {                             /* 定义开关输入框的样式 */
  opacity: 0;                              /* 透明度，隐藏输入框 */
  width: 0;                                /* 宽度，无宽度 */
  height: 0;                               /* 高度，无高度 */
}

/* 滑块样式 */
.slider {                                   /* 定义滑块的样式 */
  position: absolute;                      /* 绝对定位，相对于父元素定位 */
  cursor: pointer;                         /* 鼠标指针，提示可点击 */
  top: 0;                                  /* 顶部，从顶部开始 */
  left: 0;                                 /* 左侧，从左侧开始 */
  right: 0;                                /* 右侧，到右侧结束 */
  bottom: 0;                               /* 底部，到底部结束 */
  background-color: #ccc;                  /* 背景色，未选中状态 */
  -webkit-transition: .4s;                 /* 过渡，变化时有动画效果 */
  transition: .4s;                         /* 过渡，变化时有动画效果 */
}

/* 滑块圆点样式 */
.slider:before {                            /* 定义滑块圆点的样式 */
  position: absolute;                      /* 绝对定位，相对于父元素定位 */
  content: "";                             /* 内容，空内容 */
  height: 26px;                            /* 高度，圆点高度 */
  width: 26px;                             /* 宽度，圆点宽度 */
  left: 4px;                               /* 左侧，距离左侧4px */
  bottom: 4px;                             /* 底部，距离底部4px */
  background-color: white;                 /* 背景色，白色圆点 */
  -webkit-transition: .4s;                 /* 过渡，变化时有动画效果 */
  transition: .4s;                         /* 过渡，变化时有动画效果 */
}

/* 选中状态下滑块样式 */
input:checked + .slider {                   /* 定义选中状态下滑块的样式 */
  background-color: #2196F3;               /* 背景色，选中状态 */
}

/* 聚焦状态下滑块样式 */
input:focus + .slider {                     /* 定义聚焦状态下滑块的样式 */
  box-shadow: 0 0 1px #2196F3;             /* 阴影，聚焦时的视觉效果 */
}

/* 选中状态下滑块圆点样式 */
input:checked + .slider:before {            /* 定义选中状态下滑块圆点的样式 */
  -webkit-transform: translateX(26px);     /* 变换，向右移动 */
  -ms-transform: translateX(26px);         /* 变换，向右移动 */
  transform: translateX(26px);             /* 变换，向右移动 */
}

/* 圆形滑块样式 */
.slider.round {                             /* 定义圆形滑块的样式 */
  border-radius: 34px;                     /* 圆角，使滑块呈圆形 */
}

/* 圆形滑块圆点样式 */
.slider.round:before {                      /* 定义圆形滑块圆点的样式 */
  border-radius: 50%;                      /* 圆形，使圆点呈圆形 */
}

/* 开关标签样式 */
.toggle-label {                             /* 定义开关标签的样式 */
  color: #dc3545;                          /* 颜色 */
  margin-left: 10px;                       /* 左边距，与开关保持距离 */
  font-size: 14px;                         /* 字体大小，确保可读性 */
  //color: #409eff;                        /* 颜色，使用主题色 */
}

/* 操作按钮区域样式 - 紧凑版 */
.action-buttons {
  margin-bottom: 10px; /* 紧凑：从20px减少到10px */
  display: flex;
  gap: 10px; /* 紧凑：从15px减少到10px */
  flex-wrap: wrap;
  justify-content: center;
  padding: 8px 0; /* 紧凑：从15px 0减少到8px 0 */
}

/* 操作按钮通用样式 - 紧凑版 */
.query-btn, .select-btn, .refresh-btn, .clear-btn, .export-btn {
  padding: 10px 20px; /* 紧凑：从14px 28px减少到10px 20px */
  border: none;
  border-radius: 8px; /* 紧凑：从12px减少到8px */
  color: white;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px; /* 紧凑：从15px减少到13px */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1); /* 紧凑：减少阴影 */
  position: relative;
  overflow: hidden;
  min-width: 100px; /* 紧凑：从120px减少到100px */
  letter-spacing: 0.5px;
}

/* 按钮点击波纹效果 */
.query-btn::after, .select-btn::after, .refresh-btn::after, .clear-btn::after, .export-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.query-btn:active::after, .select-btn:active::after, .refresh-btn:active::after, .clear-btn:active::after, .export-btn:active::after {
  width: 200px; /* 紧凑：从300px减少到200px */
  height: 200px; /* 紧凑：从300px减少到200px */
}

/* 查询按钮样式 - 紫色渐变 */
.query-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 3px 10px rgba(102, 126, 234, 0.4); /* 紧凑：减少阴影 */
}

.query-btn:hover:not(:disabled) {
  transform: translateY(-2px); /* 紧凑：从-3px减少到-2px */
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.6); /* 紧凑：减少阴影 */
}

.query-btn:active:not(:disabled) {
  transform: translateY(0px); /* 紧凑：从-1px减少到0px */
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4); /* 紧凑：减少阴影 */
}

.query-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 全选按钮样式 - 粉色渐变 */
.select-btn {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  box-shadow: 0 3px 10px rgba(240, 147, 251, 0.4); /* 紧凑：减少阴影 */
}

.select-btn:hover {
  transform: translateY(-2px); /* 紧凑：从-3px减少到-2px */
  box-shadow: 0 5px 15px rgba(240, 147, 251, 0.6); /* 紧凑：减少阴影 */
}

.select-btn:active {
  transform: translateY(0px); /* 紧凑：从-1px减少到0px */
  box-shadow: 0 2px 8px rgba(240, 147, 251, 0.4); /* 紧凑：减少阴影 */
}

/* 刷新按钮样式 - 蓝色渐变 */
.refresh-btn {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  box-shadow: 0 3px 10px rgba(79, 172, 254, 0.4); /* 紧凑：减少阴影 */
}

.refresh-btn:hover {
  transform: translateY(-2px); /* 紧凑：从-3px减少到-2px */
  box-shadow: 0 5px 15px rgba(79, 172, 254, 0.6); /* 紧凑：减少阴影 */
}

.refresh-btn:active {
  transform: translateY(0px); /* 紧凑：从-1px减少到0px */
  box-shadow: 0 2px 8px rgba(79, 172, 254, 0.4); /* 紧凑：减少阴影 */
}

/* 清除按钮样式 - 橙粉渐变 */
.clear-btn {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  box-shadow: 0 3px 10px rgba(250, 112, 154, 0.4); /* 紧凑：减少阴影 */
}

.clear-btn:hover {
  transform: translateY(-2px); /* 紧凑：从-3px减少到-2px */
  box-shadow: 0 5px 15px rgba(250, 112, 154, 0.6); /* 紧凑：减少阴影 */
}

.clear-btn:active {
  transform: translateY(0px); /* 紧凑：从-1px减少到0px */
  box-shadow: 0 2px 8px rgba(250, 112, 154, 0.4); /* 紧凑：减少阴影 */
}

/* 导出按钮样式 - 绿色渐变 */
.export-btn {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  box-shadow: 0 3px 10px rgba(67, 233, 123, 0.4); /* 紧凑：减少阴影 */
}

.export-btn:hover {
  transform: translateY(-2px); /* 紧凑：从-3px减少到-2px */
  box-shadow: 0 5px 15px rgba(67, 233, 123, 0.6); /* 紧凑：减少阴影 */
}

.export-btn:active {
  transform: translateY(0px); /* 紧凑：从-1px减少到0px */
  box-shadow: 0 2px 8px rgba(67, 233, 123, 0.4); /* 紧凑：减少阴影 */
}

/* AI批量分析按钮 - 紫粉渐变 */
.ai-batch-btn {
  background: linear-gradient(135deg, #722ed1 0%, #eb2f96 100%) !important;
  box-shadow: 0 3px 10px rgba(114, 46, 209, 0.4) !important;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.ai-batch-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(114, 46, 209, 0.6) !important;
}
.ai-batch-btn:active:not(:disabled) {
  transform: translateY(0px);
  box-shadow: 0 2px 8px rgba(114, 46, 209, 0.4) !important;
}
.ai-batch-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
  box-shadow: none !important;
}
.ai-batch-btn-loading {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
/* 旋转加载圈 */
.ai-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ai-spin 0.8s linear infinite;
  vertical-align: middle;
}
@keyframes ai-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ==================== 去除表格复选框前面的点 ==================== */
/* 全局去除所有列表样式 */
* {
  list-style: none !important;
}

/* 去除所有列表样式 */
:deep(.ivu-table) {
  ul, ol {
    list-style: none !important;
    margin: 0;
    padding: 0;
  }
}

/* 去除复选框容器的点 */
:deep(.ivu-checkbox-wrapper) {
  list-style: none !important;
  margin: 0;
  padding: 0;
}

/* 确保表格内的复选框没有点 */
:deep(.ivu-table .ivu-checkbox-wrapper) {
  list-style: none !important;
  display: inline-block;
}

/* 去除复选框内部可能存在的点 */
:deep(.ivu-checkbox) {
  list-style: none !important;
}

:deep(.ivu-checkbox::before),
:deep(.ivu-checkbox::after) {
  content: none !important;
  list-style: none !important;
}

/* 去除表格单元格内的所有点 */
:deep(.ivu-table td) {
  list-style: none !important;
}

:deep(.ivu-table-cell) {
  list-style: none !important;
}

/* 强制去除所有可能的点 - 全局样式 */
:deep(*) {
  list-style: none !important;
}

/* 专门针对表格选择列的复选框 */
:deep(.ivu-table .ivu-checkbox) {
  list-style: none !important;
}

:deep(.ivu-table .ivu-checkbox-wrapper) {
  list-style-type: none !important;
  list-style-image: none !important;
}

/* 去除伪元素产生的点 */
:deep(.ivu-table .ivu-checkbox-wrapper::before),
:deep(.ivu-table .ivu-checkbox-wrapper::after),
:deep(.ivu-table .ivu-checkbox::before),
:deep(.ivu-table .ivu-checkbox::after) {
  content: none !important;
  list-style: none !important;
  display: none !important;
}

/* 去除表格选择列单元格内的所有内容列表 */
:deep(.ivu-table-selection) {
  list-style: none !important;
}

:deep(.ivu-table-selection *) {
  list-style: none !important;
}

/* 去除所有元素的::marker伪元素 */
:deep(*::marker) {
  content: none !important;
  display: none !important;
}

/* 强制覆盖所有可能的样式 */
:deep([class*="checkbox"]),
:deep([class*="selection"]) {
  list-style: none !important;
}

:deep([class*="checkbox"]::before),
:deep([class*="checkbox"]::after),
:deep([class*="checkbox"] *) {
  list-style: none !important;
}

/* 电脑端表格复选框去除点 - 加强版 */
@media (min-width: 769px) {
  :deep(.ivu-table .ivu-checkbox-wrapper) {
    list-style: none !important;
    list-style-type: none !important;
    list-style-image: none !important;
    list-style-position: initial !important;
  }
  
  :deep(.ivu-table .ivu-checkbox) {
    list-style: none !important;
    list-style-type: none !important;
  }
  
  :deep(.ivu-table td .ivu-checkbox-wrapper::before),
  :deep(.ivu-table td .ivu-checkbox-wrapper::after),
  :deep(.ivu-table td .ivu-checkbox::before),
  :deep(.ivu-table td .ivu-checkbox::after) {
    content: "" !important;
    display: none !important;
  }
  
  :deep(.ivu-table-selection) {
    list-style: none !important;
  }
  
  :deep(.ivu-table-selection::marker) {
    content: none !important;
  }
  
  /* 强制去除表格单元格内所有元素的列表样式 */
  :deep(.ivu-table td),
  :deep(.ivu-table td *),
  :deep(.ivu-table th),
  :deep(.ivu-table th *) {
    list-style: none !important;
    list-style-type: none !important;
  }
  
  /* 去除所有可能的伪元素点 */
  :deep(.ivu-table td::before),
  :deep(.ivu-table td::after),
  :deep(.ivu-table th::before),
  :deep(.ivu-table th::after) {
    content: "" !important;
    display: none !important;
  }
  
  /* 去除 ::marker 伪元素 */
  :deep(.ivu-table td::marker),
  :deep(.ivu-table th::marker),
  :deep(.ivu-table *::marker) {
    content: none !important;
    display: none !important;
  }
  
  /* 去除表格行的列表样式 */
  :deep(.ivu-table tr),
  :deep(.ivu-table tr *) {
    list-style: none !important;
    list-style-type: none !important;
  }
  
  /* 去除表格体的列表样式 */
  :deep(.ivu-table tbody),
  :deep(.ivu-table thead),
  :deep(.ivu-table tbody *),
  :deep(.ivu-table thead *) {
    list-style: none !important;
  }
  
  /* 去除表格单元格的文本装饰 */
  :deep(.ivu-table td span),
  :deep(.ivu-table th span) {
    text-decoration: none !important;
    list-style: none !important;
  }
  
  /* 强制去除任何可能的点符号 */
  :deep(.ivu-table [class*="checkbox"]),
  :deep(.ivu-table [class*="check-box"]),
  :deep(.ivu-table [class*="selection"]) {
    list-style: none !important;
    list-style-type: none !important;
  }
}

/* 分页组件样式 */
.pagination {                               /* 定义分页组件的样式 */
  display: flex;                           /* 弹性布局 */
  justify-content: center;                 /* 水平居中对齐 */
  align-items: center;                     /* 垂直居中对齐 */
  margin-top: 10px;                        /* 上边距 */
  overflow-x: auto;                        /* 允许水平滚动 */
  -webkit-overflow-scrolling: touch;       /* 提升移动端滚动体验 */
  white-space: nowrap;                     /* 禁止换行 */
}

/* 分页按钮样式 */
.page-btn {                                 /* 定义分页按钮的样式 */
  padding: 5px 10px;                       /* 内边距，使按钮内容不贴边 */
  border: none;                            /* 无边框 */
  border-radius: 5px;                      /* 圆角，使按钮更美观 */
  background-color: #007bff;               /* 背景色，使用主题色 */
  color: white;                            /* 颜色，白色文字 */
  margin: 0 5px;                           /* 左右边距，与其他按钮保持距离 */
  cursor: pointer;                         /* 鼠标指针，提示可点击 */
}

/* 待查询项底部样式 */
.pending-footer {                           /* 定义待查询项底部的样式 */
  display: flex;                           /* 弹性布局，使内部元素水平排列 */
  justify-content: space-between;          /* 两端对齐，左右元素分别靠边 */
  align-items: center;                     /* 垂直居中，使元素在垂直方向居中 */
  margin-top: 10px;                        /* 上边距，与其他元素保持距离 */
}

/* 待查询项底部文本样式 */
.pending-footer span {                      /* 定义待查询项底部文本的样式 */
  font-size: 14px;                         /* 字体大小，确保可读性 */
  color: #666;                             /* 颜色，使用灰色 */
}

/* 登录模态框覆盖层样式 */
.login-modal-overlay {                      /* 定义登录模态框覆盖层的样式 */
  position: fixed;                         /* 固定定位，使覆盖层不随滚动移动 */
  top: 0;                                  /* 顶部，从顶部开始 */
  left: 0;                                 /* 左侧，从左侧开始 */
  width: 100%;                             /* 宽度，占据整个视口 */
  height: 100%;                            /* 高度，占据整个视口 */
  background-color: rgba(0, 0, 0, 0.5);    /* 背景色，半透明黑色 */
  z-index: 1000;                           /* 层级，确保在其他元素之上 */
}

/* 登录模态框包装器样式 */
.login-modal-wrapper {                      /* 定义登录模态框包装器的样式 */
  display: flex;                           /* 弹性布局，使内容居中 */
  justify-content: center;                 /* 水平居中 */
  align-items: center;                     /* 垂直居中 */
  height: 100%;                            /* 高度，占据整个视口 */
  width: 100%;                             /* 宽度，占据整个视口 */
  position: absolute;                      /* 绝对定位 */
  top: 0;                                  /* 顶部，从顶部开始 */
  left: 0;                                 /* 左侧，从左侧开始 */
}

/* 登录模态框容器样式 */
.login-modal-container {                    /* 定义登录模态框容器的样式 */
  background: white;                       /* 背景色，白色背景 */
  border-radius: 8px;                      /* 圆角，使边框更美观 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 阴影，使模态框更立体 */
  max-width: 400px;                        /* 最大宽度，限制模态框最大宽度 */
  width: 90%;                              /* 宽度，占据容器90% */
  max-height: 90vh;                        /* 最大高度，限制模态框最大高度 */
  overflow: auto;                          /* 滚动，当内容过高时可滚动 */
  margin: 20px;                            /* 外边距，与其他元素保持距离 */
}

/* 用户名蓝色文本样式 */
.username-blue {                            /* 定义用户名蓝色文本的样式 */
  color: #007bff;                          /* 颜色，使用主题色 */
  font-weight: 600;                        /* 粗体，使文字更突出 */
  font-size: 16px;                         /* 字体大小，确保可读性 */
}

/* 主标题样式 - 美化版 */
.main-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin: 20px 0 25px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  text-shadow: none;
  letter-spacing: 2px;
  position: relative;
  padding-bottom: 15px;
}

/* 标题下划线装饰 */
.main-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

/* 退出按钮样式 - 美化版 */
.logout-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
  margin-left: 5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

/* 退出按钮悬停样式 */
.logout-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

.logout-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

/* 待查询项标题样式 */
.pend-daichaxun {                           /* 定义待查询项标题的样式 */
  text-align: left;                        /* 文本左对齐 */
  font-size: 15px;                         /* 字体大小 */
  font-weight: bold;                       /* 粗体 */
  margin: 3px 0;                           /* 上下边距改为 3px，左右边距保持为 0 */
  color: #409eff;                          /* 浅蓝色 */
  font-family: 'Microsoft YaHei', Arial, sans-serif; /* 字体族 */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); /* 添加轻微阴影，增加立体感 */
  letter-spacing: 1px;                     /* 字符间距，让文字不那么紧凑 */
}


/* 待会员服务样式 */
.pend-huiyuanfuwu {                           /* 定义待查询项标题的样式 */
  text-align: center;                        /* 文本左对齐 */
  font-size: 15px;                         /* 字体大小 */
  font-weight: bold;                       /* 粗体 */
  margin: 3px 0;                           /* 上下边距改为 3px，左右边距保持为 0 */
  color: #409eff;                          /* 浅蓝色 */
  font-family: 'Microsoft YaHei', Arial, sans-serif; /* 字体族 */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); /* 添加轻微阴影，增加立体感 */
  letter-spacing: 1px;                     /* 字符间距，让文字不那么紧凑 */
}

/* 当前用户信息容器样式 */
.now-user {                                 /* 定义当前用户信息容器的样式 */
  display: flex;                           /* 弹性布局 */
  flex-direction: row;                     /* 水平排列 */
  align-items: center;                     /* 垂直居中 */
  justify-content: center;                 /* 水平居中 */
  gap: 10px;                               /* 间距，元素之间的间隙 */
  margin-bottom: 10px;                     /* 下边距，与其他元素保持距离 */
  flex-wrap: wrap;                         /* 换行，当空间不足时换行 */
}

/* 当前用户信息中的用户名样式 */
.now-user .username-blue {                  /* 定义当前用户信息中的用户名的样式 */
  font-size: 16px;                         /* 字体大小 */
  font-weight: 600;                        /* 粗体 */
  color: #007bff;                          /* 颜色，使用主题色 */
  white-space: nowrap;                     /* 不换行，保持文本在一行 */
}

/* 充值链接按钮样式 - 美化版 */
.recharge-link-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 10px;
  vertical-align: middle;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* 充值链接按钮悬停效果 */
.recharge-link-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 充值链接按钮激活效果 */
.recharge-link-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.detail-modal-content {                     /* 定义详情模态框内容的样式 */
  font-size: 14px;                         /* 字体大小 */
  line-height: 1.8;                        /* 行高 */
}

.detail-modal-content p {                   /* 定义详情模态框内容中段落的样式 */
  margin-bottom: 10px;                     /* 下边距 */
}

.detail-modal-content strong {              /* 定义详情模态框内容中粗体文本的样式 */
  color: #1890ff;                          /* 颜色 */
}

/* 立即充值按钮样式 - 美化版 */
.recharge-btn {
  display: inline-block;
  margin-top: 8px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 4px 15px rgba(250, 112, 154, 0.4);
  letter-spacing: 1px;
}

.recharge-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(250, 112, 154, 0.5);
}

.recharge-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(250, 112, 154, 0.4);
}

/* 查看充值记录按钮样式 - 美化版 */
.view-recharge-list-btn {
  display: inline-block;
  margin-top: 12px;
  padding: 14px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  letter-spacing: 0.5px;
}

.view-recharge-list-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
}

.view-recharge-list-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
}

/* 大图样式 */
.large-image-modal img {                    /* 定义大图模态框中图片的样式 */
  border-radius: 8px;                      /* 圆角边框 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 添加阴影效果 */
}

.author-modal {                             /* 定义作者模态框的样式 */
  border-radius: 12px;                     /* 圆角 */
  background-color: black !important;      /* 设置背景颜色为黑色 */
}

.author-modal-content {                     /* 定义作者模态框内容的样式 */
  display: flex;                           /* 弹性布局 */
  align-items: center;                     /* 垂直居中 */
  gap: 20px;                               /* 间距 */
  padding: 20px;                           /* 内边距 */
}

.author-avatar {                            /* 定义作者头像的样式 */
  flex-shrink: 0;                          /* 不收缩 */
}

.author-avatar img {                        /* 定义作者头像图片的样式 */
  border: 2px solid #e6f7ff;               /* 边框 */
}

.avatar-placeholder {                       /* 定义头像占位符的样式 */
  width: 80px;                             /* 宽度 */
  height: 80px;                            /* 高度 */
  background: #f5f5f5;                     /* 背景色 */
  border-radius: 50%;                      /* 圆形 */
  display: flex;                           /* 弹性布局 */
  align-items: center;                     /* 垂直居中 */
  justify-content: center;                 /* 水平居中 */
  color: #999;                             /* 颜色 */
  font-size: 14px;                         /* 字体大小 */
}

.author-info {                              /* 定义作者信息的样式 */
  flex: 1;                                 /* 弹性增长 */
}

.author-info h3 {                           /* 定义作者信息中标题的样式 */
  margin: 0 0 10px;                        /* 外边距 */
  color: #333;                             /* 颜色 */
  font-size: 18px;                         /* 字体大小 */
}

.author-info p {                            /* 定义作者信息中段落的样式 */
  margin: 5px 0;                           /* 外边距 */
  color: #666;                             /* 颜色 */
  font-size: 14px;                         /* 字体大小 */
}

.modal-footer {                             /* 定义模态框底部的样式 */
  text-align: right;                       /* 文本右对齐 */
  margin-top: 20px;                        /* 上边距 */
  padding: 10px 0;                         /* 内边距 */
  border-top: 1px solid #eee;              /* 顶部边框 */
}

.modal-footer button {                      /* 定义模态框底部按钮的样式 */
  margin-left: 10px;                       /* 左边距 */
}

/* 模态框容器样式 */
.custom-modal .ivu-modal {                  /* 定义自定义模态框中ivu-modal的样式 */
  position: fixed;                         /* 固定定位 */
  top: 50%;                                /* 顶部 */
  left: 50%;                               /* 左侧 */
  transform: translate(-50%, -50%);        /* 变换，居中 */
  width: 700px;                            /* 宽度 */
  max-height: 90vh;                        /* 最大高度 */
  overflow-y: auto;                        /* 垂直滚动 */
  background-color: #e6f7ff;               /* 背景色 */
  border-radius: 12px;                     /* 圆角 */
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1); /* 阴影 */
}

/* 模态框标题样式 */
.query-result-modal h3 {                    /* 定义查询结果模态框中标题的样式 */
  font-size: 20px;                         /* 字体大小 */
  font-weight: 600;                        /* 字体粗细 */
  color: #1890ff;                          /* 颜色 */
  margin-bottom: 20px;                     /* 下边距 */
}

/* 模态框内容样式 */
.query-result-modal p {                     /* 定义查询结果模态框中段落的样式 */
  font-size: 16px;                         /* 字体大小 */
  line-height: 1.8;                        /* 行高 */
  color: #333;                             /* 颜色 */
  margin: 10px 0;                          /* 外边距 */
}

/* 模态框关闭按钮样式 */
.query-result-modal .close-btn {            /* 定义查询结果模态框中关闭按钮的样式 */
  margin-top: 20px;                        /* 上边距 */
  padding: 10px 20px;                      /* 内边距 */
  background-color: #1890ff;               /* 背景色 */
  color: #fff;                             /* 文字颜色 */
  border: none;                            /* 无边框 */
  border-radius: 4px;                      /* 圆角 */
  font-size: 16px;                         /* 字体大小 */
  cursor: pointer;                         /* 鼠标指针 */
  transition: background-color 0.3s ease;  /* 过渡动画 */
}

.query-result-modal .close-btn:hover {      /* 定义查询结果模态框中关闭按钮悬停时的样式 */
  background-color: #40a9ff;               /* 悬停时颜色变浅 */
}

/* 查询结果表格样式 */
.result-table {                             /* 定义查询结果表格的样式 */
  width: 100%;                             /* 宽度 */
  border-collapse: collapse;               /* 边框合并 */
  margin-top: 10px;                        /* 上边距 */
}

.result-table th,                           /* 定义查询结果表格表头的样式 */
.result-table td {                          /* 定义查询结果表格单元格的样式 */
  border: 1px solid #e8eaec;               /* 边框 */
  padding: 8px;                            /* 内边距 */
  text-align: center;                      /* 文本居中 */
}

.result-table th {                          /* 定义查询结果表格表头的样式 */
  background-color: #f8f8f9;               /* 背景色 */
  font-weight: bold;                       /* 字体粗细 */
}

.result-table td {                          /* 定义查询结果表格单元格的样式 */
  font-size: 14px;                         /* 字体大小 */
}

/* 失败原因样式 */
.result-table td.error-message {            /* 定义查询结果表格中错误信息单元格的样式 */
  color: #ff4d4f;                          /* 红色文字 */
  font-weight: bold;                       /* 粗体 */
}

/* 右上角 API 文档链接容器 */
.api-doc-link-container {                   /* 定义API文档链接容器的样式 */
  position: absolute;                      /* 绝对定位 */
  top: 10px;                               /* 顶部 */
  right: 20px;                             /* 右侧 */
  z-index: 1000;                           /* 层级 */
  margin-right: 15px;                      /* 右边距 */
}

.api-doc-link {                             /* 定义API文档链接的样式 */
  color: #007bff;                          /* 颜色 */
  text-decoration: underline;              /* 下划线 */
  font-size: 14px;                         /* 字体大小 */
  font-weight: 500;                        /* 字体粗细 */
  cursor: pointer;                         /* 鼠标指针 */
  transition: all 0.3s ease;               /* 过渡动画 */
}

.api-doc-link:hover {                       /* 定义API文档链接悬停时的样式 */
  color: #0056b3;                          /* 颜色 */
  text-decoration: none;                   /* 无下划线 */
  background-color: rgba(0, 123, 255, 0.1); /* 背景色 */
  padding: 4px 8px;                        /* 内边距 */
  border-radius: 4px;                      /* 圆角 */
}

/* 底部版权样式 */
.api-footer {                               /* 定义底部版权的样式 */
  text-align: center;                      /* 文本居中 */
  color: #999;                             /* 颜色 */
  font-size: 12px;                         /* 字体大小 */
  margin-top: 2px;                       /* 上边距 */
  padding: 20px;                           /* 内边距 */
  border-top: 1px solid #eee;              /* 顶部边框 */
}

/* ==================== 移动端适配样式 ==================== */

/* 平板适配 (769px - 1024px) */
@media (max-width: 1024px) {
  /* 主标题适配 */
  .main-title {
    font-size: 1.8rem !important;
    margin: 15px 0 !important;
  }
  
  /* 输入框区域适配 */
  .input-section {
    flex-direction: column;
    gap: 10px;
  }
  
  .input-field {
    width: 100% !important;
  }
  
  /* 按钮适配 */
  .action-buttons {
    flex-wrap: wrap;
  }
  
  .action-buttons button {
    flex: 1;
    min-width: 120px;
  }
  
  /* 侧边栏适配 */
  .sidebar {
    width: 200px !important;
  }
  
  /* 主内容区域适配 */
  .main-content {
    padding: 15px !important;
  }
}

/* 手机适配 (<= 768px) */
@media (max-width: 768px) {
  /* 移动端菜单按钮 */
  .mobile-menu-btn {
    display: block !important;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1001;
    background: #fff;
    padding: 8px 12px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    cursor: pointer;
    font-size: 20px;
  }
  
  /* 侧边栏移动端样式 */
  .sidebar-mobile {
    position: fixed;
    top: 0;
    left: 0;
    width: 80% !important;
    max-width: 300px;
    height: 100vh;
    z-index: 1000;
    overflow-y: auto;
    background: #fff;
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  }
  
  .sidebar-hidden {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  
  /* 主内容区域移动端样式 */
  .main-content-mobile {
    margin-left: 0 !important;
    padding: 60px 10px 20px !important;
    width: 100% !important;
  }
  
  /* 标题适配 */
  .mobile-title-header {
    font-size: 1.2rem !important;
    padding: 0 10px;
  }
  
  .main-title {
    font-size: 1.3rem !important;
    padding: 0 10px;
  }
  
  /* 输入框适配 */
  .input-section {
    flex-direction: column !important;
    padding: 10px !important;
  }
  
  .input-field {
    width: 100% !important;
    margin-bottom: 10px;
    font-size: 14px !important;
    padding: 10px !important;
  }
  
  /* 按钮适配 */
  .action-buttons {
    flex-direction: column !important;
    gap: 8px !important;
  }
  
  .action-buttons button,
  .query-btn,
  .select-btn {
    width: 100% !important;
    margin: 0 !important;
    padding: 12px !important;
    font-size: 14px !important;
  }
  
  /* 待查询项适配 */
  .pending-items {
    padding: 10px !important;
  }
  
  .pending-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
  }
  
  .pending-item-text {
    font-size: 13px;
    word-break: break-all;
  }
  
  /* 顶部按钮适配 */
  .top-buttons-container {
    position: static !important;
    flex-direction: column;
    width: 100%;
    margin-bottom: 15px;
  }
  
  .top-buttons-container button,
  .top-buttons-container a {
    width: 100%;
    text-align: center;
  }
  
  /* 数据卡片列表适配 */
  .card-list {
    padding: 10px !important;
  }
  
  /* 分页信息适配 */
  .page-info-mobile {
    font-size: 12px;
    padding: 8px;
  }
  
  /* 表格适配 */
  .data-table {
    font-size: 12px !important;
  }
  
  /* 模态框适配 */
  .ivu-modal {
    width: 95% !important;
    max-width: 100% !important;
    margin: 10px auto !important;
  }
  
  /* 二维码适配 */
  .floating-qrcode-container {
    right: 10px !important;
    top: auto !important;
    bottom: 80px !important;
  }
  
  .qrcode-box {
    width: 240px !important;
  }
  
  .qrcode-img {
    width: 220px !important;
    height: 238px !important;
  }
  
  /* 触摸优化 */
  button,
  a,
  .pending-item,
  .work-card {
    min-height: 44px;
    min-width: 44px;
  }
}

/* 手机横屏适配 */
@media (max-width: 768px) and (orientation: landscape) {
  .sidebar-mobile {
    max-height: 100vh;
  }
  
  .main-content-mobile {
    padding: 50px 10px 10px !important;
  }
  
  .qrcode-box {
    max-height: 80vh;
    overflow-y: auto;
  }
}

/* 小屏手机适配 (<= 480px) */
@media (max-width: 480px) {
  .main-title {
    font-size: 1.1rem !important;
  }
  
  .mobile-title-header {
    font-size: 1rem !important;
  }

  .input-field {
    font-size: 13px !important;
  }
  
  .sidebar-mobile {
    width: 85% !important;
  }
  
  .pending-item-text {
    font-size: 12px;
  }
}

/* ==================== 整体布局优化 ==================== */
.content-wrapper {
  width: 100%;
  padding: 2px 12px 10px 12px; /* 紧凑布局：减少内边距 */
}

/* 优化主内容区域背景 */
.main-content {
  background: var(--main-content-bg, linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%));
  min-height: 100vh;
  transition: background 0.3s ease;
}

/* 优化待查询项区域 - 紧凑版 */
.pending-items {
  background: var(--card-bg, #ffffff);
  border-radius: 12px; /* 紧凑：从16px减少到12px */
  padding: 12px; /* 紧凑：从20px减少到12px */
  margin-bottom: 10px; /* 紧凑：从25px减少到10px */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

/* 优化表格容器 - 紧凑版 */
.table-container {
  background: var(--card-bg, #ffffff);
  border-radius: 12px; /* 紧凑：从16px减少到12px */
  padding: 12px; /* 紧凑：从20px减少到12px */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 0;
  transition: all 0.3s ease;
}

/* View UI Plus 表格主题样式 */
.table-container ::v-deep .ivu-table {
  background: var(--table-bg, #ffffff);
  color: var(--table-text, #515a6e);
  transition: all 0.3s ease;
}

.table-container ::v-deep .ivu-table-header {
  background: var(--table-header-bg, #f8f8f9);
}

.table-container ::v-deep .ivu-table-header th {
  background: var(--table-header-bg, #f8f8f9);
  color: var(--table-text, #515a6e);
  border-color: var(--table-border, #e8eaec);
}

.table-container ::v-deep .ivu-table-body {
  background: var(--table-bg, #ffffff);
}

.table-container ::v-deep .ivu-table td {
  background: var(--table-bg, #ffffff);
  color: var(--table-text, #515a6e);
  border-color: var(--table-border, #e8eaec);
}

.table-container ::v-deep .ivu-table-stripe .ivu-table-row td {
  background: var(--table-bg, #ffffff);
}

.table-container ::v-deep .ivu-table-stripe .ivu-table-row-odd td {
  background: var(--table-stripe-bg, #f8f8f9);
}

.table-container ::v-deep .ivu-table-row-hover td {
  background: var(--table-hover-bg, #e6f7ff) !important;
}

/* ==================== 查询历史标题区域样式 - 紧凑版 ==================== */
.table-header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px; /* 紧凑：从16px 20px减少到10px 14px */
  background: var(--table-header-bg, linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)); /* 使用CSS变量支持主题切换 */
  border-radius: 10px; /* 紧凑：从12px减少到10px */
  margin-bottom: 10px; /* 紧凑：从16px减少到10px */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-left: 3px solid #1890ff; /* 紧凑：从4px减少到3px */
  transition: all 0.3s ease;
}

.table-header-section:hover {
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
  transform: translateY(-1px);
}

.table-header-left {
  display: flex;
  align-items: center;
  gap: 8px; /* 紧凑：从12px减少到8px */
}

.table-title {
  margin: 0;
  font-size: 16px; /* 紧凑：从18px减少到16px */
  font-weight: 600;
  color: var(--card-text, #1a1a2e); /* 使用CSS变量支持主题切换 */
  letter-spacing: 0.5px;
}

.table-count {
  font-size: 13px; /* 紧凑：从14px减少到13px */
  color: var(--modal-text, #666); /* 使用CSS变量支持主题切换 */
  font-weight: 400;
}

.table-header-right {
  display: flex;
  gap: 6px; /* 紧凑：从8px减少到6px */
  align-items: center;
}

/* ==================== 操作按钮组样式 ==================== */
.action-button-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

/* ==================== 操作列按钮样式 ==================== */
.action-button-group .ivu-btn {
  font-size: 12px;
  padding: 4px 8px;
  height: 26px;
  line-height: 1;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 查看详情按钮 - 信息色 */
.action-button-group .ivu-btn.ivu-btn-info {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
}

.action-button-group .ivu-btn.ivu-btn-info:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.5);
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

/* 刷新按钮 - 主色 */
.action-button-group .ivu-btn.ivu-btn-primary {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
  color: white;
  box-shadow: 0 2px 6px rgba(79, 172, 254, 0.3);
}

.action-button-group .ivu-btn.ivu-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(79, 172, 254, 0.5);
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
}

/* 删除按钮 - 错误色 */
.action-button-group .ivu-btn.ivu-btn-error {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  border: none;
  color: white;
  box-shadow: 0 2px 6px rgba(255, 107, 107, 0.3);
}

.action-button-group .ivu-btn.ivu-btn-error:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(255, 107, 107, 0.5);
  background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
}

/* 按钮点击效果 */
.action-button-group .ivu-btn:active {
  transform: translateY(0);
}

/* ==================== 表格行hover效果增强 ==================== */
.table-container ::v-deep .ivu-table tbody tr {
  transition: all 0.2s ease;
  cursor: pointer;
}

.table-container ::v-deep .ivu-table tbody tr:hover {
  background: linear-gradient(90deg, rgba(24, 144, 255, 0.08) 0%, rgba(24, 144, 255, 0.05) 100%) !important;
}

/* 经典主题下的行hover效果 */
.theme-default .table-container ::v-deep .ivu-table tbody tr:hover {
  background: #f0f8ff !important;
}

/* 星空主题下的行hover效果 */
.theme-starry .table-container ::v-deep .ivu-table tbody tr:hover {
  background: linear-gradient(90deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.15) 100%) !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .table-header-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
  }
  
  .table-header-right {
    width: 100%;
    justify-content: flex-start;
  }
  
  .table-title {
    font-size: 16px;
  }
  
  .action-button-group .ivu-btn {
    font-size: 11px;
    padding: 3px 6px;
    height: 24px;
  }
}

.table-container ::v-deep .ivu-table-border th,
.table-container ::v-deep .ivu-table-border td {
  border-color: var(--table-border, #e8eaec);
}

/* 移动端优化 */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 10px;
  }
  
  .pending-items,
  .table-container {
    padding: 15px;
    border-radius: 12px;
  }
}

/* ==================== 底部版权和提示信息样式 ==================== */
.page-footer {
  background: var(--footer-bg, linear-gradient(135deg, #667eea 0%, #764ba2 100%));
  color: var(--footer-text-color, white);
  padding: 20px;
  text-align: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.copyright {
  font-size: 14px;
  margin-bottom: 10px;
  opacity: 0.9;
}

.icp-record {
  font-size: 13px;
  margin-bottom: 10px;
  opacity: 0.85;
}

.icp-record a {
  color: inherit;
  text-decoration: none;
}

.icp-record a:hover {
  text-decoration: underline;
}

.legal-notice {
  font-size: 13px;
  line-height: 1.6;
  opacity: 0.85;
}

.warning-text {
  color: #ffeb3b;
  font-weight: bold;
}

/* 移动端底部优化 */
@media (max-width: 768px) {
  .page-footer {
    padding: 15px 10px;
  }
  
  .copyright {
    font-size: 12px;
  }

  .icp-record {
    font-size: 11px;
  }
  
  .legal-notice {
    font-size: 11px;
  }
}

/* ==================== 用户下拉菜单样式 ==================== */
.user-dropdown-wrapper {
  position: relative;
  z-index: 999;
}

.user-display {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
}

.user-display:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  padding: 8px 0;
  min-width: 160px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.user-dropdown-menu .dropdown-item {
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #515a6e;
  font-size: 14px;
}

.user-dropdown-menu .dropdown-item:hover {
  background: #f3f3f3;
  color: #2d8cf0;
}

.user-dropdown-menu .dropdown-item i {
  font-size: 16px;
}

.user-dropdown-menu .dropdown-item.divided {
  border-top: 1px solid #e8eaec;
  margin-top: 4px;
  padding-top: 12px;
}

/* ================================================== */
/* 用户个人资料模态框样式                              */
/* ================================================== */

/* 模态框加载状态 */
.user-profile-loading {
  /* 居中显示loading */
  text-align: center;
  padding: 40px 0;
}

/* 模态框内容容器 */
.user-profile-body {
  /* 设置内边距 */
  padding: 0 4px;
}

/* 顶部头像+身份标签区 */
.user-profile-header {
  /* flex 横向布局：头像 + 文字信息 */
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4ecf7 100%);
  border-radius: 8px;
  margin-bottom: 16px;
}

.user-profile-header-info {
  /* 头像右侧文字区域 */
  margin-left: 16px;
  flex: 1;
}

.user-profile-name {
  /* 用户名 + 徽章 同行显示 */
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.user-profile-role {
  /* 身份标签说明文字 */
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}

/* 身份徽章 - 通用 */
.role-badge {
  /* 徽章基础样式 */
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  line-height: 1.4;
}

/* 超级VIP徽章：金色渐变 */
.role-badge.super-vip {
  background: linear-gradient(135deg, #f5af19 0%, #f12711 100%);
  color: #fff;
}

/* VIP徽章：紫色渐变 */
.role-badge.vip {
  background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
  color: #fff;
}

/* 管理员徽章：蓝色 */
.role-badge.admin {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: #fff;
}

/* 普通用户徽章：灰色 */
.role-badge.normal {
  background: #f0f2f5;
  color: #606266;
  border: 1px solid #dcdfe6;
}

/* 资料详情列表 */
.user-profile-list {
  /* 每行用 grid 二列布局：左标签 + 右值 */
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 单行资料 */
.profile-row {
  /* 横向：标签 + 值 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f2f5;
  font-size: 14px;
}

.profile-row:hover {
  /* 鼠标悬停行高亮 */
  background: #fafbfc;
}

/* 左侧标签 */
.profile-label {
  /* 标签区域：图标+文字 */
  display: flex;
  align-items: center;
  gap: 6px;
  color: #606266;
  min-width: 110px;
}

.profile-label i {
  /* 标签前图标 */
  font-size: 16px;
  color: #909399;
}

/* 右侧值 */
.profile-value {
  /* 值右对齐 */
  color: #303133;
  text-align: right;
  word-break: break-all;
  max-width: 65%;
}

/* 副标题/补充说明文字 */
.profile-sub {
  /* 例如：到期时间、当前点数说明 */
  color: #909399;
  font-size: 12px;
  margin-left: 6px;
}

/* 强调色 - 超级VIP */
.highlight-svip {
  color: #f12711;
  font-weight: 600;
}

/* 强调色 - VIP */
.highlight-vip {
  color: #a259e6;
  font-weight: 600;
}

/* 强调色 - 已过期 */
.highlight-expired {
  color: #f56c6c;
  font-weight: 600;
}

/* 强调色 - 普通用户 */
.highlight-normal {
  color: #606266;
}

/* 强调色 - 点数 */
.highlight-points {
  color: #ff9760;
  font-weight: 600;
}

/* 强调色 - 今日查询 */
.highlight-today {
  color: #2d8cf0;
  font-weight: 600;
}

/* 强调色 - 是 */
.highlight-yes {
  color: #19be6b;
  font-weight: 600;
}

/* 强调色 - 否 */
.highlight-no {
  color: #909399;
}

/* 底部按钮区 */
.user-profile-footer {
  /* 按钮居右 */
  text-align: right;
  margin-top: 20px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
}

/* 箭头图标旋转动画 */
.rotate-icon {
  transition: transform 0.3s ease;
  transform: rotate(180deg);
}

/* API开发文档链接样式 */
.api-doc-link-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  text-decoration: none;
  white-space: nowrap;
}

.api-doc-link-header:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.api-doc-link-header i {
  font-size: 16px;
}

/* ==================== 用户充值页面样式 ==================== */
.recharge-page {
  padding: 20px;
}

.recharge-header {
  margin-bottom: 30px;
  text-align: center;
}

.recharge-header h2 {
  color: #2d8cf0;
  font-size: 28px;
  font-weight: bold;
}

.vip-packages-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.vip-package-card {
  background: linear-gradient(135deg, #fff9e6 0%, #fff 100%);
  border: 2px solid #ffd700;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);
  transition: all 0.3s ease;
}

.vip-package-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(255, 215, 0, 0.3);
}

.package-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.package-header h3 {
  font-size: 20px;
  color: #333;
  margin: 0;
}

.package-price {
  font-size: 28px;
  font-weight: bold;
  color: #ff4757;
}

.package-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.6;
}

.package-limits {
  margin-bottom: 20px;
}

.package-limits p {
  font-size: 14px;
  color: #515a6e;
  margin: 8px 0;
}

.recharge-footer {
  max-width: 400px;
  margin: 0 auto;
}

/* ==================== 系统设置页面样式 ==================== */
.settings-page {
  padding: 20px;
}

.settings-header {
  margin-bottom: 30px;
  text-align: center;
}

.settings-header h2 {
  color: #2d8cf0;
  font-size: 28px;
  font-weight: bold;
}

.settings-container {
  max-width: 800px;
  margin: 0 auto;
}

.settings-section {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.settings-section h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #2d8cf0;
}

.ip-whitelist-content {
  margin-top: 15px;
}

.current-ip {
  font-size: 14px;
  color: #2d8cf0;
  font-weight: bold;
  margin-bottom: 15px;
}

.ip-input-group {
  margin-bottom: 20px;
}

.ip-actions {
  display: flex;
  gap: 10px;
}

.site-info-display {
  font-size: 14px;
  line-height: 2;
  color: #515a6e;
}

.site-info-display p {
  margin: 10px 0;
}

.site-info-display strong {
  color: #333;
  margin-right: 10px;
}

/* 查询 Loading 遮罩层样式 */
.query-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.spinner-circle {
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2d8cf0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 16px;
  color: #2d8cf0;
  font-weight: 500;
  margin: 0;
  text-align: center;
}

/* 查询结果模态框样式 */
.query-result-content {
  padding: 10px 0;
}

/* 统计信息卡片 */
.result-summary {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.summary-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.summary-item:hover {
  transform: translateY(-2px);
}

.summary-icon {
  font-size: 24px;
}

.summary-item.success .summary-icon {
  color: #52c41a;
}

.summary-item.failed .summary-icon {
  color: #ff4d4f;
}

.summary-item.total .summary-icon {
  color: #1890ff;
}

.summary-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.summary-value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* 表格容器 */
.result-table-wrapper {
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
}

/* 现代化表格样式 */
.result-table-modern {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.result-table-modern thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.result-table-modern thead th {
  padding: 14px 12px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  border: none;
}

.result-table-modern tbody tr {
  transition: background-color 0.2s;
}

.result-table-modern tbody tr:hover {
  background-color: #f5f7fa;
}

.result-table-modern tbody tr.row-failed {
  background-color: #fff1f0;
}

.result-table-modern tbody tr.row-failed:hover {
  background-color: #ffe0de;
}

.result-table-modern tbody td {
  padding: 12px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  font-size: 13px;
}

.col-index {
  width: 60px;
  color: #999;
  font-weight: 500;
}

.col-video-id {
  min-width: 180px;
}

.video-id-text {
  font-family: 'Courier New', monospace;
  color: #1890ff;
  font-weight: 500;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-status {
  width: 100px;
}

/* 状态徽章 */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.status-badge.status-success {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.status-badge.status-failed {
  background: #fff1f0;
  color: #ff4d4f;
  border: 1px solid #ffa39e;
}

.status-icon {
  font-size: 16px;
}

.col-message {
  min-width: 160px;
  max-width: 260px;
}

.col-ai-action {
  width: 110px;
  min-width: 110px;
}

.result-ai-analyze-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 16px;
  padding: 0 10px;
  height: 28px;
  font-size: 12px;
  font-weight: 600;
  background: linear-gradient(135deg, #faad14 0%, #ff7a45 100%);
  border: none;
  color: #fff;
  box-shadow: 0 2px 6px rgba(250, 173, 20, 0.3);
  transition: all 0.25s ease;
}

.result-ai-analyze-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(250, 173, 20, 0.45);
}

.result-ai-analyze-btn:disabled {
  opacity: 0.7;
}

.ai-action-disabled {
  color: #999;
  font-size: 13px;
}

.error-message {
  color: #ff4d4f;
  font-size: 12px;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.success-mark {
  color: #52c41a;
  font-size: 18px;
  font-weight: bold;
}

/* 滚动条美化 */
.result-table-wrapper::-webkit-scrollbar {
  width: 8px;
}

.result-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.result-table-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

.result-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5568d3 0%, #65408b 100%);
}
</style>

<!-- 全局样式：用于挂载到 body 下的 Modal 组件 -->
<style>
/* View UI Plus 模态框主题样式 - 全局作用域 */
.theme-classic .ivu-modal {
  background: #ffffff !important;
}

.theme-classic .ivu-modal-header {
  background: #f8f8f9 !important;
  border-color: #e8eaec !important;
}

.theme-classic .ivu-modal-header .ivu-modal-header-inner {
  color: #515a6e !important;
}

.theme-classic .ivu-modal-body {
  background: #ffffff !important;
  color: #515a6e !important;
}

.theme-classic .ivu-modal-footer {
  background: #ffffff !important;
  border-color: #e8eaec !important;
}

/* 经典主题 - 查询成功模态框内容 */
.theme-classic .detail-modal-content {
  background: #ffffff !important;
  color: #515a6e !important;
}

.theme-classic .detail-modal-content p {
  color: #515a6e !important;
}

.theme-classic .detail-modal-content strong {
  color: #1890ff !important;
}

.theme-classic .detail-section {
  background: #f8f8f9 !important;
  color: #515a6e !important;
}

.theme-classic .detail-section h3 {
  color: #1890ff !important;
}

/* 经典主题 - 优化建议区域 */
.theme-classic .optimization-tips {
  background: #ffffff !important;
  color: #515a6e !important;
}

.theme-classic .optimization-tips h4,
.theme-classic .optimization-tips strong,
.theme-classic .optimization-tips b {
  color: #1890ff !important;
}

.theme-classic .ivu-input,
.theme-classic .ivu-textarea,
.theme-classic .ivu-input-wrapper {
  background: #ffffff !important;
  color: #333 !important;
  border-color: #e8e8e8 !important;
}

.theme-classic .ivu-input::placeholder,
.theme-classic .ivu-textarea::placeholder {
  color: #999 !important;
  opacity: 0.7;
}

/* 星空主题 */
.theme-starry .query-loading-overlay {
  background: rgba(26, 26, 46, 0.9);
}

.theme-starry .spinner-circle {
  border: 4px solid #2a2a3e;
  border-top: 4px solid #64ffda;
}

.theme-starry .loading-text {
  color: #64ffda;
}

/* 蓝色主题 */
.theme-blue .query-loading-overlay {
  background: rgba(240, 248, 255, 0.9);
}

.theme-blue .spinner-circle {
  border: 4px solid #e1f5fe;
  border-top: 4px solid #1976d2;
}

.theme-blue .loading-text {
  color: #1976d2;
}

/* 紫色主题 */
.theme-purple .query-loading-overlay {
  background: rgba(243, 229, 245, 0.9);
}

.theme-purple .spinner-circle {
  border: 4px solid #f3e5f5;
  border-top: 4px solid #7b1fa2;
}

.theme-purple .loading-text {
  color: #7b1fa2;
}

/* 绿色主题 */
.theme-green .query-loading-overlay {
  background: rgba(232, 245, 233, 0.9);
}

.theme-green .spinner-circle {
  border: 4px solid #e8f5e9;
  border-top: 4px solid #388e3c;
}

.theme-green .loading-text {
  color: #388e3c;
}

/* AI 批量分析全屏 Loading 遮罩（居中、自定义好看转圈） */
.ai-batch-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  background: rgba(10, 10, 20, 0.82);
  backdrop-filter: blur(8px);
  animation: ai-batch-fade-in 0.3s ease;
}

@keyframes ai-batch-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.ai-batch-loading-card {
  background: linear-gradient(145deg, rgba(30, 30, 60, 0.98), rgba(20, 20, 40, 0.98));
  border: 1px solid rgba(102, 126, 234, 0.3);
  border-radius: 18px;
  padding: 44px 56px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(102, 126, 234, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  min-width: 320px;
  animation: ai-batch-card-scale 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes ai-batch-card-scale {
  from { transform: scale(0.85); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.ai-batch-loading-spinner {
  position: relative;
  width: 68px;
  height: 68px;
  margin-bottom: 8px;
}

.ai-batch-spinner-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
  border-top-color: #667eea;
  border-bottom-color: #eb2f96;
  animation: ai-batch-spin 1.2s linear infinite;
}

@keyframes ai-batch-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.ai-batch-spinner-core {
  position: absolute;
  top: 14px;
  left: 14px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #eb2f96);
  animation: ai-batch-pulse 1.5s ease-in-out infinite;
}

@keyframes ai-batch-pulse {
  0%, 100% { transform: scale(0.85); opacity: 0.7; }
  50% { transform: scale(1.1); opacity: 1; }
}

.ai-batch-loading-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
}

.ai-batch-loading-text {
  font-size: 14px;
  color: #a0aec0;
  margin: 0;
  text-align: center;
  max-width: 340px;
  line-height: 1.5;
}

.ai-batch-loading-progress {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.ai-batch-progress-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 3px;
  overflow: hidden;
}

.ai-batch-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #eb2f96);
  border-radius: 3px;
  transition: width 0.4s ease;
}

.ai-batch-progress-count {
  font-size: 13px;
  color: #667eea;
  font-weight: 600;
}

/* 查询结果模态框主题适配 */
.theme-starry .query-result-modal .ivu-modal {
  background: #1a1a2e !important;
}

.theme-starry .query-result-modal .ivu-modal-header {
  background: #16213e !important;
  border-color: #2a2a3e !important;
}

.theme-starry .query-result-modal .ivu-modal-header .ivu-modal-header-inner {
  color: #e2e8f0 !important;
}

.theme-starry .query-result-modal .ivu-modal-body {
  background: #1a1a2e !important;
}

.theme-starry .query-result-modal .ivu-modal-footer {
  background: #1a1a2e !important;
  border-color: #2a2a3e !important;
}

.theme-starry .result-summary {
  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
}

.theme-starry .summary-item {
  background: rgba(22, 33, 62, 0.95);
}

.theme-starry .summary-label {
  color: #a0aec0;
}

.theme-starry .summary-value {
  color: #e2e8f0;
}

.theme-starry .result-table-wrapper {
  border-color: #2a2a3e;
}

.theme-starry .result-table-modern {
  background: #1a1a2e;
}

.theme-starry .result-table-modern tbody tr:hover {
  background-color: #16213e;
}

.theme-starry .result-table-modern tbody tr.row-failed {
  background-color: #2d1f1f;
}

.theme-starry .result-table-modern tbody tr.row-failed:hover {
  background-color: #3d2828;
}

.theme-starry .result-table-modern tbody td {
  border-bottom-color: #2a2a3e;
  color: #e2e8f0;
}

.theme-starry .col-index {
  color: #718096;
}

.theme-starry .video-id-text {
  color: #64ffda;
}

.theme-starry .error-message {
  color: #fc8181;
}

.theme-starry .result-table-wrapper::-webkit-scrollbar-track {
  background: #16213e;
}

.theme-blue .query-result-modal .ivu-modal {
  background: #ffffff !important;
}

.theme-blue .result-summary {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.theme-blue .status-badge.status-success {
  background: #e3f2fd;
  color: #1976d2;
  border-color: #90caf9;
}

.theme-purple .query-result-modal .ivu-modal {
  background: #ffffff !important;
}

.theme-purple .result-summary {
  background: linear-gradient(135deg, #7b1fa2 0%, #6a1b9a 100%);
}

.theme-purple .status-badge.status-success {
  background: #f3e5f5;
  color: #7b1fa2;
  border-color: #ce93d8;
}

.theme-green .query-result-modal .ivu-modal {
  background: #ffffff !important;
}

.theme-green .result-summary {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
}

.theme-green .status-badge.status-success {
  background: #e8f5e9;
  color: #388e3c;
  border-color: #81c784;
}

.theme-starry .ivu-modal {
  background: #1a1a2e !important;
}

.theme-starry .ivu-modal-header {
  background: #16213e !important;
  border-color: #2a2a3e !important;
}

.theme-starry .ivu-modal-header .ivu-modal-header-inner {
  color: #e2e8f0 !important;
}

.theme-starry .ivu-modal-body {
  background: #1a1a2e !important;
  color: #e2e8f0 !important;
}

.theme-starry .ivu-modal-confirm-body .ivu-modal-confirm-body-title,
.theme-starry .ivu-modal-confirm-body .ivu-modal-confirm-body-content,
.theme-starry .ivu-modal-confirm-body .ivu-icon,
.theme-starry .ivu-modal-confirm-body {
  color: #ffffff !important;
}

.theme-starry .ivu-modal-confirm-footer .ivu-btn {
  color: #ffffff !important;
}

.theme-starry .ivu-modal-footer {
  background: #1a1a2e !important;
  border-color: #2a2a3e !important;
}

/* 星空主题 - 查询成功模态框内容 */
.theme-starry .detail-modal-content {
  background: #1a1a2e !important;
  color: #e2e8f0 !important;
}

.theme-starry .detail-modal-content p {
  color: #e2e8f0 !important;
}

.theme-starry .detail-modal-content strong {
  color: #64ffda !important;
}

.theme-starry .detail-section {
  background: #16213e !important;
  color: #e2e8f0 !important;
}

.theme-starry .detail-section h3 {
  color: #64ffda !important;
}

/* 星空主题 - 优化建议区域 */
.theme-starry .optimization-tips {
  background: #16213e !important;
  color: #e2e8f0 !important;
}

.theme-starry .optimization-tips h4,
.theme-starry .optimization-tips strong,
.theme-starry .optimization-tips b {
  color: #64ffda !important;
}

.theme-starry .ivu-input,
.theme-starry .ivu-textarea,
.theme-starry .ivu-input-wrapper {
  background: #0f0f1a !important;
  color: #e2e8f0 !important;
  border-color: #2a2a3e !important;
}

.theme-starry .ivu-input::placeholder,
.theme-starry .ivu-textarea::placeholder {
  color: #e2e8f0 !important;
  opacity: 0.7;
}

/* 蓝色主题 */
.theme-blue .ivu-modal {
  background: #ffffff !important;
}

.theme-blue .ivu-modal-header {
  background: #E3F2FD !important;
  border-color: #90CAF9 !important;
}

.theme-blue .ivu-modal-header .ivu-modal-header-inner {
  color: #1565C0 !important;
}

.theme-blue .ivu-modal-body {
  background: #ffffff !important;
  color: #1565C0 !important;
}

.theme-blue .ivu-modal-footer {
  background: #ffffff !important;
  border-color: #90CAF9 !important;
}

/* 蓝色主题 - 查询成功模态框内容 */
.theme-blue .detail-modal-content {
  background: #ffffff !important;
  color: #1565C0 !important;
}

.theme-blue .detail-modal-content p {
  color: #1565C0 !important;
}

.theme-blue .detail-modal-content strong {
  color: #0D47A1 !important;
}

.theme-blue .detail-section {
  background: #E3F2FD !important;
  color: #1565C0 !important;
}

.theme-blue .detail-section h3 {
  color: #0D47A1 !important;
}

/* 蓝色主题 - 优化建议区域 */
.theme-blue .optimization-tips {
  background: #E3F2FD !important;
  color: #1565C0 !important;
}

.theme-blue .optimization-tips h4,
.theme-blue .optimization-tips strong,
.theme-blue .optimization-tips b {
  color: #0D47A1 !important;
}

/* 紫色主题 - 优化建议区域 */
.theme-purple .optimization-tips {
  background: #F3E5F5 !important;
  color: #6A1B9A !important;
}

.theme-purple .optimization-tips h4,
.theme-purple .optimization-tips strong,
.theme-purple .optimization-tips b {
  color: #4A148C !important;
}

/* 绿色主题 - 优化建议区域 */
.theme-green .optimization-tips {
  background: #E8F5E9 !important;
  color: #2E7D32 !important;
}

.theme-green .optimization-tips h4,
.theme-green .optimization-tips strong,
.theme-green .optimization-tips b {
  color: #1B5E20 !important;
}

/* 红色主题 - 优化建议区域 */
.theme-red .optimization-tips {
  background: #FFEBEE !important;
  color: #C62828 !important;
}

.theme-red .optimization-tips h4,
.theme-red .optimization-tips strong,
.theme-red .optimization-tips b {
  color: #B71C1C !important;
}

/* 橙色主题 - 优化建议区域 */
.theme-orange .optimization-tips {
  background: #FFF3E0 !important;
  color: #E65100 !important;
}

.theme-orange .optimization-tips h4,
.theme-orange .optimization-tips strong,
.theme-orange .optimization-tips b {
  color: #BF360C !important;
}

.theme-blue .ivu-input,
.theme-blue .ivu-textarea,
.theme-blue .ivu-input-wrapper {
  background: #ffffff !important;
  color: #1565C0 !important;
  border-color: #90CAF9 !important;
}

.theme-blue .ivu-input::placeholder,
.theme-blue .ivu-textarea::placeholder {
  color: #1565C0 !important;
  opacity: 0.7;
}

/* 紫色主题 */
.theme-purple .ivu-modal {
  background: #ffffff !important;
}

.theme-purple .ivu-modal-header {
  background: #F3E5F5 !important;
  border-color: #CE93D8 !important;
}

.theme-purple .ivu-modal-header .ivu-modal-header-inner {
  color: #6A1B9A !important;
}

.theme-purple .ivu-modal-body {
  background: #ffffff !important;
  color: #6A1B9A !important;
}

.theme-purple .ivu-modal-footer {
  background: #ffffff !important;
  border-color: #CE93D8 !important;
}

/* 紫色主题 - 查询成功模态框内容 */
.theme-purple .detail-modal-content {
  background: #ffffff !important;
  color: #6A1B9A !important;
}

.theme-purple .detail-modal-content p {
  color: #6A1B9A !important;
}

.theme-purple .detail-modal-content strong {
  color: #4A148C !important;
}

.theme-purple .detail-section {
  background: #F3E5F5 !important;
  color: #6A1B9A !important;
}

.theme-purple .detail-section h3 {
  color: #4A148C !important;
}

.theme-purple .ivu-input,
.theme-purple .ivu-textarea,
.theme-purple .ivu-input-wrapper {
  background: #ffffff !important;
  color: #6A1B9A !important;
  border-color: #CE93D8 !important;
}

.theme-purple .ivu-input::placeholder,
.theme-purple .ivu-textarea::placeholder {
  color: #6A1B9A !important;
  opacity: 0.7;
}

/* 绿色主题 */
.theme-green .ivu-modal {
  background: #ffffff !important;
}

.theme-green .ivu-modal-header {
  background: #E8F5E9 !important;
  border-color: #81C784 !important;
}

.theme-green .ivu-modal-header .ivu-modal-header-inner {
  color: #2E7D32 !important;
}

.theme-green .ivu-modal-body {
  background: #ffffff !important;
  color: #2E7D32 !important;
}

.theme-green .ivu-modal-footer {
  background: #ffffff !important;
  border-color: #81C784 !important;
}

/* 绿色主题 - 查询成功模态框内容 */
.theme-green .detail-modal-content {
  background: #ffffff !important;
  color: #2E7D32 !important;
}

.theme-green .detail-modal-content p {
  color: #2E7D32 !important;
}

.theme-green .detail-modal-content strong {
  color: #1B5E20 !important;
}

.theme-green .detail-section {
  background: #E8F5E9 !important;
  color: #2E7D32 !important;
}

.theme-green .detail-section h3 {
  color: #1B5E20 !important;
}

.theme-green .ivu-input,
.theme-green .ivu-textarea,
.theme-green .ivu-input-wrapper {
  background: #ffffff !important;
  color: #2E7D32 !important;
  border-color: #81C784 !important;
}

.theme-green .ivu-input::placeholder,
.theme-green .ivu-textarea::placeholder {
  color: #2E7D32 !important;
  opacity: 0.7;
}

/* 红色主题 */
.theme-red .ivu-modal {
  background: #ffffff !important;
}

.theme-red .ivu-modal-header {
  background: #FFEBEE !important;
  border-color: #EF9A9A !important;
}

.theme-red .ivu-modal-header .ivu-modal-header-inner {
  color: #C62828 !important;
}

.theme-red .ivu-modal-body {
  background: #ffffff !important;
  color: #C62828 !important;
}

.theme-red .ivu-modal-footer {
  background: #ffffff !important;
  border-color: #EF9A9A !important;
}

/* 红色主题 - 查询成功模态框内容 */
.theme-red .detail-modal-content {
  background: #ffffff !important;
  color: #C62828 !important;
}

.theme-red .detail-modal-content p {
  color: #C62828 !important;
}

.theme-red .detail-modal-content strong {
  color: #B71C1C !important;
}

.theme-red .detail-section {
  background: #FFEBEE !important;
  color: #C62828 !important;
}

.theme-red .detail-section h3 {
  color: #B71C1C !important;
}

.theme-red .ivu-input,
.theme-red .ivu-textarea,
.theme-red .ivu-input-wrapper {
  background: #ffffff !important;
  color: #C62828 !important;
  border-color: #EF9A9A !important;
}

.theme-red .ivu-input::placeholder,
.theme-red .ivu-textarea::placeholder {
  color: #C62828 !important;
  opacity: 0.7;
}

/* 橙色主题 */
.theme-orange .ivu-modal {
  background: #ffffff !important;
}

.theme-orange .ivu-modal-header {
  background: #FFF3E0 !important;
  border-color: #FFB74D !important;
}

.theme-orange .ivu-modal-header .ivu-modal-header-inner {
  color: #E65100 !important;
}

.theme-orange .ivu-modal-body {
  background: #ffffff !important;
  color: #E65100 !important;
}

.theme-orange .ivu-modal-footer {
  background: #ffffff !important;
  border-color: #FFB74D !important;
}

/* 橙色主题 - 查询成功模态框内容 */
.theme-orange .detail-modal-content {
  background: #ffffff !important;
  color: #E65100 !important;
}

.theme-orange .detail-modal-content p {
  color: #E65100 !important;
}

.theme-orange .detail-modal-content strong {
  color: #BF360C !important;
}

.theme-orange .detail-section {
  background: #FFF3E0 !important;
  color: #E65100 !important;
}

.theme-orange .detail-section h3 {
  color: #BF360C !important;
}

.theme-orange .ivu-input,
.theme-orange .ivu-textarea,
.theme-orange .ivu-input-wrapper {
  background: #ffffff !important;
  color: #E65100 !important;
  border-color: #FFB74D !important;
}

.theme-orange .ivu-input::placeholder,
.theme-orange .ivu-textarea::placeholder {
  color: #E65100 !important;
  opacity: 0.7;
}

/* ========================================
   经典主题下表格样式优化
   ======================================== */
.theme-default .ivu-table th,
.theme-default .ivu-table thead th,
.theme-default .ivu-table-header th {
  background: #e0e0e0 !important;
  color: #000000 !important;
  font-weight: 700;
  border-color: #b0b0b0 !important;
}

.theme-default .ivu-table th *,
.theme-default .ivu-table thead th *,
.theme-default .ivu-table-header th * {
  color: #000000 !important;
}

.theme-default .ivu-table td,
.theme-default .ivu-table tbody td,
.theme-default .ivu-table-body td,
.theme-default .ivu-table-cell {
  color: #000000 !important;
  border-color: #b0b0b0 !important;
}

.theme-default .ivu-table td *,
.theme-default .ivu-table tbody td *,
.theme-default .ivu-table-body td *,
.theme-default .ivu-table-cell * {
  color: #000000 !important;
}

.theme-default .ivu-table-body tr:nth-child(2n) td {
  background: #f0f0f0 !important;
}

.theme-default .ivu-table-body tr.ivu-table-row-hover td {
  background: #d6e4ff !important;
}

.theme-default .ivu-table-body tr:nth-child(2n).ivu-table-row-hover td {
  background: #adc6ff !important;
}

/* 经典模式下查询状态徽章 */
.theme-default .status-badge.status-success {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.theme-default .status-badge.status-failed {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.theme-default .status-badge.status-warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
}

.theme-default .status-badge.status-error {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.theme-default .status-badge.status-default {
  background-color: #f5f5f5 !important;
  color: #666666 !important;
}

/* 经典模式下所有表格文字 */
.theme-default .col-index,
.theme-default .col-title,
.theme-default .col-author,
.theme-default .col-category,
.theme-default .col-traffic,
.theme-default .col-engagement {
  color: #000000 !important;
}

/* 经典模式下页面文字 */
.theme-default .page-title,
.theme-default .section-title,
.theme-default .info-label,
.theme-default .info-value {
  color: #000000 !important;
}

/* 模态框遮罩层样式 */
.theme-starry .ivu-modal-mask {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

/* ================================================== */
/* 星空主题下"用户个人资料"模态框高对比度优化        */
/* ================================================== */
.theme-starry .user-profile-modal .ivu-modal-content {
  background: #1a1a2e !important;
  border: 1px solid #2d2d44 !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

.theme-starry .user-profile-modal .ivu-modal-header {
  background: #16162a !important;
  border-bottom: 1px solid #2d2d44 !important;
}

.theme-starry .user-profile-modal .ivu-modal-header-inner {
  color: #e2e8f0 !important;
  font-weight: 600 !important;
}

.theme-starry .user-profile-modal .ivu-modal-body {
  background: #1a1a2e !important;
  color: #e2e8f0 !important;
  padding: 20px !important;
}

.theme-starry .user-profile-modal .ivu-modal-close i {
  color: #94a3b8 !important;
}

.theme-starry .user-profile-modal .ivu-modal-close i:hover {
  color: #e2e8f0 !important;
}

.theme-starry .user-profile-modal .user-profile-header {
  background: linear-gradient(135deg, #252542 0%, #1e1e36 100%) !important;
  border: 1px solid #2d2d44 !important;
}

.theme-starry .user-profile-modal .user-profile-name {
  color: #f8fafc !important;
}

.theme-starry .user-profile-modal .user-profile-role {
  color: #94a3b8 !important;
}

.theme-starry .user-profile-modal .profile-row {
  border-bottom: 1px solid #2d2d44 !important;
}

.theme-starry .user-profile-modal .profile-row:hover {
  background: #252536 !important;
}

.theme-starry .user-profile-modal .profile-label {
  color: #94a3b8 !important;
}

.theme-starry .user-profile-modal .profile-label i {
  color: #64748b !important;
}

.theme-starry .user-profile-modal .profile-value {
  color: #f1f5f9 !important;
}

.theme-starry .user-profile-modal .profile-sub {
  color: #94a3b8 !important;
}

.theme-starry .user-profile-modal .role-badge.normal {
  background: #334155 !important;
  color: #e2e8f0 !important;
  border: 1px solid #475569 !important;
}

.theme-starry .user-profile-modal .highlight-points {
  color: #fb923c !important;
}

.theme-starry .user-profile-modal .highlight-today {
  color: #60a5fa !important;
}

.theme-starry .user-profile-modal .highlight-vip {
  color: #c084fc !important;
}

.theme-starry .user-profile-modal .highlight-svip {
  color: #f87171 !important;
}

.theme-starry .user-profile-modal .highlight-yes {
  color: #4ade80 !important;
}

.theme-starry .user-profile-modal .highlight-no {
  color: #94a3b8 !important;
}
</style>